import { Stack as e } from "@stereograph/teia-system-design/components/Stack";
import * as t from "react";
import n, { Fragment as r, createContext as i, createElement as a, useCallback as o, useContext as s, useEffect as c, useId as l, useMemo as u, useRef as d, useState as f, useSyncExternalStore as p } from "react";
import { Alert as m } from "@stereograph/teia-system-design/components/Alert";
import { useTranslation as h } from "react-i18next";
import { Autocomplete as g } from "@stereograph/teia-system-design/components/Autocomplete";
import { Box as _ } from "@stereograph/teia-system-design/components/Box";
import { IconButton as v } from "@stereograph/teia-system-design/components/IconButton";
import { TextField as y } from "@stereograph/teia-system-design/components/TextField";
import { Tooltip as b } from "@stereograph/teia-system-design/components/Tooltip";
import { Subtitle as x, Text as S } from "@stereograph/teia-system-design/components/Typography";
import { CloseWidgetCommand as C, ColorInput as w, InfoBoxSearch as T, NumberField as E, OpenWidgetCommand as D, PageIndicator as O, PageNumberController as k, PageSizeController as A, SearchToolbarItemContent as j, Slider as M, StandardWidget as N, StringCell as P, TabBar as F, Table as I, TableBody as R, TableFooter as z, ToolbarItem as B, ToolbarItemMenu as V, ValueWithUnitTableCell as ee, WidgetTitle as te, useForceUpdate as ne, useHasPlugin as re, useInfoboxWidgetContext as ie, useToolbarItemContext as ae, useValueController as oe, useViewerContext as H, useViewerPlugin as U, useViewerPluginSettings as se, useViewportContext as ce, useWidgetInfo as le } from "@stereograph/teiaviewer-viewport-react";
import { Fragment as W, jsx as G, jsxs as K } from "react/jsx-runtime";
import { AddFloorPlanCommand as ue, AddNavigationEdgeCommand as de, AddProjectionCommand as fe, AddZoneCommand as pe, AnnotationPositionList as me, CalculateNavigationRouteCommand as he, ClearNavigationRoutePointsCommand as ge, CreateNavigationGraphCommand as _e, DefaultFloodFillOptions as ve, DefaultNavigationMeshOptions as ye, DefaultVoxelizationOptions as be, DeleteConnectedNavigationGraphCommand as xe, DeleteNavigationEdgeCommand as Se, DeleteNavigationGraphCommand as Ce, DeleteNavigationNodeCommand as we, DeleteNavigationRoutePointCommand as Te, FloodFillSeedOperator as Ee, FloorPlanLineType as De, FloorPlanTransparentFillColor as Oe, GenerateNavigationGraphCommand as ke, MapShape as Ae, MapType as je, MeasureLinesOperator as Me, MergeNavigationNodesCommand as Ne, ModelApi as Pe, NAVIGATION_ROUTE_END_COLOR as Fe, NAVIGATION_ROUTE_START_COLOR as Ie, NavigationGraphOperator as Le, NavigationRoutingOperator as Re, ObjectTransformOperator as ze, PlanStatusList as Be, ProjectionLineType as Ve, ReverseNavigationEdgeCommand as He, RevertNavigationGraphCommand as q, SaveInfoMapCommand as Ue, SearchApi as We, SetMapCenterCommand as Ge, SetMapElevationCommand as Ke, SetMapOpacityCommand as qe, SetMapRotationCommand as Je, SetMapShapeCommand as Ye, SetMapSizeCommand as Xe, SetMapTypeCommand as Ze, SetNavigationEdgeDirectionCommand as Qe, SetNavigationElementAccessibilityCommand as $e, TeiaObjectSelection as et, TeiaSearchOperatorList as tt, TeiaSourceType as nt, TiaSearchFilterApi as rt, TwinDocDataApi as it, TwinFloorPlanApi as at, TwinObjectApi as ot, TwinProjectionApi as st, ZoneOperator as ct, fetchAllPages as lt, mergeTeiaSearchFilters as ut } from "@stereograph/teiaviewer-plugins";
import { Select as dt } from "@stereograph/teia-system-design/components/Select";
import { QueryClientProvider as ft, keepPreviousData as pt, useMutation as J, useQuery as mt, useQueryClient as ht } from "@tanstack/react-query";
import { Icon as Y } from "@stereograph/teia-system-design/components/Icon";
import { Menu as gt } from "@stereograph/teia-system-design/components/Menu";
import { ToggleButton as _t, ToggleButtonGroup as X } from "@stereograph/teia-system-design/components/ToggleButton";
import vt from "@mui/material/Collapse";
import { Button as Z } from "@stereograph/teia-system-design/components/Button";
import { CircularProgress as yt, LinearProgress as bt } from "@stereograph/teia-system-design/components/Progress";
import { Textarea as xt } from "@stereograph/teia-system-design/components/Textarea";
import { Popper as St } from "@stereograph/teia-system-design/components/Popper";
import { json as Ct } from "@codemirror/lang-json";
import { Paper as wt } from "@stereograph/teia-system-design/components/Paper";
import Tt from "@uiw/react-codemirror";
import { Modal as Et, ModalContent as Dt, ModalFooter as Ot, ModalHeader as kt } from "@stereograph/teia-system-design/components/Modal";
import { BooleanController as At, ClearSelectionCommand as jt, DeleteObjectCommand as Mt, GroupCommand as Nt, NotificationCenter as Pt, PluginNotFoundError as Ft, ReactContextNotFoundError as It, SelectObjectsCommand as Lt, SetObjectTransformCommand as Rt, SetObjectsVisibilityCommand as Q, ViewerPlugin as zt, assertNotNull as Bt } from "@stereograph/teiaviewer";
import { MathUtils as Vt, Matrix4 as Ht, Vector3 as Ut } from "three";
import { Switch as Wt } from "@stereograph/teia-system-design/components/Switch";
import { indigo as Gt } from "@stereograph/teia-system-design/components/Theme";
import { Divider as Kt } from "@stereograph/teia-system-design/components/Divider";
import { ArrowDown as qt, ArrowLeft as Jt, ArrowLeftRight as Yt, Building as Xt, Check as Zt, ChevronDown as Qt, ChevronFirst as $t, ChevronLast as en, ChevronUp as tn, CircleAlert as nn, CircleCheck as rn, CircleX as an, Clock as on, Download as sn, EllipsisVertical as cn, Eye as ln, EyeOff as un, FileUp as dn, Flag as fn, Focus as pn, Info as mn, Link2 as hn, Link2Off as gn, MapPin as _n, Pencil as vn, Plus as yn, Route as bn, SquareDashedMousePointer as xn, SquareDashedX as Sn, Trash2 as Cn, Undo2 as wn, X as Tn } from "lucide-react";
import { RadioGroup as En } from "@stereograph/teia-system-design/components/RadioGroup";
import { t as Dn } from "i18next";
import On from "@mui/material/Radio";
import { Table as kn, createMRTColumnHelper as An } from "@stereograph/teia-system-design/components/Table";
import jn from "@mui/material/IconButton";
import { Popover as Mn } from "@stereograph/teia-system-design/components/Popover";
import { createColumnHelper as Nn } from "@tanstack/react-table";
import { generateUUID as Pn } from "three/src/math/MathUtils.js";
import { Accordion as Fn, AccordionDetails as In, AccordionSummary as Ln } from "@stereograph/teia-system-design/components/Accordion";
import { DocumentViewer as Rn } from "@stereograph/teia-system-design/components/DocumentViewer";
import { Checkbox as zn } from "@stereograph/teia-system-design/components/Checkbox";
import { Radio as Bn } from "@stereograph/teia-system-design/components/Radio";
//#region \0rolldown/runtime.js
var Vn = Object.create, Hn = Object.defineProperty, Un = Object.getOwnPropertyDescriptor, Wn = Object.getOwnPropertyNames, Gn = Object.getPrototypeOf, Kn = Object.prototype.hasOwnProperty, qn = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, $ = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Jn = (e, t) => {
	let n = {};
	for (var r in e) Hn(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Hn(n, Symbol.toStringTag, { value: "Module" }), n;
}, Yn = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Wn(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Kn.call(e, s) && s !== n && Hn(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Un(t, s)) || r.enumerable
	});
	return e;
}, Xn = (e, t, n) => (n = e == null ? {} : Vn(Gn(e)), Yn(t || !e || !e.__esModule || !Kn.call(e, "default") ? Hn(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), Zn = (e) => Kn.call(e, "module.exports") ? e["module.exports"] : Yn(Hn({}, "__esModule", { value: !0 }), e);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ArrowDownOnSquareIcon.js
function Qn({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25"
	}));
}
var $n = /*#__PURE__*/ t.forwardRef(Qn);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ChatBubbleLeftEllipsisIcon.js
function er({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
	}));
}
var tr = /*#__PURE__*/ t.forwardRef(er);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/CircleStackIcon.js
function nr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
	}));
}
var rr = /*#__PURE__*/ t.forwardRef(nr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ClipboardDocumentCheckIcon.js
function ir({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75"
	}));
}
var ar = /*#__PURE__*/ t.forwardRef(ir);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ClipboardDocumentIcon.js
function or({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z"
	}));
}
var sr = /*#__PURE__*/ t.forwardRef(or);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/CodeBracketIcon.js
function cr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5"
	}));
}
var lr = /*#__PURE__*/ t.forwardRef(cr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/Cog6ToothIcon.js
function ur({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
	}), /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
	}));
}
var dr = /*#__PURE__*/ t.forwardRef(ur);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/CubeTransparentIcon.js
function fr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"
	}));
}
var pr = /*#__PURE__*/ t.forwardRef(fr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/CubeIcon.js
function mr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9"
	}));
}
var hr = /*#__PURE__*/ t.forwardRef(mr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/DocumentArrowDownIcon.js
function gr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
	}));
}
var _r = /*#__PURE__*/ t.forwardRef(gr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/DocumentPlusIcon.js
function vr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
	}));
}
var yr = /*#__PURE__*/ t.forwardRef(vr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/DocumentIcon.js
function br({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
	}));
}
var xr = /*#__PURE__*/ t.forwardRef(br);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/FolderArrowDownIcon.js
function Sr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m9 13.5 3 3m0 0 3-3m-3 3v-6m1.06-4.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
	}));
}
var Cr = /*#__PURE__*/ t.forwardRef(Sr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/MagnifyingGlassIcon.js
function wr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
	}));
}
var Tr = /*#__PURE__*/ t.forwardRef(wr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/MapPinIcon.js
function Er({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
	}), /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
	}));
}
var Dr = /*#__PURE__*/ t.forwardRef(Er);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/MapIcon.js
function Or({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z"
	}));
}
var kr = /*#__PURE__*/ t.forwardRef(Or);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/PaperAirplaneIcon.js
function Ar({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
	}));
}
var jr = /*#__PURE__*/ t.forwardRef(Ar);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/PlusIcon.js
function Mr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 4.5v15m7.5-7.5h-15"
	}));
}
var Nr = /*#__PURE__*/ t.forwardRef(Mr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/ShareIcon.js
function Pr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
	}));
}
var Fr = /*#__PURE__*/ t.forwardRef(Pr);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/Squares2X2Icon.js
function Ir({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
	}));
}
var Lr = /*#__PURE__*/ t.forwardRef(Ir);
//#endregion
//#region ../../node_modules/@heroicons/react/24/outline/esm/TrashIcon.js
function Rr({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
	}));
}
var zr = /*#__PURE__*/ t.forwardRef(Rr), Br = n.createContext(null), Vr = {
	id: -1,
	projectId: -1,
	type: "Draft"
}, Hr = (e) => {
	let { children: t, updateFilter: r, showErrors: i, twin: a = Vr } = e, { viewer: o } = H(), s = o.getPlugin("Teia").twinApiClient, c = a !== Vr && s.token !== "", l = n.useMemo(() => ({
		updateFilter: r,
		showErrors: i,
		twin: a,
		enableAutocompletion: c
	}), [
		r,
		i,
		a,
		c
	]);
	return /* @__PURE__ */ G(Br.Provider, {
		value: l,
		children: t
	});
}, Ur = () => {
	let e = n.useContext(Br);
	if (!e) throw Error("useTeiaSearchFilterEditorFormContext must be called under a TeiaSearchFilterEditorContextProvider");
	return e;
}, Wr = tt.map((e) => ({
	label: e,
	value: e
})), Gr = (e) => {
	let { condition: t } = e, { t: n } = h("teiaviewer"), r = Ur(), i = (e) => {
		e && (t.operator = e, (e === "IsNull" || e === "IsNotNull") && (t.value = ""), r.updateFilter());
	};
	return /* @__PURE__ */ G(g, {
		"data-dd-action-name": "teiaSearchFilterEditor.operatorSelector",
		onChange: (e, t) => {
			t && i(t?.value);
		},
		value: Wr.find((e) => e.value === t.operator),
		sx: {
			width: 200,
			backgroundColor: "white"
		},
		options: Wr,
		renderInput: (e) => /* @__PURE__ */ G(y, {
			...e,
			"data-dd-action-name": "teiaSearchFilterEditor.operatorSelector.input",
			"data-testid": "condition-operator-select-input",
			label: n("teiaSearchFilterEditor.operatorSelector.operator.label")
		}),
		renderOption: (e, t) => /* @__PURE__ */ a("li", {
			...e,
			key: t.label,
			style: { whiteSpace: "nowrap" }
		}, t.label)
	});
}, Kr = (e) => e.operator != "IsNull" && e.operator != "IsNotNull", qr = (e) => {
	let { condition: t } = e, n = Ur(), { t: r } = h("teiaviewer");
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(Gr, { condition: t }), Kr(t) && /* @__PURE__ */ G(y, {
		error: !!n.showErrors && t.value == "",
		"data-dd-action-name": "teiaSearchFilterEditor.guidCondition.value_text_field",
		"data-testid": "condition-value-text-input",
		placeholder: r("teiaSearchFilterEditor.guidCondition.value_text_field.label"),
		name: "value",
		value: t.value,
		onChange: (e) => {
			t.value = e.target.value, n.updateFilter();
		},
		sx: {
			minWidth: 200,
			backgroundColor: (e) => e.palette.background.paper
		},
		label: r("teiaSearchFilterEditor.guidCondition.value_text_field.label")
	})] });
}, Jr = (e) => {
	let { condition: t } = e, n = Ur(), { t: r } = h("teiaviewer");
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(Gr, { condition: t }), Kr(t) && /* @__PURE__ */ G(y, {
		error: !!n.showErrors && t.value == "",
		"data-dd-action-name": "teiaSearchFilterEditor.openDataAllCondition.value_text_field",
		"data-testid": "condition-value-text-input",
		placeholder: r("teiaSearchFilterEditor.openDataAllCondition.value_text_field.label"),
		name: "value",
		value: t.value,
		onChange: (e) => {
			t.value = e.target.value, n.updateFilter();
		},
		sx: {
			minWidth: 200,
			backgroundColor: (e) => e.palette.background.paper
		},
		label: r("teiaSearchFilterEditor.openDataAllCondition.value_text_field.label")
	})] });
}, Yr = (e) => {
	let { condition: t } = e, n = Ur(), { t: r } = h("teiaviewer");
	return /* @__PURE__ */ K(W, { children: [
		/* @__PURE__ */ G(y, {
			error: !!n.showErrors && t.key == "",
			"data-dd-action-name": "teiaSearchFilterEditor.openDataCondition.key_text_field",
			"data-testid": "condition-key-text-input",
			placeholder: r("teiaSearchFilterEditor.openDataCondition.key_text_field.label"),
			name: "Key",
			value: t.key,
			onChange: (e) => {
				t.key = e.target.value, n.updateFilter();
			},
			sx: {
				minWidth: 140,
				backgroundColor: (e) => e.palette.background.paper
			},
			inputProps: { sx: {
				minWidth: 140,
				backgroundColor: "white"
			} },
			label: r("teiaSearchFilterEditor.openDataCondition.key_text_field.label")
		}),
		/* @__PURE__ */ G(Gr, { condition: t }),
		Kr(t) && /* @__PURE__ */ G(y, {
			error: !!n.showErrors && t.value == "",
			"data-dd-action-name": "teiaSearchFilterEditor.openDataCondition.value_text_field",
			placeholder: r("teiaSearchFilterEditor.openDataCondition.value_text_field.label"),
			name: "value",
			value: t.value,
			onChange: (e) => {
				t.value = e.target.value, n.updateFilter();
			},
			sx: {
				minWidth: 200,
				backgroundColor: (e) => e.palette.background.paper
			},
			inputProps: { sx: { minWidth: 200 } },
			"data-testid": "condition-value-text-input",
			label: r("teiaSearchFilterEditor.openDataCondition.value_text_field.label")
		})
	] });
}, Xr = (e) => {
	let { condition: t } = e, n = Ur(), { t: r } = h("teiaviewer");
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(Gr, { condition: t }), Kr(t) && /* @__PURE__ */ G(y, {
		"data-dd-action-name": "teiaSearchFilterEditor.parentGuidCondition.value_text_field",
		error: !!n.showErrors && t.value == "",
		"data-testid": "condition-value-text-input",
		placeholder: "GUID",
		name: "value",
		value: t.value,
		onChange: (e) => {
			t.value = e.target.value, n.updateFilter();
		},
		label: r("teiaSearchFilterEditor.parentGuidCondition.textField.label"),
		sx: {
			minWidth: 200,
			backgroundColor: "white"
		}
	})] });
}, Zr = () => {
	let { plugin: e } = U("Teia");
	return We(e.twinApiClient);
}, Qr = /* @__PURE__ */ function(e) {
	return e.MainKey = "TwinObject", e.Search = "Search", e.Values = "Values", e.Fields = "Fields", e.SearchAll = "SearchAll", e.FlattenedObject = "FlattenedObject", e.GetObject = "GetObject", e;
}({}), $r = () => {
	let { plugin: e } = U("Teia");
	return ot(e.twinApiClient);
}, ei = (e) => {
	let { twin: t, dataFamily: n, startPage: r, pageSize: i, enabled: a } = e, o = $r(), s = [
		t.projectId,
		t.type,
		"TwinObject",
		"Fields",
		n
	];
	return mt({
		queryKey: s,
		queryFn: async () => lt((e, r) => o.getTwinObjectFields(t, n, e, r), r, i),
		enabled: a
	});
}, ti = (e) => {
	let { twin: t, filter: n, properties: r, orderBy: i, orderDirection: a, enabled: o, pageSize: s } = e, c = $r(), l = Zr(), u = ht(), d = [
		t.projectId,
		"TwinObject",
		"Values",
		n,
		r,
		i,
		a
	];
	return mt({
		queryKey: d,
		queryFn: async () => {
			let e = await u.fetchQuery({
				queryKey: ["Hash", ...d],
				queryFn: () => l.getSearchFilterHash(n, r, i, a)
			});
			return c.getTwinObjectValues(t, e, s);
		},
		enabled: o
	});
}, ni = (e) => {
	let t = $r();
	return mt({
		queryKey: [
			"TwinObject",
			"FlattenedObject",
			e.id
		],
		queryFn: () => t.flattenedObjectProperties_deprecated(e)
	});
}, ri = (e) => {
	let { filter: t, properties: n, orderBy: r, orderDirection: i, pageSize: a = 100, enabled: o } = e, s = $r(), c = Zr(), l = ht(), u = [
		"TwinObject",
		"SearchAll",
		n,
		r,
		i,
		a
	];
	return mt({
		queryKey: [
			"TwinObject",
			"Search",
			{ ...e }
		],
		queryFn: async () => {
			let e = await l.fetchQuery({
				queryKey: ["Hash", ...u],
				queryFn: () => c.getSearchFilterHash(t, n, r, i)
			});
			return lt((t, n) => s.search(e, t, n), 1, a);
		},
		enabled: o
	});
}, ii = (e) => {
	let { twin: t, uuid: n, families: r = [] } = e, i = $r();
	return mt({
		queryKey: [
			"TwinObject",
			"GetObject",
			t.id,
			n,
			...r
		],
		queryFn: () => i.getTwinObject(t, n, r)
	});
}, ai = (e) => {
	let { updateFilter: t } = Ur(), n = d(null);
	return { onValueInputChange: (r) => {
		n.current && clearTimeout(n.current), n.current = setTimeout(() => {
			n.current = null, e.value = r, t();
		}, 500);
	} };
}, oi = [], si = [], ci = (e) => {
	let { condition: t } = e, { t: n } = h("teiaviewer"), { plugin: r } = U("Teia"), { updateFilter: i, twin: a, showErrors: o, enableAutocompletion: s } = Ur(), c = "property" in t ? t.property : "", { onValueInputChange: l } = ai(t), u = "property" in t ? c !== "" && t.name !== "" : t.name !== "", { data: d, isLoading: f, error: p } = ei({
		twin: a,
		dataFamily: "TwinBimData",
		startPage: 1,
		pageSize: 100,
		enabled: s
	}), m = c;
	t.name !== "" && c == "" && (m = d?.find((e) => e?.name === t.name)?.propertyName ?? "");
	let { data: g, isLoading: _, error: v } = ti({
		twin: a,
		filter: {
			type: "TwinProject",
			operator: "EqualTo",
			value: String(a.id)
		},
		properties: [{
			family: "TwinBimData",
			propertyName: m,
			name: t.name
		}],
		enabled: s && u,
		pageSize: 100
	}), y = !!(p ?? v) || !a || r.twinApiClient.token === "", b = y ? oi : [], x = y ? si : [], S = [], C = (e) => {
		"property" in t && (t.property = e ?? "");
	}, w = (e) => {
		C(e), i();
	}, T = (e) => {
		t.name = e ?? "", i();
	}, E = (e) => {
		t.value = e ?? "", i();
	}, D = (e) => {
		b.push(e), C(e), i();
	}, O = (e) => {
		x.push(e), t.name = e, i();
	}, k = (e) => {
		S.push(e), t.value = e, i();
	};
	if ("property" in t) {
		for (let e of d ?? []) {
			let t = e;
			t.propertyName && t.propertyName !== "" && !b.includes(t.propertyName) && b.push(t.propertyName);
		}
		b.sort((e, t) => e.localeCompare(t));
	}
	for (let e of d ?? []) {
		let n = e;
		n.name && n.name !== "" && !x.includes(n.name) && (n.propertyName === c || !("property" in t)) && x.push(n.name);
	}
	x.sort((e, t) => e.localeCompare(t));
	for (let e of g?.data ?? []) e.value !== "" && S.push(e.value);
	S.sort((e, t) => e.localeCompare(t)), _i(t.value, S), "property" in t && _i(t.property, b), _i(t.name, x);
	let A = x.includes(t.name);
	return !y && !f && !_ && !A && (t.name = ""), /* @__PURE__ */ K(W, { children: [
		"property" in t && /* @__PURE__ */ G(dt, {
			creatable: y,
			error: !!o && t.property == "",
			value: t.property,
			onChange: w,
			onCreateOption: D,
			options: b,
			label: n("teiaSearchFilterEditor.propertyCondition.property_autocomplete.text_field.label"),
			"data-dd-action-name": "teiaSearchFilterEditor.propertyCondition.property_autocomplete.text_field",
			loading: f,
			"data-testid": "condition-property-select-input",
			ListboxProps: { style: { overflowX: "auto" } },
			sx: {
				minWidth: 150,
				backgroundColor: (e) => e.palette.background.paper
			}
		}),
		/* @__PURE__ */ G(dt, {
			resizable: !0,
			creatable: y,
			error: !!o && t.name == "",
			value: t.name,
			onChange: T,
			onCreateOption: O,
			options: x,
			label: n("teiaSearchFilterEditor.propertyCondition.name_autocomplete.text_field.label"),
			"data-dd-action-name": "teiaSearchFilterEditor.propertyCondition.name_autocomplete.text_field",
			loading: f,
			"data-testid": "condition-name-select-input",
			ListboxProps: { style: { overflowX: "auto" } },
			sx: {
				minWidth: 200,
				backgroundColor: (e) => e.palette.background.paper
			}
		}, "property" in t ? "propertyCondition" : "attributeCondition"),
		/* @__PURE__ */ G(Gr, { condition: t }),
		/* @__PURE__ */ G(dt, {
			hidden: Kr(t),
			onInputChange: l,
			resizable: !0,
			creatable: !0,
			error: !!o && t.value == "",
			onChange: E,
			value: t.value,
			onCreateOption: k,
			options: S,
			label: n("teiaSearchFilterEditor.propertyCondition.values_autocomplete.text_field.label"),
			"data-dd-action-name": "teiaSearchFilterEditor.propertyCondition.value_autocomplete.text_field",
			loading: _,
			"data-testid": "condition-value-select-input",
			ListboxProps: { style: { overflowX: "auto" } },
			sx: {
				minWidth: 200,
				backgroundColor: (e) => e.palette.background.paper
			}
		})
	] });
}, li = [], ui = "Element Specific", di = "Type", fi = (e) => {
	let { condition: t } = e, { t: n } = h("teiaviewer"), { updateFilter: r, twin: i, showErrors: a, enableAutocompletion: o } = Ur(), { onValueInputChange: s } = ai(t), { data: c, isLoading: l } = ti({
		twin: i,
		filter: {
			type: "TwinProject",
			operator: "EqualTo",
			value: String(i.id)
		},
		properties: [{
			family: "TwinBimData",
			propertyName: ui,
			name: di
		}],
		enabled: o,
		pageSize: 100
	}), u = (e) => {
		t.value = e ?? "", r();
	}, d = (e) => {
		li.push(e), t.value = e, r();
	};
	for (; li.length > 0;) li.pop();
	for (let e of c?.data ?? []) e.value !== "" && li.push(e.value);
	return _i(t.value, li), /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(Gr, { condition: t }), Kr(t) && /* @__PURE__ */ G(dt, {
		onInputChange: s,
		creatable: !0,
		error: !!a && t.value == "",
		value: t.value,
		onChange: u,
		onCreateOption: d,
		options: li,
		getOptionLabel: (e) => e,
		label: n("teiaSearchFilterEditor.typeCondition.values_autocomplete.text_field.label"),
		"data-dd-action-name": "teiaSearchFilterEditor.typeCondition.values_autocomplete.text_field",
		loading: l,
		"data-testid": "condition-value-select-input",
		ListboxProps: { style: { overflowX: "auto" } },
		sx: {
			minWidth: 225,
			backgroundColor: (e) => e.palette.background.paper
		}
	})] });
}, pi = (e) => {
	let { condition: t } = e, n = Ur();
	return /* @__PURE__ */ K(W, { children: [
		/* @__PURE__ */ G(y, {
			"data-dd-action-name": "teiaSearchFilterEditor.userDataAllCondition.name_text_field",
			error: !!n.showErrors && t.name == "",
			"data-testid": "condition-name-text-input",
			placeholder: "Name",
			name: "Name",
			value: t.name,
			onChange: (e) => {
				t.name = e.target.value, n.updateFilter();
			},
			label: "Name",
			sx: {
				flexGrow: 1,
				minWidth: 128,
				maxWidth: 208,
				backgroundColor: (e) => e.palette.background.paper
			}
		}, "name-field"),
		/* @__PURE__ */ G(Gr, { condition: t }),
		Kr(t) && /* @__PURE__ */ G(y, {
			"data-dd-action-name": "teiaSearchFilterEditor.userDataAllCondition.value_text_field",
			error: !!n.showErrors && t.value == "",
			"data-testid": "condition-value-text-input",
			placeholder: "Value",
			name: "value",
			value: t.value,
			onChange: (e) => {
				t.value = e.target.value, n.updateFilter();
			},
			label: "Value",
			sx: {
				minWidth: 200,
				backgroundColor: (e) => e.palette.background.paper
			}
		})
	] });
}, mi = (e) => {
	let { condition: t } = e, n = Ur(), { t: r } = h("teiaviewer");
	return /* @__PURE__ */ K(W, { children: [
		/* @__PURE__ */ G(y, {
			"data-dd-action-name": "teiaSearchFilterEditor.userDataByApplicationCondition.applicationName_text_field",
			error: !!n.showErrors && t.applicationName == "",
			"data-testid": "condition-applicationName-text-input",
			placeholder: r("teiaSearchFilterEditor.userDataByApplicationCondition.applicationName_text_field.label"),
			name: "ApplicationName",
			value: t.applicationName,
			onChange: (e) => {
				t.applicationName = e.target.value, n.updateFilter();
			},
			sx: {
				flexGrow: 1,
				minWidth: 128,
				maxWidth: 208,
				backgroundColor: (e) => e.palette.background.paper
			},
			label: r("teiaSearchFilterEditor.userDataByApplicationCondition.applicationName_text_field.label")
		}),
		/* @__PURE__ */ G(y, {
			error: !!n.showErrors && t.name == "",
			"data-testid": "condition-name-text-input",
			placeholder: r("teiaSearchFilterEditor.userDataByApplicationCondition.name_text_field.label"),
			name: "Name",
			value: t.name,
			onChange: (e) => {
				t.name = e.target.value, n.updateFilter();
			},
			sx: {
				flexGrow: 1,
				minWidth: 128,
				maxWidth: 208,
				backgroundColor: (e) => e.palette.background.paper
			},
			label: r("teiaSearchFilterEditor.userDataByApplicationCondition.name_text_field.label")
		}),
		/* @__PURE__ */ G(Gr, { condition: t }),
		Kr(t) && /* @__PURE__ */ G(y, {
			resizable: !0,
			error: !!n.showErrors && t.value == "",
			placeholder: r("teiaSearchFilterEditor.userDataByApplicationCondition.value_text_field.label"),
			name: "value",
			value: t.value,
			onChange: (e) => {
				t.value = e.target.value, n.updateFilter();
			},
			sx: {
				minWidth: 200,
				backgroundColor: "white"
			},
			"data-testid": "condition-value-text-input",
			label: r("teiaSearchFilterEditor.userDataByApplicationCondition.value_text_field.label")
		})
	] });
}, hi = [
	{
		type: "Property",
		category: "BimData",
		title: "Property"
	},
	{
		type: "Attribute",
		category: "BimData",
		title: "Attribute"
	},
	{
		type: "Guid",
		category: "BimData",
		title: "Guid"
	},
	{
		type: "Parent",
		category: "BimData",
		title: "Parent"
	},
	{
		type: "Type",
		category: "BimData",
		title: "Type"
	},
	{
		type: "OpenDataAll",
		category: "OpenData",
		title: "OpenData (All)"
	},
	{
		type: "OpenData",
		category: "OpenData",
		title: "OpenData (Key)"
	},
	{
		type: "UserData",
		category: "UserData",
		title: "UserData (All)"
	},
	{
		type: "UserDataByApplication",
		category: "UserData",
		title: "UserData (Name)"
	}
], gi = (t) => {
	let { condition: n, onRemove: r, level: i } = t, o = Ur(), { t: s } = h("teiaviewer"), c = /* @__PURE__ */ G(W, {});
	switch (n.type) {
		case "Property":
			c = /* @__PURE__ */ G(ci, { condition: n });
			break;
		case "Attribute":
			c = /* @__PURE__ */ G(ci, { condition: n });
			break;
		case "Guid":
			c = /* @__PURE__ */ G(qr, { condition: n });
			break;
		case "Type":
			c = /* @__PURE__ */ G(fi, { condition: n });
			break;
		case "UserData":
			c = /* @__PURE__ */ G(pi, { condition: n });
			break;
		case "UserDataByApplication":
			c = /* @__PURE__ */ G(mi, { condition: n });
			break;
		case "OpenData":
			c = /* @__PURE__ */ G(Yr, { condition: n });
			break;
		case "Parent":
			c = /* @__PURE__ */ G(Xr, { condition: n });
			break;
		case "OpenDataAll": c = /* @__PURE__ */ G(Jr, { condition: n });
	}
	let l = (e) => {
		for (let e in n) delete n[e];
		switch (n.type = e, n.operator = "EqualTo", n.value = "", e) {
			case "Empty":
			case "Guid":
			case "Parent":
			case "Type":
			case "OpenDataAll":
			case "Integration":
			case "IntegrationObject":
			case "TwinProject":
			case "Field": break;
			case "Property":
				n.name = "", n.property = "";
				break;
			case "Attribute":
				n.name = "";
				break;
			case "UserData":
				n.name = "";
				break;
			case "UserDataByApplication":
				n.name = "", n.applicationName = "";
				break;
			case "OpenData": n.key = "";
		}
	}, u = (e) => {
		e ? (l(e), o.updateFilter()) : (l("Empty"), o.updateFilter());
	}, d = n.type === "Empty" ? null : n.type, f = n.type === "Guid" || n.type === "Parent" || n.type === "Type" || n.type === "OpenDataAll";
	return /* @__PURE__ */ K(e, {
		"data-testid": "condition",
		className: "teia-search-filter-editor-condition",
		"data-level": i,
		direction: "row",
		spacing: 2,
		justifyContent: "space-between",
		alignItems: "center",
		sx: {
			width: "100%",
			borderRadius: 1
		},
		children: [/* @__PURE__ */ G(e, {
			direction: "row",
			alignItems: "center",
			sx: {
				pl: i * 4,
				overflowX: "auto",
				width: "100%"
			},
			children: /* @__PURE__ */ G(e, {
				id: "controls",
				direction: "row",
				spacing: 2,
				children: /* @__PURE__ */ K(e, {
					direction: "row",
					spacing: 1,
					sx: {
						width: "100%",
						whiteSpace: "nowrap",
						paddingY: "8px",
						"& > div": {
							display: "inline-block",
							flex: "none"
						},
						"& > *:last-of-type": { display: f ? "inherit" : "inline-block" }
					},
					children: [/* @__PURE__ */ G(g, {
						"data-dd-action-name": "teiaSearchFilterEditor.condition_select",
						"aria-invalid": !!o.showErrors && d === void 0,
						groupBy: (e) => e.category,
						options: hi,
						getOptionLabel: (e) => e.title,
						renderOption: (e, t) => /* @__PURE__ */ a("li", {
							...e,
							key: t.type,
							style: { whiteSpace: "nowrap" }
						}, t.title),
						ListboxProps: { sx: { "& > li:nth-of-type(n+2)": {
							borderTop: "1px solid",
							borderTopColor: "divider"
						} } },
						renderGroup: (e) => /* @__PURE__ */ K(_, {
							component: "li",
							sx: { py: 2 },
							children: [/* @__PURE__ */ G(S, {
								variant: "body2",
								sx: {
									paddingLeft: 4,
									py: 2,
									color: "text.disabled"
								},
								children: e.group
							}), /* @__PURE__ */ G("ul", { children: e.children })]
						}, e.key),
						onChange: (e, t) => u(t ? t.type : null),
						value: hi.find((e) => e.type === d) ?? null,
						renderInput: (e) => /* @__PURE__ */ G(y, {
							...e,
							"data-dd-action-name": "teiaSearchFilterEditor.condition_select_input",
							"data-testid": "condition-type-select-input",
							error: !!o.showErrors && !d,
							label: s("teiaSearchFilterEditor.condition_select.label"),
							placeholder: s("teiaSearchFilterEditor.condition_select.placeholder"),
							sx: { width: 200 }
						}),
						sx: { backgroundColor: (e) => e.palette.background.paper }
					}), c]
				})
			})
		}), /* @__PURE__ */ G(b, {
			title: s("teiaSearchFilterEditor.remove_condition_tooltip.label"),
			children: /* @__PURE__ */ G(v, {
				"data-dd-action-name": "teiaSearchFilterEditor.remove_condition_button",
				"data-testid": "search-filter-remove-condition-button",
				"aria-label": s("teiaSearchFilterEditor.remove_condition_button.label"),
				onClick: r,
				variant: "error",
				icon: zr
			})
		})]
	});
}, _i = (e, t) => {
	e !== "" && (t.includes(e) || t.push(e));
}, vi = (e) => /* @__PURE__ */ K("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ G("g", {
		clipPath: "url(#clip0_1580_2867)",
		children: /* @__PURE__ */ G("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.4697 21.4805C14.7626 21.7734 15.2374 21.7734 15.5303 21.4805L21.5303 15.4805C21.8232 15.1876 21.8232 14.7127 21.5303 14.4198L15.5303 8.4198C15.2374 8.12691 14.7626 8.12691 14.4697 8.4198C14.1768 8.7127 14.1768 9.18757 14.4697 9.48046L19.1893 14.2001H9C6.10051 14.2001 3.75 11.8496 3.75 8.95013V4.95013C3.75 4.53592 3.41421 4.20013 3 4.20013C2.58579 4.20013 2.25 4.53592 2.25 4.95013V8.95013C2.25 12.6781 5.27208 15.7001 9 15.7001H19.1893L14.4697 20.4198C14.1768 20.7127 14.1768 21.1876 14.4697 21.4805Z",
			fill: "gray"
		})
	}), /* @__PURE__ */ G("defs", { children: /* @__PURE__ */ G("clipPath", {
		id: "clip0_1580_2867",
		children: /* @__PURE__ */ G("rect", {
			width: 19.5,
			height: 17.5,
			fill: "white",
			transform: "translate(2.25 4.20013)"
		})
	}) })]
}), yi = (e) => {
	let { anchorEl: t, open: n, handleClose: r, onAddCondition: i, onAddGroup: a, setAnchorEl: o, groupedOptions: s } = e, { t: c } = h("teiaviewer");
	return /* @__PURE__ */ K(gt, {
		anchorEl: t,
		open: n,
		onClose: r,
		onClick: () => o(null),
		elevation: 3,
		anchorOrigin: {
			vertical: "bottom",
			horizontal: "right"
		},
		transformOrigin: {
			vertical: "top",
			horizontal: "right"
		},
		slotProps: { paper: { sx: {
			borderColor: (e) => e.palette.text.primary,
			borderRadius: ".375rem",
			borderWidth: "1px",
			border: (e) => `1px solid ${e.palette.text.disabled}`,
			color: "#374151",
			marginTop: ".25rem"
		} } },
		children: [
			/* @__PURE__ */ G(_, {
				component: "li",
				sx: {
					fontSize: "0.875rem",
					fontWeight: 500,
					color: (e) => e.palette.text.disabled,
					p: 2
				},
				children: c("teiaSearchFilterEditor.group.category.label")
			}),
			/* @__PURE__ */ G(_, {
				sx: {
					p: 2,
					cursor: "pointer",
					"&:hover": { backgroundColor: (e) => e.palette.info.light },
					fontWeight: 500
				},
				"data-testid": "search-filter-add-group-menu-item",
				onClick: () => {
					a(), r();
				},
				children: c("teiaSearchFilterEditor.group.add_group_menu.label")
			}),
			Object.entries(s).map(([e, t]) => /* @__PURE__ */ K(_, { children: [/* @__PURE__ */ G(_, {
				component: "li",
				sx: {
					fontSize: "0.875rem",
					fontWeight: 500,
					color: (e) => e.palette.text.disabled,
					p: 2
				},
				children: e
			}), t.map((e) => /* @__PURE__ */ G(_, {
				"data-testid": "search-filter-add-condition-menu-item",
				sx: {
					p: 2,
					cursor: "pointer",
					"&:hover": {
						backgroundColor: (e) => e.palette.info.light,
						borderRadius: "1"
					}
				},
				onClick: () => {
					i(e.type), r();
				},
				children: e.title
			}, e.type))] }, e))
		]
	});
}, bi = (t) => {
	let { group: n } = t, r = Ur(), { t: i } = h("teiaviewer");
	return /* @__PURE__ */ K(e, {
		direction: "row",
		alignItems: "center",
		spacing: 2,
		children: [
			/* @__PURE__ */ G(S, { children: i("teiaSearchFilterEditor.condition_input.label") }),
			/* @__PURE__ */ K(X, {
				"data-testid": "group-operator",
				exclusive: !0,
				value: n.condition,
				onChange: (e, t) => {
					t && (n.condition = t, r.updateFilter());
				},
				color: "primary",
				sx: {
					backgroundColor: (e) => e.palette.background.paper,
					borderRadius: 1
				},
				children: [/* @__PURE__ */ G(b, {
					title: i("teiaSearchFilterEditor.condition_input.text_field.and.label"),
					children: /* @__PURE__ */ G(_t, {
						"data-dd-action-name": "teiaSearchFilterEditor.condition_input.text_field.and",
						value: "And",
						"data-testid": "AND",
						children: i("teiaSearchFilterEditor.condition_input.text_field.and.label")
					})
				}), /* @__PURE__ */ G(b, {
					title: i("teiaSearchFilterEditor.condition_input.text_field.or.label"),
					children: /* @__PURE__ */ G(_t, {
						"data-dd-action-name": "teiaSearchFilterEditor.condition_input.text_field.or",
						value: "Or",
						"data-testid": "OR",
						children: i("teiaSearchFilterEditor.condition_input.text_field.or.label")
					})
				})]
			}),
			/* @__PURE__ */ G(S, { children: i("teiaSearchFilterEditor.condition_input.conditions.label") })
		]
	});
}, xi = (e) => {
	let t;
	switch (e) {
		case "Property":
			t = {
				type: "Property",
				operator: "Contains",
				value: "",
				name: "",
				property: ""
			};
			break;
		case "Attribute":
			t = {
				type: "Attribute",
				operator: "Contains",
				value: "",
				name: ""
			};
			break;
		case "UserData":
			t = {
				type: "UserData",
				operator: "Contains",
				value: "",
				name: ""
			};
			break;
		case "UserDataByApplication":
			t = {
				type: "UserDataByApplication",
				operator: "Contains",
				value: "",
				name: "",
				applicationName: ""
			};
			break;
		case "OpenData":
			t = {
				type: "OpenData",
				operator: "Contains",
				value: "",
				key: ""
			};
			break;
		case "Field":
			t = {
				type: "Field",
				operator: "IsNotNull",
				value: "",
				field: ""
			};
			break;
		default: t = {
			type: e,
			operator: "Contains",
			value: ""
		};
	}
	return t;
}, Si = (t) => {
	let { group: n, level: r, onRemove: i } = t, a = Ur(), o = r === 0, { t: s } = h("teiaviewer"), [c, l] = f(null), u = !!c, d = (e) => {
		l(e.currentTarget);
	}, p = () => {
		l(null);
	}, m = (e) => {
		let t = xi(e);
		n.rules.push(t), a.updateFilter();
	}, g = () => {
		n.rules.push({
			condition: "And",
			rules: []
		}), a.updateFilter();
	}, y = hi.reduce((e, t) => (e[t.category] || (e[t.category] = []), e[t.category].push(t), e), {}), x = (e) => {
		n.rules.splice(e, 1), a.updateFilter();
	};
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ K(e, {
		direction: "row",
		alignItems: "center",
		justifyContent: "space-between",
		className: "teia-search-filter-editor-logical",
		"data-level": r,
		sx: {
			...o && {
				paddingY: 3,
				backgroundColor: (e) => e.palette.primary.light,
				borderBottomLeftRadius: 0,
				borderBottomRightRadius: 0
			},
			...r >= 1 && {
				paddingY: 2,
				borderRadius: 1,
				borderBottomRightRadius: 0
			},
			paddingLeft: o ? 4 : r * 4
		},
		children: [/* @__PURE__ */ K(e, {
			direction: "row",
			alignItems: "center",
			spacing: 2,
			children: [
				r > 0 && /* @__PURE__ */ G(Y, {
					component: vi,
					fontSize: "small",
					sx: { marginTop: "-4px" }
				}),
				/* @__PURE__ */ G(bi, { group: n }),
				/* @__PURE__ */ G(b, {
					title: s("teiaSearchFilterEditor.group.add_condition_tooltip.label"),
					children: /* @__PURE__ */ G(v, {
						"data-dd-action-name": "teiaSearchFilterEditor.group.add_condition_button",
						"data-testid": "search-filter-add-rule-button",
						"aria-label": s("teiaSearchFilterEditor.group.add_condition_tooltip.label"),
						onClick: d,
						icon: Nr
					})
				}),
				/* @__PURE__ */ G(yi, {
					open: u,
					anchorEl: c,
					setAnchorEl: l,
					handleClose: p,
					groupedOptions: y,
					onAddCondition: m,
					onAddGroup: g
				})
			]
		}), /* @__PURE__ */ G(_, { children: r > 0 && /* @__PURE__ */ G(b, {
			title: s("teiaSearchFilterEditor.group.remove_group_tooltip.label"),
			children: /* @__PURE__ */ G(v, {
				"data-dd-action-name": "teiaSearchFilterEditor.group.remove_group_button",
				"data-testid": "search-filter-remove-group-button",
				"aria-label": s("teiaSearchFilterEditor.group.remove_group_tooltip.label"),
				onClick: i,
				variant: "error",
				icon: zr
			})
		}) })]
	}), /* @__PURE__ */ G(e, {
		"data-testid": "group",
		"data-level": r,
		className: "teia-search-filter-editor-group",
		sx: { width: "100%" },
		spacing: 1,
		children: /* @__PURE__ */ G(e, {
			direction: "row",
			sx: {
				width: "100%",
				position: "relative",
				borderRadius: () => {
					if (o) return "8px";
					if (r > 0) return "0 0 8px 8px";
				},
				borderTopRightRadius: r === 1 ? 2 : 0,
				paddingLeft: o ? 0 : 4
			},
			children: /* @__PURE__ */ G(e, {
				direction: "column",
				spacing: 1,
				sx: {
					width: "100%",
					minHeight: "50px"
				},
				children: n.rules.map((e, t) => /* @__PURE__ */ G(Ci, {
					rule: e,
					level: r + 1,
					onRemove: () => x(t)
				}, `rule-${t}`))
			})
		})
	})] });
}, Ci = (t) => {
	let { rule: n, level: r, onRemove: i, ...a } = t;
	return n.condition ? /* @__PURE__ */ G(e, {
		className: "teia-search-filter-editor-rule",
		sx: {
			borderTop: (e) => `1px solid ${e.palette.primary.light}`,
			borderLeft: (e) => `1px solid ${e.palette.primary.light}`,
			borderBottom: (e) => `1px solid ${e.palette.primary.light}`,
			borderRadius: 1,
			borderTopRightRadius: 0,
			...r === 0 && { borderRight: (e) => `1px solid ${e.palette.primary.light}` },
			...r === 1 && { marginLeft: 1 },
			...r >= 1 && { marginTop: 1 },
			paddingBottom: 1
		},
		children: /* @__PURE__ */ G(Si, {
			level: r,
			group: n,
			onRemove: i,
			...a
		})
	}) : /* @__PURE__ */ G(gi, {
		onRemove: i,
		condition: n,
		level: r,
		...a
	});
}, wi = (e) => {
	let { twin: t, defaultGroupOperator: n = "And", defaultFilter: r = {}, showErrors: i = !1, onChange: a, ...o } = e, s = Ei(r, n), { t: c } = h("teiaviewer"), l = Oi(s), u = () => {
		a?.(s, !Oi(s));
	}, d = i && l;
	return /* @__PURE__ */ K("div", {
		...o,
		children: [!!d && /* @__PURE__ */ G(m, {
			severity: "error",
			"data-testid": "search-filter-errors-alert",
			sx: { mb: 1 },
			children: c("teiaSearchFilterEditor.errors.text")
		}), /* @__PURE__ */ G(Hr, {
			updateFilter: u,
			showErrors: d,
			twin: t,
			children: /* @__PURE__ */ G(Ci, {
				rule: s,
				level: 0
			})
		})]
	});
};
function Ti(e, t = "And") {
	return !Oi(Ei(e, t));
}
function Ei(e, t) {
	return Object.keys(e).length === 0 ? {
		condition: t,
		rules: []
	} : e.type ? {
		condition: t,
		rules: [e]
	} : Di(e);
}
function Di(e) {
	if (e.type) return e;
	{
		let t = e;
		return {
			condition: t.condition,
			rules: t.rules?.map((e) => Di(e))
		};
	}
}
function Oi(e) {
	if (e.type === "Empty" || e.operator != "IsNull" && e.operator != "IsNotNull" && e.value === "" || "name" in e && e.name === "" || "property" in e && e.property === "" || "key" in e && e.key === "") return !0;
	if (e.condition) {
		for (let t of e.rules) if (Oi(t)) return !0;
	}
	return !1;
}
//#endregion
//#region src/components/TeiaSearchFilterEditor/toolbar/AIButton.tsx
var ki = (e) => {
	let { onClick: t } = e, { t: n } = h("teiaviewer"), [r, i] = f(!0);
	return /* @__PURE__ */ K(Z, {
		"aria-label": n("teiaSearchFilterEditor.ai.button.label"),
		onClick: t,
		onMouseEnter: () => i(!0),
		onMouseLeave: () => i(!1),
		"data-testid": "search-filter-ai-button",
		"data-dd-action-name": "teiaSearchFilterEditor.ai.button",
		sx: {
			minWidth: 0,
			height: "36px",
			px: 1,
			color: "common.white",
			backgroundImage: (e) => `linear-gradient(90deg, ${e.palette.ia.primary} 0%,
          ${e.palette.ia.secondary} 50%, ${e.palette.ia.secondary} 100%)`,
			backgroundSize: "200% 100%",
			transition: "background-position 0.3s ease",
			"&:hover": { backgroundPosition: "15%" }
		},
		children: [/* @__PURE__ */ G(vt, {
			in: r,
			orientation: "horizontal",
			timeout: 300,
			children: /* @__PURE__ */ G(_, {
				sx: {
					whiteSpace: "nowrap",
					px: 1
				},
				children: n("teiaSearchFilterEditor.ai.button.help_text")
			})
		}), /* @__PURE__ */ G(Y, { component: tr })]
	});
};
//#endregion
//#region ../../node_modules/@heroicons/react/24/solid/esm/GlobeEuropeAfricaIcon.js
function Ai({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM8.547 4.505a8.25 8.25 0 1 0 11.672 8.214l-.46-.46a2.252 2.252 0 0 1-.422-.586l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.211.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.654-.261a2.25 2.25 0 0 1-1.384-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 0 1-1.458-1.137l1.279-2.132Z",
		clipRule: "evenodd"
	}));
}
var ji = /*#__PURE__*/ t.forwardRef(Ai);
//#endregion
//#region ../../node_modules/@heroicons/react/24/solid/esm/PaperAirplaneIcon.js
function Mi({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", { d: "M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z" }));
}
var Ni = /*#__PURE__*/ t.forwardRef(Mi), Pi = () => {
	let { plugin: e } = U("Teia");
	return J({ mutationFn: (t) => rt(e.tiaApiClient).generateSearchFilter(t) });
}, Fi = [
	6.54554,
	11.9999,
	17.4545
], Ii = () => /* @__PURE__ */ G(_, {
	sx: {
		display: "flex",
		flexShrink: 0,
		color: (e) => e.palette.ia.primary,
		"& ellipse": { animation: "teia-search-filter-ai-bump 2s infinite" },
		"@keyframes teia-search-filter-ai-bump": {
			"0%, 40%, 100%": { transform: "translateY(0%)" },
			"20%": { transform: "translateY(-10%)" }
		}
	},
	children: /* @__PURE__ */ K("svg", {
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": !0,
		children: [/* @__PURE__ */ G("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.84836 2.771C7.18302 2.42773 9.57113 2.25 12.0003 2.25C14.4292 2.25 16.8171 2.4277\n          19.1516 2.77091C21.1299 3.06177 22.5 4.79445 22.5 6.74056V12.7595C22.5 14.7056 21.1299\n          16.4383 19.1516 16.7291C17.2123 17.0142 15.2361 17.1851 13.2302 17.2348C13.1266 17.2374\n          13.0318 17.2788 12.9638 17.3468L8.78033 21.5303C8.56583 21.7448 8.24324 21.809 7.96299\n          21.6929C7.68273 21.5768 7.5 21.3034 7.5 21V17.045C6.60901 16.9634 5.72491 16.8579 4.84836\n          16.729C2.87004 16.4381 1.5 14.7054 1.5 12.7593V6.74064C1.5 4.79455 2.87005 3.06188\n          4.84836 2.771Z",
			fill: "currentColor"
		}), Fi.map((e, t) => /* @__PURE__ */ G("ellipse", {
			cx: e,
			cy: "9.81825",
			rx: "1.63636",
			ry: "1.63636",
			fill: "white",
			style: { animationDelay: `${t * .3}s` }
		}, e))]
	})
}), Li = (e) => e.cause?.status === 403 ? "teiaSearchFilterEditor.ai.errors.no_more_token.text" : "teiaSearchFilterEditor.ai.errors.default.text", Ri = (t) => {
	let { twin: n, onGenerate: r } = t, { t: i } = h("teiaviewer"), [a, o] = f(""), { mutate: s, isPending: c, error: l, reset: u } = Pi(), d = a.trim() === "" || c, p = () => {
		d || s({
			filterDescription: a.trim(),
			projectId: n.projectId,
			twinProjectType: n.type
		}, { onSuccess: (e) => r(e.filter) });
	};
	return /* @__PURE__ */ K(e, {
		spacing: 1,
		sx: {
			position: "relative",
			p: 2,
			borderRadius: 1,
			"&::before": {
				content: "\"\"",
				position: "absolute",
				inset: 0,
				borderRadius: 1,
				padding: "2px",
				background: (e) => `linear-gradient(90deg, ${e.palette.ia.primary},
            ${e.palette.ia.secondary}, ${e.palette.ia.primary})`,
				backgroundSize: "300% 300%",
				animation: "teia-search-filter-ai-border 4s linear infinite",
				mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
				WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
				maskComposite: "exclude",
				WebkitMaskComposite: "xor",
				pointerEvents: "none"
			},
			"@keyframes teia-search-filter-ai-border": {
				"0%, 100%": { backgroundPosition: "0% 50%" },
				"50%": { backgroundPosition: "100% 50%" }
			}
		},
		children: [
			!!l && /* @__PURE__ */ G(m, {
				severity: "error",
				"data-testid": "search-filter-ai-error",
				children: i(Li(l))
			}),
			/* @__PURE__ */ K(e, {
				direction: "row",
				spacing: 2,
				alignItems: "center",
				children: [
					/* @__PURE__ */ G(Ii, {}),
					/* @__PURE__ */ G(xt, {
						sx: { width: 1 },
						placeholder: i("teiaSearchFilterEditor.ai.textarea.placeholder"),
						value: a,
						disabled: c,
						rows: void 0,
						maxRows: 5,
						onChange: (e) => {
							o(e.target.value), u();
						},
						onKeyDown: (e) => {
							e.stopPropagation(), e.key === "Enter" && !e.shiftKey && (e.preventDefault(), p());
						},
						slotProps: { htmlInput: { "data-testid": "search-filter-ai-textarea" } },
						"data-dd-action-name": "teiaSearchFilterEditor.ai.textarea"
					}),
					c ? /* @__PURE__ */ G(yt, { size: 24 }) : /* @__PURE__ */ G(v, {
						icon: Ni,
						"aria-label": i("teiaSearchFilterEditor.ai.generate_button.label"),
						onClick: p,
						disabled: d,
						"data-testid": "search-filter-ai-generate-button",
						"data-dd-action-name": "teiaSearchFilterEditor.ai.generate_button"
					})
				]
			}),
			/* @__PURE__ */ G(S, {
				variant: "caption",
				sx: { color: "text.disabled" },
				children: i("teiaSearchFilterEditor.ai.disclaimer.text")
			})
		]
	});
}, zi = (e) => /* @__PURE__ */ K("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.125 3.05078C5.91789 3.05078 5.75 3.21867 5.75 3.42578V20.6758C5.75 20.8829 5.91789 21.0508 6.125 21.0508H18.875C19.0821 21.0508 19.25 20.8829 19.25 20.6758V11.6758C19.25 10.226 18.0747 9.05078 16.625 9.05078H15.125C14.0895 9.05078 13.25 8.21132 13.25 7.17578V5.67578C13.25 4.22603 12.0747 3.05078 10.625 3.05078H6.125ZM6.125 1.55078C5.08947 1.55078 4.25 2.39025 4.25 3.42578V20.6758C4.25 21.7113 5.08947 22.5508 6.125 22.5508H18.875C19.9105 22.5508 20.75 21.7113 20.75 20.6758V11.3008C20.75 5.91601 16.3848 1.55078 11 1.55078H6.125ZM14.257 3.71863C14.5715 4.30097 14.75 4.96753 14.75 5.67578V7.17578C14.75 7.38289 14.9179 7.55078 15.125 7.55078H16.625C17.3332 7.55078 17.9998 7.72928 18.5822 8.04374C17.7488 6.10627 16.1945 4.55201 14.257 3.71863Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ G("path", {
			d: "M1 12.3027C1 11.1982 1.89543 10.3027 3 10.3027H20.9997C22.1043 10.3027 22.9997 11.1982 22.9997 12.3027V17.3027C22.9997 18.4073 22.1043 19.3027 20.9997 19.3027H3C1.89543 19.3027 1 18.4073 1 17.3027V12.3027Z",
			fill: "#5D7DFF"
		}),
		/* @__PURE__ */ G("path", {
			d: "M5.19475 12.411H6.25867V15.9608C6.25867 16.2889 6.18492 16.5739 6.03743 16.8159C5.8916 17.0578 5.68859 17.2443 5.42841 17.3752C5.16823 17.5061 4.8658 17.5716 4.5211 17.5716C4.21452 17.5716 3.93611 17.5177 3.68587 17.41C3.43729 17.3006 3.24009 17.1349 3.09425 16.9128C2.94842 16.6891 2.87633 16.4082 2.87799 16.0701H3.94937C3.95268 16.2044 3.98002 16.3195 4.0314 16.4157C4.08443 16.5101 4.15652 16.583 4.24766 16.6344C4.34046 16.6841 4.44984 16.709 4.57579 16.709C4.70836 16.709 4.82022 16.6808 4.91137 16.6245C5.00417 16.5665 5.0746 16.4819 5.12266 16.3709C5.17072 16.2599 5.19475 16.1232 5.19475 15.9608V12.411ZM9.7003 13.8752C9.68042 13.6747 9.59507 13.5189 9.44427 13.4078C9.29346 13.2968 9.0888 13.2413 8.83027 13.2413C8.65461 13.2413 8.50629 13.2662 8.38532 13.3159C8.26434 13.3639 8.17154 13.431 8.10691 13.5172C8.04393 13.6034 8.01245 13.7012 8.01245 13.8105C8.00913 13.9017 8.02819 13.9812 8.06962 14.0492C8.11271 14.1171 8.17154 14.176 8.24611 14.2257C8.32069 14.2737 8.40686 14.316 8.50464 14.3525C8.60241 14.3873 8.70681 14.4171 8.81785 14.4419L9.27523 14.5513C9.4973 14.601 9.70113 14.6673 9.88674 14.7502C10.0723 14.833 10.2331 14.935 10.369 15.0559C10.5049 15.1769 10.6101 15.3194 10.6847 15.4835C10.7609 15.6475 10.7999 15.8356 10.8015 16.0478C10.7999 16.3593 10.7203 16.6294 10.5629 16.8581C10.4071 17.0852 10.1817 17.2617 9.88674 17.3876C9.59341 17.5119 9.2396 17.574 8.8253 17.574C8.41432 17.574 8.05636 17.5111 7.75144 17.3851C7.44817 17.2592 7.21119 17.0727 7.0405 16.8258C6.87147 16.5772 6.78281 16.2698 6.77452 15.9036H7.81607C7.82767 16.0743 7.87656 16.2168 7.96273 16.3311C8.05056 16.4438 8.1674 16.5292 8.31323 16.5872C8.46072 16.6435 8.62727 16.6717 8.81287 16.6717C8.99517 16.6717 9.15343 16.6452 9.28766 16.5922C9.42355 16.5391 9.52878 16.4654 9.60336 16.3709C9.67793 16.2765 9.71522 16.1679 9.71522 16.0453C9.71522 15.9309 9.68125 15.8348 9.6133 15.7569C9.54701 15.679 9.44924 15.6127 9.31998 15.5581C9.19237 15.5034 9.03577 15.4537 8.85016 15.4089L8.29583 15.2697C7.86661 15.1653 7.52772 15.0021 7.27914 14.78C7.03056 14.5579 6.9071 14.2588 6.90875 13.8826C6.9071 13.5744 6.98913 13.3051 7.15485 13.0748C7.32223 12.8444 7.55175 12.6646 7.84341 12.5353C8.13508 12.4061 8.46652 12.3414 8.83773 12.3414C9.21557 12.3414 9.54536 12.4061 9.82708 12.5353C10.1105 12.6646 10.3309 12.8444 10.4883 13.0748C10.6457 13.3051 10.7269 13.5719 10.7319 13.8752H9.7003ZM15.9938 14.9565C15.9938 15.5117 15.8885 15.984 15.6781 16.3734C15.4693 16.7628 15.1842 17.0603 14.823 17.2658C14.4633 17.4696 14.059 17.5716 13.6099 17.5716C13.1575 17.5716 12.7515 17.4688 12.3918 17.2633C12.0322 17.0578 11.748 16.7604 11.5392 16.3709C11.3304 15.9815 11.226 15.51 11.226 14.9565C11.226 14.4013 11.3304 13.929 11.5392 13.5396C11.748 13.1502 12.0322 12.8535 12.3918 12.6497C12.7515 12.4442 13.1575 12.3414 13.6099 12.3414C14.059 12.3414 14.4633 12.4442 14.823 12.6497C15.1842 12.8535 15.4693 13.1502 15.6781 13.5396C15.8885 13.929 15.9938 14.4013 15.9938 14.9565ZM14.9025 14.9565C14.9025 14.5969 14.8486 14.2936 14.7409 14.0467C14.6349 13.7998 14.4849 13.6125 14.291 13.4849C14.0971 13.3573 13.8701 13.2935 13.6099 13.2935C13.3497 13.2935 13.1227 13.3573 12.9288 13.4849C12.7349 13.6125 12.5841 13.7998 12.4764 14.0467C12.3703 14.2936 12.3173 14.5969 12.3173 14.9565C12.3173 15.3161 12.3703 15.6194 12.4764 15.8663C12.5841 16.1132 12.7349 16.3005 12.9288 16.4281C13.1227 16.5557 13.3497 16.6195 13.6099 16.6195C13.8701 16.6195 14.0971 16.5557 14.291 16.4281C14.4849 16.3005 14.6349 16.1132 14.7409 15.8663C14.8486 15.6194 14.9025 15.3161 14.9025 14.9565ZM20.8393 12.411V17.502H19.9096L17.6947 14.2978H17.6574V17.502H16.5811V12.411H17.5257L19.7231 15.6127H19.7679V12.411H20.8393Z",
			fill: "white"
		})
	]
}), Bi = (e) => /* @__PURE__ */ K("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ K("g", {
		clipPath: "url(#clip0_7676_45640)",
		children: [
			/* @__PURE__ */ G("path", {
				d: "M16.4881 7.34C16.2681 7.12 15.9881 7.02 15.7081 7.02C15.4281 7.02 15.1381 7.13 14.9281 7.34L1.83812 20.43C1.40812 20.86 1.40812 21.56 1.83812 22L2.51812 22.68C2.94812 23.11 3.64812 23.11 4.08812 22.68L17.1781 9.59C17.6081 9.16 17.6081 8.46 17.1781 8.02L16.4981 7.34H16.4881ZM16.2681 8.91L13.2681 11.95L12.5981 11.28L15.5981 8.24C15.5981 8.24 15.6481 8.21 15.6781 8.21C15.7081 8.21 15.7381 8.22 15.7581 8.24L16.2781 8.76C16.2781 8.76 16.3081 8.81 16.3081 8.84C16.3081 8.87 16.2981 8.9 16.2781 8.92L16.2681 8.91Z",
				fill: "#5D7DFF"
			}),
			/* @__PURE__ */ G("path", {
				d: "M9.69812 4.96L11.7481 7.01C11.8881 7.15 12.0681 7.22 12.2481 7.22C12.4281 7.22 12.6081 7.15 12.7481 7.01C13.0181 6.74 13.0181 6.29 12.7481 6.02L10.6981 3.97C10.4281 3.7 9.97813 3.7 9.70813 3.97C9.43813 4.24 9.43813 4.69 9.70813 4.96H9.69812Z",
				fill: "#5D7DFF"
			}),
			/* @__PURE__ */ G("path", {
				d: "M9.09812 4.01C9.17812 4.01 9.26813 3.99 9.34812 3.96C9.42812 3.93 9.49813 3.88 9.55813 3.82C9.67813 3.7 9.74813 3.53 9.74813 3.36C9.74813 3.19 9.67813 3.02 9.55813 2.9C9.49813 2.84 9.42812 2.79 9.34812 2.76C9.10813 2.66 8.81812 2.72 8.63812 2.9C8.51813 3.02 8.44812 3.19 8.44812 3.36C8.44812 3.53 8.51813 3.7 8.63812 3.82C8.75812 3.94 8.92812 4.01 9.09812 4.01Z",
				fill: "#5D7DFF"
			}),
			/* @__PURE__ */ G("path", {
				d: "M18.1181 7C18.2981 7 18.4781 6.93 18.6181 6.79L20.6681 4.74C20.9381 4.47 20.9381 4.02 20.6681 3.75C20.3981 3.48 19.9481 3.48 19.6781 3.75L17.6281 5.8C17.3581 6.07 17.3581 6.52 17.6281 6.79C17.7681 6.93 17.9481 7 18.1281 7H18.1181Z",
				fill: "#5D7DFF"
			}),
			/* @__PURE__ */ G("path", {
				d: "M21.2681 3.8C21.3581 3.8 21.4381 3.79 21.5181 3.75C21.5981 3.72 21.6681 3.67 21.7281 3.61C21.8481 3.49 21.9181 3.32 21.9181 3.15C21.9181 2.98 21.8481 2.81 21.7281 2.69C21.4881 2.45 21.0581 2.45 20.8081 2.69C20.6881 2.82 20.6181 2.98 20.6181 3.15C20.6181 3.32 20.6881 3.49 20.8081 3.61C20.9281 3.73 21.0981 3.8 21.2681 3.8Z",
				fill: "#5D7DFF"
			}),
			/* @__PURE__ */ G("path", {
				d: "M20.5181 13.79L18.4681 11.74C18.1981 11.47 17.7481 11.47 17.4781 11.74C17.2081 12.01 17.2081 12.46 17.4781 12.73L19.5281 14.78C19.6681 14.92 19.8481 14.99 20.0281 14.99C20.2081 14.99 20.3881 14.92 20.5281 14.78C20.7981 14.51 20.7981 14.06 20.5281 13.79H20.5181Z",
				fill: "#5D7DFF"
			}),
			/* @__PURE__ */ G("path", {
				d: "M20.6681 14.93C20.5481 15.05 20.4781 15.22 20.4781 15.39C20.4781 15.56 20.5481 15.73 20.6681 15.85C20.7881 15.97 20.9581 16.04 21.1281 16.04C21.2981 16.04 21.4681 15.97 21.5881 15.85C21.7081 15.73 21.7781 15.56 21.7781 15.39C21.7781 15.22 21.7081 15.05 21.5881 14.93C21.3481 14.69 20.9081 14.69 20.6681 14.93Z",
				fill: "#5D7DFF"
			}),
			/* @__PURE__ */ G("path", {
				d: "M8.25813 10.1H11.1481C11.5381 10.1 11.8481 9.79 11.8481 9.4C11.8481 9.01 11.5381 8.7 11.1481 8.7H8.25813C7.86813 8.7 7.55813 9.01 7.55813 9.4C7.55813 9.79 7.86813 10.1 8.25813 10.1Z",
				fill: "#5D7DFF"
			}),
			/* @__PURE__ */ G("path", {
				d: "M15.1581 5.79C15.5481 5.79 15.8581 5.48 15.8581 5.09V2.2C15.8581 1.81 15.5481 1.5 15.1581 1.5C14.7681 1.5 14.4581 1.81 14.4581 2.2V5.09C14.4581 5.48 14.7681 5.79 15.1581 5.79Z",
				fill: "#5D7DFF"
			}),
			/* @__PURE__ */ G("path", {
				d: "M15.1581 12.87C14.7681 12.87 14.4581 13.18 14.4581 13.57V16.46C14.4581 16.85 14.7681 17.16 15.1581 17.16C15.5481 17.16 15.8581 16.85 15.8581 16.46V13.57C15.8581 13.18 15.5481 12.87 15.1581 12.87Z",
				fill: "#5D7DFF"
			}),
			/* @__PURE__ */ G("path", {
				d: "M22.1481 8.7H19.2581C18.8681 8.7 18.5581 9.01 18.5581 9.4C18.5581 9.79 18.8681 10.1 19.2581 10.1H22.1481C22.5381 10.1 22.8481 9.79 22.8481 9.4C22.8481 9.01 22.5381 8.7 22.1481 8.7Z",
				fill: "#5D7DFF"
			})
		]
	}), /* @__PURE__ */ G("defs", { children: /* @__PURE__ */ G("clipPath", {
		id: "clip0_7676_45640",
		children: /* @__PURE__ */ G("rect", {
			width: 21.35,
			height: 21.51,
			fill: "white",
			transform: "translate(1.5 1.5)"
		})
	}) })]
}), Vi = () => `filter-${(/* @__PURE__ */ new Date()).toISOString().slice(0, 10)}.json`, Hi = (e) => {
	let { onClose: t, text: n } = e, { t: r } = h("teiaviewer"), [i, a] = f(Vi);
	return /* @__PURE__ */ K(Et, {
		open: !0,
		onClose: t,
		children: [
			/* @__PURE__ */ G(kt, { children: r("teiaSearchFilterEditor.json.download_modal.title") }),
			/* @__PURE__ */ G(Dt, { children: /* @__PURE__ */ G(y, {
				sx: { mt: 1 },
				label: r("teiaSearchFilterEditor.json.download_modal.file_name.label"),
				value: i,
				onChange: (e) => a(e.target.value),
				onKeyDown: (e) => e.stopPropagation(),
				slotProps: { htmlInput: { "data-testid": "search-filter-json-file-name-input" } }
			}) }),
			/* @__PURE__ */ K(Ot, { children: [/* @__PURE__ */ G(Z, {
				variant: "secondary",
				onClick: t,
				"data-dd-action-name": "teiaSearchFilterEditor.json.download_modal.cancel_button",
				children: r("teiaSearchFilterEditor.json.download_modal.cancel_button.text")
			}), /* @__PURE__ */ G(Z, {
				variant: "primary",
				onClick: () => {
					let e = URL.createObjectURL(new Blob([n], { type: "application/json" })), r = document.createElement("a");
					r.href = e, r.download = i.trim() === "" ? Vi() : i.trim(), r.click(), URL.revokeObjectURL(e), t();
				},
				"data-testid": "search-filter-json-download-confirm-button",
				"data-dd-action-name": "teiaSearchFilterEditor.json.download_modal.confirm_button",
				children: r("teiaSearchFilterEditor.json.download_modal.confirm_button.text")
			})] })
		]
	});
}, Ui = (e) => JSON.stringify(e, null, 2), Wi = (e) => {
	let t = JSON.parse(e);
	if (typeof t != "object" || !t || Array.isArray(t)) throw TypeError("The filter must be a JSON object");
	return t;
}, Gi = (e, t) => {
	let [n, r] = f(() => Ui(e)), [i, a] = f(""), [o, s] = f(e);
	e !== o && (s(e), r(Ui(e)), a(""));
	let c = (e) => {
		try {
			let t = Wi(e);
			return a(""), t;
		} catch (e) {
			a(e instanceof Error ? e.message : String(e));
			return;
		}
	};
	return {
		text: n,
		error: i,
		setText: (e) => {
			r(e), c(e);
		},
		format: () => {
			let e = c(n);
			e && r(Ui(e));
		},
		apply: () => {
			let e = c(n);
			e && t?.(e);
		}
	};
}, Ki = [Ct()], qi = (t) => {
	let { filter: n, onChange: r } = t, { t: i } = h("teiaviewer"), { text: a, error: o, setText: s, format: c, apply: l } = Gi(n, r), [u, d] = f(!1);
	return /* @__PURE__ */ K(wt, {
		sx: {
			p: 2,
			boxShadow: 4
		},
		children: [/* @__PURE__ */ K(e, {
			spacing: 2,
			children: [!!o && /* @__PURE__ */ G(m, {
				severity: "error",
				"data-testid": "search-filter-json-error",
				sx: {
					width: 0,
					minWidth: "100%",
					boxSizing: "border-box"
				},
				children: o
			}), /* @__PURE__ */ K(e, {
				direction: "row",
				spacing: 2,
				children: [/* @__PURE__ */ G(Tt, {
					value: a,
					onChange: s,
					onKeyDown: (e) => e.stopPropagation(),
					extensions: Ki,
					theme: "light",
					height: "240px",
					width: "400px",
					basicSetup: {
						lineNumbers: !0,
						foldGutter: !0,
						highlightActiveLine: !0
					},
					style: {
						fontSize: 13,
						border: "1px solid lightgray"
					}
				}), /* @__PURE__ */ K(e, {
					justifyContent: "space-between",
					alignItems: "center",
					children: [/* @__PURE__ */ K(e, {
						spacing: 1,
						children: [
							/* @__PURE__ */ G(Ji, { text: a }),
							/* @__PURE__ */ G(b, {
								title: i("teiaSearchFilterEditor.json.download_button.label"),
								children: /* @__PURE__ */ G(v, {
									icon: $n,
									"aria-label": i("teiaSearchFilterEditor.json.download_button.label"),
									onClick: () => d(!0),
									"data-testid": "search-filter-json-download-button",
									"data-dd-action-name": "teiaSearchFilterEditor.json.download_button"
								})
							}),
							/* @__PURE__ */ G(b, {
								title: i("teiaSearchFilterEditor.json.format_button.label"),
								children: /* @__PURE__ */ G(v, {
									icon: Bi,
									"aria-label": i("teiaSearchFilterEditor.json.format_button.label"),
									onClick: c,
									"data-testid": "search-filter-json-format-button",
									"data-dd-action-name": "teiaSearchFilterEditor.json.format_button"
								})
							})
						]
					}), /* @__PURE__ */ G(b, {
						title: i("teiaSearchFilterEditor.json.apply_button.label"),
						children: /* @__PURE__ */ G(v, {
							variant: "primary",
							icon: jr,
							"aria-label": i("teiaSearchFilterEditor.json.apply_button.label"),
							onClick: l,
							"data-testid": "search-filter-json-apply-button",
							"data-dd-action-name": "teiaSearchFilterEditor.json.apply_button"
						})
					})]
				})]
			})]
		}), !!u && /* @__PURE__ */ G(Hi, {
			text: a,
			onClose: () => d(!1)
		})]
	});
}, Ji = (e) => {
	let { text: t } = e, { t: n } = h("teiaviewer"), [r, i] = f(!1);
	c(() => {
		if (!r) return;
		let e = setTimeout(() => i(!1), 2e3);
		return () => clearTimeout(e);
	}, [r]);
	let a = async () => {
		await navigator.clipboard.writeText(t), i(!0);
	}, o = n(r ? "teiaSearchFilterEditor.json.copy_button.copied_label" : "teiaSearchFilterEditor.json.copy_button.label");
	return /* @__PURE__ */ G(b, {
		title: o,
		children: /* @__PURE__ */ G(v, {
			icon: r ? ar : sr,
			"aria-label": o,
			onClick: a,
			"data-testid": "search-filter-json-copy-button",
			"data-dd-action-name": "teiaSearchFilterEditor.json.copy_button"
		})
	});
}, Yi = (e) => {
	let { filter: t, onChange: n } = e, { t: r } = h("teiaviewer"), [i, a] = f(null);
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(b, {
		title: r("teiaSearchFilterEditor.json.button.label"),
		children: /* @__PURE__ */ G(v, {
			icon: zi,
			"aria-label": r("teiaSearchFilterEditor.json.button.label"),
			onClick: (e) => {
				let t = e.currentTarget;
				t.blur(), a((e) => e ? null : t);
			},
			"data-testid": "search-filter-json-button",
			"data-dd-action-name": "teiaSearchFilterEditor.json.button"
		})
	}), /* @__PURE__ */ G(St, {
		open: !!i,
		anchorEl: i,
		placement: "bottom-end",
		sx: { zIndex: 9999 },
		modifiers: [{
			name: "offset",
			options: { offset: [0, 8] }
		}],
		children: /* @__PURE__ */ G(qi, {
			filter: t,
			onChange: n
		})
	})] });
}, Xi = {}, Zi = (t) => {
	let { twin: n, defaultFilter: r = Xi, defaultGroupOperator: i, onChange: a, enableJsonEditor: o = !1, enableAI: s = !1, ...c } = t, [l, u] = f(!1), d = s && !!n, p = (e) => {
		a?.(e, Ti(e, i));
	};
	return /* @__PURE__ */ K(e, {
		spacing: 1,
		children: [
			!!(o || d) && /* @__PURE__ */ K(e, {
				direction: "row",
				spacing: 1,
				alignItems: "center",
				justifyContent: "flex-end",
				children: [!!d && /* @__PURE__ */ G(ki, { onClick: () => u((e) => !e) }), !!o && /* @__PURE__ */ G(Yi, {
					filter: r,
					onChange: p
				})]
			}),
			!!d && !!l && /* @__PURE__ */ G(Ri, {
				twin: n,
				onGenerate: p
			}),
			/* @__PURE__ */ G(wi, {
				...c,
				twin: n,
				defaultFilter: r,
				defaultGroupOperator: i,
				onChange: a
			})
		]
	});
}, Qi = (e = null) => {
	let { plugin: t } = U("Teia"), n = () => e === null || t.currentSource?.sourceType === e ? t.currentSource : null, [r, i] = f(n());
	return c(() => {
		let e = () => {
			i(n());
		};
		return t.signals.onSourceChanged.connect(e), () => {
			t.signals.onSourceChanged.disconnect(e);
		};
	}, []), r;
}, $i = () => Qi(nt.Twin) !== null, ea = () => {
	let e = Qi(nt.Twin);
	if (!e) throw Error("Twin is not a source of the viewer.");
	return e;
}, ta = (e) => /* @__PURE__ */ K("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ G("path", { d: "M21 7.27H21.2L12.2 2.07C12 1.97 11.7 1.97 11.4 2.07L2.4 7.27C2.2 7.37 2 7.67 2 7.87V16.87C2 17.17 2.1 17.37 2.4 17.47L11 22.47V11.77L4.2 7.87L11.7 3.47L19.2 7.87L12.4 11.77V22.47L21 17.47C21.2 17.37 21.4 17.07 21.4 16.87V7.87C21.4 7.57 21.3 7.37 21 7.27ZM5.32 11.5L6.39 13.65L7.47 12.74L8.91 13.57L7.09 15.01L9.12 18.97L7.35 17.95L6.22 15.69L5.08 16.64L3.64 15.81L5.51 14.32L3.54 10.47L5.31 11.49L5.32 11.5ZM19.51 12.14L17.32 13.42V14.13L19.38 12.92V14.19L17.32 15.4V17.47L15.99 18.25V12.92L19.51 10.86V12.14Z" }), /* @__PURE__ */ G("path", { d: "M15.02 7.79C15.03 7.23 14.65 6.7 13.89 6.23C13.16 5.78 12.36 5.55 11.56 5.56C10.74 5.56 9.94 5.8 9.19 6.26L7.26 7.45L12.09 10.42L13.83 9.35C14.61 8.87 15.02 8.34 15.03 7.78L15.02 7.79ZM10.03 7.09C10.97 6.52 11.89 6.52 12.85 7.11C13.29 7.38 13.52 7.65 13.52 7.87C13.52 8.15 13.17 8.42 12.88 8.6L12.23 9L9.57 7.36L10.02 7.08L10.03 7.09Z" })]
}), na = () => {
	let { viewer: e } = H(), { t } = h("teiaviewer"), n = Qi(), { isOpened: r } = le("FloorPlan"), i = re("FloorPlan");
	return /* @__PURE__ */ G(B, {
		"data-testid": "floor-plan-toolbar-item",
		active: r,
		disabled: !i || n?.sourceType !== nt.Twin,
		"data-dd-action-name": `teia.toolbar.floor_plan.${r ? "close" : "open"}`,
		label: t("toolbar.export_plan.tooltip"),
		onClick: () => {
			new D(e, "FloorPlan").execute();
		},
		icon: ta
	});
}, ra = (e) => /* @__PURE__ */ G("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ G("path", { d: "M21 7.25012H2.99999C2.05999 7.25012 1.29999 8.01012 1.29999 8.95012V16.9501C1.29999 17.8901 2.05999 18.6501 2.99999 18.6501H21C21.94 18.6501 22.7 17.8901 22.7 16.9501V8.95012C22.7 8.01012 21.94 7.25012 21 7.25012ZM5.39999 12.6501H6.59999C6.65999 12.6501 6.69999 12.6101 6.69999 12.5501V8.65012H9.29999V12.5501C9.29999 12.6101 9.33999 12.6501 9.39999 12.6501H10.6C10.66 12.6501 10.7 12.6101 10.7 12.5501V8.65012H13.3V12.5501C13.3 12.6101 13.34 12.6501 13.4 12.6501H14.6C14.66 12.6501 14.7 12.6101 14.7 12.5501V8.65012H17.3V12.5501C17.3 12.6101 17.34 12.6501 17.4 12.6501H18.6C18.66 12.6501 18.7 12.6101 18.7 12.5501V8.65012H21.3V17.2501H2.69999V8.65012H5.29999V12.5501C5.29999 12.6101 5.33999 12.6501 5.39999 12.6501Z" })
}), ia = () => {
	let { viewport: e } = ce(), { viewer: t } = H(), n = re("MeasureLine"), [r, i] = f(!1), [a, o] = f(null), { t: s } = h("teiaviewer");
	return c(() => {
		let e = () => {
			i(!1);
		};
		return t.signals.onSceneReset.connect(e), () => {
			t.signals.onSceneReset.disconnect(e);
		};
	}, []), c(() => {
		let e = (e) => {
			e.name !== "MeasureLinesOperator" && i(!1);
		};
		return t.signals.onOperatorChanged.connect(e), () => {
			t.signals.onOperatorChanged.disconnect(e);
		};
	}, []), /* @__PURE__ */ G(B, {
		"data-testid": "measure-line-toolbar-item",
		icon: ra,
		label: s("toolbar.measure_lines.tooltip"),
		"data-dd-action-name": "toolbar.measure_lines",
		onClick: () => {
			let n = a;
			n || (n = new Me(e), o(n)), r ? (i(!1), e.resetDefaultOperator()) : (new jt(t).execute(), i(!0), e.setOperator(n), e.canvas.focus());
		},
		active: r,
		disabled: !n
	});
}, aa = () => {
	let { viewer: e } = H(), { isOpened: t } = le("NavigationGraph"), n = re("Path"), { t: r } = h("teiaviewer");
	return /* @__PURE__ */ G(B, {
		"data-testid": "navigation-graph-toolbar-item",
		icon: Fr,
		label: r("teia.widgets.navigation_widget.title"),
		active: t,
		disabled: !n,
		onClick: () => new D(e, "NavigationGraph").execute()
	});
}, oa = (e) => /* @__PURE__ */ G("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ G("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.2617 2.25C12.6759 2.25 13.0117 2.58579 13.0117 3V14.6893L16.2314 11.4697C16.5243 11.1768 16.9992 11.1768 17.292 11.4697C17.5849 11.7626 17.5849 12.2374 17.292 12.5303L12.792 17.0303C12.4992 17.3232 12.0243 17.3232 11.7314 17.0303L7.23139 12.5303C6.9385 12.2374 6.9385 11.7626 7.23139 11.4697C7.52428 11.1768 7.99916 11.1768 8.29205 11.4697L11.5117 14.6893V3C11.5117 2.58579 11.8475 2.25 12.2617 2.25ZM3.26172 15.75C3.67593 15.75 4.01172 16.0858 4.01172 16.5V18.75C4.01172 19.5784 4.68329 20.25 5.51172 20.25H19.0117C19.8401 20.25 20.5117 19.5784 20.5117 18.75V16.5C20.5117 16.0858 20.8475 15.75 21.2617 15.75C21.6759 15.75 22.0117 16.0858 22.0117 16.5V18.75C22.0117 20.4069 20.6686 21.75 19.0117 21.75H5.51172C3.85486 21.75 2.51172 20.4069 2.51172 18.75V16.5C2.51172 16.0858 2.84751 15.75 3.26172 15.75Z"
	})
}), sa = (e) => /* @__PURE__ */ K("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", { d: "M5.46484 18.4105H18.9648V20.098H5.46484V18.4105Z" }),
		/* @__PURE__ */ G("path", { d: "M9.35938 8.41633H15.0703V16.4632H9.35938V8.41633Z" }),
		/* @__PURE__ */ G("path", { d: "M5.59766 10.5218L12.2181 3.90137L18.8385 10.5218H5.59766Z" })
	]
}), ca = (e) => /* @__PURE__ */ K("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", { d: "M6.32469 15.0853C6.45469 15.2153 6.63469 15.2853 6.81469 15.2853C6.99469 15.2853 7.17469 15.2153 7.30469 15.0853C7.57469 14.8153 7.57469 14.3753 7.30469 14.1053L6.39469 13.1953H11.7047V18.5053L10.7947 17.5953C10.6647 17.4653 10.4847 17.3953 10.3047 17.3953C10.1247 17.3953 9.94469 17.4653 9.81469 17.5953C9.54469 17.8653 9.54469 18.3053 9.81469 18.5753L11.9147 20.6753C12.0447 20.8053 12.2247 20.8753 12.4047 20.8753C12.5847 20.8753 12.7647 20.8053 12.8947 20.6753L14.9947 18.5753C15.2647 18.3053 15.2647 17.8653 14.9947 17.5953C14.8647 17.4653 14.6847 17.3953 14.5047 17.3953C14.3247 17.3953 14.1447 17.4653 14.0147 17.5953L13.1047 18.5053V13.1953H18.4147L17.5047 14.1053C17.2347 14.3753 17.2347 14.8153 17.5047 15.0853C17.6347 15.2153 17.8147 15.2853 17.9947 15.2853C18.1747 15.2853 18.3547 15.2153 18.4847 15.0853L20.5847 12.9853C20.8547 12.7153 20.8547 12.2753 20.5847 12.0053L18.4847 9.90527C18.3547 9.77527 18.1747 9.70527 17.9947 9.70527C17.8147 9.70527 17.6347 9.77527 17.5047 9.90527C17.2347 10.1753 17.2347 10.6153 17.5047 10.8853L18.4147 11.7953H13.1047V6.48527L14.0147 7.39527C14.1447 7.52527 14.3247 7.59527 14.5047 7.59527C14.6847 7.59527 14.8647 7.52527 14.9947 7.39527C15.2647 7.12527 15.2647 6.68527 14.9947 6.41527L12.8947 4.31527C12.7647 4.18527 12.5847 4.11527 12.4047 4.11527C12.2247 4.11527 12.0447 4.18527 11.9147 4.31527L9.81469 6.41527C9.54469 6.68527 9.54469 7.12527 9.81469 7.39527C9.94469 7.52527 10.1247 7.59527 10.3047 7.59527C10.4847 7.59527 10.6647 7.52527 10.7947 7.39527L11.7047 6.48527V11.7953H6.39469L7.30469 10.8853C7.57469 10.6153 7.57469 10.1753 7.30469 9.90527C7.17469 9.77527 6.99469 9.70527 6.81469 9.70527C6.63469 9.70527 6.45469 9.77527 6.32469 9.90527L4.22469 12.0053C3.95469 12.2753 3.95469 12.7153 4.22469 12.9853L6.32469 15.0853Z" }),
		/* @__PURE__ */ G("path", { d: "M21.8447 3.05527V6.83527H23.2447V1.65527H17.7847V3.05527H21.8447Z" }),
		/* @__PURE__ */ G("path", { d: "M21.8447 21.9453H17.7847V23.3453H23.2447V17.8753H21.8447V21.9453Z" }),
		/* @__PURE__ */ G("path", { d: "M2.95469 3.05527H7.04469V1.65527H1.55469V6.83527H2.95469V3.05527Z" }),
		/* @__PURE__ */ G("path", { d: "M2.95469 21.9453V17.8753H1.55469V23.3453H7.04469V21.9453H2.95469Z" })
	]
}), la = (e) => /* @__PURE__ */ K("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ G("path", { d: "M22.7346 6.46371L21.5046 5.23371C21.3046 5.03371 20.9446 5.03371 20.7546 5.23371C20.5446 5.44371 20.5446 5.78371 20.7546 5.98371L21.0746 6.30371H18.3946V3.61371L18.7146 3.93371C18.9146 4.13371 19.2746 4.13371 19.4646 3.93371C19.6746 3.72371 19.6746 3.38371 19.4646 3.18371L18.2346 1.95371C18.0346 1.75371 17.6746 1.75371 17.4846 1.95371L16.2546 3.18371C16.0446 3.39371 16.0446 3.73371 16.2546 3.93371C16.4546 4.13371 16.8146 4.13371 17.0046 3.93371L17.3246 3.61371V6.29371H14.6446L14.9646 5.97371C15.1746 5.76371 15.1746 5.42371 14.9646 5.22371C14.7646 5.02371 14.4046 5.02371 14.2146 5.22371L12.9846 6.45371C12.7746 6.66371 12.7746 7.00371 12.9846 7.20371L14.2146 8.43371C14.4146 8.63371 14.7746 8.63371 14.9646 8.43371C15.1746 8.22371 15.1746 7.88371 14.9646 7.68371L14.6446 7.36371H17.3246V10.0437L17.0046 9.72371C16.8046 9.52371 16.4446 9.52371 16.2546 9.72371C16.0446 9.93371 16.0446 10.2737 16.2546 10.4737L17.4846 11.7037C17.5846 11.8037 17.7246 11.8537 17.8646 11.8537C18.0046 11.8537 18.1446 11.7937 18.2446 11.7037L19.4746 10.4737C19.6846 10.2637 19.6846 9.92371 19.4746 9.72371C19.2746 9.52371 18.9146 9.52371 18.7246 9.72371L18.4046 10.0437V7.36371H21.0846L20.7646 7.68371C20.5546 7.89371 20.5546 8.23371 20.7646 8.43371C20.9646 8.63371 21.3246 8.63371 21.5146 8.43371L22.7446 7.20371C22.9546 6.99371 22.9546 6.65371 22.7446 6.45371L22.7346 6.46371Z" }), /* @__PURE__ */ G("path", { d: "M17.7146 14.1637L2.62457 6.22371C2.43457 6.12371 2.20457 6.30371 2.27457 6.51371L7.22457 22.8237C7.28457 23.0337 7.56457 23.0637 7.67457 22.8737L11.0746 17.0837C11.0746 17.0837 11.1446 16.9937 11.2046 16.9737L17.6846 14.6137C17.8846 14.5437 17.9046 14.2637 17.7146 14.1637Z" })]
}), ua = /* @__PURE__ */ $(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? r(e) : typeof define == "function" && define.amd ? define(["exports"], r) : r(n.URI = n.URI || {});
	})(e, (function(e) {
		function t() {
			var e = [...arguments];
			if (e.length > 1) {
				e[0] = e[0].slice(0, -1);
				for (var t = e.length - 1, n = 1; n < t; ++n) e[n] = e[n].slice(1, -1);
				return e[t] = e[t].slice(1), e.join("");
			}
			return e[0];
		}
		function n(e) {
			return "(?:" + e + ")";
		}
		function r(e) {
			return e === void 0 ? "undefined" : e === null ? "null" : Object.prototype.toString.call(e).split(" ").pop().split("]").shift().toLowerCase();
		}
		function i(e) {
			return e.toUpperCase();
		}
		function a(e) {
			return e == null ? [] : e instanceof Array ? e : typeof e.length != "number" || e.split || e.setInterval || e.call ? [e] : Array.prototype.slice.call(e);
		}
		function o(e, t) {
			var n = e;
			if (t) for (var r in t) n[r] = t[r];
			return n;
		}
		function s(e) {
			var r = "[A-Za-z]", i = "[0-9]", a = t(i, "[A-Fa-f]"), o = n(n("%[EFef]" + a + "%" + a + a + "%" + a + a) + "|" + n("%[89A-Fa-f]" + a + "%" + a + a) + "|" + n("%" + a + a)), s = "[\\:\\/\\?\\#\\[\\]\\@]", c = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", l = t(s, c), u = e ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", d = e ? "[\\uE000-\\uF8FF]" : "[]", f = t(r, i, "[\\-\\.\\_\\~]", u), p = n(r + t(r, i, "[\\+\\-\\.]") + "*"), m = n(n(o + "|" + t(f, c, "[\\:]")) + "*");
			n(n("25[0-5]") + "|" + n("2[0-4]" + i) + "|" + n("1" + i + i) + "|" + n("[1-9]" + i) + "|" + i);
			var h = n(n("25[0-5]") + "|" + n("2[0-4]" + i) + "|" + n("1" + i + i) + "|" + n("0?[1-9]" + i) + "|0?0?" + i), g = n(h + "\\." + h + "\\." + h + "\\." + h), _ = n(a + "{1,4}"), v = n(n(_ + "\\:" + _) + "|" + g), y = n([
				n(n(_ + "\\:") + "{6}" + v),
				n("\\:\\:" + n(_ + "\\:") + "{5}" + v),
				n(n(_) + "?\\:\\:" + n(_ + "\\:") + "{4}" + v),
				n(n(n(_ + "\\:") + "{0,1}" + _) + "?\\:\\:" + n(_ + "\\:") + "{3}" + v),
				n(n(n(_ + "\\:") + "{0,2}" + _) + "?\\:\\:" + n(_ + "\\:") + "{2}" + v),
				n(n(n(_ + "\\:") + "{0,3}" + _) + "?\\:\\:" + _ + "\\:" + v),
				n(n(n(_ + "\\:") + "{0,4}" + _) + "?\\:\\:" + v),
				n(n(n(_ + "\\:") + "{0,5}" + _) + "?\\:\\:" + _),
				n(n(n(_ + "\\:") + "{0,6}" + _) + "?\\:\\:")
			].join("|")), b = n(n(f + "|" + o) + "+");
			n(y + "\\%25" + b);
			var x = n(y + n("\\%25|\\%(?!" + a + "{2})") + b), S = n("[vV]" + a + "+\\." + t(f, c, "[\\:]") + "+"), C = n("\\[" + n(x + "|" + y + "|" + S) + "\\]"), w = n(n(o + "|" + t(f, c)) + "*"), T = n(C + "|" + g + "(?!" + w + ")|" + w), E = n(i + "*"), D = n(n(m + "@") + "?" + T + n("\\:" + E) + "?"), O = n(o + "|" + t(f, c, "[\\:\\@]")), k = n(O + "*"), A = n(O + "+"), j = n(n(o + "|" + t(f, c, "[\\@]")) + "+"), M = n(n("\\/" + k) + "*"), N = n("\\/" + n(A + M) + "?"), P = n(j + M), F = n(A + M), I = "(?!" + O + ")";
			n(M + "|" + N + "|" + P + "|" + F + "|" + I);
			var R = n(n(O + "|" + t("[\\/\\?]", d)) + "*"), z = n(n(O + "|[\\/\\?]") + "*"), B = n(n("\\/\\/" + D + M) + "|" + N + "|" + F + "|" + I), V = n(p + "\\:" + B + n("\\?" + R) + "?" + n("\\#" + z) + "?"), ee = n(n(n("\\/\\/" + D + M) + "|" + N + "|" + P + "|" + I) + n("\\?" + R) + "?" + n("\\#" + z) + "?");
			return n(V + "|" + ee), n(p + "\\:" + B + n("\\?" + R) + "?"), "" + p + n(n("\\/\\/(" + n("(" + m + ")@") + "?(" + T + ")" + n("\\:(" + E + ")") + "?)") + "?(" + M + "|" + N + "|" + F + "|" + I + ")") + n("\\?(" + R + ")") + n("\\#(" + z + ")"), "" + n(n("\\/\\/(" + n("(" + m + ")@") + "?(" + T + ")" + n("\\:(" + E + ")") + "?)") + "?(" + M + "|" + N + "|" + P + "|" + I + ")") + n("\\?(" + R + ")") + n("\\#(" + z + ")"), "" + p + n(n("\\/\\/(" + n("(" + m + ")@") + "?(" + T + ")" + n("\\:(" + E + ")") + "?)") + "?(" + M + "|" + N + "|" + F + "|" + I + ")") + n("\\?(" + R + ")"), "" + n("\\#(" + z + ")"), "" + n("(" + m + ")@") + T + n("\\:(" + E + ")"), {
				NOT_SCHEME: new RegExp(t("[^]", r, i, "[\\+\\-\\.]"), "g"),
				NOT_USERINFO: new RegExp(t("[^\\%\\:]", f, c), "g"),
				NOT_HOST: new RegExp(t("[^\\%\\[\\]\\:]", f, c), "g"),
				NOT_PATH: new RegExp(t("[^\\%\\/\\:\\@]", f, c), "g"),
				NOT_PATH_NOSCHEME: new RegExp(t("[^\\%\\/\\@]", f, c), "g"),
				NOT_QUERY: new RegExp(t("[^\\%]", f, c, "[\\:\\@\\/\\?]", d), "g"),
				NOT_FRAGMENT: new RegExp(t("[^\\%]", f, c, "[\\:\\@\\/\\?]"), "g"),
				ESCAPE: new RegExp(t("[^]", f, c), "g"),
				UNRESERVED: new RegExp(f, "g"),
				OTHER_CHARS: new RegExp(t("[^\\%]", f, l), "g"),
				PCT_ENCODED: new RegExp(o, "g"),
				IPV4ADDRESS: RegExp("^(" + g + ")$"),
				IPV6ADDRESS: RegExp("^\\[?(" + y + ")" + n(n("\\%25|\\%(?!" + a + "{2})") + "(" + b + ")") + "?\\]?$")
			};
		}
		var c = s(!1), l = s(!0), u = function() {
			function e(e, t) {
				var n = [], r = !0, i = !1, a = void 0;
				try {
					for (var o = e[Symbol.iterator](), s; !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t)); r = !0);
				} catch (e) {
					i = !0, a = e;
				} finally {
					try {
						!r && o.return && o.return();
					} finally {
						if (i) throw a;
					}
				}
				return n;
			}
			return function(t, n) {
				if (Array.isArray(t)) return t;
				if (Symbol.iterator in Object(t)) return e(t, n);
				throw TypeError("Invalid attempt to destructure non-iterable instance");
			};
		}(), d = function(e) {
			if (Array.isArray(e)) {
				for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
				return n;
			}
			return Array.from(e);
		}, f = 2147483647, p = 36, m = 1, h = 26, g = 38, _ = 700, v = 72, y = 128, b = "-", x = /^xn--/, S = /[^\0-\x7E]/, C = /[\x2E\u3002\uFF0E\uFF61]/g, w = {
			overflow: "Overflow: input needs wider integers to process",
			"not-basic": "Illegal input >= 0x80 (not a basic code point)",
			"invalid-input": "Invalid input"
		}, T = p - m, E = Math.floor, D = String.fromCharCode;
		function O(e) {
			throw RangeError(w[e]);
		}
		function k(e, t) {
			for (var n = [], r = e.length; r--;) n[r] = t(e[r]);
			return n;
		}
		function A(e, t) {
			var n = e.split("@"), r = "";
			n.length > 1 && (r = n[0] + "@", e = n[1]), e = e.replace(C, ".");
			var i = k(e.split("."), t).join(".");
			return r + i;
		}
		function j(e) {
			for (var t = [], n = 0, r = e.length; n < r;) {
				var i = e.charCodeAt(n++);
				if (i >= 55296 && i <= 56319 && n < r) {
					var a = e.charCodeAt(n++);
					(a & 64512) == 56320 ? t.push(((i & 1023) << 10) + (a & 1023) + 65536) : (t.push(i), n--);
				} else t.push(i);
			}
			return t;
		}
		var M = function(e) {
			return String.fromCodePoint.apply(String, d(e));
		}, N = function(e) {
			return e - 48 < 10 ? e - 22 : e - 65 < 26 ? e - 65 : e - 97 < 26 ? e - 97 : p;
		}, P = function(e, t) {
			return e + 22 + 75 * (e < 26) - ((t != 0) << 5);
		}, F = function(e, t, n) {
			var r = 0;
			for (e = n ? E(e / _) : e >> 1, e += E(e / t); e > T * h >> 1; r += p) e = E(e / T);
			return E(r + (T + 1) * e / (e + g));
		}, I = function(e) {
			var t = [], n = e.length, r = 0, i = y, a = v, o = e.lastIndexOf(b);
			o < 0 && (o = 0);
			for (var s = 0; s < o; ++s) e.charCodeAt(s) >= 128 && O("not-basic"), t.push(e.charCodeAt(s));
			for (var c = o > 0 ? o + 1 : 0; c < n;) {
				for (var l = r, u = 1, d = p;; d += p) {
					c >= n && O("invalid-input");
					var g = N(e.charCodeAt(c++));
					(g >= p || g > E((f - r) / u)) && O("overflow"), r += g * u;
					var _ = d <= a ? m : d >= a + h ? h : d - a;
					if (g < _) break;
					var x = p - _;
					u > E(f / x) && O("overflow"), u *= x;
				}
				var S = t.length + 1;
				a = F(r - l, S, l == 0), E(r / S) > f - i && O("overflow"), i += E(r / S), r %= S, t.splice(r++, 0, i);
			}
			return String.fromCodePoint.apply(String, t);
		}, R = function(e) {
			var t = [];
			e = j(e);
			var n = e.length, r = y, i = 0, a = v, o = !0, s = !1, c = void 0;
			try {
				for (var l = e[Symbol.iterator](), u; !(o = (u = l.next()).done); o = !0) {
					var d = u.value;
					d < 128 && t.push(D(d));
				}
			} catch (e) {
				s = !0, c = e;
			} finally {
				try {
					!o && l.return && l.return();
				} finally {
					if (s) throw c;
				}
			}
			var g = t.length, _ = g;
			for (g && t.push(b); _ < n;) {
				var x = f, S = !0, C = !1, w = void 0;
				try {
					for (var T = e[Symbol.iterator](), k; !(S = (k = T.next()).done); S = !0) {
						var A = k.value;
						A >= r && A < x && (x = A);
					}
				} catch (e) {
					C = !0, w = e;
				} finally {
					try {
						!S && T.return && T.return();
					} finally {
						if (C) throw w;
					}
				}
				var M = _ + 1;
				x - r > E((f - i) / M) && O("overflow"), i += (x - r) * M, r = x;
				var N = !0, I = !1, R = void 0;
				try {
					for (var z = e[Symbol.iterator](), B; !(N = (B = z.next()).done); N = !0) {
						var V = B.value;
						if (V < r && ++i > f && O("overflow"), V == r) {
							for (var ee = i, te = p;; te += p) {
								var ne = te <= a ? m : te >= a + h ? h : te - a;
								if (ee < ne) break;
								var re = ee - ne, ie = p - ne;
								t.push(D(P(ne + re % ie, 0))), ee = E(re / ie);
							}
							t.push(D(P(ee, 0))), a = F(i, M, _ == g), i = 0, ++_;
						}
					}
				} catch (e) {
					I = !0, R = e;
				} finally {
					try {
						!N && z.return && z.return();
					} finally {
						if (I) throw R;
					}
				}
				++i, ++r;
			}
			return t.join("");
		}, z = {
			version: "2.1.0",
			ucs2: {
				decode: j,
				encode: M
			},
			decode: I,
			encode: R,
			toASCII: function(e) {
				return A(e, function(e) {
					return S.test(e) ? "xn--" + R(e) : e;
				});
			},
			toUnicode: function(e) {
				return A(e, function(e) {
					return x.test(e) ? I(e.slice(4).toLowerCase()) : e;
				});
			}
		}, B = {};
		function V(e) {
			var t = e.charCodeAt(0), n = void 0;
			return n = t < 16 ? "%0" + t.toString(16).toUpperCase() : t < 128 ? "%" + t.toString(16).toUpperCase() : t < 2048 ? "%" + (t >> 6 | 192).toString(16).toUpperCase() + "%" + (t & 63 | 128).toString(16).toUpperCase() : "%" + (t >> 12 | 224).toString(16).toUpperCase() + "%" + (t >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (t & 63 | 128).toString(16).toUpperCase(), n;
		}
		function ee(e) {
			for (var t = "", n = 0, r = e.length; n < r;) {
				var i = parseInt(e.substr(n + 1, 2), 16);
				if (i < 128) t += String.fromCharCode(i), n += 3;
				else if (i >= 194 && i < 224) {
					if (r - n >= 6) {
						var a = parseInt(e.substr(n + 4, 2), 16);
						t += String.fromCharCode((i & 31) << 6 | a & 63);
					} else t += e.substr(n, 6);
					n += 6;
				} else if (i >= 224) {
					if (r - n >= 9) {
						var o = parseInt(e.substr(n + 4, 2), 16), s = parseInt(e.substr(n + 7, 2), 16);
						t += String.fromCharCode((i & 15) << 12 | (o & 63) << 6 | s & 63);
					} else t += e.substr(n, 9);
					n += 9;
				} else t += e.substr(n, 3), n += 3;
			}
			return t;
		}
		function te(e, t) {
			function n(e) {
				var n = ee(e);
				return n.match(t.UNRESERVED) ? n : e;
			}
			return e.scheme &&= String(e.scheme).replace(t.PCT_ENCODED, n).toLowerCase().replace(t.NOT_SCHEME, ""), e.userinfo !== void 0 && (e.userinfo = String(e.userinfo).replace(t.PCT_ENCODED, n).replace(t.NOT_USERINFO, V).replace(t.PCT_ENCODED, i)), e.host !== void 0 && (e.host = String(e.host).replace(t.PCT_ENCODED, n).toLowerCase().replace(t.NOT_HOST, V).replace(t.PCT_ENCODED, i)), e.path !== void 0 && (e.path = String(e.path).replace(t.PCT_ENCODED, n).replace(e.scheme ? t.NOT_PATH : t.NOT_PATH_NOSCHEME, V).replace(t.PCT_ENCODED, i)), e.query !== void 0 && (e.query = String(e.query).replace(t.PCT_ENCODED, n).replace(t.NOT_QUERY, V).replace(t.PCT_ENCODED, i)), e.fragment !== void 0 && (e.fragment = String(e.fragment).replace(t.PCT_ENCODED, n).replace(t.NOT_FRAGMENT, V).replace(t.PCT_ENCODED, i)), e;
		}
		function ne(e) {
			return e.replace(/^0*(.*)/, "$1") || "0";
		}
		function re(e, t) {
			var n = u(e.match(t.IPV4ADDRESS) || [], 2)[1];
			return n ? n.split(".").map(ne).join(".") : e;
		}
		function ie(e, t) {
			var n = u(e.match(t.IPV6ADDRESS) || [], 3), r = n[1], i = n[2];
			if (r) {
				for (var a = u(r.toLowerCase().split("::").reverse(), 2), o = a[0], s = a[1], c = s ? s.split(":").map(ne) : [], l = o.split(":").map(ne), d = t.IPV4ADDRESS.test(l[l.length - 1]), f = d ? 7 : 8, p = l.length - f, m = Array(f), h = 0; h < f; ++h) m[h] = c[h] || l[p + h] || "";
				d && (m[f - 1] = re(m[f - 1], t));
				var g = m.reduce(function(e, t, n) {
					if (!t || t === "0") {
						var r = e[e.length - 1];
						r && r.index + r.length === n ? r.length++ : e.push({
							index: n,
							length: 1
						});
					}
					return e;
				}, []).sort(function(e, t) {
					return t.length - e.length;
				})[0], _ = void 0;
				if (g && g.length > 1) {
					var v = m.slice(0, g.index), y = m.slice(g.index + g.length);
					_ = v.join(":") + "::" + y.join(":");
				} else _ = m.join(":");
				return i && (_ += "%" + i), _;
			}
			return e;
		}
		var ae = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i, oe = "".match(/(){0}/)[1] === void 0;
		function H(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = {}, r = t.iri === !1 ? c : l;
			t.reference === "suffix" && (e = (t.scheme ? t.scheme + ":" : "") + "//" + e);
			var i = e.match(ae);
			if (i) {
				oe ? (n.scheme = i[1], n.userinfo = i[3], n.host = i[4], n.port = parseInt(i[5], 10), n.path = i[6] || "", n.query = i[7], n.fragment = i[8], isNaN(n.port) && (n.port = i[5])) : (n.scheme = i[1] || void 0, n.userinfo = e.indexOf("@") === -1 ? void 0 : i[3], n.host = e.indexOf("//") === -1 ? void 0 : i[4], n.port = parseInt(i[5], 10), n.path = i[6] || "", n.query = e.indexOf("?") === -1 ? void 0 : i[7], n.fragment = e.indexOf("#") === -1 ? void 0 : i[8], isNaN(n.port) && (n.port = e.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? i[4] : void 0)), n.host &&= ie(re(n.host, r), r), n.reference = n.scheme === void 0 && n.userinfo === void 0 && n.host === void 0 && n.port === void 0 && !n.path && n.query === void 0 ? "same-document" : n.scheme === void 0 ? "relative" : n.fragment === void 0 ? "absolute" : "uri", t.reference && t.reference !== "suffix" && t.reference !== n.reference && (n.error = n.error || "URI is not a " + t.reference + " reference.");
				var a = B[(t.scheme || n.scheme || "").toLowerCase()];
				if (!t.unicodeSupport && (!a || !a.unicodeSupport)) {
					if (n.host && (t.domainHost || a && a.domainHost)) try {
						n.host = z.toASCII(n.host.replace(r.PCT_ENCODED, ee).toLowerCase());
					} catch (e) {
						n.error = n.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
					}
					te(n, c);
				} else te(n, r);
				a && a.parse && a.parse(n, t);
			} else n.error = n.error || "URI can not be parsed.";
			return n;
		}
		function U(e, t) {
			var n = t.iri === !1 ? c : l, r = [];
			return e.userinfo !== void 0 && (r.push(e.userinfo), r.push("@")), e.host !== void 0 && r.push(ie(re(String(e.host), n), n).replace(n.IPV6ADDRESS, function(e, t, n) {
				return "[" + t + (n ? "%25" + n : "") + "]";
			})), (typeof e.port == "number" || typeof e.port == "string") && (r.push(":"), r.push(String(e.port))), r.length ? r.join("") : void 0;
		}
		var se = /^\.\.?\//, ce = /^\/\.(\/|$)/, le = /^\/\.\.(\/|$)/, W = /^\/?(?:.|\n)*?(?=\/|$)/;
		function G(e) {
			for (var t = []; e.length;) if (e.match(se)) e = e.replace(se, "");
			else if (e.match(ce)) e = e.replace(ce, "/");
			else if (e.match(le)) e = e.replace(le, "/"), t.pop();
			else if (e === "." || e === "..") e = "";
			else {
				var n = e.match(W);
				if (n) {
					var r = n[0];
					e = e.slice(r.length), t.push(r);
				} else throw Error("Unexpected dot segment condition");
			}
			return t.join("");
		}
		function K(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.iri ? l : c, r = [], i = B[(t.scheme || e.scheme || "").toLowerCase()];
			if (i && i.serialize && i.serialize(e, t), e.host && !n.IPV6ADDRESS.test(e.host) && (t.domainHost || i && i.domainHost)) try {
				e.host = t.iri ? z.toUnicode(e.host) : z.toASCII(e.host.replace(n.PCT_ENCODED, ee).toLowerCase());
			} catch (n) {
				e.error = e.error || "Host's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + n;
			}
			te(e, n), t.reference !== "suffix" && e.scheme && (r.push(e.scheme), r.push(":"));
			var a = U(e, t);
			if (a !== void 0 && (t.reference !== "suffix" && r.push("//"), r.push(a), e.path && e.path.charAt(0) !== "/" && r.push("/")), e.path !== void 0) {
				var o = e.path;
				!t.absolutePath && (!i || !i.absolutePath) && (o = G(o)), a === void 0 && (o = o.replace(/^\/\//, "/%2F")), r.push(o);
			}
			return e.query !== void 0 && (r.push("?"), r.push(e.query)), e.fragment !== void 0 && (r.push("#"), r.push(e.fragment)), r.join("");
		}
		function ue(e, t) {
			var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments[3], i = {};
			return r || (e = H(K(e, n), n), t = H(K(t, n), n)), n ||= {}, !n.tolerant && t.scheme ? (i.scheme = t.scheme, i.userinfo = t.userinfo, i.host = t.host, i.port = t.port, i.path = G(t.path || ""), i.query = t.query) : (t.userinfo !== void 0 || t.host !== void 0 || t.port !== void 0 ? (i.userinfo = t.userinfo, i.host = t.host, i.port = t.port, i.path = G(t.path || ""), i.query = t.query) : (t.path ? (t.path.charAt(0) === "/" ? i.path = G(t.path) : (i.path = (e.userinfo !== void 0 || e.host !== void 0 || e.port !== void 0) && !e.path ? "/" + t.path : e.path ? e.path.slice(0, e.path.lastIndexOf("/") + 1) + t.path : t.path, i.path = G(i.path)), i.query = t.query) : (i.path = e.path, i.query = t.query === void 0 ? e.query : t.query), i.userinfo = e.userinfo, i.host = e.host, i.port = e.port), i.scheme = e.scheme), i.fragment = t.fragment, i;
		}
		function de(e, t, n) {
			var r = o({ scheme: "null" }, n);
			return K(ue(H(e, r), H(t, r), r, !0), r);
		}
		function fe(e, t) {
			return typeof e == "string" ? e = K(H(e, t), t) : r(e) === "object" && (e = H(K(e, t), t)), e;
		}
		function pe(e, t, n) {
			return typeof e == "string" ? e = K(H(e, n), n) : r(e) === "object" && (e = K(e, n)), typeof t == "string" ? t = K(H(t, n), n) : r(t) === "object" && (t = K(t, n)), e === t;
		}
		function me(e, t) {
			return e && e.toString().replace(!t || !t.iri ? c.ESCAPE : l.ESCAPE, V);
		}
		function he(e, t) {
			return e && e.toString().replace(!t || !t.iri ? c.PCT_ENCODED : l.PCT_ENCODED, ee);
		}
		var ge = {
			scheme: "http",
			domainHost: !0,
			parse: function(e, t) {
				return e.host || (e.error = e.error || "HTTP URIs must have a host."), e;
			},
			serialize: function(e, t) {
				var n = String(e.scheme).toLowerCase() === "https";
				return (e.port === (n ? 443 : 80) || e.port === "") && (e.port = void 0), e.path ||= "/", e;
			}
		}, _e = {
			scheme: "https",
			domainHost: ge.domainHost,
			parse: ge.parse,
			serialize: ge.serialize
		};
		function ve(e) {
			return typeof e.secure == "boolean" ? e.secure : String(e.scheme).toLowerCase() === "wss";
		}
		var ye = {
			scheme: "ws",
			domainHost: !0,
			parse: function(e, t) {
				var n = e;
				return n.secure = ve(n), n.resourceName = (n.path || "/") + (n.query ? "?" + n.query : ""), n.path = void 0, n.query = void 0, n;
			},
			serialize: function(e, t) {
				if ((e.port === (ve(e) ? 443 : 80) || e.port === "") && (e.port = void 0), typeof e.secure == "boolean" && (e.scheme = e.secure ? "wss" : "ws", e.secure = void 0), e.resourceName) {
					var n = u(e.resourceName.split("?"), 2), r = n[0], i = n[1];
					e.path = r && r !== "/" ? r : void 0, e.query = i, e.resourceName = void 0;
				}
				return e.fragment = void 0, e;
			}
		}, be = {
			scheme: "wss",
			domainHost: ye.domainHost,
			parse: ye.parse,
			serialize: ye.serialize
		}, xe = {}, Se = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]", Ce = "[0-9A-Fa-f]", we = n(n("%[EFef]" + Ce + "%" + Ce + Ce + "%" + Ce + Ce) + "|" + n("%[89A-Fa-f]" + Ce + "%" + Ce + Ce) + "|" + n("%" + Ce + Ce)), Te = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", Ee = t("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", "[\\\"\\\\]"), De = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]", Oe = new RegExp(Se, "g"), ke = new RegExp(we, "g"), Ae = new RegExp(t("[^]", Te, "[\\.]", "[\\\"]", Ee), "g"), je = new RegExp(t("[^]", Se, De), "g"), Me = je;
		function Ne(e) {
			var t = ee(e);
			return t.match(Oe) ? t : e;
		}
		var Pe = {
			scheme: "mailto",
			parse: function(e, t) {
				var n = e, r = n.to = n.path ? n.path.split(",") : [];
				if (n.path = void 0, n.query) {
					for (var i = !1, a = {}, o = n.query.split("&"), s = 0, c = o.length; s < c; ++s) {
						var l = o[s].split("=");
						switch (l[0]) {
							case "to":
								for (var u = l[1].split(","), d = 0, f = u.length; d < f; ++d) r.push(u[d]);
								break;
							case "subject":
								n.subject = he(l[1], t);
								break;
							case "body":
								n.body = he(l[1], t);
								break;
							default: i = !0, a[he(l[0], t)] = he(l[1], t);
						}
					}
					i && (n.headers = a);
				}
				n.query = void 0;
				for (var p = 0, m = r.length; p < m; ++p) {
					var h = r[p].split("@");
					if (h[0] = he(h[0]), t.unicodeSupport) h[1] = he(h[1], t).toLowerCase();
					else try {
						h[1] = z.toASCII(he(h[1], t).toLowerCase());
					} catch (e) {
						n.error = n.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
					}
					r[p] = h.join("@");
				}
				return n;
			},
			serialize: function(e, t) {
				var n = e, r = a(e.to);
				if (r) {
					for (var o = 0, s = r.length; o < s; ++o) {
						var c = String(r[o]), l = c.lastIndexOf("@"), u = c.slice(0, l).replace(ke, Ne).replace(ke, i).replace(Ae, V), d = c.slice(l + 1);
						try {
							d = t.iri ? z.toUnicode(d) : z.toASCII(he(d, t).toLowerCase());
						} catch (e) {
							n.error = n.error || "Email address's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + e;
						}
						r[o] = u + "@" + d;
					}
					n.path = r.join(",");
				}
				var f = e.headers = e.headers || {};
				e.subject && (f.subject = e.subject), e.body && (f.body = e.body);
				var p = [];
				for (var m in f) f[m] !== xe[m] && p.push(m.replace(ke, Ne).replace(ke, i).replace(je, V) + "=" + f[m].replace(ke, Ne).replace(ke, i).replace(Me, V));
				return p.length && (n.query = p.join("&")), n;
			}
		}, Fe = /^([^\:]+)\:(.*)/, Ie = {
			scheme: "urn",
			parse: function(e, t) {
				var n = e.path && e.path.match(Fe), r = e;
				if (n) {
					var i = t.scheme || r.scheme || "urn", a = n[1].toLowerCase(), o = n[2], s = B[i + ":" + (t.nid || a)];
					r.nid = a, r.nss = o, r.path = void 0, s && (r = s.parse(r, t));
				} else r.error = r.error || "URN can not be parsed.";
				return r;
			},
			serialize: function(e, t) {
				var n = t.scheme || e.scheme || "urn", r = e.nid, i = B[n + ":" + (t.nid || r)];
				i && (e = i.serialize(e, t));
				var a = e, o = e.nss;
				return a.path = (r || t.nid) + ":" + o, a;
			}
		}, Le = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/, Re = {
			scheme: "urn:uuid",
			parse: function(e, t) {
				var n = e;
				return n.uuid = n.nss, n.nss = void 0, !t.tolerant && (!n.uuid || !n.uuid.match(Le)) && (n.error = n.error || "UUID is not valid."), n;
			},
			serialize: function(e, t) {
				var n = e;
				return n.nss = (e.uuid || "").toLowerCase(), n;
			}
		};
		B[ge.scheme] = ge, B[_e.scheme] = _e, B[ye.scheme] = ye, B[be.scheme] = be, B[Pe.scheme] = Pe, B[Ie.scheme] = Ie, B[Re.scheme] = Re, e.SCHEMES = B, e.pctEncChar = V, e.pctDecChars = ee, e.parse = H, e.removeDotSegments = G, e.serialize = K, e.resolveComponents = ue, e.resolve = de, e.normalize = fe, e.equal = pe, e.escapeComponent = me, e.unescapeComponent = he, Object.defineProperty(e, "__esModule", { value: !0 });
	}));
})), da = /* @__PURE__ */ $(((e, t) => {
	t.exports = function e(t, n) {
		if (t === n) return !0;
		if (t && n && typeof t == "object" && typeof n == "object") {
			if (t.constructor !== n.constructor) return !1;
			var r, i, a;
			if (Array.isArray(t)) {
				if (r = t.length, r != n.length) return !1;
				for (i = r; i-- !== 0;) if (!e(t[i], n[i])) return !1;
				return !0;
			}
			if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
			if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
			if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
			if (a = Object.keys(t), r = a.length, r !== Object.keys(n).length) return !1;
			for (i = r; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(n, a[i])) return !1;
			for (i = r; i-- !== 0;) {
				var o = a[i];
				if (!e(t[o], n[o])) return !1;
			}
			return !0;
		}
		return t !== t && n !== n;
	};
})), fa = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e) {
		for (var t = 0, n = e.length, r = 0, i; r < n;) t++, i = e.charCodeAt(r++), i >= 55296 && i <= 56319 && r < n && (i = e.charCodeAt(r), (i & 64512) == 56320 && r++);
		return t;
	};
})), pa = /* @__PURE__ */ $(((e, t) => {
	t.exports = {
		copy: n,
		checkDataType: r,
		checkDataTypes: i,
		coerceToTypes: o,
		toHash: s,
		getProperty: u,
		escapeQuotes: d,
		equal: da(),
		ucs2length: fa(),
		varOccurences: f,
		varReplace: p,
		schemaHasRules: m,
		schemaHasRulesExcept: h,
		schemaUnknownRules: g,
		toQuotedString: _,
		getPathExpr: v,
		getPath: y,
		getData: S,
		unescapeFragment: w,
		unescapeJsonPointer: D,
		escapeFragment: T,
		escapeJsonPointer: E
	};
	function n(e, t) {
		for (var n in t ||= {}, e) t[n] = e[n];
		return t;
	}
	function r(e, t, n, r) {
		var i = r ? " !== " : " === ", a = r ? " || " : " && ", o = r ? "!" : "", s = r ? "" : "!";
		switch (e) {
			case "null": return t + i + "null";
			case "array": return o + "Array.isArray(" + t + ")";
			case "object": return "(" + o + t + a + "typeof " + t + i + "\"object\"" + a + s + "Array.isArray(" + t + "))";
			case "integer": return "(typeof " + t + i + "\"number\"" + a + s + "(" + t + " % 1)" + a + t + i + t + (n ? a + o + "isFinite(" + t + ")" : "") + ")";
			case "number": return "(typeof " + t + i + "\"" + e + "\"" + (n ? a + o + "isFinite(" + t + ")" : "") + ")";
			default: return "typeof " + t + i + "\"" + e + "\"";
		}
	}
	function i(e, t, n) {
		switch (e.length) {
			case 1: return r(e[0], t, n, !0);
			default:
				var i = "", a = s(e);
				for (var o in a.array && a.object && (i = a.null ? "(" : "(!" + t + " || ", i += "typeof " + t + " !== \"object\")", delete a.null, delete a.array, delete a.object), a.number && delete a.integer, a) i += (i ? " && " : "") + r(o, t, n, !0);
				return i;
		}
	}
	var a = s([
		"string",
		"number",
		"integer",
		"boolean",
		"null"
	]);
	function o(e, t) {
		if (Array.isArray(t)) {
			for (var n = [], r = 0; r < t.length; r++) {
				var i = t[r];
				(a[i] || e === "array" && i === "array") && (n[n.length] = i);
			}
			if (n.length) return n;
		} else if (a[t]) return [t];
		else if (e === "array" && t === "array") return ["array"];
	}
	function s(e) {
		for (var t = {}, n = 0; n < e.length; n++) t[e[n]] = !0;
		return t;
	}
	var c = /^[a-z$_][a-z$_0-9]*$/i, l = /'|\\/g;
	function u(e) {
		return typeof e == "number" ? "[" + e + "]" : c.test(e) ? "." + e : "['" + d(e) + "']";
	}
	function d(e) {
		return e.replace(l, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
	}
	function f(e, t) {
		t += "[^0-9]";
		var n = e.match(new RegExp(t, "g"));
		return n ? n.length : 0;
	}
	function p(e, t, n) {
		return t += "([^0-9])", n = n.replace(/\$/g, "$$$$"), e.replace(new RegExp(t, "g"), n + "$1");
	}
	function m(e, t) {
		if (typeof e == "boolean") return !e;
		for (var n in e) if (t[n]) return !0;
	}
	function h(e, t, n) {
		if (typeof e == "boolean") return !e && n != "not";
		for (var r in e) if (r != n && t[r]) return !0;
	}
	function g(e, t) {
		if (typeof e != "boolean") {
			for (var n in e) if (!t[n]) return n;
		}
	}
	function _(e) {
		return "'" + d(e) + "'";
	}
	function v(e, t, n, r) {
		return C(e, n ? "'/' + " + t + (r ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : r ? "'[' + " + t + " + ']'" : "'[\\'' + " + t + " + '\\']'");
	}
	function y(e, t, n) {
		return C(e, _(n ? "/" + E(t) : u(t)));
	}
	var b = /^\/(?:[^~]|~0|~1)*$/, x = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
	function S(e, t, n) {
		var r, i, a, o;
		if (e === "") return "rootData";
		if (e[0] == "/") {
			if (!b.test(e)) throw Error("Invalid JSON-pointer: " + e);
			i = e, a = "rootData";
		} else {
			if (o = e.match(x), !o) throw Error("Invalid JSON-pointer: " + e);
			if (r = +o[1], i = o[2], i == "#") {
				if (r >= t) throw Error("Cannot access property/index " + r + " levels up, current level is " + t);
				return n[t - r];
			}
			if (r > t) throw Error("Cannot access data " + r + " levels up, current level is " + t);
			if (a = "data" + (t - r || ""), !i) return a;
		}
		for (var s = a, c = i.split("/"), l = 0; l < c.length; l++) {
			var d = c[l];
			d && (a += u(D(d)), s += " && " + a);
		}
		return s;
	}
	function C(e, t) {
		return e == "\"\"" ? t : (e + " + " + t).replace(/([^\\])' \+ '/g, "$1");
	}
	function w(e) {
		return D(decodeURIComponent(e));
	}
	function T(e) {
		return encodeURIComponent(E(e));
	}
	function E(e) {
		return e.replace(/~/g, "~0").replace(/\//g, "~1");
	}
	function D(e) {
		return e.replace(/~1/g, "/").replace(/~0/g, "~");
	}
})), ma = /* @__PURE__ */ $(((e, t) => {
	var n = pa();
	t.exports = r;
	function r(e) {
		n.copy(e, this);
	}
})), ha = /* @__PURE__ */ $(((e, t) => {
	var n = t.exports = function(e, t, n) {
		typeof t == "function" && (n = t, t = {}), n = t.cb || n;
		var i = typeof n == "function" ? n : n.pre || function() {}, a = n.post || function() {};
		r(t, i, a, e, "", e);
	};
	n.keywords = {
		additionalItems: !0,
		items: !0,
		contains: !0,
		additionalProperties: !0,
		propertyNames: !0,
		not: !0
	}, n.arrayKeywords = {
		items: !0,
		allOf: !0,
		anyOf: !0,
		oneOf: !0
	}, n.propsKeywords = {
		definitions: !0,
		properties: !0,
		patternProperties: !0,
		dependencies: !0
	}, n.skipKeywords = {
		default: !0,
		enum: !0,
		const: !0,
		required: !0,
		maximum: !0,
		minimum: !0,
		exclusiveMaximum: !0,
		exclusiveMinimum: !0,
		multipleOf: !0,
		maxLength: !0,
		minLength: !0,
		pattern: !0,
		format: !0,
		maxItems: !0,
		minItems: !0,
		uniqueItems: !0,
		maxProperties: !0,
		minProperties: !0
	};
	function r(e, t, a, o, s, c, l, u, d, f) {
		if (o && typeof o == "object" && !Array.isArray(o)) {
			for (var p in t(o, s, c, l, u, d, f), o) {
				var m = o[p];
				if (Array.isArray(m)) {
					if (p in n.arrayKeywords) for (var h = 0; h < m.length; h++) r(e, t, a, m[h], s + "/" + p + "/" + h, c, s, p, o, h);
				} else if (p in n.propsKeywords) {
					if (m && typeof m == "object") for (var g in m) r(e, t, a, m[g], s + "/" + p + "/" + i(g), c, s, p, o, g);
				} else (p in n.keywords || e.allKeys && !(p in n.skipKeywords)) && r(e, t, a, m, s + "/" + p, c, s, p, o);
			}
			a(o, s, c, l, u, d, f);
		}
	}
	function i(e) {
		return e.replace(/~/g, "~0").replace(/\//g, "~1");
	}
})), ga = /* @__PURE__ */ $(((e, t) => {
	var n = ua(), r = da(), i = pa(), a = ma(), o = ha();
	t.exports = s, s.normalizeId = y, s.fullPath = g, s.url = b, s.ids = x, s.inlineRef = p, s.schema = c;
	function s(e, t, n) {
		var r = this._refs[n];
		if (typeof r == "string") {
			if (this._refs[r]) r = this._refs[r];
			else return s.call(this, e, t, r);
		}
		if (r ||= this._schemas[n], r instanceof a) return p(r.schema, this._opts.inlineRefs) ? r.schema : r.validate || this._compile(r);
		var i = c.call(this, t, n), o, l, u;
		return i && (o = i.schema, t = i.root, u = i.baseId), o instanceof a ? l = o.validate || e.call(this, o.schema, t, void 0, u) : o !== void 0 && (l = p(o, this._opts.inlineRefs) ? o : e.call(this, o, t, void 0, u)), l;
	}
	function c(e, t) {
		var r = n.parse(t), i = _(r), o = g(this._getId(e.schema));
		if (Object.keys(e.schema).length === 0 || i !== o) {
			var s = y(i), c = this._refs[s];
			if (typeof c == "string") return l.call(this, e, c, r);
			if (c instanceof a) c.validate || this._compile(c), e = c;
			else if (c = this._schemas[s], c instanceof a) {
				if (c.validate || this._compile(c), s == y(t)) return {
					schema: c,
					root: e,
					baseId: o
				};
				e = c;
			} else return;
			if (!e.schema) return;
			o = g(this._getId(e.schema));
		}
		return d.call(this, r, o, e.schema, e);
	}
	function l(e, t, n) {
		var r = c.call(this, e, t);
		if (r) {
			var i = r.schema, a = r.baseId;
			e = r.root;
			var o = this._getId(i);
			return o && (a = b(a, o)), d.call(this, n, a, i, e);
		}
	}
	var u = i.toHash([
		"properties",
		"patternProperties",
		"enum",
		"dependencies",
		"definitions"
	]);
	function d(e, t, n, r) {
		if (e.fragment = e.fragment || "", e.fragment.slice(0, 1) == "/") {
			for (var a = e.fragment.split("/"), o = 1; o < a.length; o++) {
				var s = a[o];
				if (s) {
					if (s = i.unescapeFragment(s), n = n[s], n === void 0) break;
					var l;
					if (!u[s] && (l = this._getId(n), l && (t = b(t, l)), n.$ref)) {
						var d = b(t, n.$ref), f = c.call(this, r, d);
						f && (n = f.schema, r = f.root, t = f.baseId);
					}
				}
			}
			if (n !== void 0 && n !== r.schema) return {
				schema: n,
				root: r,
				baseId: t
			};
		}
	}
	var f = i.toHash([
		"type",
		"format",
		"pattern",
		"maxLength",
		"minLength",
		"maxProperties",
		"minProperties",
		"maxItems",
		"minItems",
		"maximum",
		"minimum",
		"uniqueItems",
		"multipleOf",
		"required",
		"enum"
	]);
	function p(e, t) {
		if (t === !1) return !1;
		if (t === void 0 || t === !0) return m(e);
		if (t) return h(e) <= t;
	}
	function m(e) {
		var t;
		if (Array.isArray(e)) {
			for (var n = 0; n < e.length; n++) if (t = e[n], typeof t == "object" && !m(t)) return !1;
		} else for (var r in e) if (r == "$ref" || (t = e[r], typeof t == "object" && !m(t))) return !1;
		return !0;
	}
	function h(e) {
		var t = 0, n;
		if (Array.isArray(e)) {
			for (var r = 0; r < e.length; r++) if (n = e[r], typeof n == "object" && (t += h(n)), t == Infinity) return Infinity;
		} else for (var i in e) {
			if (i == "$ref") return Infinity;
			if (f[i]) t++;
			else if (n = e[i], typeof n == "object" && (t += h(n) + 1), t == Infinity) return Infinity;
		}
		return t;
	}
	function g(e, t) {
		return t !== !1 && (e = y(e)), _(n.parse(e));
	}
	function _(e) {
		return n.serialize(e).split("#")[0] + "#";
	}
	var v = /#\/?$/;
	function y(e) {
		return e ? e.replace(v, "") : "";
	}
	function b(e, t) {
		return t = y(t), n.resolve(e, t);
	}
	function x(e) {
		var t = y(this._getId(e)), a = { "": t }, s = { "": g(t, !1) }, c = {}, l = this;
		return o(e, { allKeys: !0 }, function(e, t, o, u, d, f, p) {
			if (t !== "") {
				var m = l._getId(e), h = a[u], g = s[u] + "/" + d;
				if (p !== void 0 && (g += "/" + (typeof p == "number" ? p : i.escapeFragment(p))), typeof m == "string") {
					m = h = y(h ? n.resolve(h, m) : m);
					var _ = l._refs[m];
					if (typeof _ == "string" && (_ = l._refs[_]), _ && _.schema) {
						if (!r(e, _.schema)) throw Error("id \"" + m + "\" resolves to more than one schema");
					} else if (m != y(g)) {
						if (m[0] == "#") {
							if (c[m] && !r(e, c[m])) throw Error("id \"" + m + "\" resolves to more than one schema");
							c[m] = e;
						} else l._refs[m] = g;
					}
				}
				a[t] = h, s[t] = g;
			}
		}), c;
	}
})), _a = /* @__PURE__ */ $(((e, t) => {
	var n = ga();
	t.exports = {
		Validation: a(r),
		MissingRef: a(i)
	};
	function r(e) {
		this.message = "validation failed", this.errors = e, this.ajv = this.validation = !0;
	}
	i.message = function(e, t) {
		return "can't resolve reference " + t + " from id " + e;
	};
	function i(e, t, r) {
		this.message = r || i.message(e, t), this.missingRef = n.url(e, t), this.missingSchema = n.normalizeId(n.fullPath(this.missingRef));
	}
	function a(e) {
		return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e, e;
	}
})), va = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t) {
		t ||= {}, typeof t == "function" && (t = { cmp: t });
		var n = typeof t.cycles == "boolean" && t.cycles, r = t.cmp && (function(e) {
			return function(t) {
				return function(n, r) {
					return e({
						key: n,
						value: t[n]
					}, {
						key: r,
						value: t[r]
					});
				};
			};
		})(t.cmp), i = [];
		return (function e(t) {
			if (t && t.toJSON && typeof t.toJSON == "function" && (t = t.toJSON()), t !== void 0) {
				if (typeof t == "number") return isFinite(t) ? "" + t : "null";
				if (typeof t != "object") return JSON.stringify(t);
				var a, o;
				if (Array.isArray(t)) {
					for (o = "[", a = 0; a < t.length; a++) a && (o += ","), o += e(t[a]) || "null";
					return o + "]";
				}
				if (t === null) return "null";
				if (i.indexOf(t) !== -1) {
					if (n) return JSON.stringify("__cycle__");
					throw TypeError("Converting circular structure to JSON");
				}
				var s = i.push(t) - 1, c = Object.keys(t).sort(r && r(t));
				for (o = "", a = 0; a < c.length; a++) {
					var l = c[a], u = e(t[l]);
					u && (o && (o += ","), o += JSON.stringify(l) + ":" + u);
				}
				return i.splice(s, 1), "{" + o + "}";
			}
		})(e);
	};
})), ya = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = "", i = e.schema.$async === !0, a = e.util.schemaHasRulesExcept(e.schema, e.RULES.all, "$ref"), o = e.self._getId(e.schema);
		if (e.opts.strictKeywords) {
			var s = e.util.schemaUnknownRules(e.schema, e.RULES.keywords);
			if (s) {
				var c = "unknown keyword: " + s;
				if (e.opts.strictKeywords === "log") e.logger.warn(c);
				else throw Error(c);
			}
		}
		if (e.isTop && (r += " var validate = ", i && (e.async = !0, r += "async "), r += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ", o && (e.opts.sourceCode || e.opts.processCode) && (r += " " + ("/*# sourceURL=" + o + " */") + " ")), typeof e.schema == "boolean" || !(a || e.schema.$ref)) {
			var t = "false schema", l = e.level, u = e.dataLevel, d = e.schema[t], f = e.schemaPath + e.util.getProperty(t), p = e.errSchemaPath + "/" + t, m = !e.opts.allErrors, h, g = "data" + (u || ""), _ = "valid" + l;
			if (e.schema === !1) {
				e.isTop ? m = !0 : r += " var " + _ + " = false; ";
				var v = v || [];
				v.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: '" + (h || "false schema") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(p) + " , params: {} ", e.opts.messages !== !1 && (r += " , message: 'boolean schema is false' "), e.opts.verbose && (r += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), r += " } ");
				var y = r;
				r = v.pop(), !e.compositeRule && m ? 
				/* istanbul ignore if */
				e.async ? r += " throw new ValidationError([" + y + "]); " : r += " validate.errors = [" + y + "]; return false; " : r += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
			} else e.isTop ? r += i ? " return data; " : " validate.errors = null; return true; " : r += " var " + _ + " = true; ";
			return e.isTop && (r += " }; return validate; "), r;
		}
		if (e.isTop) {
			var b = e.isTop, l = e.level = 0, u = e.dataLevel = 0, g = "data";
			if (e.rootId = e.resolve.fullPath(e.self._getId(e.root.schema)), e.baseId = e.baseId || e.rootId, delete e.isTop, e.dataPathArr = [""], e.schema.default !== void 0 && e.opts.useDefaults && e.opts.strictDefaults) {
				var x = "default is ignored in the schema root";
				if (e.opts.strictDefaults === "log") e.logger.warn(x);
				else throw Error(x);
			}
			r += " var vErrors = null; ", r += " var errors = 0;     ", r += " if (rootData === undefined) rootData = data; ";
		} else {
			var l = e.level, u = e.dataLevel, g = "data" + (u || "");
			if (o && (e.baseId = e.resolve.url(e.baseId, o)), i && !e.async) throw Error("async schema in sync schema");
			r += " var errs_" + l + " = errors;";
		}
		var _ = "valid" + l, m = !e.opts.allErrors, S = "", C = "", h, w = e.schema.type, T = Array.isArray(w);
		if (w && e.opts.nullable && e.schema.nullable === !0 && (T ? w.indexOf("null") == -1 && (w = w.concat("null")) : w != "null" && (w = [w, "null"], T = !0)), T && w.length == 1 && (w = w[0], T = !1), e.schema.$ref && a) {
			if (e.opts.extendRefs == "fail") throw Error("$ref: validation keywords used in schema at path \"" + e.errSchemaPath + "\" (see option extendRefs)");
			e.opts.extendRefs !== !0 && (a = !1, e.logger.warn("$ref: keywords ignored in schema at path \"" + e.errSchemaPath + "\""));
		}
		if (e.schema.$comment && e.opts.$comment && (r += " " + e.RULES.all.$comment.code(e, "$comment")), w) {
			if (e.opts.coerceTypes) var E = e.util.coerceToTypes(e.opts.coerceTypes, w);
			var D = e.RULES.types[w];
			if (E || T || D === !0 || D && !W(D)) {
				var f = e.schemaPath + ".type", p = e.errSchemaPath + "/type", f = e.schemaPath + ".type", p = e.errSchemaPath + "/type", O = T ? "checkDataTypes" : "checkDataType";
				if (r += " if (" + e.util[O](w, g, e.opts.strictNumbers, !0) + ") { ", E) {
					var k = "dataType" + l, A = "coerced" + l;
					r += " var " + k + " = typeof " + g + "; var " + A + " = undefined; ", e.opts.coerceTypes == "array" && (r += " if (" + k + " == 'object' && Array.isArray(" + g + ") && " + g + ".length == 1) { " + g + " = " + g + "[0]; " + k + " = typeof " + g + "; if (" + e.util.checkDataType(e.schema.type, g, e.opts.strictNumbers) + ") " + A + " = " + g + "; } "), r += " if (" + A + " !== undefined) ; ";
					var j = E;
					if (j) for (var M, N = -1, P = j.length - 1; N < P;) M = j[N += 1], M == "string" ? r += " else if (" + k + " == 'number' || " + k + " == 'boolean') " + A + " = '' + " + g + "; else if (" + g + " === null) " + A + " = ''; " : M == "number" || M == "integer" ? (r += " else if (" + k + " == 'boolean' || " + g + " === null || (" + k + " == 'string' && " + g + " && " + g + " == +" + g + " ", M == "integer" && (r += " && !(" + g + " % 1)"), r += ")) " + A + " = +" + g + "; ") : M == "boolean" ? r += " else if (" + g + " === 'false' || " + g + " === 0 || " + g + " === null) " + A + " = false; else if (" + g + " === 'true' || " + g + " === 1) " + A + " = true; " : M == "null" ? r += " else if (" + g + " === '' || " + g + " === 0 || " + g + " === false) " + A + " = null; " : e.opts.coerceTypes == "array" && M == "array" && (r += " else if (" + k + " == 'string' || " + k + " == 'number' || " + k + " == 'boolean' || " + g + " == null) " + A + " = [" + g + "]; ");
					r += " else {   ";
					var v = v || [];
					v.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: '" + (h || "type") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(p) + " , params: { type: '", r += T ? "" + w.join(",") : "" + w, r += "' } ", e.opts.messages !== !1 && (r += " , message: 'should be ", r += T ? "" + w.join(",") : "" + w, r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + f + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), r += " } ");
					var y = r;
					r = v.pop(), !e.compositeRule && m ? 
					/* istanbul ignore if */
					e.async ? r += " throw new ValidationError([" + y + "]); " : r += " validate.errors = [" + y + "]; return false; " : r += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } if (" + A + " !== undefined) {  ";
					var F = u ? "data" + (u - 1 || "") : "parentData", I = u ? e.dataPathArr[u] : "parentDataProperty";
					r += " " + g + " = " + A + "; ", u || (r += "if (" + F + " !== undefined)"), r += " " + F + "[" + I + "] = " + A + "; } ";
				} else {
					var v = v || [];
					v.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: '" + (h || "type") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(p) + " , params: { type: '", r += T ? "" + w.join(",") : "" + w, r += "' } ", e.opts.messages !== !1 && (r += " , message: 'should be ", r += T ? "" + w.join(",") : "" + w, r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + f + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), r += " } ");
					var y = r;
					r = v.pop(), !e.compositeRule && m ? 
					/* istanbul ignore if */
					e.async ? r += " throw new ValidationError([" + y + "]); " : r += " validate.errors = [" + y + "]; return false; " : r += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
				}
				r += " } ";
			}
		}
		if (e.schema.$ref && !a) r += " " + e.RULES.all.$ref.code(e, "$ref") + " ", m && (r += " } if (errors === ", r += b ? "0" : "errs_" + l, r += ") { ", C += "}");
		else {
			var R = e.RULES;
			if (R) {
				for (var D, z = -1, B = R.length - 1; z < B;) if (D = R[z += 1], W(D)) {
					if (D.type && (r += " if (" + e.util.checkDataType(D.type, g, e.opts.strictNumbers) + ") { "), e.opts.useDefaults) {
						if (D.type == "object" && e.schema.properties) {
							var d = e.schema.properties, V = Object.keys(d);
							if (V) for (var ee, te = -1, ne = V.length - 1; te < ne;) {
								ee = V[te += 1];
								var re = d[ee];
								if (re.default !== void 0) {
									var ie = g + e.util.getProperty(ee);
									if (e.compositeRule) {
										if (e.opts.strictDefaults) {
											var x = "default is ignored for: " + ie;
											if (e.opts.strictDefaults === "log") e.logger.warn(x);
											else throw Error(x);
										}
									} else r += " if (" + ie + " === undefined ", e.opts.useDefaults == "empty" && (r += " || " + ie + " === null || " + ie + " === '' "), r += " ) " + ie + " = ", e.opts.useDefaults == "shared" ? r += " " + e.useDefault(re.default) + " " : r += " " + JSON.stringify(re.default) + " ", r += "; ";
								}
							}
						} else if (D.type == "array" && Array.isArray(e.schema.items)) {
							var ae = e.schema.items;
							if (ae) {
								for (var re, N = -1, oe = ae.length - 1; N < oe;) if (re = ae[N += 1], re.default !== void 0) {
									var ie = g + "[" + N + "]";
									if (e.compositeRule) {
										if (e.opts.strictDefaults) {
											var x = "default is ignored for: " + ie;
											if (e.opts.strictDefaults === "log") e.logger.warn(x);
											else throw Error(x);
										}
									} else r += " if (" + ie + " === undefined ", e.opts.useDefaults == "empty" && (r += " || " + ie + " === null || " + ie + " === '' "), r += " ) " + ie + " = ", e.opts.useDefaults == "shared" ? r += " " + e.useDefault(re.default) + " " : r += " " + JSON.stringify(re.default) + " ", r += "; ";
								}
							}
						}
					}
					var H = D.rules;
					if (H) {
						for (var U, se = -1, ce = H.length - 1; se < ce;) if (U = H[se += 1], G(U)) {
							var le = U.code(e, U.keyword, D.type);
							le && (r += " " + le + " ", m && (S += "}"));
						}
					}
					if (m && (r += " " + S + " ", S = ""), D.type && (r += " } ", w && w === D.type && !E)) {
						r += " else { ";
						var f = e.schemaPath + ".type", p = e.errSchemaPath + "/type", v = v || [];
						v.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: '" + (h || "type") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(p) + " , params: { type: '", r += T ? "" + w.join(",") : "" + w, r += "' } ", e.opts.messages !== !1 && (r += " , message: 'should be ", r += T ? "" + w.join(",") : "" + w, r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + f + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + g + " "), r += " } ");
						var y = r;
						r = v.pop(), !e.compositeRule && m ? 
						/* istanbul ignore if */
						e.async ? r += " throw new ValidationError([" + y + "]); " : r += " validate.errors = [" + y + "]; return false; " : r += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ";
					}
					m && (r += " if (errors === ", r += b ? "0" : "errs_" + l, r += ") { ", C += "}");
				}
			}
		}
		m && (r += " " + C + " "), b ? (i ? (r += " if (errors === 0) return data;           ", r += " else throw new ValidationError(vErrors); ") : (r += " validate.errors = vErrors; ", r += " return errors === 0;       "), r += " }; return validate;") : r += " var " + _ + " = errors === errs_" + l + ";";
		function W(e) {
			for (var t = e.rules, n = 0; n < t.length; n++) if (G(t[n])) return !0;
		}
		function G(t) {
			return e.schema[t.keyword] !== void 0 || t.implements && K(t);
		}
		function K(t) {
			for (var n = t.implements, r = 0; r < n.length; r++) if (e.schema[n[r]] !== void 0) return !0;
		}
		return r;
	};
})), ba = /* @__PURE__ */ $(((e, t) => {
	var n = ga(), r = pa(), i = _a(), a = va(), o = ya(), s = r.ucs2length, c = da(), l = i.Validation;
	t.exports = u;
	function u(e, t, p, v) {
		var y = this, b = this._opts, x = [void 0], S = {}, C = [], w = {}, T = [], E = {}, D = [];
		function O(e, t) {
			var n = b.regExp ? "regExp" : "new RegExp";
			return "var pattern" + e + " = " + n + "(" + r.toQuotedString(t[e]) + ");";
		}
		t ||= {
			schema: e,
			refVal: x,
			refs: S
		};
		var k = d.call(this, e, t, v), A = this._compilations[k.index];
		if (k.compiling) return A.callValidate = F;
		var j = this._formats, M = this.RULES;
		try {
			var N = I(e, t, p, v);
			A.validate = N;
			var P = A.callValidate;
			return P && (P.schema = N.schema, P.errors = null, P.refs = N.refs, P.refVal = N.refVal, P.root = N.root, P.$async = N.$async, b.sourceCode && (P.source = N.source)), N;
		} finally {
			f.call(this, e, t, v);
		}
		function F() {
			var e = A.validate, t = e.apply(this, arguments);
			return F.errors = e.errors, t;
		}
		function I(e, a, d, f) {
			var p = !a || a && a.schema == e;
			if (a.schema != t.schema) return u.call(y, e, a, d, f);
			var v = e.$async === !0, w = o({
				isTop: !0,
				schema: e,
				isRoot: p,
				baseId: f,
				root: a,
				schemaPath: "",
				errSchemaPath: "#",
				errorPath: "\"\"",
				MissingRefError: i.MissingRef,
				RULES: M,
				validate: o,
				util: r,
				resolve: n,
				resolveRef: R,
				usePattern: te,
				useDefault: ne,
				useCustomRule: re,
				opts: b,
				formats: j,
				logger: y.logger,
				self: y
			});
			w = _(x, h) + _(C, O) + _(T, m) + _(D, g) + w, b.processCode && (w = b.processCode(w, e));
			var E;
			try {
				E = Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", "regExp", w)(y, M, j, t, x, T, D, c, s, l, b.regExp), x[0] = E;
			} catch (e) {
				throw y.logger.error("Error compiling schema, function code:", w), e;
			}
			return E.schema = e, E.errors = null, E.refs = S, E.refVal = x, E.root = p ? E : a, v && (E.$async = !0), b.sourceCode === !0 && (E.source = {
				code: w,
				patterns: C,
				defaults: T
			}), E;
		}
		function R(e, r, i) {
			r = n.url(e, r);
			var a = S[r], o, s;
			if (a !== void 0) return o = x[a], s = "refVal[" + a + "]", ee(o, s);
			if (!i && t.refs) {
				var c = t.refs[r];
				if (c !== void 0) return o = t.refVal[c], s = z(r, o), ee(o, s);
			}
			s = z(r);
			var l = n.call(y, I, t, r);
			if (l === void 0) {
				var d = p && p[r];
				d && (l = n.inlineRef(d, b.inlineRefs) ? d : u.call(y, d, t, p, e));
			}
			if (l === void 0) B(r);
			else return V(r, l), ee(l, s);
		}
		function z(e, t) {
			var n = x.length;
			return x[n] = t, S[e] = n, "refVal" + n;
		}
		function B(e) {
			delete S[e];
		}
		function V(e, t) {
			var n = S[e];
			x[n] = t;
		}
		function ee(e, t) {
			return typeof e == "object" || typeof e == "boolean" ? {
				code: t,
				schema: e,
				inline: !0
			} : {
				code: t,
				$async: e && !!e.$async
			};
		}
		function te(e) {
			var t = w[e];
			return t === void 0 && (t = w[e] = C.length, C[t] = e), "pattern" + t;
		}
		function ne(e) {
			switch (typeof e) {
				case "boolean":
				case "number": return "" + e;
				case "string": return r.toQuotedString(e);
				case "object":
					if (e === null) return "null";
					var t = a(e), n = E[t];
					return n === void 0 && (n = E[t] = T.length, T[n] = e), "default" + n;
			}
		}
		function re(e, t, n, r) {
			if (y._opts.validateSchema !== !1) {
				var i = e.definition.dependencies;
				if (i && !i.every(function(e) {
					return Object.prototype.hasOwnProperty.call(n, e);
				})) throw Error("parent schema must have all required keywords: " + i.join(","));
				var a = e.definition.validateSchema;
				if (a && !a(t)) {
					var o = "keyword schema is invalid: " + y.errorsText(a.errors);
					if (y._opts.validateSchema == "log") y.logger.error(o);
					else throw Error(o);
				}
			}
			var s = e.definition.compile, c = e.definition.inline, l = e.definition.macro, u;
			if (s) u = s.call(y, t, n, r);
			else if (l) u = l.call(y, t, n, r), b.validateSchema !== !1 && y.validateSchema(u, !0);
			else if (c) u = c.call(y, r, e.keyword, t, n);
			else if (u = e.definition.validate, !u) return;
			if (u === void 0) throw Error("custom keyword \"" + e.keyword + "\"failed to compile");
			var d = D.length;
			return D[d] = u, {
				code: "customRule" + d,
				validate: u
			};
		}
	}
	function d(e, t, n) {
		var r = p.call(this, e, t, n);
		return r >= 0 ? {
			index: r,
			compiling: !0
		} : (r = this._compilations.length, this._compilations[r] = {
			schema: e,
			root: t,
			baseId: n
		}, {
			index: r,
			compiling: !1
		});
	}
	function f(e, t, n) {
		var r = p.call(this, e, t, n);
		r >= 0 && this._compilations.splice(r, 1);
	}
	function p(e, t, n) {
		for (var r = 0; r < this._compilations.length; r++) {
			var i = this._compilations[r];
			if (i.schema == e && i.root == t && i.baseId == n) return r;
		}
		return -1;
	}
	function m(e) {
		return "var default" + e + " = defaults[" + e + "];";
	}
	function h(e, t) {
		return t[e] === void 0 ? "" : "var refVal" + e + " = refVal[" + e + "];";
	}
	function g(e) {
		return "var customRule" + e + " = customRules[" + e + "];";
	}
	function _(e, t) {
		if (!e.length) return "";
		for (var n = "", r = 0; r < e.length; r++) n += t(r, e);
		return n;
	}
})), xa = /* @__PURE__ */ $(((e, t) => {
	var n = t.exports = function() {
		this._cache = {};
	};
	n.prototype.put = function(e, t) {
		this._cache[e] = t;
	}, n.prototype.get = function(e) {
		return this._cache[e];
	}, n.prototype.del = function(e) {
		delete this._cache[e];
	}, n.prototype.clear = function() {
		this._cache = {};
	};
})), Sa = /* @__PURE__ */ $(((e, t) => {
	var n = pa(), r = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, i = [
		0,
		31,
		28,
		31,
		30,
		31,
		30,
		31,
		31,
		30,
		31,
		30,
		31
	], a = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i, o = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i, s = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, c = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, l = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i, u = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i, d = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i, f = /^(?:\/(?:[^~/]|~0|~1)*)*$/, p = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i, m = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
	t.exports = h;
	function h(e) {
		return e = e == "full" ? "full" : "fast", n.copy(h[e], Object.create(null));
	}
	h.fast = {
		date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
		time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
		"date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
		uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
		"uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
		"uri-template": l,
		url: u,
		email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
		hostname: o,
		ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
		ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
		regex: w,
		uuid: d,
		"json-pointer": f,
		"json-pointer-uri-fragment": p,
		"relative-json-pointer": m
	}, h.full = {
		date: _,
		time: v,
		"date-time": b,
		uri: S,
		"uri-reference": c,
		"uri-template": l,
		url: u,
		email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
		hostname: o,
		ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
		ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
		regex: w,
		uuid: d,
		"json-pointer": f,
		"json-pointer-uri-fragment": p,
		"relative-json-pointer": m
	};
	function g(e) {
		return e % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
	}
	function _(e) {
		var t = e.match(r);
		if (!t) return !1;
		var n = +t[1], a = +t[2], o = +t[3];
		return a >= 1 && a <= 12 && o >= 1 && o <= (a == 2 && g(n) ? 29 : i[a]);
	}
	function v(e, t) {
		var n = e.match(a);
		if (!n) return !1;
		var r = n[1], i = n[2], o = n[3], s = n[5];
		return (r <= 23 && i <= 59 && o <= 59 || r == 23 && i == 59 && o == 60) && (!t || s);
	}
	var y = /t|\s/i;
	function b(e) {
		var t = e.split(y);
		return t.length == 2 && _(t[0]) && v(t[1], !0);
	}
	var x = /\/|:/;
	function S(e) {
		return x.test(e) && s.test(e);
	}
	var C = /[^\\]\\Z/;
	function w(e) {
		if (C.test(e)) return !1;
		try {
			return new RegExp(e), !0;
		} catch {
			return !1;
		}
	}
})), Ca = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, l = "data" + (a || ""), u = "valid" + i, d, f;
		if (o == "#" || o == "#/") e.isRoot ? (d = e.async, f = "validate") : (d = e.root.schema.$async === !0, f = "root.refVal[0]");
		else {
			var p = e.resolveRef(e.baseId, o, e.isRoot);
			if (p === void 0) {
				var m = e.MissingRefError.message(e.baseId, o);
				if (e.opts.missingRefs == "fail") {
					e.logger.error(m);
					var h = h || [];
					h.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: '$ref' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(s) + " , params: { ref: '" + e.util.escapeQuotes(o) + "' } ", e.opts.messages !== !1 && (r += " , message: 'can\\'t resolve reference " + e.util.escapeQuotes(o) + "' "), e.opts.verbose && (r += " , schema: " + e.util.toQuotedString(o) + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + l + " "), r += " } ");
					var g = r;
					r = h.pop(), !e.compositeRule && c ? 
					/* istanbul ignore if */
					e.async ? r += " throw new ValidationError([" + g + "]); " : r += " validate.errors = [" + g + "]; return false; " : r += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c && (r += " if (false) { ");
				} else if (e.opts.missingRefs == "ignore") e.logger.warn(m), c && (r += " if (true) { ");
				else throw new e.MissingRefError(e.baseId, o, m);
			} else if (p.inline) {
				var _ = e.util.copy(e);
				_.level++;
				var v = "valid" + _.level;
				_.schema = p.schema, _.schemaPath = "", _.errSchemaPath = o;
				var y = e.validate(_).replace(/validate\.schema/g, p.code);
				r += " " + y + " ", c && (r += " if (" + v + ") { ");
			} else d = p.$async === !0 || e.async && p.$async !== !1, f = p.code;
		}
		if (f) {
			var h = h || [];
			h.push(r), r = "", e.opts.passContext ? r += " " + f + ".call(this, " : r += " " + f + "( ", r += " " + l + ", (dataPath || '')", e.errorPath != "\"\"" && (r += " + " + e.errorPath);
			var b = a ? "data" + (a - 1 || "") : "parentData", x = a ? e.dataPathArr[a] : "parentDataProperty";
			r += " , " + b + " , " + x + ", rootData)  ";
			var S = r;
			if (r = h.pop(), d) {
				if (!e.async) throw Error("async schema referenced by sync schema");
				c && (r += " var " + u + "; "), r += " try { await " + S + "; ", c && (r += " " + u + " = true; "), r += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ", c && (r += " " + u + " = false; "), r += " } ", c && (r += " if (" + u + ") { ");
			} else r += " if (!" + S + ") { if (vErrors === null) vErrors = " + f + ".errors; else vErrors = vErrors.concat(" + f + ".errors); errors = vErrors.length; } ", c && (r += " else { ");
		}
		return r;
	};
})), wa = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.schema[t], a = e.schemaPath + e.util.getProperty(t), o = e.errSchemaPath + "/" + t, s = !e.opts.allErrors, c = e.util.copy(e), l = "";
		c.level++;
		var u = "valid" + c.level, d = c.baseId, f = !0, p = i;
		if (p) for (var m, h = -1, g = p.length - 1; h < g;) m = p[h += 1], (e.opts.strictKeywords ? typeof m == "object" && Object.keys(m).length > 0 || m === !1 : e.util.schemaHasRules(m, e.RULES.all)) && (f = !1, c.schema = m, c.schemaPath = a + "[" + h + "]", c.errSchemaPath = o + "/" + h, r += "  " + e.validate(c) + " ", c.baseId = d, s && (r += " if (" + u + ") { ", l += "}"));
		return s && (r += f ? " if (true) { " : " " + l.slice(0, -1) + " "), r;
	};
})), Ta = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "valid" + i, f = "errs__" + i, p = e.util.copy(e), m = "";
		p.level++;
		var h = "valid" + p.level;
		if (o.every(function(t) {
			return e.opts.strictKeywords ? typeof t == "object" && Object.keys(t).length > 0 || t === !1 : e.util.schemaHasRules(t, e.RULES.all);
		})) {
			var g = p.baseId;
			r += " var " + f + " = errors; var " + d + " = false;  ";
			var _ = e.compositeRule;
			e.compositeRule = p.compositeRule = !0;
			var v = o;
			if (v) for (var y, b = -1, x = v.length - 1; b < x;) y = v[b += 1], p.schema = y, p.schemaPath = s + "[" + b + "]", p.errSchemaPath = c + "/" + b, r += "  " + e.validate(p) + " ", p.baseId = g, r += " " + d + " = " + d + " || " + h + "; if (!" + d + ") { ", m += "}";
			e.compositeRule = p.compositeRule = _, r += " " + m + " if (!" + d + ") {   var err =   ", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: {} ", e.opts.messages !== !1 && (r += " , message: 'should match some schema in anyOf' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } "), r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && l && 
			/* istanbul ignore if */
			(e.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), r += " } else {  errors = " + f + "; if (vErrors !== null) { if (" + f + ") vErrors.length = " + f + "; else vErrors = null; } ", e.opts.allErrors && (r += " } ");
		} else l && (r += " if (true) { ");
		return r;
	};
})), Ea = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.schema[t], a = e.errSchemaPath + "/" + t;
		e.opts.allErrors;
		var o = e.util.toQuotedString(i);
		return e.opts.$comment === !0 ? r += " console.log(" + o + ");" : typeof e.opts.$comment == "function" && (r += " self._opts.$comment(" + o + ", " + e.util.toQuotedString(a) + ", validate.root.schema);"), r;
	};
})), Da = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "valid" + i, f = e.opts.$data && o && o.$data;
		f && (r += " var schema" + i + " = " + e.util.getData(o.$data, a, e.dataPathArr) + "; ", "" + i), f || (r += " var schema" + i + " = validate.schema" + s + ";"), r += "var " + d + " = equal(" + u + ", schema" + i + "); if (!" + d + ") {   ";
		var p = p || [];
		p.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'const' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { allowedValue: schema" + i + " } ", e.opts.messages !== !1 && (r += " , message: 'should be equal to constant' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
		var m = r;
		return r = p.pop(), !e.compositeRule && l ? 
		/* istanbul ignore if */
		e.async ? r += " throw new ValidationError([" + m + "]); " : r += " validate.errors = [" + m + "]; return false; " : r += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " }", l && (r += " else { "), r;
	};
})), Oa = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "valid" + i, f = "errs__" + i, p = e.util.copy(e), m = "";
		p.level++;
		var h = "valid" + p.level, g = "i" + i, _ = p.dataLevel = e.dataLevel + 1, v = "data" + _, y = e.baseId, b = e.opts.strictKeywords ? typeof o == "object" && Object.keys(o).length > 0 || o === !1 : e.util.schemaHasRules(o, e.RULES.all);
		if (r += "var " + f + " = errors;var " + d + ";", b) {
			var x = e.compositeRule;
			e.compositeRule = p.compositeRule = !0, p.schema = o, p.schemaPath = s, p.errSchemaPath = c, r += " var " + h + " = false; for (var " + g + " = 0; " + g + " < " + u + ".length; " + g + "++) { ", p.errorPath = e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers, !0);
			var S = u + "[" + g + "]";
			p.dataPathArr[_] = g;
			var C = e.validate(p);
			p.baseId = y, e.util.varOccurences(C, v) < 2 ? r += " " + e.util.varReplace(C, v, S) + " " : r += " var " + v + " = " + S + "; " + C + " ", r += " if (" + h + ") break; }  ", e.compositeRule = p.compositeRule = x, r += " " + m + " if (!" + h + ") {";
		} else r += " if (" + u + ".length == 0) {";
		var w = w || [];
		w.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'contains' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: {} ", e.opts.messages !== !1 && (r += " , message: 'should contain a valid item' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
		var T = r;
		return r = w.pop(), !e.compositeRule && l ? 
		/* istanbul ignore if */
		e.async ? r += " throw new ValidationError([" + T + "]); " : r += " validate.errors = [" + T + "]; return false; " : r += " var err = " + T + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else { ", b && (r += "  errors = " + f + "; if (vErrors !== null) { if (" + f + ") vErrors.length = " + f + "; else vErrors = null; } "), e.opts.allErrors && (r += " } "), r;
	};
})), ka = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "errs__" + i, f = e.util.copy(e), p = "";
		f.level++;
		var m = "valid" + f.level, h = {}, g = {}, _ = e.opts.ownProperties;
		for (x in o) if (x != "__proto__") {
			var v = o[x], y = Array.isArray(v) ? g : h;
			y[x] = v;
		}
		r += "var " + d + " = errors;";
		var b = e.errorPath;
		for (var x in r += "var missing" + i + ";", g) if (y = g[x], y.length) {
			if (r += " if ( " + u + e.util.getProperty(x) + " !== undefined ", _ && (r += " && Object.prototype.hasOwnProperty.call(" + u + ", '" + e.util.escapeQuotes(x) + "') "), l) {
				r += " && ( ";
				var S = y;
				if (S) for (var C, w = -1, T = S.length - 1; w < T;) {
					C = S[w += 1], w && (r += " || ");
					var E = e.util.getProperty(C), D = u + E;
					r += " ( ( " + D + " === undefined ", _ && (r += " || ! Object.prototype.hasOwnProperty.call(" + u + ", '" + e.util.escapeQuotes(C) + "') "), r += ") && (missing" + i + " = " + e.util.toQuotedString(e.opts.jsonPointers ? C : E) + ") ) ";
				}
				r += ")) {  ";
				var O = "missing" + i, k = "' + " + O + " + '";
				e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(b, O, !0) : b + " + " + O);
				var A = A || [];
				A.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { property: '" + e.util.escapeQuotes(x) + "', missingProperty: '" + k + "', depsCount: " + y.length + ", deps: '" + e.util.escapeQuotes(y.length == 1 ? y[0] : y.join(", ")) + "' } ", e.opts.messages !== !1 && (r += " , message: 'should have ", y.length == 1 ? r += "property " + e.util.escapeQuotes(y[0]) : r += "properties " + e.util.escapeQuotes(y.join(", ")), r += " when property " + e.util.escapeQuotes(x) + " is present' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
				var j = r;
				r = A.pop(), !e.compositeRule && l ? 
				/* istanbul ignore if */
				e.async ? r += " throw new ValidationError([" + j + "]); " : r += " validate.errors = [" + j + "]; return false; " : r += " var err = " + j + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
			} else {
				r += " ) { ";
				var M = y;
				if (M) for (var C, N = -1, P = M.length - 1; N < P;) {
					C = M[N += 1];
					var E = e.util.getProperty(C), k = e.util.escapeQuotes(C), D = u + E;
					e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(b, C, e.opts.jsonPointers)), r += " if ( " + D + " === undefined ", _ && (r += " || ! Object.prototype.hasOwnProperty.call(" + u + ", '" + e.util.escapeQuotes(C) + "') "), r += ") {  var err =   ", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { property: '" + e.util.escapeQuotes(x) + "', missingProperty: '" + k + "', depsCount: " + y.length + ", deps: '" + e.util.escapeQuotes(y.length == 1 ? y[0] : y.join(", ")) + "' } ", e.opts.messages !== !1 && (r += " , message: 'should have ", y.length == 1 ? r += "property " + e.util.escapeQuotes(y[0]) : r += "properties " + e.util.escapeQuotes(y.join(", ")), r += " when property " + e.util.escapeQuotes(x) + " is present' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } "), r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
				}
			}
			r += " }   ", l && (p += "}", r += " else { ");
		}
		e.errorPath = b;
		var F = f.baseId;
		for (var x in h) {
			var v = h[x];
			(e.opts.strictKeywords ? typeof v == "object" && Object.keys(v).length > 0 || v === !1 : e.util.schemaHasRules(v, e.RULES.all)) && (r += " " + m + " = true; if ( " + u + e.util.getProperty(x) + " !== undefined ", _ && (r += " && Object.prototype.hasOwnProperty.call(" + u + ", '" + e.util.escapeQuotes(x) + "') "), r += ") { ", f.schema = v, f.schemaPath = s + e.util.getProperty(x), f.errSchemaPath = c + "/" + e.util.escapeFragment(x), r += "  " + e.validate(f) + " ", f.baseId = F, r += " }  ", l && (r += " if (" + m + ") { ", p += "}"));
		}
		return l && (r += "   " + p + " if (" + d + " == errors) {"), r;
	};
})), Aa = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "valid" + i, f = e.opts.$data && o && o.$data;
		f && (r += " var schema" + i + " = " + e.util.getData(o.$data, a, e.dataPathArr) + "; ", "" + i);
		var p = "i" + i, m = "schema" + i;
		f || (r += " var " + m + " = validate.schema" + s + ";"), r += "var " + d + ";", f && (r += " if (schema" + i + " === undefined) " + d + " = true; else if (!Array.isArray(schema" + i + ")) " + d + " = false; else {"), r += "" + d + " = false;for (var " + p + "=0; " + p + "<" + m + ".length; " + p + "++) if (equal(" + u + ", " + m + "[" + p + "])) { " + d + " = true; break; }", f && (r += "  }  "), r += " if (!" + d + ") {   ";
		var h = h || [];
		h.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'enum' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { allowedValues: schema" + i + " } ", e.opts.messages !== !1 && (r += " , message: 'should be equal to one of the allowed values' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
		var g = r;
		return r = h.pop(), !e.compositeRule && l ? 
		/* istanbul ignore if */
		e.async ? r += " throw new ValidationError([" + g + "]); " : r += " validate.errors = [" + g + "]; return false; " : r += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " }", l && (r += " else { "), r;
	};
})), ja = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || "");
		if (e.opts.format === !1) return l && (r += " if (true) { "), r;
		var d = e.opts.$data && o && o.$data, f;
		d ? (r += " var schema" + i + " = " + e.util.getData(o.$data, a, e.dataPathArr) + "; ", f = "schema" + i) : f = o;
		var p = e.opts.unknownFormats, m = Array.isArray(p);
		if (d) {
			var h = "format" + i, g = "isObject" + i, _ = "formatType" + i;
			r += " var " + h + " = formats[" + f + "]; var " + g + " = typeof " + h + " == 'object' && !(" + h + " instanceof RegExp) && " + h + ".validate; var " + _ + " = " + g + " && " + h + ".type || 'string'; if (" + g + ") { ", e.async && (r += " var async" + i + " = " + h + ".async; "), r += " " + h + " = " + h + ".validate; } if (  ", d && (r += " (" + f + " !== undefined && typeof " + f + " != 'string') || "), r += " (", p != "ignore" && (r += " (" + f + " && !" + h + " ", m && (r += " && self._opts.unknownFormats.indexOf(" + f + ") == -1 "), r += ") || "), r += " (" + h + " && " + _ + " == '" + n + "' && !(typeof " + h + " == 'function' ? ", e.async ? r += " (async" + i + " ? await " + h + "(" + u + ") : " + h + "(" + u + ")) " : r += " " + h + "(" + u + ") ", r += " : " + h + ".test(" + u + "))))) {";
		} else {
			var h = e.formats[o];
			if (!h) {
				if (p == "ignore") return e.logger.warn("unknown format \"" + o + "\" ignored in schema at path \"" + e.errSchemaPath + "\""), l && (r += " if (true) { "), r;
				if (m && p.indexOf(o) >= 0) return l && (r += " if (true) { "), r;
				throw Error("unknown format \"" + o + "\" is used in schema at path \"" + e.errSchemaPath + "\"");
			}
			var g = typeof h == "object" && !(h instanceof RegExp) && h.validate, _ = g && h.type || "string";
			if (g) {
				var v = h.async === !0;
				h = h.validate;
			}
			if (_ != n) return l && (r += " if (true) { "), r;
			if (v) {
				if (!e.async) throw Error("async format in sync schema");
				var y = "formats" + e.util.getProperty(o) + ".validate";
				r += " if (!(await " + y + "(" + u + "))) { ";
			} else {
				r += " if (! ";
				var y = "formats" + e.util.getProperty(o);
				g && (y += ".validate"), r += typeof h == "function" ? " " + y + "(" + u + ") " : " " + y + ".test(" + u + ") ", r += ") { ";
			}
		}
		var b = b || [];
		b.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'format' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { format:  ", r += d ? "" + f : "" + e.util.toQuotedString(o), r += "  } ", e.opts.messages !== !1 && (r += " , message: 'should match format \"", r += d ? "' + " + f + " + '" : "" + e.util.escapeQuotes(o), r += "\"' "), e.opts.verbose && (r += " , schema:  ", r += d ? "validate.schema" + s : "" + e.util.toQuotedString(o), r += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
		var x = r;
		return r = b.pop(), !e.compositeRule && l ? 
		/* istanbul ignore if */
		e.async ? r += " throw new ValidationError([" + x + "]); " : r += " validate.errors = [" + x + "]; return false; " : r += " var err = " + x + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ", l && (r += " else { "), r;
	};
})), Ma = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "valid" + i, f = "errs__" + i, p = e.util.copy(e);
		p.level++;
		var m = "valid" + p.level, h = e.schema.then, g = e.schema.else, _ = h !== void 0 && (e.opts.strictKeywords ? typeof h == "object" && Object.keys(h).length > 0 || h === !1 : e.util.schemaHasRules(h, e.RULES.all)), v = g !== void 0 && (e.opts.strictKeywords ? typeof g == "object" && Object.keys(g).length > 0 || g === !1 : e.util.schemaHasRules(g, e.RULES.all)), y = p.baseId;
		if (_ || v) {
			var b;
			p.createErrors = !1, p.schema = o, p.schemaPath = s, p.errSchemaPath = c, r += " var " + f + " = errors; var " + d + " = true;  ";
			var x = e.compositeRule;
			e.compositeRule = p.compositeRule = !0, r += "  " + e.validate(p) + " ", p.baseId = y, p.createErrors = !0, r += "  errors = " + f + "; if (vErrors !== null) { if (" + f + ") vErrors.length = " + f + "; else vErrors = null; }  ", e.compositeRule = p.compositeRule = x, _ ? (r += " if (" + m + ") {  ", p.schema = e.schema.then, p.schemaPath = e.schemaPath + ".then", p.errSchemaPath = e.errSchemaPath + "/then", r += "  " + e.validate(p) + " ", p.baseId = y, r += " " + d + " = " + m + "; ", _ && v ? (b = "ifClause" + i, r += " var " + b + " = 'then'; ") : b = "'then'", r += " } ", v && (r += " else { ")) : r += " if (!" + m + ") { ", v && (p.schema = e.schema.else, p.schemaPath = e.schemaPath + ".else", p.errSchemaPath = e.errSchemaPath + "/else", r += "  " + e.validate(p) + " ", p.baseId = y, r += " " + d + " = " + m + "; ", _ && v ? (b = "ifClause" + i, r += " var " + b + " = 'else'; ") : b = "'else'", r += " } "), r += " if (!" + d + ") {   var err =   ", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'if' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { failingKeyword: " + b + " } ", e.opts.messages !== !1 && (r += " , message: 'should match \"' + " + b + " + '\" schema' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } "), r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && l && 
			/* istanbul ignore if */
			(e.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), r += " }   ", l && (r += " else { ");
		} else l && (r += " if (true) { ");
		return r;
	};
})), Na = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "valid" + i, f = "errs__" + i, p = e.util.copy(e), m = "";
		p.level++;
		var h = "valid" + p.level, g = "i" + i, _ = p.dataLevel = e.dataLevel + 1, v = "data" + _, y = e.baseId;
		if (r += "var " + f + " = errors;var " + d + ";", Array.isArray(o)) {
			var b = e.schema.additionalItems;
			if (b === !1) {
				r += " " + d + " = " + u + ".length <= " + o.length + "; ";
				var x = c;
				c = e.errSchemaPath + "/additionalItems", r += "  if (!" + d + ") {   ";
				var S = S || [];
				S.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + o.length + " } ", e.opts.messages !== !1 && (r += " , message: 'should NOT have more than " + o.length + " items' "), e.opts.verbose && (r += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
				var C = r;
				r = S.pop(), !e.compositeRule && l ? 
				/* istanbul ignore if */
				e.async ? r += " throw new ValidationError([" + C + "]); " : r += " validate.errors = [" + C + "]; return false; " : r += " var err = " + C + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ", c = x, l && (m += "}", r += " else { ");
			}
			var w = o;
			if (w) {
				for (var T, E = -1, D = w.length - 1; E < D;) if (T = w[E += 1], e.opts.strictKeywords ? typeof T == "object" && Object.keys(T).length > 0 || T === !1 : e.util.schemaHasRules(T, e.RULES.all)) {
					r += " " + h + " = true; if (" + u + ".length > " + E + ") { ";
					var O = u + "[" + E + "]";
					p.schema = T, p.schemaPath = s + "[" + E + "]", p.errSchemaPath = c + "/" + E, p.errorPath = e.util.getPathExpr(e.errorPath, E, e.opts.jsonPointers, !0), p.dataPathArr[_] = E;
					var k = e.validate(p);
					p.baseId = y, e.util.varOccurences(k, v) < 2 ? r += " " + e.util.varReplace(k, v, O) + " " : r += " var " + v + " = " + O + "; " + k + " ", r += " }  ", l && (r += " if (" + h + ") { ", m += "}");
				}
			}
			if (typeof b == "object" && (e.opts.strictKeywords ? typeof b == "object" && Object.keys(b).length > 0 || b === !1 : e.util.schemaHasRules(b, e.RULES.all))) {
				p.schema = b, p.schemaPath = e.schemaPath + ".additionalItems", p.errSchemaPath = e.errSchemaPath + "/additionalItems", r += " " + h + " = true; if (" + u + ".length > " + o.length + ") {  for (var " + g + " = " + o.length + "; " + g + " < " + u + ".length; " + g + "++) { ", p.errorPath = e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers, !0);
				var O = u + "[" + g + "]";
				p.dataPathArr[_] = g;
				var k = e.validate(p);
				p.baseId = y, e.util.varOccurences(k, v) < 2 ? r += " " + e.util.varReplace(k, v, O) + " " : r += " var " + v + " = " + O + "; " + k + " ", l && (r += " if (!" + h + ") break; "), r += " } }  ", l && (r += " if (" + h + ") { ", m += "}");
			}
		} else if (e.opts.strictKeywords ? typeof o == "object" && Object.keys(o).length > 0 || o === !1 : e.util.schemaHasRules(o, e.RULES.all)) {
			p.schema = o, p.schemaPath = s, p.errSchemaPath = c, r += "  for (var " + g + " = 0; " + g + " < " + u + ".length; " + g + "++) { ", p.errorPath = e.util.getPathExpr(e.errorPath, g, e.opts.jsonPointers, !0);
			var O = u + "[" + g + "]";
			p.dataPathArr[_] = g;
			var k = e.validate(p);
			p.baseId = y, e.util.varOccurences(k, v) < 2 ? r += " " + e.util.varReplace(k, v, O) + " " : r += " var " + v + " = " + O + "; " + k + " ", l && (r += " if (!" + h + ") break; "), r += " }";
		}
		return l && (r += " " + m + " if (" + f + " == errors) {"), r;
	};
})), Pa = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u, d = "data" + (a || ""), f = e.opts.$data && o && o.$data, p;
		f ? (r += " var schema" + i + " = " + e.util.getData(o.$data, a, e.dataPathArr) + "; ", p = "schema" + i) : p = o;
		var m = t == "maximum", h = m ? "exclusiveMaximum" : "exclusiveMinimum", g = e.schema[h], _ = e.opts.$data && g && g.$data, v = m ? "<" : ">", y = m ? ">" : "<", u = void 0;
		if (!(f || typeof o == "number" || o === void 0)) throw Error(t + " must be number");
		if (!(_ || g === void 0 || typeof g == "number" || typeof g == "boolean")) throw Error(h + " must be number or boolean");
		if (_) {
			var b = e.util.getData(g.$data, a, e.dataPathArr), x = "exclusive" + i, S = "exclType" + i, C = "exclIsNumber" + i, w = "op" + i, T = "' + " + w + " + '";
			r += " var schemaExcl" + i + " = " + b + "; ", b = "schemaExcl" + i, r += " var " + x + "; var " + S + " = typeof " + b + "; if (" + S + " != 'boolean' && " + S + " != 'undefined' && " + S + " != 'number') { ";
			var u = h, E = E || [];
			E.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: '" + (u || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: {} ", e.opts.messages !== !1 && (r += " , message: '" + h + " should be boolean' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), r += " } ");
			var D = r;
			r = E.pop(), !e.compositeRule && l ? 
			/* istanbul ignore if */
			e.async ? r += " throw new ValidationError([" + D + "]); " : r += " validate.errors = [" + D + "]; return false; " : r += " var err = " + D + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else if ( ", f && (r += " (" + p + " !== undefined && typeof " + p + " != 'number') || "), r += " " + S + " == 'number' ? ( (" + x + " = " + p + " === undefined || " + b + " " + v + "= " + p + ") ? " + d + " " + y + "= " + b + " : " + d + " " + y + " " + p + " ) : ( (" + x + " = " + b + " === true) ? " + d + " " + y + "= " + p + " : " + d + " " + y + " " + p + " ) || " + d + " !== " + d + ") { var op" + i + " = " + x + " ? '" + v + "' : '" + v + "='; ", o === void 0 && (u = h, c = e.errSchemaPath + "/" + h, p = b, f = _);
		} else {
			var C = typeof g == "number", T = v;
			if (C && f) {
				var w = "'" + T + "'";
				r += " if ( ", f && (r += " (" + p + " !== undefined && typeof " + p + " != 'number') || "), r += " ( " + p + " === undefined || " + g + " " + v + "= " + p + " ? " + d + " " + y + "= " + g + " : " + d + " " + y + " " + p + " ) || " + d + " !== " + d + ") { ";
			} else {
				C && o === void 0 ? (x = !0, u = h, c = e.errSchemaPath + "/" + h, p = g, y += "=") : (C && (p = Math[m ? "min" : "max"](g, o)), g === (!C || p) ? (x = !0, u = h, c = e.errSchemaPath + "/" + h, y += "=") : (x = !1, T += "="));
				var w = "'" + T + "'";
				r += " if ( ", f && (r += " (" + p + " !== undefined && typeof " + p + " != 'number') || "), r += " " + d + " " + y + " " + p + " || " + d + " !== " + d + ") { ";
			}
		}
		u ||= t;
		var E = E || [];
		E.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: '" + (u || "_limit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { comparison: " + w + ", limit: " + p + ", exclusive: " + x + " } ", e.opts.messages !== !1 && (r += " , message: 'should be " + T + " ", r += f ? "' + " + p : "" + p + "'"), e.opts.verbose && (r += " , schema:  ", r += f ? "validate.schema" + s : "" + o, r += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), r += " } ");
		var D = r;
		return r = E.pop(), !e.compositeRule && l ? 
		/* istanbul ignore if */
		e.async ? r += " throw new ValidationError([" + D + "]); " : r += " validate.errors = [" + D + "]; return false; " : r += " var err = " + D + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ", l && (r += " else { "), r;
	};
})), Fa = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u, d = "data" + (a || ""), f = e.opts.$data && o && o.$data, p;
		if (f ? (r += " var schema" + i + " = " + e.util.getData(o.$data, a, e.dataPathArr) + "; ", p = "schema" + i) : p = o, !(f || typeof o == "number")) throw Error(t + " must be number");
		var m = t == "maxItems" ? ">" : "<";
		r += "if ( ", f && (r += " (" + p + " !== undefined && typeof " + p + " != 'number') || "), r += " " + d + ".length " + m + " " + p + ") { ";
		var u = t, h = h || [];
		h.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: '" + (u || "_limitItems") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + p + " } ", e.opts.messages !== !1 && (r += " , message: 'should NOT have ", r += t == "maxItems" ? "more" : "fewer", r += " than ", r += f ? "' + " + p + " + '" : "" + o, r += " items' "), e.opts.verbose && (r += " , schema:  ", r += f ? "validate.schema" + s : "" + o, r += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), r += " } ");
		var g = r;
		return r = h.pop(), !e.compositeRule && l ? 
		/* istanbul ignore if */
		e.async ? r += " throw new ValidationError([" + g + "]); " : r += " validate.errors = [" + g + "]; return false; " : r += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += "} ", l && (r += " else { "), r;
	};
})), Ia = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u, d = "data" + (a || ""), f = e.opts.$data && o && o.$data, p;
		if (f ? (r += " var schema" + i + " = " + e.util.getData(o.$data, a, e.dataPathArr) + "; ", p = "schema" + i) : p = o, !(f || typeof o == "number")) throw Error(t + " must be number");
		var m = t == "maxLength" ? ">" : "<";
		r += "if ( ", f && (r += " (" + p + " !== undefined && typeof " + p + " != 'number') || "), e.opts.unicode === !1 ? r += " " + d + ".length " : r += " ucs2length(" + d + ") ", r += " " + m + " " + p + ") { ";
		var u = t, h = h || [];
		h.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: '" + (u || "_limitLength") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + p + " } ", e.opts.messages !== !1 && (r += " , message: 'should NOT be ", r += t == "maxLength" ? "longer" : "shorter", r += " than ", r += f ? "' + " + p + " + '" : "" + o, r += " characters' "), e.opts.verbose && (r += " , schema:  ", r += f ? "validate.schema" + s : "" + o, r += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), r += " } ");
		var g = r;
		return r = h.pop(), !e.compositeRule && l ? 
		/* istanbul ignore if */
		e.async ? r += " throw new ValidationError([" + g + "]); " : r += " validate.errors = [" + g + "]; return false; " : r += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += "} ", l && (r += " else { "), r;
	};
})), La = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u, d = "data" + (a || ""), f = e.opts.$data && o && o.$data, p;
		if (f ? (r += " var schema" + i + " = " + e.util.getData(o.$data, a, e.dataPathArr) + "; ", p = "schema" + i) : p = o, !(f || typeof o == "number")) throw Error(t + " must be number");
		var m = t == "maxProperties" ? ">" : "<";
		r += "if ( ", f && (r += " (" + p + " !== undefined && typeof " + p + " != 'number') || "), r += " Object.keys(" + d + ").length " + m + " " + p + ") { ";
		var u = t, h = h || [];
		h.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: '" + (u || "_limitProperties") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + p + " } ", e.opts.messages !== !1 && (r += " , message: 'should NOT have ", r += t == "maxProperties" ? "more" : "fewer", r += " than ", r += f ? "' + " + p + " + '" : "" + o, r += " properties' "), e.opts.verbose && (r += " , schema:  ", r += f ? "validate.schema" + s : "" + o, r += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), r += " } ");
		var g = r;
		return r = h.pop(), !e.compositeRule && l ? 
		/* istanbul ignore if */
		e.async ? r += " throw new ValidationError([" + g + "]); " : r += " validate.errors = [" + g + "]; return false; " : r += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += "} ", l && (r += " else { "), r;
	};
})), Ra = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = e.opts.$data && o && o.$data, f;
		if (d ? (r += " var schema" + i + " = " + e.util.getData(o.$data, a, e.dataPathArr) + "; ", f = "schema" + i) : f = o, !(d || typeof o == "number")) throw Error(t + " must be number");
		r += "var division" + i + ";if (", d && (r += " " + f + " !== undefined && ( typeof " + f + " != 'number' || "), r += " (division" + i + " = " + u + " / " + f + ", ", e.opts.multipleOfPrecision ? r += " Math.abs(Math.round(division" + i + ") - division" + i + ") > 1e-" + e.opts.multipleOfPrecision + " " : r += " division" + i + " !== parseInt(division" + i + ") ", r += " ) ", d && (r += "  )  "), r += " ) {   ";
		var p = p || [];
		p.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { multipleOf: " + f + " } ", e.opts.messages !== !1 && (r += " , message: 'should be multiple of ", r += d ? "' + " + f : "" + f + "'"), e.opts.verbose && (r += " , schema:  ", r += d ? "validate.schema" + s : "" + o, r += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
		var m = r;
		return r = p.pop(), !e.compositeRule && l ? 
		/* istanbul ignore if */
		e.async ? r += " throw new ValidationError([" + m + "]); " : r += " validate.errors = [" + m + "]; return false; " : r += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += "} ", l && (r += " else { "), r;
	};
})), za = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "errs__" + i, f = e.util.copy(e);
		f.level++;
		var p = "valid" + f.level;
		if (e.opts.strictKeywords ? typeof o == "object" && Object.keys(o).length > 0 || o === !1 : e.util.schemaHasRules(o, e.RULES.all)) {
			f.schema = o, f.schemaPath = s, f.errSchemaPath = c, r += " var " + d + " = errors;  ";
			var m = e.compositeRule;
			e.compositeRule = f.compositeRule = !0, f.createErrors = !1;
			var h;
			f.opts.allErrors && (h = f.opts.allErrors, f.opts.allErrors = !1), r += " " + e.validate(f) + " ", f.createErrors = !0, h && (f.opts.allErrors = h), e.compositeRule = f.compositeRule = m, r += " if (" + p + ") {   ";
			var g = g || [];
			g.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: {} ", e.opts.messages !== !1 && (r += " , message: 'should NOT be valid' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
			var _ = r;
			r = g.pop(), !e.compositeRule && l ? 
			/* istanbul ignore if */
			e.async ? r += " throw new ValidationError([" + _ + "]); " : r += " validate.errors = [" + _ + "]; return false; " : r += " var err = " + _ + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else {  errors = " + d + "; if (vErrors !== null) { if (" + d + ") vErrors.length = " + d + "; else vErrors = null; } ", e.opts.allErrors && (r += " } ");
		} else r += "  var err =   ", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: {} ", e.opts.messages !== !1 && (r += " , message: 'should NOT be valid' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } "), r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l && (r += " if (false) { ");
		return r;
	};
})), Ba = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "valid" + i, f = "errs__" + i, p = e.util.copy(e), m = "";
		p.level++;
		var h = "valid" + p.level, g = p.baseId, _ = "prevValid" + i, v = "passingSchemas" + i;
		r += "var " + f + " = errors , " + _ + " = false , " + d + " = false , " + v + " = null; ";
		var y = e.compositeRule;
		e.compositeRule = p.compositeRule = !0;
		var b = o;
		if (b) for (var x, S = -1, C = b.length - 1; S < C;) x = b[S += 1], (e.opts.strictKeywords ? typeof x == "object" && Object.keys(x).length > 0 || x === !1 : e.util.schemaHasRules(x, e.RULES.all)) ? (p.schema = x, p.schemaPath = s + "[" + S + "]", p.errSchemaPath = c + "/" + S, r += "  " + e.validate(p) + " ", p.baseId = g) : r += " var " + h + " = true; ", S && (r += " if (" + h + " && " + _ + ") { " + d + " = false; " + v + " = [" + v + ", " + S + "]; } else { ", m += "}"), r += " if (" + h + ") { " + d + " = " + _ + " = true; " + v + " = " + S + "; }";
		return e.compositeRule = p.compositeRule = y, r += "" + m + "if (!" + d + ") {   var err =   ", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { passingSchemas: " + v + " } ", e.opts.messages !== !1 && (r += " , message: 'should match exactly one schema in oneOf' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } "), r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && l && 
		/* istanbul ignore if */
		(e.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), r += "} else {  errors = " + f + "; if (vErrors !== null) { if (" + f + ") vErrors.length = " + f + "; else vErrors = null; }", e.opts.allErrors && (r += " } "), r;
	};
})), Va = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "valid" + i, f = e.opts.$data && o && o.$data, p;
		f ? (r += " var schema" + i + " = " + e.util.getData(o.$data, a, e.dataPathArr) + "; ", p = "schema" + i) : p = o;
		var m = e.opts.regExp ? "regExp" : "new RegExp";
		if (f) r += " var " + d + " = true; try { " + d + " = " + m + "(" + p + ").test(" + u + "); } catch(e) { " + d + " = false; } if ( ", f && (r += " (" + p + " !== undefined && typeof " + p + " != 'string') || "), r += " !" + d + ") {";
		else {
			var h = e.usePattern(o);
			r += " if ( ", f && (r += " (" + p + " !== undefined && typeof " + p + " != 'string') || "), r += " !" + h + ".test(" + u + ") ) {";
		}
		var g = g || [];
		g.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { pattern:  ", r += f ? "" + p : "" + e.util.toQuotedString(o), r += "  } ", e.opts.messages !== !1 && (r += " , message: 'should match pattern \"", r += f ? "' + " + p + " + '" : "" + e.util.escapeQuotes(o), r += "\"' "), e.opts.verbose && (r += " , schema:  ", r += f ? "validate.schema" + s : "" + e.util.toQuotedString(o), r += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
		var _ = r;
		return r = g.pop(), !e.compositeRule && l ? 
		/* istanbul ignore if */
		e.async ? r += " throw new ValidationError([" + _ + "]); " : r += " validate.errors = [" + _ + "]; return false; " : r += " var err = " + _ + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += "} ", l && (r += " else { "), r;
	};
})), Ha = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "errs__" + i, f = e.util.copy(e), p = "";
		f.level++;
		var m = "valid" + f.level, h = "key" + i, g = "idx" + i, _ = f.dataLevel = e.dataLevel + 1, v = "data" + _, y = "dataProperties" + i, b = Object.keys(o || {}).filter(N), x = e.schema.patternProperties || {}, S = Object.keys(x).filter(N), C = e.schema.additionalProperties, w = b.length || S.length, T = C === !1, E = typeof C == "object" && Object.keys(C).length, D = e.opts.removeAdditional, O = T || E || D, k = e.opts.ownProperties, A = e.baseId, j = e.schema.required;
		if (j && !(e.opts.$data && j.$data) && j.length < e.opts.loopRequired) var M = e.util.toHash(j);
		function N(e) {
			return e !== "__proto__";
		}
		if (r += "var " + d + " = errors;var " + m + " = true;", k && (r += " var " + y + " = undefined;"), O) {
			if (r += k ? " " + y + " = " + y + " || Object.keys(" + u + "); for (var " + g + "=0; " + g + "<" + y + ".length; " + g + "++) { var " + h + " = " + y + "[" + g + "]; " : " for (var " + h + " in " + u + ") { ", w) {
				if (r += " var isAdditional" + i + " = !(false ", b.length) {
					if (b.length > 8) r += " || validate.schema" + s + ".hasOwnProperty(" + h + ") ";
					else {
						var P = b;
						if (P) for (var F, I = -1, R = P.length - 1; I < R;) F = P[I += 1], r += " || " + h + " == " + e.util.toQuotedString(F) + " ";
					}
				}
				if (S.length) {
					var z = S;
					if (z) for (var B, V = -1, ee = z.length - 1; V < ee;) B = z[V += 1], r += " || " + e.usePattern(B) + ".test(" + h + ") ";
				}
				r += " ); if (isAdditional" + i + ") { ";
			}
			if (D == "all") r += " delete " + u + "[" + h + "]; ";
			else {
				var te = e.errorPath, ne = "' + " + h + " + '";
				if (e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(e.errorPath, h, e.opts.jsonPointers)), T) {
					if (D) r += " delete " + u + "[" + h + "]; ";
					else {
						r += " " + m + " = false; ";
						var re = c;
						c = e.errSchemaPath + "/additionalProperties";
						var ie = ie || [];
						ie.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { additionalProperty: '" + ne + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is an invalid additional property" : r += "should NOT have additional properties", r += "' "), e.opts.verbose && (r += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
						var ae = r;
						r = ie.pop(), !e.compositeRule && l ? 
						/* istanbul ignore if */
						e.async ? r += " throw new ValidationError([" + ae + "]); " : r += " validate.errors = [" + ae + "]; return false; " : r += " var err = " + ae + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c = re, l && (r += " break; ");
					}
				} else if (E) {
					if (D == "failing") {
						r += " var " + d + " = errors;  ";
						var oe = e.compositeRule;
						e.compositeRule = f.compositeRule = !0, f.schema = C, f.schemaPath = e.schemaPath + ".additionalProperties", f.errSchemaPath = e.errSchemaPath + "/additionalProperties", f.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, h, e.opts.jsonPointers);
						var H = u + "[" + h + "]";
						f.dataPathArr[_] = h;
						var U = e.validate(f);
						f.baseId = A, e.util.varOccurences(U, v) < 2 ? r += " " + e.util.varReplace(U, v, H) + " " : r += " var " + v + " = " + H + "; " + U + " ", r += " if (!" + m + ") { errors = " + d + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + u + "[" + h + "]; }  ", e.compositeRule = f.compositeRule = oe;
					} else {
						f.schema = C, f.schemaPath = e.schemaPath + ".additionalProperties", f.errSchemaPath = e.errSchemaPath + "/additionalProperties", f.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, h, e.opts.jsonPointers);
						var H = u + "[" + h + "]";
						f.dataPathArr[_] = h;
						var U = e.validate(f);
						f.baseId = A, e.util.varOccurences(U, v) < 2 ? r += " " + e.util.varReplace(U, v, H) + " " : r += " var " + v + " = " + H + "; " + U + " ", l && (r += " if (!" + m + ") break; ");
					}
				}
				e.errorPath = te;
			}
			w && (r += " } "), r += " }  ", l && (r += " if (" + m + ") { ", p += "}");
		}
		var se = e.opts.useDefaults && !e.compositeRule;
		if (b.length) {
			var ce = b;
			if (ce) for (var F, le = -1, W = ce.length - 1; le < W;) {
				F = ce[le += 1];
				var G = o[F];
				if (e.opts.strictKeywords ? typeof G == "object" && Object.keys(G).length > 0 || G === !1 : e.util.schemaHasRules(G, e.RULES.all)) {
					var K = e.util.getProperty(F), H = u + K, ue = se && G.default !== void 0;
					f.schema = G, f.schemaPath = s + K, f.errSchemaPath = c + "/" + e.util.escapeFragment(F), f.errorPath = e.util.getPath(e.errorPath, F, e.opts.jsonPointers), f.dataPathArr[_] = e.util.toQuotedString(F);
					var U = e.validate(f);
					if (f.baseId = A, e.util.varOccurences(U, v) < 2) {
						U = e.util.varReplace(U, v, H);
						var de = H;
					} else {
						var de = v;
						r += " var " + v + " = " + H + "; ";
					}
					if (ue) r += " " + U + " ";
					else {
						if (M && M[F]) {
							r += " if ( " + de + " === undefined ", k && (r += " || ! Object.prototype.hasOwnProperty.call(" + u + ", '" + e.util.escapeQuotes(F) + "') "), r += ") { " + m + " = false; ";
							var te = e.errorPath, re = c, fe = e.util.escapeQuotes(F);
							e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(te, F, e.opts.jsonPointers)), c = e.errSchemaPath + "/required";
							var ie = ie || [];
							ie.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { missingProperty: '" + fe + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + fe + "\\'", r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
							var ae = r;
							r = ie.pop(), !e.compositeRule && l ? 
							/* istanbul ignore if */
							e.async ? r += " throw new ValidationError([" + ae + "]); " : r += " validate.errors = [" + ae + "]; return false; " : r += " var err = " + ae + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c = re, e.errorPath = te, r += " } else { ";
						} else l ? (r += " if ( " + de + " === undefined ", k && (r += " || ! Object.prototype.hasOwnProperty.call(" + u + ", '" + e.util.escapeQuotes(F) + "') "), r += ") { " + m + " = true; } else { ") : (r += " if (" + de + " !== undefined ", k && (r += " &&   Object.prototype.hasOwnProperty.call(" + u + ", '" + e.util.escapeQuotes(F) + "') "), r += " ) { ");
						r += " " + U + " } ";
					}
				}
				l && (r += " if (" + m + ") { ", p += "}");
			}
		}
		if (S.length) {
			var pe = S;
			if (pe) for (var B, me = -1, he = pe.length - 1; me < he;) {
				B = pe[me += 1];
				var G = x[B];
				if (e.opts.strictKeywords ? typeof G == "object" && Object.keys(G).length > 0 || G === !1 : e.util.schemaHasRules(G, e.RULES.all)) {
					f.schema = G, f.schemaPath = e.schemaPath + ".patternProperties" + e.util.getProperty(B), f.errSchemaPath = e.errSchemaPath + "/patternProperties/" + e.util.escapeFragment(B), r += k ? " " + y + " = " + y + " || Object.keys(" + u + "); for (var " + g + "=0; " + g + "<" + y + ".length; " + g + "++) { var " + h + " = " + y + "[" + g + "]; " : " for (var " + h + " in " + u + ") { ", r += " if (" + e.usePattern(B) + ".test(" + h + ")) { ", f.errorPath = e.util.getPathExpr(e.errorPath, h, e.opts.jsonPointers);
					var H = u + "[" + h + "]";
					f.dataPathArr[_] = h;
					var U = e.validate(f);
					f.baseId = A, e.util.varOccurences(U, v) < 2 ? r += " " + e.util.varReplace(U, v, H) + " " : r += " var " + v + " = " + H + "; " + U + " ", l && (r += " if (!" + m + ") break; "), r += " } ", l && (r += " else " + m + " = true; "), r += " }  ", l && (r += " if (" + m + ") { ", p += "}");
				}
			}
		}
		return l && (r += " " + p + " if (" + d + " == errors) {"), r;
	};
})), Ua = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "errs__" + i, f = e.util.copy(e), p = "";
		f.level++;
		var m = "valid" + f.level;
		if (r += "var " + d + " = errors;", e.opts.strictKeywords ? typeof o == "object" && Object.keys(o).length > 0 || o === !1 : e.util.schemaHasRules(o, e.RULES.all)) {
			f.schema = o, f.schemaPath = s, f.errSchemaPath = c;
			var h = "key" + i, g = "idx" + i, _ = "i" + i, v = "' + " + h + " + '", y = "data" + (f.dataLevel = e.dataLevel + 1), b = "dataProperties" + i, x = e.opts.ownProperties, S = e.baseId;
			x && (r += " var " + b + " = undefined; "), r += x ? " " + b + " = " + b + " || Object.keys(" + u + "); for (var " + g + "=0; " + g + "<" + b + ".length; " + g + "++) { var " + h + " = " + b + "[" + g + "]; " : " for (var " + h + " in " + u + ") { ", r += " var startErrs" + i + " = errors; ";
			var C = h, w = e.compositeRule;
			e.compositeRule = f.compositeRule = !0;
			var T = e.validate(f);
			f.baseId = S, e.util.varOccurences(T, y) < 2 ? r += " " + e.util.varReplace(T, y, C) + " " : r += " var " + y + " = " + C + "; " + T + " ", e.compositeRule = f.compositeRule = w, r += " if (!" + m + ") { for (var " + _ + "=startErrs" + i + "; " + _ + "<errors; " + _ + "++) { vErrors[" + _ + "].propertyName = " + h + "; }   var err =   ", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { propertyName: '" + v + "' } ", e.opts.messages !== !1 && (r += " , message: 'property name \\'" + v + "\\' is invalid' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } "), r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && l && 
			/* istanbul ignore if */
			(e.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), l && (r += " break; "), r += " } }";
		}
		return l && (r += " " + p + " if (" + d + " == errors) {"), r;
	};
})), Wa = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "valid" + i, f = e.opts.$data && o && o.$data;
		f && (r += " var schema" + i + " = " + e.util.getData(o.$data, a, e.dataPathArr) + "; ", "" + i);
		var p = "schema" + i;
		if (!f) {
			if (o.length < e.opts.loopRequired && e.schema.properties && Object.keys(e.schema.properties).length) {
				var m = [], h = o;
				if (h) for (var g, _ = -1, v = h.length - 1; _ < v;) {
					g = h[_ += 1];
					var y = e.schema.properties[g];
					y && (e.opts.strictKeywords ? typeof y == "object" && Object.keys(y).length > 0 || y === !1 : e.util.schemaHasRules(y, e.RULES.all)) || (m[m.length] = g);
				}
			} else var m = o;
		}
		if (f || m.length) {
			var b = e.errorPath, x = f || m.length >= e.opts.loopRequired, S = e.opts.ownProperties;
			if (l) {
				if (r += " var missing" + i + "; ", x) {
					f || (r += " var " + p + " = validate.schema" + s + "; ");
					var C = "i" + i, w = "schema" + i + "[" + C + "]", T = "' + " + w + " + '";
					e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(b, w, e.opts.jsonPointers)), r += " var " + d + " = true; ", f && (r += " if (schema" + i + " === undefined) " + d + " = true; else if (!Array.isArray(schema" + i + ")) " + d + " = false; else {"), r += " for (var " + C + " = 0; " + C + " < " + p + ".length; " + C + "++) { " + d + " = " + u + "[" + p + "[" + C + "]] !== undefined ", S && (r += " &&   Object.prototype.hasOwnProperty.call(" + u + ", " + p + "[" + C + "]) "), r += "; if (!" + d + ") break; } ", f && (r += "  }  "), r += "  if (!" + d + ") {   ";
					var E = E || [];
					E.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { missingProperty: '" + T + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + T + "\\'", r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
					var D = r;
					r = E.pop(), !e.compositeRule && l ? 
					/* istanbul ignore if */
					e.async ? r += " throw new ValidationError([" + D + "]); " : r += " validate.errors = [" + D + "]; return false; " : r += " var err = " + D + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else { ";
				} else {
					r += " if ( ";
					var O = m;
					if (O) for (var k, C = -1, A = O.length - 1; C < A;) {
						k = O[C += 1], C && (r += " || ");
						var j = e.util.getProperty(k), M = u + j;
						r += " ( ( " + M + " === undefined ", S && (r += " || ! Object.prototype.hasOwnProperty.call(" + u + ", '" + e.util.escapeQuotes(k) + "') "), r += ") && (missing" + i + " = " + e.util.toQuotedString(e.opts.jsonPointers ? k : j) + ") ) ";
					}
					r += ") {  ";
					var w = "missing" + i, T = "' + " + w + " + '";
					e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(b, w, !0) : b + " + " + w);
					var E = E || [];
					E.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { missingProperty: '" + T + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + T + "\\'", r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
					var D = r;
					r = E.pop(), !e.compositeRule && l ? 
					/* istanbul ignore if */
					e.async ? r += " throw new ValidationError([" + D + "]); " : r += " validate.errors = [" + D + "]; return false; " : r += " var err = " + D + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else { ";
				}
			} else if (x) {
				f || (r += " var " + p + " = validate.schema" + s + "; ");
				var C = "i" + i, w = "schema" + i + "[" + C + "]", T = "' + " + w + " + '";
				e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(b, w, e.opts.jsonPointers)), f && (r += " if (" + p + " && !Array.isArray(" + p + ")) {  var err =   ", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { missingProperty: '" + T + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + T + "\\'", r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } "), r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + p + " !== undefined) { "), r += " for (var " + C + " = 0; " + C + " < " + p + ".length; " + C + "++) { if (" + u + "[" + p + "[" + C + "]] === undefined ", S && (r += " || ! Object.prototype.hasOwnProperty.call(" + u + ", " + p + "[" + C + "]) "), r += ") {  var err =   ", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { missingProperty: '" + T + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + T + "\\'", r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } "), r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ", f && (r += "  }  ");
			} else {
				var N = m;
				if (N) for (var k, P = -1, F = N.length - 1; P < F;) {
					k = N[P += 1];
					var j = e.util.getProperty(k), T = e.util.escapeQuotes(k), M = u + j;
					e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(b, k, e.opts.jsonPointers)), r += " if ( " + M + " === undefined ", S && (r += " || ! Object.prototype.hasOwnProperty.call(" + u + ", '" + e.util.escapeQuotes(k) + "') "), r += ") {  var err =   ", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { missingProperty: '" + T + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + T + "\\'", r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } "), r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
				}
			}
			e.errorPath = b;
		} else l && (r += " if (true) {");
		return r;
	};
})), Ga = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u = "data" + (a || ""), d = "valid" + i, f = e.opts.$data && o && o.$data, p;
		if (f ? (r += " var schema" + i + " = " + e.util.getData(o.$data, a, e.dataPathArr) + "; ", p = "schema" + i) : p = o, (o || f) && e.opts.uniqueItems !== !1) {
			f && (r += " var " + d + "; if (" + p + " === false || " + p + " === undefined) " + d + " = true; else if (typeof " + p + " != 'boolean') " + d + " = false; else { "), r += " var i = " + u + ".length , " + d + " = true , j; if (i > 1) { ";
			var m = e.schema.items && e.schema.items.type, h = Array.isArray(m);
			if (!m || m == "object" || m == "array" || h && (m.indexOf("object") >= 0 || m.indexOf("array") >= 0)) r += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + u + "[i], " + u + "[j])) { " + d + " = false; break outer; } } } ";
			else {
				r += " var itemIndices = {}, item; for (;i--;) { var item = " + u + "[i]; ";
				var g = "checkDataType" + (h ? "s" : "");
				r += " if (" + e.util[g](m, "item", e.opts.strictNumbers, !0) + ") continue; ", h && (r += " if (typeof item == 'string') item = '\"' + item; "), r += " if (typeof itemIndices[item] == 'number') { " + d + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ";
			}
			r += " } ", f && (r += "  }  "), r += " if (!" + d + ") {   ";
			var _ = _ || [];
			_.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { i: i, j: j } ", e.opts.messages !== !1 && (r += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "), e.opts.verbose && (r += " , schema:  ", r += f ? "validate.schema" + s : "" + o, r += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), r += " } ");
			var v = r;
			r = _.pop(), !e.compositeRule && l ? 
			/* istanbul ignore if */
			e.async ? r += " throw new ValidationError([" + v + "]); " : r += " validate.errors = [" + v + "]; return false; " : r += " var err = " + v + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ", l && (r += " else { ");
		} else l && (r += " if (true) { ");
		return r;
	};
})), Ka = /* @__PURE__ */ $(((e, t) => {
	t.exports = {
		$ref: Ca(),
		allOf: wa(),
		anyOf: Ta(),
		$comment: Ea(),
		const: Da(),
		contains: Oa(),
		dependencies: ka(),
		enum: Aa(),
		format: ja(),
		if: Ma(),
		items: Na(),
		maximum: Pa(),
		minimum: Pa(),
		maxItems: Fa(),
		minItems: Fa(),
		maxLength: Ia(),
		minLength: Ia(),
		maxProperties: La(),
		minProperties: La(),
		multipleOf: Ra(),
		not: za(),
		oneOf: Ba(),
		pattern: Va(),
		properties: Ha(),
		propertyNames: Ua(),
		required: Wa(),
		uniqueItems: Ga(),
		validate: ya()
	};
})), qa = /* @__PURE__ */ $(((e, t) => {
	var n = Ka(), r = pa().toHash;
	t.exports = function() {
		var e = [
			{
				type: "number",
				rules: [
					{ maximum: ["exclusiveMaximum"] },
					{ minimum: ["exclusiveMinimum"] },
					"multipleOf",
					"format"
				]
			},
			{
				type: "string",
				rules: [
					"maxLength",
					"minLength",
					"pattern",
					"format"
				]
			},
			{
				type: "array",
				rules: [
					"maxItems",
					"minItems",
					"items",
					"contains",
					"uniqueItems"
				]
			},
			{
				type: "object",
				rules: [
					"maxProperties",
					"minProperties",
					"required",
					"dependencies",
					"propertyNames",
					{ properties: ["additionalProperties", "patternProperties"] }
				]
			},
			{ rules: [
				"$ref",
				"const",
				"enum",
				"not",
				"anyOf",
				"oneOf",
				"allOf",
				"if"
			] }
		], t = ["type", "$comment"];
		return e.all = r(t), e.types = r([
			"number",
			"integer",
			"string",
			"array",
			"object",
			"boolean",
			"null"
		]), e.forEach(function(r) {
			r.rules = r.rules.map(function(r) {
				var i;
				if (typeof r == "object") {
					var a = Object.keys(r)[0];
					i = r[a], r = a, i.forEach(function(n) {
						t.push(n), e.all[n] = !0;
					});
				}
				return t.push(r), e.all[r] = {
					keyword: r,
					code: n[r],
					implements: i
				};
			}), e.all.$comment = {
				keyword: "$comment",
				code: n.$comment
			}, r.type && (e.types[r.type] = r);
		}), e.keywords = r(t.concat([
			"$schema",
			"$id",
			"id",
			"$data",
			"$async",
			"title",
			"description",
			"default",
			"definitions",
			"examples",
			"readOnly",
			"writeOnly",
			"contentMediaType",
			"contentEncoding",
			"additionalItems",
			"then",
			"else"
		])), e.custom = {}, e;
	};
})), Ja = /* @__PURE__ */ $(((e, t) => {
	var n = [
		"multipleOf",
		"maximum",
		"exclusiveMaximum",
		"minimum",
		"exclusiveMinimum",
		"maxLength",
		"minLength",
		"pattern",
		"additionalItems",
		"maxItems",
		"minItems",
		"uniqueItems",
		"maxProperties",
		"minProperties",
		"required",
		"additionalProperties",
		"enum",
		"format",
		"const"
	];
	t.exports = function(e, t) {
		for (var r = 0; r < t.length; r++) {
			e = JSON.parse(JSON.stringify(e));
			for (var i = t[r].split("/"), a = e, o = 1; o < i.length; o++) a = a[i[o]];
			for (o = 0; o < n.length; o++) {
				var s = n[o], c = a[s];
				c && (a[s] = { anyOf: [c, { $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#" }] });
			}
		}
		return e;
	};
})), Ya = /* @__PURE__ */ $(((e, t) => {
	var n = _a().MissingRef;
	t.exports = r;
	function r(e, t, i) {
		var a = this;
		if (typeof this._opts.loadSchema != "function") throw Error("options.loadSchema should be a function");
		typeof t == "function" && (i = t, t = void 0);
		var o = s(e).then(function() {
			var n = a._addSchema(e, void 0, t);
			return n.validate || c(n);
		});
		return i && o.then(function(e) {
			i(null, e);
		}, i), o;
		function s(e) {
			var t = e.$schema;
			return t && !a.getSchema(t) ? r.call(a, { $ref: t }, !0) : Promise.resolve();
		}
		function c(e) {
			try {
				return a._compile(e);
			} catch (e) {
				if (e instanceof n) return r(e);
				throw e;
			}
			function r(n) {
				var r = n.missingSchema;
				if (l(r)) throw Error("Schema " + r + " is loaded but " + n.missingRef + " cannot be resolved");
				var i = a._loadingSchemas[r];
				return i || (i = a._loadingSchemas[r] = a._opts.loadSchema(r), i.then(o, o)), i.then(function(e) {
					if (!l(r)) return s(e).then(function() {
						l(r) || a.addSchema(e, r, void 0, t);
					});
				}).then(function() {
					return c(e);
				});
				function o() {
					delete a._loadingSchemas[r];
				}
				function l(e) {
					return a._refs[e] || a._schemas[e];
				}
			}
		}
	}
})), Xa = /* @__PURE__ */ $(((e, t) => {
	t.exports = function(e, t, n) {
		var r = " ", i = e.level, a = e.dataLevel, o = e.schema[t], s = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, l = !e.opts.allErrors, u, d = "data" + (a || ""), f = "valid" + i, p = "errs__" + i, m = e.opts.$data && o && o.$data, h;
		m ? (r += " var schema" + i + " = " + e.util.getData(o.$data, a, e.dataPathArr) + "; ", h = "schema" + i) : h = o;
		var g = this, _ = "definition" + i, v = g.definition, y = "", b, x, S, C, w;
		if (m && v.$data) {
			w = "keywordValidate" + i;
			var T = v.validateSchema;
			r += " var " + _ + " = RULES.custom['" + t + "'].definition; var " + w + " = " + _ + ".validate;";
		} else {
			if (C = e.useCustomRule(g, o, e.schema, e), !C) return;
			h = "validate.schema" + s, w = C.code, b = v.compile, x = v.inline, S = v.macro;
		}
		var E = w + ".errors", D = "i" + i, O = "ruleErr" + i, k = v.async;
		if (k && !e.async) throw Error("async keyword in sync schema");
		if (x || S || (r += "" + E + " = null;"), r += "var " + p + " = errors;var " + f + ";", m && v.$data && (y += "}", r += " if (" + h + " === undefined) { " + f + " = true; } else { ", T && (y += "}", r += " " + f + " = " + _ + ".validateSchema(" + h + "); if (" + f + ") { ")), x) v.statements ? r += " " + C.validate + " " : r += " " + f + " = " + C.validate + "; ";
		else if (S) {
			var A = e.util.copy(e), y = "";
			A.level++;
			var j = "valid" + A.level;
			A.schema = C.validate, A.schemaPath = "";
			var M = e.compositeRule;
			e.compositeRule = A.compositeRule = !0;
			var N = e.validate(A).replace(/validate\.schema/g, w);
			e.compositeRule = A.compositeRule = M, r += " " + N;
		} else {
			var P = P || [];
			P.push(r), r = "", r += "  " + w + ".call( ", e.opts.passContext ? r += "this" : r += "self", b || v.schema === !1 ? r += " , " + d + " " : r += " , " + h + " , " + d + " , validate.schema" + e.schemaPath + " ", r += " , (dataPath || '')", e.errorPath != "\"\"" && (r += " + " + e.errorPath);
			var F = a ? "data" + (a - 1 || "") : "parentData", I = a ? e.dataPathArr[a] : "parentDataProperty";
			r += " , " + F + " , " + I + " , rootData )  ";
			var R = r;
			r = P.pop(), v.errors === !1 ? (r += " " + f + " = ", k && (r += "await "), r += "" + R + "; ") : k ? (E = "customErrors" + i, r += " var " + E + " = null; try { " + f + " = await " + R + "; } catch (e) { " + f + " = false; if (e instanceof ValidationError) " + E + " = e.errors; else throw e; } ") : r += " " + E + " = null; " + f + " = " + R + "; ";
		}
		if (v.modifying && (r += " if (" + F + ") " + d + " = " + F + "[" + I + "];"), r += "" + y, v.valid) l && (r += " if (true) { ");
		else {
			r += " if ( ", v.valid === void 0 ? (r += " !", r += S ? "" + j : "" + f) : r += " " + !v.valid + " ", r += ") { ", u = g.keyword;
			var P = P || [];
			P.push(r), r = "";
			var P = P || [];
			P.push(r), r = "", e.createErrors === !1 ? r += " {} " : (r += " { keyword: '" + (u || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { keyword: '" + g.keyword + "' } ", e.opts.messages !== !1 && (r += " , message: 'should pass \"" + g.keyword + "\" keyword validation' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), r += " } ");
			var z = r;
			r = P.pop(), !e.compositeRule && l ? 
			/* istanbul ignore if */
			e.async ? r += " throw new ValidationError([" + z + "]); " : r += " validate.errors = [" + z + "]; return false; " : r += " var err = " + z + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
			var B = r;
			r = P.pop(), x ? v.errors ? v.errors != "full" && (r += "  for (var " + D + "=" + p + "; " + D + "<errors; " + D + "++) { var " + O + " = vErrors[" + D + "]; if (" + O + ".dataPath === undefined) " + O + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + O + ".schemaPath === undefined) { " + O + ".schemaPath = \"" + c + "\"; } ", e.opts.verbose && (r += " " + O + ".schema = " + h + "; " + O + ".data = " + d + "; "), r += " } ") : v.errors === !1 ? r += " " + B + " " : (r += " if (" + p + " == errors) { " + B + " } else {  for (var " + D + "=" + p + "; " + D + "<errors; " + D + "++) { var " + O + " = vErrors[" + D + "]; if (" + O + ".dataPath === undefined) " + O + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + O + ".schemaPath === undefined) { " + O + ".schemaPath = \"" + c + "\"; } ", e.opts.verbose && (r += " " + O + ".schema = " + h + "; " + O + ".data = " + d + "; "), r += " } } ") : S ? (r += "   var err =   ", e.createErrors === !1 ? r += " {} " : (r += " { keyword: '" + (u || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { keyword: '" + g.keyword + "' } ", e.opts.messages !== !1 && (r += " , message: 'should pass \"" + g.keyword + "\" keyword validation' "), e.opts.verbose && (r += " , schema: validate.schema" + s + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), r += " } "), r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && l && 
			/* istanbul ignore if */
			(e.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; ")) : v.errors === !1 ? r += " " + B + " " : (r += " if (Array.isArray(" + E + ")) { if (vErrors === null) vErrors = " + E + "; else vErrors = vErrors.concat(" + E + "); errors = vErrors.length;  for (var " + D + "=" + p + "; " + D + "<errors; " + D + "++) { var " + O + " = vErrors[" + D + "]; if (" + O + ".dataPath === undefined) " + O + ".dataPath = (dataPath || '') + " + e.errorPath + ";  " + O + ".schemaPath = \"" + c + "\";  ", e.opts.verbose && (r += " " + O + ".schema = " + h + "; " + O + ".data = " + d + "; "), r += " } } else { " + B + " } "), r += " } ", l && (r += " else { ");
		}
		return r;
	};
})), Za = /* @__PURE__ */ Jn({
	$id: () => $a,
	$schema: () => Qa,
	default: () => io,
	definitions: () => to,
	properties: () => ro,
	title: () => eo,
	type: () => no
}), Qa, $a, eo, to, no, ro, io, ao = qn((() => {
	Qa = "http://json-schema.org/draft-07/schema#", $a = "http://json-schema.org/draft-07/schema#", eo = "Core schema meta-schema", to = {
		schemaArray: {
			type: "array",
			minItems: 1,
			items: { $ref: "#" }
		},
		nonNegativeInteger: {
			type: "integer",
			minimum: 0
		},
		nonNegativeIntegerDefault0: { allOf: [{ $ref: "#/definitions/nonNegativeInteger" }, { default: 0 }] },
		simpleTypes: { enum: [
			"array",
			"boolean",
			"integer",
			"null",
			"number",
			"object",
			"string"
		] },
		stringArray: {
			type: "array",
			items: { type: "string" },
			uniqueItems: !0,
			default: []
		}
	}, no = ["object", "boolean"], ro = {
		$id: {
			type: "string",
			format: "uri-reference"
		},
		$schema: {
			type: "string",
			format: "uri"
		},
		$ref: {
			type: "string",
			format: "uri-reference"
		},
		$comment: { type: "string" },
		title: { type: "string" },
		description: { type: "string" },
		default: !0,
		readOnly: {
			type: "boolean",
			default: !1
		},
		examples: {
			type: "array",
			items: !0
		},
		multipleOf: {
			type: "number",
			exclusiveMinimum: 0
		},
		maximum: { type: "number" },
		exclusiveMaximum: { type: "number" },
		minimum: { type: "number" },
		exclusiveMinimum: { type: "number" },
		maxLength: { $ref: "#/definitions/nonNegativeInteger" },
		minLength: { $ref: "#/definitions/nonNegativeIntegerDefault0" },
		pattern: {
			type: "string",
			format: "regex"
		},
		additionalItems: { $ref: "#" },
		items: {
			anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }],
			default: !0
		},
		maxItems: { $ref: "#/definitions/nonNegativeInteger" },
		minItems: { $ref: "#/definitions/nonNegativeIntegerDefault0" },
		uniqueItems: {
			type: "boolean",
			default: !1
		},
		contains: { $ref: "#" },
		maxProperties: { $ref: "#/definitions/nonNegativeInteger" },
		minProperties: { $ref: "#/definitions/nonNegativeIntegerDefault0" },
		required: { $ref: "#/definitions/stringArray" },
		additionalProperties: { $ref: "#" },
		definitions: {
			type: "object",
			additionalProperties: { $ref: "#" },
			default: {}
		},
		properties: {
			type: "object",
			additionalProperties: { $ref: "#" },
			default: {}
		},
		patternProperties: {
			type: "object",
			additionalProperties: { $ref: "#" },
			propertyNames: { format: "regex" },
			default: {}
		},
		dependencies: {
			type: "object",
			additionalProperties: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }] }
		},
		propertyNames: { $ref: "#" },
		const: !0,
		enum: {
			type: "array",
			items: !0,
			minItems: 1,
			uniqueItems: !0
		},
		type: { anyOf: [{ $ref: "#/definitions/simpleTypes" }, {
			type: "array",
			items: { $ref: "#/definitions/simpleTypes" },
			minItems: 1,
			uniqueItems: !0
		}] },
		format: { type: "string" },
		contentMediaType: { type: "string" },
		contentEncoding: { type: "string" },
		if: { $ref: "#" },
		then: { $ref: "#" },
		else: { $ref: "#" },
		allOf: { $ref: "#/definitions/schemaArray" },
		anyOf: { $ref: "#/definitions/schemaArray" },
		oneOf: { $ref: "#/definitions/schemaArray" },
		not: { $ref: "#" }
	}, io = {
		$schema: Qa,
		$id: $a,
		title: eo,
		definitions: to,
		type: no,
		properties: ro,
		default: !0
	};
})), oo = /* @__PURE__ */ $(((e, t) => {
	var n = (ao(), Zn(Za).default);
	t.exports = {
		$id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
		definitions: { simpleTypes: n.definitions.simpleTypes },
		type: "object",
		dependencies: {
			schema: ["validate"],
			$data: ["validate"],
			statements: ["inline"],
			valid: { not: { required: ["macro"] } }
		},
		properties: {
			type: n.properties.type,
			schema: { type: "boolean" },
			statements: { type: "boolean" },
			dependencies: {
				type: "array",
				items: { type: "string" }
			},
			metaSchema: { type: "object" },
			modifying: { type: "boolean" },
			valid: { type: "boolean" },
			$data: { type: "boolean" },
			async: { type: "boolean" },
			errors: { anyOf: [{ type: "boolean" }, { const: "full" }] }
		}
	};
})), so = /* @__PURE__ */ $(((e, t) => {
	var n = /^[a-z_$][a-z0-9_$-]*$/i, r = Xa(), i = oo();
	t.exports = {
		add: a,
		get: o,
		remove: s,
		validate: c
	};
	function a(e, t) {
		var i = this.RULES;
		if (i.keywords[e]) throw Error("Keyword " + e + " is already defined");
		if (!n.test(e)) throw Error("Keyword " + e + " is not a valid identifier");
		if (t) {
			this.validateKeyword(t, !0);
			var a = t.type;
			if (Array.isArray(a)) for (var o = 0; o < a.length; o++) c(e, a[o], t);
			else c(e, a, t);
			var s = t.metaSchema;
			s && (t.$data && this._opts.$data && (s = { anyOf: [s, { $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#" }] }), t.validateSchema = this.compile(s, !0));
		}
		i.keywords[e] = i.all[e] = !0;
		function c(e, t, n) {
			for (var a, o = 0; o < i.length; o++) {
				var s = i[o];
				if (s.type == t) {
					a = s;
					break;
				}
			}
			a || (a = {
				type: t,
				rules: []
			}, i.push(a));
			var c = {
				keyword: e,
				definition: n,
				custom: !0,
				code: r,
				implements: n.implements
			};
			a.rules.push(c), i.custom[e] = c;
		}
		return this;
	}
	function o(e) {
		var t = this.RULES.custom[e];
		return t ? t.definition : this.RULES.keywords[e] || !1;
	}
	function s(e) {
		var t = this.RULES;
		delete t.keywords[e], delete t.all[e], delete t.custom[e];
		for (var n = 0; n < t.length; n++) for (var r = t[n].rules, i = 0; i < r.length; i++) if (r[i].keyword == e) {
			r.splice(i, 1);
			break;
		}
		return this;
	}
	function c(e, t) {
		c.errors = null;
		var n = this._validateKeyword = this._validateKeyword || this.compile(i, !0);
		if (n(e)) return !0;
		if (c.errors = n.errors, t) throw Error("custom keyword definition is invalid: " + this.errorsText(n.errors));
		return !1;
	}
})), co = /* @__PURE__ */ Jn({
	$id: () => uo,
	$schema: () => lo,
	additionalProperties: () => !1,
	default: () => go,
	description: () => fo,
	properties: () => ho,
	required: () => mo,
	type: () => po
}), lo, uo, fo, po, mo, ho, go, _o = qn((() => {
	lo = "http://json-schema.org/draft-07/schema#", uo = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#", fo = "Meta-schema for $data reference (JSON Schema extension proposal)", po = "object", mo = ["$data"], ho = { $data: {
		type: "string",
		anyOf: [{ format: "relative-json-pointer" }, { format: "json-pointer" }]
	} }, go = {
		$schema: lo,
		$id: uo,
		description: fo,
		type: po,
		required: mo,
		properties: ho,
		additionalProperties: !1
	};
})), vo = /* @__PURE__ */ Xn((/* @__PURE__ */ $(((e, t) => {
	var n = ba(), r = ga(), i = xa(), a = ma(), o = va(), s = Sa(), c = qa(), l = Ja(), u = pa();
	t.exports = g, g.prototype.validate = _, g.prototype.compile = v, g.prototype.addSchema = y, g.prototype.addMetaSchema = b, g.prototype.validateSchema = x, g.prototype.getSchema = C, g.prototype.removeSchema = E, g.prototype.addFormat = F, g.prototype.errorsText = P, g.prototype._addSchema = O, g.prototype._compile = k, g.prototype.compileAsync = Ya();
	var d = so();
	g.prototype.addKeyword = d.add, g.prototype.getKeyword = d.get, g.prototype.removeKeyword = d.remove, g.prototype.validateKeyword = d.validate;
	var f = _a();
	g.ValidationError = f.Validation, g.MissingRefError = f.MissingRef, g.$dataMetaSchema = l;
	var p = "http://json-schema.org/draft-07/schema", m = [
		"removeAdditional",
		"useDefaults",
		"coerceTypes",
		"strictDefaults"
	], h = ["/properties"];
	function g(e) {
		if (!(this instanceof g)) return new g(e);
		e = this._opts = u.copy(e) || {}, te(this), this._schemas = {}, this._refs = {}, this._fragments = {}, this._formats = s(e.format), this._cache = e.cache || new i(), this._loadingSchemas = {}, this._compilations = [], this.RULES = c(), this._getId = A(e), e.loopRequired = e.loopRequired || Infinity, e.errorDataPath == "property" && (e._errorDataPathProperty = !0), e.serialize === void 0 && (e.serialize = o), this._metaOpts = ee(this), e.formats && z(this), e.keywords && B(this), I(this), typeof e.meta == "object" && this.addMetaSchema(e.meta), e.nullable && this.addKeyword("nullable", { metaSchema: { type: "boolean" } }), R(this);
	}
	function _(e, t) {
		var n;
		if (typeof e == "string") {
			if (n = this.getSchema(e), !n) throw Error("no schema with key or ref \"" + e + "\"");
		} else {
			var r = this._addSchema(e);
			n = r.validate || this._compile(r);
		}
		var i = n(t);
		return n.$async !== !0 && (this.errors = n.errors), i;
	}
	function v(e, t) {
		var n = this._addSchema(e, void 0, t);
		return n.validate || this._compile(n);
	}
	function y(e, t, n, i) {
		if (Array.isArray(e)) {
			for (var a = 0; a < e.length; a++) this.addSchema(e[a], void 0, n, i);
			return this;
		}
		var o = this._getId(e);
		if (o !== void 0 && typeof o != "string") throw Error("schema id must be string");
		return t = r.normalizeId(t || o), V(this, t), this._schemas[t] = this._addSchema(e, n, i, !0), this;
	}
	function b(e, t, n) {
		return this.addSchema(e, t, n, !0), this;
	}
	function x(e, t) {
		var n = e.$schema;
		if (n !== void 0 && typeof n != "string") throw Error("$schema must be a string");
		if (n = n || this._opts.defaultMeta || S(this), !n) return this.logger.warn("meta-schema not available"), this.errors = null, !0;
		var r = this.validate(n, e);
		if (!r && t) {
			var i = "schema is invalid: " + this.errorsText();
			if (this._opts.validateSchema == "log") this.logger.error(i);
			else throw Error(i);
		}
		return r;
	}
	function S(e) {
		var t = e._opts.meta;
		return e._opts.defaultMeta = typeof t == "object" ? e._getId(t) || t : e.getSchema(p) ? p : void 0, e._opts.defaultMeta;
	}
	function C(e) {
		var t = T(this, e);
		switch (typeof t) {
			case "object": return t.validate || this._compile(t);
			case "string": return this.getSchema(t);
			case "undefined": return w(this, e);
		}
	}
	function w(e, t) {
		var i = r.schema.call(e, { schema: {} }, t);
		if (i) {
			var o = i.schema, s = i.root, c = i.baseId, l = n.call(e, o, s, void 0, c);
			return e._fragments[t] = new a({
				ref: t,
				fragment: !0,
				schema: o,
				root: s,
				baseId: c,
				validate: l
			}), l;
		}
	}
	function T(e, t) {
		return t = r.normalizeId(t), e._schemas[t] || e._refs[t] || e._fragments[t];
	}
	function E(e) {
		if (e instanceof RegExp) return D(this, this._schemas, e), D(this, this._refs, e), this;
		switch (typeof e) {
			case "undefined": return D(this, this._schemas), D(this, this._refs), this._cache.clear(), this;
			case "string":
				var t = T(this, e);
				return t && this._cache.del(t.cacheKey), delete this._schemas[e], delete this._refs[e], this;
			case "object":
				var n = this._opts.serialize, i = n ? n(e) : e;
				this._cache.del(i);
				var a = this._getId(e);
				a && (a = r.normalizeId(a), delete this._schemas[a], delete this._refs[a]);
		}
		return this;
	}
	function D(e, t, n) {
		for (var r in t) {
			var i = t[r];
			!i.meta && (!n || n.test(r)) && (e._cache.del(i.cacheKey), delete t[r]);
		}
	}
	function O(e, t, n, i) {
		if (typeof e != "object" && typeof e != "boolean") throw Error("schema should be object or boolean");
		var o = this._opts.serialize, s = o ? o(e) : e, c = this._cache.get(s);
		if (c) return c;
		i ||= this._opts.addUsedSchema !== !1;
		var l = r.normalizeId(this._getId(e));
		l && i && V(this, l);
		var u = this._opts.validateSchema !== !1 && !t, d;
		u && !(d = l && l == r.normalizeId(e.$schema)) && this.validateSchema(e, !0);
		var f = new a({
			id: l,
			schema: e,
			localRefs: r.ids.call(this, e),
			cacheKey: s,
			meta: n
		});
		return l[0] != "#" && i && (this._refs[l] = f), this._cache.put(s, f), u && d && this.validateSchema(e, !0), f;
	}
	function k(e, t) {
		if (e.compiling) return e.validate = a, a.schema = e.schema, a.errors = null, a.root = t || a, e.schema.$async === !0 && (a.$async = !0), a;
		e.compiling = !0;
		var r;
		e.meta && (r = this._opts, this._opts = this._metaOpts);
		var i;
		try {
			i = n.call(this, e.schema, t, e.localRefs);
		} catch (t) {
			throw delete e.validate, t;
		} finally {
			e.compiling = !1, e.meta && (this._opts = r);
		}
		return e.validate = i, e.refs = i.refs, e.refVal = i.refVal, e.root = i.root, i;
		function a() {
			var t = e.validate, n = t.apply(this, arguments);
			return a.errors = t.errors, n;
		}
	}
	function A(e) {
		switch (e.schemaId) {
			case "auto": return N;
			case "id": return j;
			default: return M;
		}
	}
	function j(e) {
		return e.$id && this.logger.warn("schema $id ignored", e.$id), e.id;
	}
	function M(e) {
		return e.id && this.logger.warn("schema id ignored", e.id), e.$id;
	}
	function N(e) {
		if (e.$id && e.id && e.$id != e.id) throw Error("schema $id is different from id");
		return e.$id || e.id;
	}
	function P(e, t) {
		if (e ||= this.errors, !e) return "No errors";
		t ||= {};
		for (var n = t.separator === void 0 ? ", " : t.separator, r = t.dataVar === void 0 ? "data" : t.dataVar, i = "", a = 0; a < e.length; a++) {
			var o = e[a];
			o && (i += r + o.dataPath + " " + o.message + n);
		}
		return i.slice(0, -n.length);
	}
	function F(e, t) {
		return typeof t == "string" && (t = new RegExp(t)), this._formats[e] = t, this;
	}
	function I(e) {
		var t;
		if (e._opts.$data && (t = (_o(), Zn(co).default), e.addMetaSchema(t, t.$id, !0)), e._opts.meta !== !1) {
			var n = (ao(), Zn(Za).default);
			e._opts.$data && (n = l(n, h)), e.addMetaSchema(n, p, !0), e._refs["http://json-schema.org/schema"] = p;
		}
	}
	function R(e) {
		var t = e._opts.schemas;
		if (t) {
			if (Array.isArray(t)) e.addSchema(t);
			else for (var n in t) e.addSchema(t[n], n);
		}
	}
	function z(e) {
		for (var t in e._opts.formats) {
			var n = e._opts.formats[t];
			e.addFormat(t, n);
		}
	}
	function B(e) {
		for (var t in e._opts.keywords) {
			var n = e._opts.keywords[t];
			e.addKeyword(t, n);
		}
	}
	function V(e, t) {
		if (e._schemas[t] || e._refs[t]) throw Error("schema with key or id \"" + t + "\" already exists");
	}
	function ee(e) {
		for (var t = u.copy(e._opts), n = 0; n < m.length; n++) delete t[m[n]];
		return t;
	}
	function te(e) {
		var t = e._opts.logger;
		if (t === !1) e.logger = {
			log: ne,
			warn: ne,
			error: ne
		};
		else {
			if (t === void 0 && (t = console), !(typeof t == "object" && t.log && t.warn && t.error)) throw Error("logger must implement log, warn and error methods");
			e.logger = t;
		}
	}
	function ne() {}
})))(), 1), yo = /* @__PURE__ */ new Ht(), bo = new vo.default(), xo = {
	$schema: "http://json-schema.org/draft-07/schema#",
	type: "object",
	patternProperties: { ".*": {
		type: "object",
		properties: { matrix: {
			type: "array",
			items: { type: "number" },
			minItems: 16,
			maxItems: 16
		} },
		required: ["matrix"],
		additionalProperties: !1
	} },
	additionalProperties: !1
}, So = () => {
	let { viewport: e } = ce(), { viewer: t } = H(), [r, i] = n.useState(!1), [a, o] = n.useState(null), { t: s } = h("teiaviewer"), l = d(null), u = () => {
		let n = a;
		n || (n = new ze(e), o(n)), new jt(t).execute(), r ? (i(!1), e.resetDefaultOperator()) : (i(!0), e.setOperator(n), e.canvas.focus());
	}, f = () => {
		l.current?.click();
	}, p = async (e) => {
		let t = e.target.files?.[0];
		if (t) {
			try {
				let e = await t.text(), n = JSON.parse(e);
				m(n) && g(n);
			} catch {
				Pt.instance.pushNotification({
					type: "viewer_info",
					status: "error",
					message: s("widgets.object_translations.import_error.text"),
					title: s("widgets.object_translations.import_error.title")
				});
			}
			l.current && (l.current.value = "");
		}
	}, m = (e) => {
		let t = s("widgets.object_translations.import_success.text"), n = s("widgets.object_translations.import_success.title"), r = bo.compile(xo)(e);
		return r || (t = s("widgets.object_translations.import_warning.text"), n = s("widgets.object_translations.import_warning.title")), Pt.instance.pushNotification({
			type: "viewer_info",
			status: r ? "success" : "warning",
			message: t,
			title: n
		}), r;
	}, g = (e) => {
		let n = [];
		for (let r of t.scene.bimMeshController.getAllObjects()) {
			let i = e[r.uuid];
			i?.matrix && (yo.fromArray(i.matrix), n.push(new Rt(t, r.uuid, yo)));
		}
		let r = new Nt(t, n);
		r.isUndoable = !0, r.execute(), t.requestRender();
	}, _ = () => {
		let e = {};
		for (let n of t.scene.bimMeshController.getAllObjects()) {
			let r = n.getStateController();
			if (r._stateIds.size === 0) continue;
			let i = !1;
			for (let e of r._stateIds) if (t.objectStateHistory.getState(e)?.matrix) {
				i = !0;
				break;
			}
			i && (e[n.uuid] = { matrix: n.getMatrix(yo).toArray() });
		}
		return e;
	};
	return c(() => {
		let n = () => {
			for (let n of t.scene.objectSelection.getObjects()) if (!n.isBimMesh) {
				i(!1), e.resetDefaultOperator();
				break;
			}
		};
		return t.signals.onObjectSelectionChanged.connect(n), () => {
			t.signals.onObjectSelectionChanged.disconnect(n);
		};
	}, [e, t]), c(() => {
		let e = (e) => {
			e.name !== "ObjectTransformOperator" && i(!1);
		};
		return t.signals.onOperatorChanged.connect(e), () => {
			t.signals.onOperatorChanged.disconnect(e);
		};
	}, [t]), /* @__PURE__ */ K(V, {
		"data-testid": "object-transform-toolbar-menu",
		icon: ca,
		label: s("toolbar.object_translations.tooltip"),
		"data-dd-action-name": "toolbar.object_translations",
		children: [
			/* @__PURE__ */ G("input", {
				"data-testid": "object-transform-import-input",
				type: "file",
				style: { display: "none" },
				ref: l,
				onChange: p
			}),
			/* @__PURE__ */ G(B, {
				"data-testid": "object-transform-import-toolbar-item",
				icon: sa,
				label: s("toolbar.object_translations_import.tooltip"),
				"data-dd-action-name": "toolbar.object_translations_import",
				onClick: f
			}),
			/* @__PURE__ */ G(B, {
				"data-testid": "object-transform-export-toolbar-item",
				icon: oa,
				label: s("toolbar.object_translations_download.tooltip"),
				"data-dd-action-name": "toolbar.object_translations_download",
				onClick: () => {
					let e = new Blob([JSON.stringify(_())]), t = document.createElement("a"), n = /* @__PURE__ */ new Date();
					t.download = `object_positions_${n.getDate()}/${n.getMonth() + 1}/${n.getFullYear()}_${n.getHours()}:${n.getMinutes()}:${n.getSeconds()}.json`;
					let r = URL.createObjectURL(e);
					t.href = r, t.click(), URL.revokeObjectURL(r), Pt.instance.pushNotification({
						type: "viewer_info",
						status: "success",
						message: s("widgets.object_translations.export_sucess.text"),
						title: s("widgets.object_translations.export_sucess.title")
					});
				}
			}),
			/* @__PURE__ */ G(B, {
				"data-testid": "object-transform-mode-toolbar-item",
				icon: la,
				onClick: u,
				label: s("toolbar.object_translations_widget.tooltip"),
				"data-dd-action-name": "toolbar.object_translations_widget",
				active: r
			})
		]
	});
}, Co = (e) => /* @__PURE__ */ K("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", { d: "M12.12 0.649902C12.01 0.649902 11.9 0.679902 11.81 0.739902C11.91 0.679902 12.02 0.649902 12.12 0.649902Z" }),
		/* @__PURE__ */ G("path", { d: "M4.07001 5.64987C4.07001 5.42987 4.19001 5.22987 4.37001 5.11987C4.18001 5.22987 4.07001 5.42987 4.07001 5.64987Z" }),
		/* @__PURE__ */ G("path", { d: "M19.86 5.11987C20.05 5.22987 20.16 5.42987 20.16 5.64987C20.16 5.42987 20.04 5.22987 19.86 5.11987Z" }),
		/* @__PURE__ */ G("path", { d: "M12.43 0.739902C12.33 0.679902 12.22 0.649902 12.12 0.649902C12.23 0.649902 12.34 0.679902 12.43 0.739902Z" }),
		/* @__PURE__ */ G("path", { d: "M19.86 5.1199L12.43 0.739902C12.33 0.679902 12.22 0.649902 12.12 0.649902C12.02 0.649902 11.9 0.679902 11.81 0.739902L4.38002 5.1199C4.19002 5.2299 4.08002 5.4299 4.08002 5.6499V13.1599C4.08002 13.3799 4.20002 13.5799 4.38002 13.6899L8.70002 16.2399L9.89002 15.5399L10.88 16.0899L7.90002 14.3299L5.32002 12.8099V6.7299L11.51 10.3799V16.4599L11.14 16.2399L9.89002 16.9399L11.81 18.0699C11.81 18.0699 11.91 18.0999 11.96 18.1099C12.01 18.1299 12.07 18.1499 12.12 18.1499C12.17 18.1499 12.23 18.1199 12.28 18.1099C12.33 18.0999 12.39 18.0999 12.43 18.0699L14.25 16.9999L13.42 16.5099L13.1 16.3199L14.25 15.5599L15.47 16.2799L19.86 13.6899C20.05 13.5799 20.16 13.3799 20.16 13.1599V5.6499C20.16 5.4299 20.04 5.2299 19.86 5.1199ZM12.12 9.3199L5.91002 5.6499L12.12 1.9899L18.33 5.6499L12.12 9.3099V9.3199ZM18.93 9.2799V12.8099L16.35 14.3299L12.74 16.4599V10.3799L18.93 6.7299V9.2699V9.2799Z" }),
		/* @__PURE__ */ G("path", { d: "M18.26 19.3699L15.6 20.9399L15.19 21.1799L12.06 23.0299L8.89 21.1599L8.49 20.9199L5.86 19.3699H5.84L9.06 17.4199L9.47 17.1799L9.89 16.9499L8.7 16.2499L4.3 18.8399C4.11 18.9499 4 19.1499 4 19.3699C4 19.5899 4.12 19.7999 4.3 19.9099L11.73 24.2899C11.73 24.2899 11.83 24.3199 11.88 24.3299C11.93 24.3399 11.99 24.3699 12.04 24.3699C12.09 24.3699 12.15 24.3399 12.2 24.3299C12.25 24.3199 12.31 24.3199 12.35 24.2899L19.78 19.9099C19.97 19.7999 20.08 19.5999 20.08 19.3799C20.08 19.1599 19.96 18.9499 19.78 18.8399L15.46 16.2899L14.24 17.0099L18.25 19.3699H18.26Z" }),
		/* @__PURE__ */ G("path", { d: "M11.14 16.2399L10.87 16.0999L11.13 16.2499L11.14 16.2399Z" }),
		/* @__PURE__ */ G("path", { d: "M13.1 16.3299L13.42 16.5199L14.25 17.0099L15.47 16.2899L14.25 15.5699L13.1 16.3299Z" }),
		/* @__PURE__ */ G("path", { d: "M11.13 16.2499L10.87 16.0999L9.89001 15.5499L8.70001 16.2499L9.89001 16.9499L11.13 16.2499Z" })
	]
}), wo = () => {
	let { viewer: e } = H(), { t } = h("teiaviewer"), n = Qi(), { isOpened: r } = le("Projection"), i = re("Projection");
	return /* @__PURE__ */ G(B, {
		"data-testid": "projection-toolbar-item",
		active: r,
		disabled: !i || n?.sourceType !== nt.Twin,
		label: t("toolbar.projection.tooltip"),
		onClick: () => {
			new D(e, "Projection").execute();
		},
		icon: Co
	});
}, To = (e) => /* @__PURE__ */ G("svg", {
	viewBox: "0 0 20 22",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ G("path", {
		d: "M12.717.329a.796.796 0 0 0-.388.388c-.057.125-.061.271-.062 2.341v2.209h-2.209c-2.07.001-2.216.005-2.341.062a.729.729 0 0 0 0 1.342c.125.057.271.061 2.341.062h2.209v2.209c.001 2.07.005 2.216.062 2.341.172.374.603.549.954.388a.796.796 0 0 0 .388-.388c.057-.125.061-.271.062-2.341V6.733h2.209c2.07-.001 2.216-.005 2.341-.062a.796.796 0 0 0 .388-.388c.161-.351-.014-.782-.388-.954-.125-.057-.271-.061-2.341-.062h-2.209V3.058c-.001-2.07-.005-2.216-.062-2.341-.172-.374-.603-.549-.954-.388m-4.9 1.961a9.328 9.328 0 0 0-2.11.462c-.461.168-1.333.607-1.724.866a8.17 8.17 0 0 0-2.85 3.232C.82 7.483.666 7.893.518 8.482.33 9.227.285 9.62.285 10.5c0 .885.042 1.248.233 2.01.154.612.299 1 .615 1.64a8.049 8.049 0 0 0 3.717 3.717c.64.316 1.028.462 1.64.615a7.449 7.449 0 0 0 1.71.24 8.165 8.165 0 0 0 5.246-1.646l.33-.249 2.387 2.385c1.834 1.833 2.422 2.4 2.537 2.452.606.274 1.238-.358.964-.964-.052-.115-.619-.703-2.452-2.537l-2.385-2.387.249-.33A8.271 8.271 0 0 0 16.7 11.25c.051-.561.042-.877-.029-1.033-.22-.48-.818-.596-1.184-.23a.77.77 0 0 0-.22.563 7.309 7.309 0 0 1-.37 2.141 6.746 6.746 0 0 1-4.206 4.206c-3.212 1.101-6.784-.375-8.259-3.414-1.786-3.679.024-8.058 3.877-9.38a7.309 7.309 0 0 1 2.141-.37c.33-.002.589-.163.721-.45.161-.351-.014-.782-.388-.954-.105-.048-.207-.06-.483-.056-.193.003-.41.01-.483.017",
		fillRule: "evenodd"
	})
}), Eo = () => {
	let { t: e } = h("teiaviewer");
	return /* @__PURE__ */ G(V, {
		"data-testid": "teia-search-toolbar-menu",
		icon: Tr,
		label: e("teia.toolbar.search.tooltip"),
		"data-dd-action-name": "teia.toolbar.search",
		children: /* @__PURE__ */ G(_, {
			sx: { paddingX: 2 },
			children: /* @__PURE__ */ G(Oo, {})
		})
	});
}, Do = [
	{
		operator: "Contains",
		type: "Property",
		property: "Element Specific",
		name: "Name",
		value: ""
	},
	{
		operator: "EqualTo",
		type: "Guid",
		value: ""
	},
	{
		operator: "Contains",
		type: "Type",
		value: ""
	}
], Oo = () => Qi(nt.Twin) ? /* @__PURE__ */ G(ko, {}) : /* @__PURE__ */ G(j, {}), ko = () => {
	let { viewer: t } = H(), { closeParentMenu: n } = ae(), { t: r } = h("teiaviewer");
	return /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 2,
		children: [/* @__PURE__ */ G(j, { useSearchHook: Ao }), /* @__PURE__ */ G(b, {
			title: r("teia.toolbar.search.button.tooltip"),
			placement: "bottom",
			children: /* @__PURE__ */ G(v, {
				"data-testid": "teia-search-advanced-button",
				onClick: () => {
					n(), new D(t, "TeiaAdvancedSearch").execute();
				},
				"aria-label": "open-advanced-search",
				"data-dd-action-name": "teia.toolbar.advanced_search.button",
				sx: {
					width: "40px",
					height: "40px"
				},
				icon: To
			})
		})]
	});
}, Ao = (e) => {
	let t = ea(), n = e.split(";"), r = [];
	for (let e of n) for (let t of Do) {
		let n = {
			...t,
			value: e
		};
		r.push(n);
	}
	let { refetch: i } = ri({
		filter: ut([{
			condition: "Or",
			rules: r
		}, t.filter], "And"),
		enabled: !1
	});
	return async () => (await i()).data?.map((e) => e.twinObjectGuid) ?? [];
}, jo = (e) => /* @__PURE__ */ K("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", { d: "M1.79992 19.2151C1.79992 19.3951 1.88992 19.5551 2.04992 19.6451L7.81992 23.0151V16.9951L1.79992 13.4851V19.2151Z" }),
		/* @__PURE__ */ G("path", { d: "M22.5799 6.08511L16.5099 2.54511C16.3499 2.45511 16.1599 2.45511 15.9999 2.54511L9.92992 6.08511C9.76992 6.17511 9.67992 6.34511 9.67992 6.52511V9.89511L8.57992 9.25511C8.41992 9.16511 8.22992 9.16511 8.06992 9.25511L2.29992 12.6151L8.31992 16.1251L11.7699 14.1151L12.7699 14.6951L8.81992 16.9951V23.0151L14.5899 19.6451C14.7399 19.5551 14.8399 19.3951 14.8399 19.2151V15.9051L15.9999 16.5751C16.1599 16.6651 16.3499 16.6651 16.5099 16.5751L22.5799 13.0351C22.7399 12.9451 22.8299 12.7751 22.8299 12.5951V6.52511C22.8299 6.34511 22.7299 6.17511 22.5799 6.08511ZM15.7499 15.2551L10.6899 12.3051V7.40511L15.7499 10.3551V15.2551ZM16.2499 9.48511L11.1799 6.52511L16.2499 3.56511L21.3199 6.52511L16.2499 9.48511ZM21.8199 12.3051L16.7599 15.2551V10.3551L21.8199 7.40511V12.3051Z" }),
		/* @__PURE__ */ G("path", { d: "M9.94992 5.01511L10.7799 1.51511L10.8199 1.37511L10.6799 1.36511L7.10992 0.985107L8.22992 2.57511L0.169922 7.61511L0.699922 8.46511L8.80992 3.39511L9.94992 5.01511Z" })
	]
}), Mo = (e) => /* @__PURE__ */ G("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ G("path", { d: "M19.7495 11.5298C19.7495 8.56305 18.1784 5.96168 15.8208 4.51318C13.1977 6.98332 11.1611 10.0669 9.93213 13.5278C11.2023 14.1103 12.5986 14.4551 14.0708 14.5034C14.1901 14.5073 14.31 14.5103 14.4302 14.5103C16.2908 14.5102 18.0474 14.034 19.5737 13.1978C19.6849 12.6573 19.7495 12.0999 19.7495 11.5298ZM9.53369 14.7759C9.11263 16.2213 8.83429 17.7202 8.70459 19.2632C9.58511 19.5819 10.5286 19.7603 11.52 19.7603C14.864 19.7602 17.744 17.7628 19.0298 14.8979C17.6135 15.4851 16.0618 15.81 14.4302 15.8101C14.1777 15.8101 13.9268 15.8019 13.6782 15.7866C12.2124 15.6964 10.8127 15.3437 9.53369 14.7759ZM11.5298 3.30029C8.4504 3.30034 5.76642 4.99504 4.3501 7.50439C5.19574 9.7577 6.76294 11.646 8.77686 12.8911C10.0277 9.45802 12.0304 6.39676 14.5874 3.89404C13.6414 3.51394 12.6101 3.30029 11.5298 3.30029ZM3.30029 11.5298C3.30029 14.5896 4.96676 17.2504 7.4458 18.6675C7.6069 17.1185 7.91105 15.6169 8.35107 14.1714C6.33636 12.9966 4.69996 11.2511 3.646 9.16357C3.42148 9.91336 3.3003 10.7071 3.30029 11.5298ZM21.0503 11.5298C21.0503 12.2832 20.9569 13.014 20.7944 13.7124C20.7914 13.736 20.7873 13.7596 20.7817 13.7827C19.7727 17.9582 16.0064 21.06 11.52 21.0601C10.1784 21.0601 8.91206 20.7803 7.75537 20.2876C7.71201 20.2691 7.67262 20.2447 7.63525 20.2183C4.3146 18.7306 1.99951 15.4093 1.99951 11.5298C1.99953 9.96477 2.37524 8.48241 3.05225 7.17139L3.20557 6.88623C4.83907 3.97527 7.95162 1.99955 11.5298 1.99951C13.0604 1.99951 14.5052 2.36857 15.7837 3.00635L16.0366 3.13721L16.0386 3.13818C19.0202 4.74706 21.0502 7.90146 21.0503 11.5298Z" })
}), No = (e) => /* @__PURE__ */ K("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", { d: "M4.71484 16.7836V18.0795H6.01074V19.0795H3.71484V16.7836H4.71484ZM13.1934 18.0795V19.0795H9.60156V18.0795H13.1934ZM19.0801 16.7836V19.0795H16.7842V18.0795H18.0801V16.7836H19.0801ZM4.71484 9.60101V13.1928H3.71484V9.60101H4.71484ZM19.0801 9.60101V13.1928H18.0801V9.60101H19.0801ZM6.01074 3.71429V4.71429H4.71484V6.01019H3.71484V3.71429H6.01074ZM19.0801 3.71429V6.01019H18.0801V4.71429H16.7842V3.71429H19.0801ZM13.1934 3.71429V4.71429H9.60156V3.71429H13.1934Z" }),
		/* @__PURE__ */ G("path", { d: "M19.0708 2.30016V3.7152H20.4858V4.7152H18.0708V2.30016H19.0708Z" }),
		/* @__PURE__ */ G("path", { d: "M19.0708 1.30017L19.0708 3.7152L21.4858 3.71521V4.71521L18.0708 4.7152L18.0708 1.30017H19.0708Z" }),
		/* @__PURE__ */ G("path", { d: "M3.71484 21.4938V19.0795L1.2998 19.0788L1.2998 18.0788L4.71484 18.0795V21.4938H3.71484Z" }),
		/* @__PURE__ */ G("path", { d: "M21.4855 19.0792H19.0704V21.4942H18.0704V18.0792H21.4855V19.0792Z" }),
		/* @__PURE__ */ G("path", { d: "M1.30017 3.71484L3.71484 3.71429L3.71521 1.2998L4.71521 1.2998L4.71484 4.71429L1.30017 4.71484L1.30017 3.71484Z" }),
		/* @__PURE__ */ G("path", { d: "M6.01074 19.0795V18.0795H4.71484V16.7836H3.71484L3.71484 18.0791L1.2998 18.0788L1.2998 19.0788L3.71484 19.0795V21.4938H4.71484L4.71484 19.0791L6.01074 19.0795ZM21.4855 19.0792V18.0792L19.0801 18.0791V16.7836H18.0801V18.0795H16.7842V19.0795L18.0703 19.0791L18.0704 21.4942H19.0704V19.0792H21.4855ZM13.1934 18.0795H9.60156V19.0795H13.1934V18.0795ZM4.71484 9.60101H3.71484V13.1928H4.71484V9.60101ZM19.0801 9.60101H18.0801V13.1928H19.0801V9.60101ZM6.01074 4.71429V3.71429L4.71484 3.71387L4.71521 1.2998L3.71521 1.2998L3.71484 3.71429L1.30017 3.71484L1.30017 4.71484L3.71484 4.71387L3.71484 6.01019H4.71484V4.71429H6.01074ZM21.4858 4.71521V3.71521L19.0801 3.71429L19.0703 3.71387L19.0708 1.30017H18.0708L18.0708 2.30016L18.0703 3.71387L16.7842 3.71429V4.71429L18.0703 4.71387L18.0801 4.71429V6.01019H19.0801V4.71484L21.4858 4.71521ZM13.1934 3.71429H9.60156V4.71429H13.1934V3.71429ZM13.4932 19.3799H9.30176V17.7793H13.4932V19.3799ZM5.01465 17.7793H6.31055V19.3799H5.01465V21.7939H3.41504V19.3789H1V17.7783H3.41504V16.4834H5.01465V17.7793ZM19.3799 17.7793H21.7852V19.3789H19.3799L19.3701 19.3799V21.7939H17.7705V19.3799H16.4844V17.7793H17.7803V16.4834H19.3799V17.7793ZM5.01465 13.4932H3.41504V9.30078H5.01465V13.4932ZM19.3799 13.4932H17.7803V9.30078H19.3799V13.4932ZM13.4932 5.01465H9.30176V3.41406H13.4932V5.01465ZM5.01465 3.41406H6.31055V5.01465H5.01465V6.31055H3.41504V5.01465H1V3.41504L3.41504 3.41406V1H5.01562L5.01465 3.41406ZM19.3711 3.41406L21.7861 3.41504V5.01562H19.3799V6.31055H17.7803V5.01562L16.4844 5.01465V3.41406H17.7705V1H19.3711V3.41406Z" })
	]
}), Po = (e) => /* @__PURE__ */ K("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", { d: "M22.2969 15.7986C22.2769 15.7286 22.2569 15.6486 22.2369 15.5786L21.7151 14.611L21.5451 14.111H20.0351L20.6069 15.3786H17.7669C16.627 15.3786 15.587 16.0186 15.087 17.0387L14.827 17.5487C14.577 18.0587 14.057 18.3787 13.487 18.3787H10.2671C9.69706 18.3787 9.17707 18.0587 8.92707 17.5487L8.66708 17.0387C8.15708 16.0186 7.1171 15.3786 5.98712 15.3786H3.13716L5.34713 8.18832C5.53712 7.55829 6.12711 7.12828 6.7771 7.12828H9.66706L9.65706 5.62821H6.7771C5.45712 5.62821 4.29714 6.48825 3.90715 7.7483L1.49719 15.5886C1.47719 15.6586 1.45719 15.7286 1.43719 15.8086C1.38719 15.9086 1.36719 16.0186 1.36719 16.1387V20.6388C1.36719 22.2989 2.70717 23.639 4.36714 23.639H19.3669C21.0269 23.639 22.3669 22.2989 22.3669 20.6388V16.1387C22.3669 16.0186 22.3369 15.9086 22.2969 15.8086V15.7986ZM20.8669 20.6288C20.8669 21.4589 20.1969 22.1289 19.3669 22.1289H4.36714C3.53715 22.1289 2.86716 21.4589 2.86716 20.6288V16.8787H5.97712C6.54711 16.8787 7.0671 17.1987 7.3171 17.7087L7.57709 18.2187C8.08708 19.2388 9.12707 19.8788 10.2571 19.8788H13.477C14.617 19.8788 15.657 19.2388 16.157 18.2187L16.417 17.7087C16.667 17.1987 17.1869 16.8787 17.7569 16.8787H20.8669V20.6288Z" }),
		/* @__PURE__ */ G("path", { d: "M13.1106 9.60044V10.8964H14.4065V11.8964H12.1107V9.60044H13.1106ZM17.5891 10.8964V11.8964H15.9973V10.8964H17.5891ZM21.4757 9.60044V11.8964H19.1799V10.8964H20.4758V9.60044H21.4757ZM13.1106 6.41769V8.00955H12.1107V6.41769H13.1106ZM21.4757 6.41769V8.00955H20.4758V6.41769H21.4757ZM14.4065 2.53081V3.53085H13.1106V4.8268H12.1107V2.53081H14.4065ZM21.4757 2.53081V4.8268H20.4758V3.53085H19.1799V2.53081H21.4757ZM17.5891 2.53081V3.53085H15.9973V2.53081H17.5891Z" }),
		/* @__PURE__ */ G("path", { d: "M21.4664 1.11661V2.53171H22.8815V3.53175H20.4665V1.11661H21.4664Z" }),
		/* @__PURE__ */ G("path", { d: "M21.4664 1.11661V2.53171H22.8815V3.53175H20.4665V1.11661H21.4664Z" }),
		/* @__PURE__ */ G("path", { d: "M12.1107 13.3108V11.8964L10.6956 11.8957V10.8957L13.1106 10.8964V13.3108H12.1107Z" }),
		/* @__PURE__ */ G("path", { d: "M22.8811 11.8961H21.4661V13.3112H20.4661V10.896H22.8811V11.8961Z" }),
		/* @__PURE__ */ G("path", { d: "M10.696 2.53136L12.1107 2.53081L12.111 1.11626H13.111L13.1106 3.53085L10.696 3.5314V2.53136Z" }),
		/* @__PURE__ */ G("path", { d: "M14.4065 11.8964V10.8964H13.1106V9.60044H12.1107V10.896L10.6956 10.8957V11.8957L12.1107 11.8964V13.3108H13.1106V11.896L14.4065 11.8964ZM22.8811 11.8961V10.896L21.4757 10.896V9.60044H20.4758V10.8964H19.1799V11.8964L20.466 11.896L20.4661 13.3112H21.4661V11.8961H22.8811ZM17.5891 10.8964H15.9973V11.8964H17.5891V10.8964ZM13.1106 6.41769H12.1107V8.00955H13.1106V6.41769ZM21.4757 6.41769H20.4758V8.00955H21.4757V6.41769ZM14.4065 3.53085V2.53081L13.1106 2.53038L13.111 1.11626H12.111L12.1107 2.53081L10.696 2.53136V3.5314L12.1107 3.53042V4.8268H13.1106V3.53085H14.4065ZM22.8815 3.53175V2.53171L21.4757 2.53081L21.466 2.53038L21.4664 1.11661H20.4665L20.466 2.53038L19.1799 2.53081V3.53085L20.466 3.53042L20.4758 3.53085V4.8268H21.4757V3.5314L22.8815 3.53175ZM17.5891 2.53081H15.9973V3.53085H17.5891V2.53081ZM17.8337 12.0944L15.6975 12.1092V10.674L17.8337 10.6592V12.0944ZM13.358 10.674H14.6539V12.1092H13.358V13.5233H11.8678V12.1082H10.4528V10.673H11.8678V9.37802H13.358V10.674ZM21.7104 10.6739H23.1157V12.1082H21.7104L21.7007 12.1092V13.5233L20.228 13.5233V12.1092H18.9419V10.674H20.2377V9.37802L21.7104 9.37798V10.6739ZM13.358 8.30992H11.8678V6.11744H13.358V8.30992ZM21.7104 8.30988L20.2377 8.30992V6.11744L21.7104 6.11741V8.30988ZM17.8337 3.75464L15.6975 3.76943V2.28916L17.8337 2.27437V3.75464ZM13.358 2.28916H14.6539V3.76943H13.358V5.12717H11.8678V3.76943H10.4528V2.29014L11.8678 2.28916V0.875037H13.359L13.358 2.28916ZM21.7016 2.28912L23.1167 2.2901V3.77037H21.7104V5.12713L20.2377 5.12717V3.77041L18.9419 3.76943V2.28916H20.228V0.875037L21.7016 0.875V2.28912Z" })
	]
}), Fo = () => {
	let { t: e } = h("teiaviewer"), { viewer: t } = H(), n = re("Zone"), r = async (e) => {
		if (t.scene.objectSelection.length === 0 && e === "object") return;
		let n = new pe(t, t.scene.objectSelection, e, { selected: !0 });
		if (await n.execute(), t.viewport) {
			let e = new ct(t.viewport, n);
			t.viewport.setOperator(e);
		}
	};
	return /* @__PURE__ */ K(V, {
		"data-testid": "zone-toolbar-menu",
		icon: No,
		label: e("toolbar.zone.tooltip"),
		"data-dd-action-name": "toolbar.zone",
		disabled: !n,
		children: [
			/* @__PURE__ */ G(B, {
				"data-testid": "zone-duplicate-toolbar-item",
				icon: jo,
				label: e("toolbar.zone_duplicate.tooltip"),
				"data-dd-action-name": "toolbar.zone_duplicate",
				onClick: () => r("object")
			}),
			/* @__PURE__ */ G(B, {
				"data-testid": "zone-sphere-toolbar-item",
				icon: Mo,
				label: e("toolbar.zone_sphere.tooltip"),
				"data-dd-action-name": "toolbar.zone_sphere",
				onClick: () => r("sphere")
			}),
			/* @__PURE__ */ G(B, {
				"data-testid": "zone-cube-toolbar-item",
				icon: hr,
				label: e("toolbar.zone_cube.tooltip"),
				"data-dd-action-name": "toolbar.zone_cube",
				onClick: () => r("cube")
			}),
			/* @__PURE__ */ G(B, {
				icon: Po,
				label: e("toolbar.zone_widget.tooltip"),
				"data-dd-action-name": "toolbar.zone_widget"
			})
		]
	});
}, Io = (e) => {
	let { children: t } = e, { plugin: n } = U("Teia");
	return /* @__PURE__ */ G(ft, {
		client: n.queryClient,
		children: t
	});
}, Lo = i(null), Ro = () => {
	let e = s(Lo);
	if (!e) throw new It("TeiaAdvancedSearchWidgetContext");
	return e;
}, zo = (e) => {
	let { initialFilter: t, ...n } = e, [r, i] = f(!1), [a, o] = f({
		filter: t ?? {},
		isValid: !0,
		showErrors: !1
	}), s = u(() => ({
		filterState: a,
		setFilterState: o,
		errorFromApi: r,
		setErrorFromApi: i
	}), [
		a,
		o,
		r
	]);
	return /* @__PURE__ */ G(Lo.Provider, {
		...n,
		value: s
	});
}, Bo = () => {
	let e = Qi(nt.Twin), { errorFromApi: t } = Ro(), { t: n } = h("teiaviewer");
	return /* @__PURE__ */ K(_, {
		sx: {
			display: e ? "block" : "flex",
			padding: "5px",
			alignItems: "center",
			justifyContent: "center",
			width: 1,
			height: 1
		},
		children: [
			/* @__PURE__ */ G(m, {
				severity: "error",
				"data-testid": "advanced-search-no-twin-alert",
				sx: {
					display: e ? "none" : "flex",
					width: "50%"
				},
				children: n("teia.widgets.advanced_search_widget.errors.no_twin.text")
			}),
			/* @__PURE__ */ G(m, {
				severity: "error",
				"data-testid": "advanced-search-api-error-alert",
				sx: {
					display: t ? "flex" : "none",
					width: "100%",
					marginBottom: "0.25rem"
				},
				children: n("teia.widgets.advanced_search_widget.errors.error_from_api.text")
			}),
			!!e && /* @__PURE__ */ G(Vo, { twin: e })
		]
	});
}, Vo = (e) => {
	let { twin: t } = e, { filterState: n, setFilterState: r } = Ro(), [i] = se("PluginUI", "advancedSearch.enableJsonEditor"), [a] = se("PluginUI", "advancedSearch.enableAI"), s = o((e, t) => {
		r({
			showErrors: !1,
			filter: e,
			isValid: t
		});
	}, [r]);
	return /* @__PURE__ */ G(Zi, {
		twin: t,
		defaultFilter: n.filter,
		onChange: s,
		showErrors: n.showErrors,
		enableJsonEditor: i,
		enableAI: a
	});
}, Ho = () => {
	let { t } = h("teiaviewer"), [n, r] = f(!1), [i, a] = f(!1), { filterState: o, setFilterState: s, setErrorFromApi: c } = Ro(), { viewer: l } = H(), { plugin: u } = U("Teia"), d = ea(), p = ut([o.filter, d.filter], "And"), { refetch: m } = ri({
		filter: p,
		enabled: !1
	});
	return d ? /* @__PURE__ */ K(e, {
		spacing: 1,
		direction: "row",
		alignItems: "center",
		justifyContent: "space-between",
		sx: {
			width: 1,
			height: 1
		},
		children: [/* @__PURE__ */ G(Wt, {
			sx: { margin: 0 },
			label: t("teia.widgets.advanced_search_widget.filter_on_visible_input.text"),
			"data-dd-action-name": "teia.widgets.advanced_search_widget.filter_on_visible_input",
			id: "filter-on-visible",
			"data-testid": "advanced-search-visible-only-switch",
			checked: n,
			onChange: (e, t) => {
				r(t);
			}
		}), /* @__PURE__ */ G(Z, {
			variant: "secondary",
			sx: { py: 0 },
			onClick: async () => {
				if (s((e) => ({
					...e,
					showErrors: !0
				})), o.isValid) {
					a(!0);
					try {
						let { data: e } = await m();
						Bt(e);
						let t = u.getSceneObjectForTeiaObjects(e);
						n && (t = u.getVisibleSceneObjectForTeiaObjects(e));
						let r = new et(t, !1, p);
						new Lt(l, r).execute(), a(!1), c(!1);
					} catch {
						a(!1), c(!0);
					}
				}
			},
			isLoading: i,
			"aria-label": t("teia.widgets.advanced_search_widget.search_button.label"),
			"data-dd-action-name": "teia.widgets.advanced_search_widget.search_button",
			"data-testid": "advanced-search-search-button",
			children: t("teia.widgets.advanced_search_widget.search_button.text")
		})]
	}) : null;
}, Uo = class extends N {
	constructor(e, t = {}) {
		let { initialFilter: n, ...r } = t;
		super(e, {
			width: 885,
			height: 300,
			minWidth: 885,
			minHeight: 300,
			isScrollable: !0,
			isResizable: !0,
			...r
		}), this.type = "TeiaAdvancedSearch", this.Header = () => {
			let { t: e } = h("teiaviewer");
			return /* @__PURE__ */ G(te, {
				icon: To,
				"data-testid": "advanced-search-widget-title",
				children: e("teia.widgets.advanced_search_widget.title")
			});
		}, this.Content = () => /* @__PURE__ */ G(Bo, {}), this.Footer = Ho, this.ContextProvider = (e) => /* @__PURE__ */ G(zo, {
			...e,
			initialFilter: this._initialFilter
		}), this._initialFilter = n;
	}
}, Wo = (e) => /* @__PURE__ */ K("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ G("path", { d: "M22.43 16.0206C22.41 15.9506 22.39 15.8706 22.37 15.8006L21.3 12.4606L21.13 11.9606L19.86 12.7306L20.74 15.6006H17.9C16.76 15.6006 15.72 16.2406 15.22 17.2606L14.96 17.7706C14.71 18.2806 14.19 18.6006 13.62 18.6006H10.4C9.83 18.6006 9.31 18.2806 9.06 17.7706L8.8 17.2606C8.29 16.2406 7.25 15.6006 6.12 15.6006H3.27L5.48 8.41059C5.67 7.78059 6.26 7.35059 6.91 7.35059H13.24V5.85059H6.91C5.59 5.85059 4.43 6.71059 4.04 7.97059L1.63 15.8106C1.61 15.8806 1.59 15.9506 1.57 16.0306C1.52 16.1306 1.5 16.2406 1.5 16.3606V20.8606C1.5 22.5206 2.84 23.8606 4.5 23.8606H19.5C21.16 23.8606 22.5 22.5206 22.5 20.8606V16.3606C22.5 16.2406 22.47 16.1306 22.43 16.0306V16.0206ZM21 20.8506C21 21.6806 20.33 22.3506 19.5 22.3506H4.5C3.67 22.3506 3 21.6806 3 20.8506V17.1006H6.11C6.68 17.1006 7.2 17.4206 7.45 17.9306L7.71 18.4406C8.22 19.4606 9.26 20.1006 10.39 20.1006H13.61C14.75 20.1006 15.79 19.4606 16.29 18.4406L16.55 17.9306C16.8 17.4206 17.32 17.1006 17.89 17.1006H21V20.8506Z" }), /* @__PURE__ */ G("path", { d: "M22.6201 6.55041V2.81041C22.6201 2.65041 22.5401 2.51041 22.4101 2.44041L18.7201 0.260414C18.5801 0.180414 18.3901 0.190414 18.2801 0.260414L14.5801 2.44041C14.4501 2.51041 14.3701 2.65041 14.3701 2.81041V6.55041C14.3701 6.70041 14.4501 6.84041 14.5801 6.92041L16.5501 8.08041L14.5401 9.26041C14.4101 9.34041 14.3301 9.48041 14.3301 9.63041C14.3301 9.78041 14.4101 9.93041 14.5401 10.0104L18.2701 12.2004C18.2701 12.2004 18.3301 12.2204 18.3701 12.2304C18.3901 12.2304 18.4201 12.2504 18.4601 12.2504C18.5001 12.2504 18.5301 12.2404 18.5801 12.2304C18.6101 12.2304 18.6501 12.2304 18.6801 12.2004L22.3801 10.0204C22.5101 9.94041 22.5901 9.80041 22.5901 9.65041C22.5901 9.50041 22.5101 9.35041 22.3801 9.27041L20.4101 8.11041L22.4201 6.92041C22.5501 6.84041 22.6301 6.70041 22.6301 6.55041H22.6201ZM15.2401 6.30041V3.56041L18.0701 5.23041V7.97041L17.9401 7.90041L15.2301 6.30041H15.2401ZM18.4901 4.49041L15.6501 2.81041L18.4901 1.13041L21.3401 2.81041L18.4901 4.49041ZM17.0401 8.78041L17.3901 8.58041L18.3101 9.12041C18.3101 9.12041 18.3601 9.14041 18.3701 9.14041C18.4701 9.18041 18.5101 9.17041 18.6101 9.14041C18.6401 9.14041 18.6801 9.13041 18.7101 9.11041L19.5501 8.62041L21.3001 9.65041L18.4601 11.3304L15.6101 9.65041L17.0301 8.79041L17.0401 8.78041ZM18.9301 7.97041V5.23041L21.7601 3.56041V6.30041L18.9301 7.97041Z" })]
}), Go = {
	rule: {},
	lineColor: "#000000FF",
	lineType: De.Solid,
	lineWidth: 1,
	fillColor: Oe,
	name: "Layer 1",
	order: 1,
	annotations: []
}, Ko = {
	prefix: "",
	suffix: "",
	field: {
		family: "TwinBimData",
		name: "Name",
		propertyName: "Element Specific"
	},
	fontColor: "#000000",
	fontSize: 15,
	position: "center",
	id: Vt.generateUUID()
}, qo = {
	direction: [
		0,
		1,
		0
	],
	name: "",
	floorPlanLayers: [{ ...Go }]
}, Jo = () => {
	let e = { ...qo };
	return e.floorPlanLayers = [{ ...Go }], e;
}, Yo = () => ({ ...Go }), Xo = () => ({
	...Ko,
	id: Vt.generateUUID()
}), Zo = i(null), Qo = (e) => {
	let { children: t } = e, [n, r] = f(0), [i, a] = f(null), [o, s] = f(/* @__PURE__ */ new Map()), [c, l] = f(Jo()), d = u(() => ({
		newPlanConfig: c,
		setNewPlanConfig: l,
		selectedTabIndex: n,
		setSelectedTabIndex: r,
		updatedId: i,
		setUpdatedId: a,
		floorPlans: o,
		setFloorPlans: s
	}), [
		c,
		n,
		i,
		o
	]);
	return /* @__PURE__ */ G(Zo.Provider, {
		value: d,
		children: t
	});
}, $o = () => {
	let e = s(Zo);
	if (e === null) throw Error("usePlanContext must be used within a PlanWidgetProvider");
	return e;
}, es = (t) => {
	let { annotationId: n, formValues: r, updateAnnotation: i } = t, a = ea(), { t: o } = h("teiaviewer"), { forceUpdate: s } = ne(), c = r.current.annotations.find((e) => e.id === n), l = c?.field?.propertyName, { data: u, isLoading: d, error: f } = ei({
		twin: a,
		dataFamily: "TwinBimData",
		startPage: 1,
		pageSize: 100,
		enabled: !0
	}), p = [];
	for (let e of u ?? []) {
		let t = e;
		t.propertyName && t.propertyName !== "" && !p.includes(t.propertyName) && p.push(t.propertyName);
	}
	p.sort((e, t) => e.localeCompare(t));
	let m = [];
	for (let e of u ?? []) {
		let t = e;
		t.name && t.name !== "" && t.propertyName === l && !m.includes(t.name) && m.push(t.name);
	}
	return m.sort((e, t) => e.localeCompare(t)), d ? /* @__PURE__ */ G(yt, {
		size: 20,
		style: { margin: "5px 0px" }
	}) : /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 2,
		children: [/* @__PURE__ */ G(dt, {
			error: !!f,
			defaultValue: (c?.field).propertyName,
			onChange: (e) => {
				e && (i((t) => {
					let n = t;
					n.propertyName = e;
				}, n), s());
			},
			"data-testid": "floor-plan-annotation-property-select",
			options: p,
			label: o("teiaSearchFilterEditor.propertyCondition.property_autocomplete.text_field.label"),
			"data-dd-action-name": "teiaSearchFilterEditor.propertyCondition.property_autocomplete.text_field",
			sx: {
				minWidth: 200,
				backgroundColor: (e) => e.palette.background.paper
			}
		}), /* @__PURE__ */ G(dt, {
			error: !!f,
			defaultValue: (c?.field).name,
			onChange: (e) => {
				e && (i((t) => {
					let n = t;
					n.name = e;
				}, n), s());
			},
			"data-testid": "floor-plan-annotation-name-select",
			options: m,
			label: o("teiaSearchFilterEditor.propertyCondition.name_autocomplete.text_field.label"),
			"data-dd-action-name": "teiaSearchFilterEditor.propertyCondition.name_autocomplete.text_field.label",
			sx: {
				minWidth: 200,
				backgroundColor: (e) => e.palette.background.paper
			}
		})]
	});
}, ts = (t) => {
	let { annotationId: n, formValues: r, updateAnnotation: i } = t, a = ea(), { t: o } = h("teiaviewer"), s = r.current.annotations.find((e) => e.id === n), { data: c, isLoading: l, error: u } = ei({
		twin: a,
		dataFamily: "TwinOpenData",
		startPage: 1,
		pageSize: 100,
		enabled: !0
	}), d = [];
	for (let e of c ?? []) {
		let t = e;
		t.key && !d.includes(t.key) && d.push(t.key);
	}
	return d.sort((e, t) => e.localeCompare(t)), l ? /* @__PURE__ */ G(yt, {
		size: 20,
		style: { margin: "5px 0px" }
	}) : /* @__PURE__ */ G(e, {
		direction: "row",
		children: /* @__PURE__ */ G(dt, {
			error: !!u,
			"data-dd-action-name": "teiaSearchFilterEditor.openDataCondition.key_text_field",
			label: o("teiaSearchFilterEditor.openDataCondition.key_text_field.label"),
			defaultValue: (s?.field).key,
			onChange: (e) => {
				e && i((t) => {
					let n = t;
					n.key = e;
				}, n);
			},
			options: d,
			"data-testid": "floor-plan-annotation-key-select",
			sx: {
				minWidth: 200,
				backgroundColor: (e) => e.palette.background.paper
			}
		})
	});
}, ns, rs, is = (t) => {
	let { annotationId: n, formValues: r, updateAnnotation: i } = t, { t: a } = h("teiaviewer"), o = r.current.annotations.find((e) => e.id === n), [s, c] = f((o?.field).key), [l, u] = f((o?.field).applicationName);
	return /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 2,
		children: [/* @__PURE__ */ G(y, {
			error: (o?.field).applicationName == "",
			"data-dd-action-name": "teiaSearchFilterEditor.userDataByApplicationCondition.applicationName_text_field.label",
			placeholder: a("teiaSearchFilterEditor.userDataByApplicationCondition.applicationName_text_field.label"),
			name: "Key",
			defaultValue: l,
			onChange: (e) => {
				u(e.target.value), rs && clearTimeout(rs), rs = setTimeout(() => {
					i((t) => {
						let n = t;
						n.applicationName = e.target.value;
					}, n);
				}, 500);
			},
			"data-testid": "floor-plan-annotation-application-input",
			sx: {
				minWidth: 140,
				backgroundColor: (e) => e.palette.background.paper
			},
			inputProps: { sx: {
				minWidth: 140,
				backgroundColor: "white"
			} }
		}), /* @__PURE__ */ G(y, {
			error: (o?.field).key == "",
			"data-dd-action-name": "teiaSearchFilterEditor.userDataByApplicationCondition.name_text_field.label",
			placeholder: a("teiaSearchFilterEditor.userDataByApplicationCondition.name_text_field.label"),
			name: "Key",
			defaultValue: s,
			onChange: (e) => {
				c(e.target.value), ns && clearTimeout(ns), ns = setTimeout(() => {
					i((t) => {
						let n = t;
						n.key = e.target.value;
					}, n);
				}, 500);
			},
			"data-testid": "floor-plan-annotation-user-key-input",
			sx: {
				minWidth: 140,
				backgroundColor: (e) => e.palette.background.paper
			},
			inputProps: { sx: {
				minWidth: 140,
				backgroundColor: "white"
			} }
		})]
	});
}, as = (e) => {
	let { annotation: t, formValues: n, updateAnnotation: r } = e;
	return /* @__PURE__ */ K(W, { children: [
		t.field.family === "TwinBimData" && /* @__PURE__ */ G(es, {
			annotationId: t.id,
			formValues: n,
			updateAnnotation: r
		}),
		t.field.family === "TwinOpenData" && /* @__PURE__ */ G(ts, {
			annotationId: t.id,
			formValues: n,
			updateAnnotation: r
		}),
		t.field.family === "TwinUserData" && /* @__PURE__ */ G(is, {
			annotationId: t.id,
			formValues: n,
			updateAnnotation: r
		})
	] });
}, os = [
	"TwinBimData",
	"TwinOpenData",
	"TwinUserData"
], ss = (t) => {
	let { annotation: n, formValues: r, updateAnnotation: i, updateAnnotationField: a, removeAnnotation: s } = t, { t: c } = h("teiaviewer"), l = o((e) => {
		a("prefix", e.target.value, n.id);
	}, [a, n.id]), u = o((e) => {
		a("suffix", e.target.value, n.id);
	}, [a, n.id]), d = o((e) => {
		a("fontSize", Math.max(0, Number(e)), n.id);
	}, [a, n.id]), f = o((e) => {
		e && a("position", e, n.id);
	}, [a, n.id]), p = o((e) => {
		e && i((t) => {
			t.family = e;
		}, n.id, !0);
	}, [i, n.id]);
	return /* @__PURE__ */ K(e, {
		direction: "row",
		justifyContent: "space-between",
		alignItems: "start",
		flexWrap: "wrap-reverse",
		children: [/* @__PURE__ */ K(e, {
			spacing: 2,
			sx: {
				minWidth: "408px",
				marginRight: "20px"
			},
			children: [
				/* @__PURE__ */ G(y, {
					label: c("teia.widgets.floor_plan_widget.add_layer_tab.annotations.prefix.text"),
					sx: {
						width: "100%",
						backgroundColor: "white",
						borderRadius: "8px"
					},
					onChange: l,
					"data-testid": "floor-plan-annotation-prefix-input",
					defaultValue: n.prefix
				}),
				/* @__PURE__ */ G(y, {
					label: c("teia.widgets.floor_plan_widget.add_layer_tab.annotations.suffix.text"),
					sx: {
						width: "100%",
						backgroundColor: "white",
						borderRadius: "8px"
					},
					onChange: u,
					"data-testid": "floor-plan-annotation-suffix-input",
					defaultValue: n.suffix
				}),
				/* @__PURE__ */ G(dt, {
					label: c("teia.widgets.floor_plan_widget.add_layer_tab.annotations.family.text"),
					defaultValue: n.field.family,
					onChange: p,
					"data-testid": "floor-plan-annotation-family-select",
					options: os,
					sx: {
						backgroundColor: "white",
						borderRadius: "10px",
						width: "205px"
					}
				}),
				/* @__PURE__ */ G(as, {
					annotation: n,
					updateAnnotation: i,
					formValues: r
				})
			]
		}), /* @__PURE__ */ K(e, {
			direction: "row",
			alignItems: "flex-start",
			justifyContent: "space-between",
			sx: { marginBottom: "10px" },
			children: [/* @__PURE__ */ K(e, {
				spacing: 2,
				alignItems: "flex-start",
				sx: { minWidth: "250px" },
				children: [
					/* @__PURE__ */ K(e, {
						direction: "row",
						alignItems: "center",
						children: [/* @__PURE__ */ G(S, {
							sx: { marginRight: "9px" },
							children: c("teia.widgets.floor_plan_widget.add_layer_tab.annotations.font_size.text")
						}), /* @__PURE__ */ G(E, {
							value: n.fontSize,
							min: 0,
							sx: {
								backgroundColor: "white",
								marginLeft: 2,
								borderRadius: "10px",
								width: "150px"
							},
							onChange: d,
							"data-testid": "floor-plan-annotation-font-size-input"
						})]
					}),
					/* @__PURE__ */ K(e, {
						direction: "row",
						alignItems: "center",
						children: [/* @__PURE__ */ G(S, { children: c("teia.widgets.floor_plan_widget.add_layer_tab.annotations.font_color.text") }), /* @__PURE__ */ G(_, {
							sx: {
								backgroundColor: "white",
								borderRadius: "10px",
								marginLeft: 2,
								width: "150px",
								"& div div": { width: "100%" }
							},
							"data-testid": "floor-plan-annotation-font-color",
							children: /* @__PURE__ */ G(cs, {
								annotation: n,
								updateAnnotationField: a
							})
						})]
					}),
					/* @__PURE__ */ K(e, {
						direction: "row",
						alignItems: "center",
						children: [/* @__PURE__ */ G(S, {
							sx: { marginRight: "15px" },
							children: c("teia.widgets.floor_plan_widget.add_layer_tab.annotations.position.text")
						}), /* @__PURE__ */ G(dt, {
							defaultValue: n.position,
							onChange: f,
							"data-testid": "floor-plan-annotation-position-select",
							options: me,
							sx: {
								backgroundColor: "white",
								borderRadius: "10px",
								marginLeft: 2,
								width: "150px"
							}
						})]
					})
				]
			}), /* @__PURE__ */ G(v, {
				icon: Cn,
				"aria-label": c("teia.widgets.floor_plan_widget.add_layer_tab.annotations.remove.text"),
				"data-dd-action-name": "teia.widgets.floor_plan_widget.annotation.delete",
				onClick: () => s(n.id),
				"data-testid": "floor-plan-annotation-remove-button",
				sx: { width: "20px" }
			})]
		})]
	});
}, cs = (e) => {
	let { annotation: t, updateAnnotationField: n } = e, [r, i] = f(t.fontColor), a = o((e) => {
		n("fontColor", e, t.id), i(e);
	}, [n, t.id]);
	return /* @__PURE__ */ G(w, {
		onChange: a,
		color: r
	});
}, ls = (t) => {
	let { formValues: n } = t, { t: r } = h("teiaviewer"), { forceUpdate: i } = ne(), a = o(() => {
		n.current.annotations = [...n.current.annotations, Xo()], i();
	}, [n, i]), s = o((e, t, r) => {
		n.current.annotations = n.current.annotations.map((n) => n.id === r ? {
			...n,
			[e]: t
		} : n);
	}, [n]), c = o((e, t, r = !1) => {
		n.current.annotations = n.current.annotations.map((n) => {
			if (n.id !== t) return n;
			let r = { ...n.field };
			return e(r), {
				...n,
				field: r
			};
		}), r && i();
	}, [n, i]), l = o((e) => {
		n.current.annotations = n.current.annotations.filter((t) => t.id !== e), i();
	}, [n, i]);
	return /* @__PURE__ */ K(e, { children: [/* @__PURE__ */ K(e, {
		direction: "row",
		alignItems: "center",
		justifyContent: "space-between",
		sx: { marginBottom: 2 },
		children: [/* @__PURE__ */ G(S, { children: r("teia.widgets.floor_plan_widget.add_layer_tab.annotations.text") }), /* @__PURE__ */ G(v, {
			icon: yn,
			"aria-label": r("teia.widgets.floor_plan_widget.add_layer_tab.annotations.add.text"),
			"data-dd-action-name": "teia.widgets.floor_plan_widget.annotation.add",
			onClick: a,
			"data-testid": "floor-plan-add-annotation-button",
			sx: {
				backgroundColor: "white",
				borderRadius: "100%",
				padding: 2
			}
		})]
	}), n.current.annotations.map((t, r) => /* @__PURE__ */ K(e, { children: [/* @__PURE__ */ G(ss, {
		annotation: t,
		formValues: n,
		updateAnnotation: c,
		updateAnnotationField: s,
		removeAnnotation: l
	}), r != n.current.annotations.length - 1 && /* @__PURE__ */ G(Kt, { sx: {
		marginBottom: 2,
		marginTop: 2
	} })] }, t.id))] });
}, us = [{
	type: De.Solid,
	display: "______"
}, {
	type: De.Dash,
	display: "_ _ _ _"
}], ds = (t) => {
	let { formValues: n } = t, { t: r } = h("teiaviewer"), i = (e) => {
		let t = Math.max(0, Math.round(e));
		n.current.lineWidth = t;
	}, a = (e) => {
		e && (n.current.lineType = e.type);
	}, o = us.find((e) => e.type === n.current.lineType);
	return /* @__PURE__ */ K(e, {
		sx: { margin: "3px 0px" },
		spacing: 2,
		children: [/* @__PURE__ */ K(e, {
			direction: "row",
			sx: { alignItems: "center" },
			children: [
				/* @__PURE__ */ G(S, { children: r("teia.widgets.floor_plan_widget.add_layer_tab.line.text") }),
				/* @__PURE__ */ G(dt, {
					defaultValue: o,
					onChange: a,
					"data-testid": "floor-plan-line-type-select",
					options: us,
					sx: {
						backgroundColor: "white",
						borderRadius: "10px",
						"& input": { fontFamily: "serif" },
						marginLeft: 2,
						width: "150px"
					},
					getOptionLabel: (e) => e.display
				}),
				/* @__PURE__ */ G(E, {
					value: n.current.lineWidth,
					min: 0,
					sx: {
						backgroundColor: "white",
						borderRadius: "10px",
						marginLeft: 2,
						width: "100px"
					},
					onChange: i,
					"data-testid": "floor-plan-line-width-input"
				}),
				/* @__PURE__ */ G(_, {
					sx: {
						backgroundColor: "white",
						borderRadius: "10px",
						marginLeft: 2
					},
					"data-testid": "floor-plan-line-color",
					children: /* @__PURE__ */ G(fs, {
						formValues: n,
						colorKey: "lineColor"
					})
				})
			]
		}), /* @__PURE__ */ K(e, {
			direction: "row",
			sx: { alignItems: "center" },
			children: [/* @__PURE__ */ G("p", { children: r("teia.widgets.floor_plan_widget.add_layer_tab.background.text") }), /* @__PURE__ */ G(_, {
				sx: {
					backgroundColor: "white",
					borderRadius: "10px",
					marginLeft: 2
				},
				"data-testid": "floor-plan-fill-color",
				children: /* @__PURE__ */ G(fs, {
					formValues: n,
					colorKey: "fillColor"
				})
			})]
		})]
	});
}, fs = (e) => {
	let { formValues: t, colorKey: n } = e, [r, i] = f(t.current[n]);
	return /* @__PURE__ */ G(w, {
		onChange: (e) => {
			t.current[n] = e, i(e);
		},
		color: r
	});
}, ps = (t) => {
	let { setActiveSection: n, currentLayerIndex: r } = t, { t: i } = h("teiaviewer"), a = ea(), { setNewPlanConfig: s, newPlanConfig: c } = $o(), l = c.floorPlanLayers[r], [u, p] = f(!1), [g, v] = f(Object.keys(l.rule).length > 0), y = d({
		name: l.name,
		lineColor: l.lineColor,
		lineType: l.lineType,
		lineWidth: l.lineWidth,
		fillColor: l.fillColor ?? Oe,
		annotations: l.annotations.map((e) => ({
			...e,
			id: Vt.generateUUID()
		}))
	}), [b, x] = f({
		filter: structuredClone(l.rule),
		isValid: !0,
		showErrors: !1
	}), C = o(() => {
		v((e) => (e && x({
			showErrors: !1,
			filter: {},
			isValid: !1
		}), !e));
	}, []), w = o(() => {
		n(0);
	}, [n]), T = o(() => {
		let e = b.filter;
		if (b.isValid && e.rules?.length !== 0) {
			let e = {
				...l,
				...y.current,
				rule: structuredClone(b.filter)
			};
			s((t) => {
				let n = [...t.floorPlanLayers];
				return n[r] = e, {
					...t,
					floorPlanLayers: n
				};
			}), n(0), p(!1);
		} else p(!0);
	}, [
		b,
		y,
		l,
		r,
		s,
		n
	]), E = o((e, t) => {
		x({
			showErrors: !1,
			filter: e,
			isValid: t
		});
	}, [x]);
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(ms, { formValues: y }), /* @__PURE__ */ K(e, {
		spacing: 2,
		sx: {
			width: "100%",
			justifyContent: "space-between"
		},
		divider: /* @__PURE__ */ G(Kt, {}),
		children: [
			/* @__PURE__ */ K(e, { children: [
				/* @__PURE__ */ G(S, {
					sx: { marginTop: "15px" },
					children: i("teia.widgets.floor_plan_widget.add_layer_tab.properties.title")
				}),
				/* @__PURE__ */ K(e, {
					sx: {
						marginTop: 2,
						alignItems: "center"
					},
					direction: "row",
					children: [/* @__PURE__ */ G(Y, {
						component: To,
						fontSize: "small",
						sx: {
							fill: (e) => e.palette.primary.main,
							marginRight: 3
						}
					}), /* @__PURE__ */ G(Z, {
						variant: "info",
						sx: {
							width: "200px",
							backgroundColor: (e) => e.palette.primary.main,
							"&:hover": { backgroundColor: (e) => e.palette.primary.dark },
							color: "white",
							paddingTop: 1,
							paddingBottom: 1
						},
						onClick: C,
						"data-testid": "floor-plan-layer-filter-button",
						children: i("teia.widgets.floor_plan_widget.add_layer_tab.advanced_search.text")
					})]
				}),
				!!g && /* @__PURE__ */ G(_, {
					sx: {
						backgroundColor: "white",
						borderRadius: "10px",
						marginTop: 2,
						border: "1px solid #80808070"
					},
					children: /* @__PURE__ */ G(Zi, {
						twin: a,
						defaultFilter: b.filter,
						onChange: E,
						showErrors: b.showErrors
					})
				})
			] }),
			/* @__PURE__ */ K(e, { children: [/* @__PURE__ */ G(S, { children: i("teia.widgets.floor_plan_widget.add_layer_tab.customize_style.text") }), /* @__PURE__ */ G(ds, { formValues: y })] }),
			/* @__PURE__ */ G(e, { children: /* @__PURE__ */ G(ls, { formValues: y }) }),
			!!u && /* @__PURE__ */ G(m, {
				severity: "warning",
				"data-testid": "floor-plan-layer-filter-warning",
				children: i("teia.widgets.floor_plan_widget.add_layer_tab.warnings.invalid_filter.text")
			}),
			/* @__PURE__ */ K(e, {
				direction: "row",
				sx: {
					justifyContent: "flex-end",
					margin: "10px 0px"
				},
				children: [/* @__PURE__ */ G(Z, {
					variant: "info",
					onClick: w,
					"data-testid": "floor-plan-layer-cancel-button",
					sx: {
						marginBottom: 2,
						marginRight: 2,
						backgroundColor: (e) => e.palette.error.main,
						"&:hover": { backgroundColor: (e) => e.palette.error.dark },
						color: "white",
						padding: 3,
						paddingTop: 1,
						paddingBottom: 1
					},
					children: i("teia.widgets.floor_plan_widget.add_layer_tab.cancel.text")
				}), /* @__PURE__ */ G(Z, {
					variant: "info",
					onClick: T,
					"data-testid": "floor-plan-layer-validate-button",
					sx: {
						marginBottom: 2,
						backgroundColor: (e) => e.palette.primary.main,
						"&:hover": { backgroundColor: (e) => e.palette.primary.dark },
						color: "white",
						padding: 3,
						paddingTop: 1,
						paddingBottom: 1
					},
					children: i("teia.widgets.floor_plan_widget.add_layer_tab.validate.text")
				})]
			})
		]
	})] });
}, ms = (t) => {
	let { formValues: n } = t, { t: r } = h("teiaviewer"), [i, a] = f(n.current.name), s = o((e) => {
		n.current.name = e.target.value, a(e.target.value);
	}, [n]);
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G("h4", {
		style: {
			fontSize: "16px",
			margin: 0
		},
		children: r("teia.widgets.floor_plan_widget.add_layer_tab.title", { name: n.current.name })
	}), /* @__PURE__ */ K(e, {
		direction: "row",
		sx: {
			alignItems: "center",
			marginTop: 3
		},
		children: [/* @__PURE__ */ G(Y, {
			component: dr,
			fontSize: "small",
			sx: {
				color: (e) => e.palette.primary.main,
				marginRight: 3
			}
		}), /* @__PURE__ */ G(y, {
			label: r("teia.widgets.floor_plan_widget.add_layer_tab.layer_name.label"),
			sx: {
				width: "100%",
				backgroundColor: "white",
				borderRadius: "8px"
			},
			onChange: s,
			"data-testid": "floor-plan-layer-name-input",
			value: i
		})]
	})] });
}, hs = (e) => /* @__PURE__ */ K("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ K("g", {
		clipPath: "url(#clip0_900_2925)",
		children: [
			/* @__PURE__ */ G("path", { d: "M6.21 20.2402L5.82 20.3902L3.8 21.1402L3.84 19.2102L0 23.2002L3.74 24.4302L3.78 22.4402L6.24 21.5202L6.44 21.4502L11.33 19.6102L9.98 18.8302L6.21 20.2402Z" }),
			/* @__PURE__ */ G("path", { d: "M22.74 14.0302C22.69 14.0302 22.64 14.0502 22.59 14.0602L22.54 14.0702L22.49 14.0902L19.18 15.3302L18.72 15.5102V16.8102L19.78 16.4002L22.95 15.2102L23.01 15.1902C23.21 15.0902 23.35 14.8902 23.35 14.6502C23.35 14.3102 23.08 14.0402 22.74 14.0402V14.0302Z" }),
			/* @__PURE__ */ G("path", { d: "M4.31 13.7202C4.31 14.1202 4.52 14.4802 4.86 14.6902L11.19 18.3802L12.54 19.1702L17.72 22.1902V8.7702L4.31 0.950195V13.7202ZM9.29 7.2902L11.09 9.9102L12.99 9.4502L15.89 11.2502L12.47 12.0002L15.35 16.8902L12.7 15.0902L10.99 12.3202L9.09 12.8002L6.05 11.0002L9.56 10.2202L6.02 5.4802L9.3 7.2802L9.29 7.2902Z" })
		]
	}), /* @__PURE__ */ G("defs", { children: /* @__PURE__ */ G("clipPath", {
		id: "clip0_900_2925",
		children: /* @__PURE__ */ G("rect", {
			width: 24,
			height: 24,
			transform: "translate(0 0.950195)"
		})
	}) })]
}), gs = (e) => /* @__PURE__ */ K("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", { d: "M12.9501 3.31013L12.8001 3.21013H12.7901C12.6501 3.12013 12.4901 3.08013 12.3301 3.08013C12.1701 3.08013 12.0101 3.12013 11.8701 3.21013L11.7401 3.29013L1.3501 9.78013L12.3301 16.6401L12.9001 16.2801L23.3101 9.78013L12.9501 3.31013ZM13.3201 12.9901H11.4201L11.6201 10.0101L9.5901 6.34013H11.3601L12.5401 8.39013L13.8201 6.32013H15.5801L13.3401 10.0001L13.3201 12.9801V12.9901Z" }),
		/* @__PURE__ */ G("path", { d: "M12.8701 17.4902C12.6901 17.5602 12.5001 17.6002 12.3001 17.6002C12.0901 17.6002 11.8801 17.5502 11.6801 17.4702V19.4502L11.6601 19.8802H9.21008L12.3001 23.6102L15.5501 19.8802L12.8701 19.8802V17.4902Z" }),
		/* @__PURE__ */ G("path", { d: "M12.3001 1.76016V1.74016L12.8001 2.05016L12.9401 2.14016V0.740159C12.9201 0.500159 12.7801 0.28016 12.5601 0.19016C12.2501 0.0601597 11.8901 0.230159 11.7701 0.570159C11.7501 0.620159 11.7501 0.680159 11.7401 0.740159V2.11016L11.8001 2.07016L12.3001 1.76016Z" })
	]
}), _s = (e) => /* @__PURE__ */ K("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", { d: "M0.87 14.0802L0.77 14.0502C0.72 14.0502 0.67 14.0302 0.62 14.0302C0.28 14.0302 0.01 14.3002 0.01 14.6402C0.01 14.8802 0.15 15.0802 0.35 15.1802L0.41 15.2002L3.58 16.3902L4.64 16.8002V15.5002L4.18 15.3202L0.87 14.0802Z" }),
		/* @__PURE__ */ G("path", { d: "M19.55 21.1402L17.53 20.3902L17.14 20.2402L13.37 18.8302L12.02 19.6102L16.92 21.4502L17.11 21.5202L19.57 22.4402L19.61 24.4302L23.35 23.2002L19.51 19.2102L19.55 21.1402Z" }),
		/* @__PURE__ */ G("path", { d: "M5.63 22.1802L10.81 19.1602L12.16 18.3702L18.49 14.6802C18.83 14.4802 19.04 14.1102 19.04 13.7102V0.950195L5.63 8.7702V22.1802ZM10.14 15.1302L13.15 9.8402L10.52 11.3702L10.68 9.7702L15.29 7.0902L15.41 8.2002L12.77 13.2902L15.88 11.4802L16.04 12.8902L10.01 16.4002L10.14 15.1302Z" })
	]
}), vs = "TwinPlan", ys = () => {
	let { plugin: e } = U("Teia");
	return at(e.twinApiClient);
}, bs = (e, t, n, r, i, a) => {
	let o = ys();
	return mt({
		queryKey: [
			vs,
			e.projectId,
			e.type,
			"GetPlansConfig",
			t,
			n,
			i
		],
		queryFn: () => o.getTwinPlans(e, t, n, i, a),
		refetchInterval: r
	});
}, xs = (e) => {
	let t = ht();
	return () => {
		t.invalidateQueries({ queryKey: [
			vs,
			e.projectId,
			e.type,
			"GetPlansConfig"
		] });
	};
}, Ss = (e) => {
	let t = ys(), n = ht();
	return J({
		mutationFn: async (n) => {
			await t.addPlan(e, n.plan);
		},
		onSuccess: () => n.invalidateQueries({ queryKey: [
			vs,
			e.projectId,
			e.type
		] })
	});
}, Cs = (e) => {
	let t = ys(), n = ht();
	return J({
		mutationFn: async (n) => {
			await t.updatePlan(e, n.floorPlanConfigurationId, n.plan);
		},
		onSuccess: () => n.invalidateQueries({ queryKey: [
			vs,
			e.projectId,
			e.type
		] })
	});
}, ws = (e) => {
	let t = ys(), n = ht();
	return J({
		mutationFn: async (n) => {
			await t.deletePlan(e, n.floorPlanConfiguationId);
		},
		onSuccess: () => n.invalidateQueries({ queryKey: [
			vs,
			e.projectId,
			e.type
		] })
	});
}, Ts = (e) => /* @__PURE__ */ G("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ G("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.375 3C9.16789 3 9 3.16789 9 3.375V16.125C9 16.3321 9.16789 16.5 9.375 16.5H19.125C19.3321 16.5 19.5 16.3321 19.5 16.125V11.625C19.5 10.1753 18.3247 9 16.875 9H15.375C14.3395 9 13.5 8.16053 13.5 7.125V5.625C13.5 4.17525 12.3247 3 10.875 3H9.375ZM14.5069 3.66756C14.8214 4.24997 15 4.91663 15 5.625V7.125C15 7.33211 15.1679 7.5 15.375 7.5H16.875C17.5832 7.5 18.2498 7.67848 18.8321 7.99292C17.9986 6.05538 16.4443 4.50088 14.5069 3.66756ZM21 16.125C21 17.1605 20.1605 18 19.125 18H16.5V20.625C16.5 21.6605 15.6605 22.5 14.625 22.5H4.875C3.83947 22.5 3 21.6605 3 20.625V7.875C3 6.83947 3.83947 6 4.875 6H6.75C7.00224 6 7.25236 6.00959 7.5 6.02845V3.375C7.5 2.33947 8.33947 1.5 9.375 1.5H11.25C11.8028 1.5 12.3454 1.54608 12.8741 1.63477C17.4859 2.4085 21 6.41814 21 11.25V16.125ZM7.5 7.53358C7.25313 7.51136 7.00297 7.5 6.75 7.5H4.875C4.66789 7.5 4.5 7.66789 4.5 7.875V20.625C4.5 20.8321 4.66789 21 4.875 21H14.625C14.8321 21 15 20.8321 15 20.625V18H9.375C8.33947 18 7.5 17.1605 7.5 16.125V7.53358Z"
	})
}), Es = (e) => new Promise((t) => setTimeout(t, e)), Ds = (e) => ({
	rule: e.rule,
	lineColor: e.lineColor,
	lineType: e.lineType,
	lineWidth: e.lineWidth,
	fillColor: e.fillColor ?? Oe,
	name: e.name,
	order: e.order,
	annotations: e.annotations
}), Os = (e) => ({
	name: e.name,
	direction: e.direction,
	floorPlanLayers: e.floorPlanLayers.map(Ds)
}), ks = (e) => ({
	name: e.name,
	direction: e.direction,
	floorPlanLayers: e.floorPlanLayers.map((e) => ({
		...Ds(e),
		id: e.id
	}))
});
async function As(e, t, n, r, i) {
	let a = await at(e.twinApiClient).downloadExport(t, n, i), o = document.createElement("a");
	o.href = a, o.download = `${r}.${i.toLocaleLowerCase()}`, o.click(), URL.revokeObjectURL(a);
}
async function js(e, t, n, r = 20, i = 3e3) {
	for (let a = 0; a < r; a++) try {
		return await at(e.twinApiClient).downloadAnalyze(t, n);
	} catch {
		await Es(i);
	}
	throw Error("Analyze file not ready after waiting.");
}
async function Ms(e, t, n, r) {
	await at(e.twinApiClient).generateAnalyze(t, n);
	let i = await js(e, t, n), a = document.createElement("a");
	a.href = i, a.download = `${r}.xlsx`, a.click(), URL.revokeObjectURL(i);
}
async function Ns(e, t, n, r) {
	let i = await at(e.twinApiClient).downloadConfiguration(t, n), a = document.createElement("a");
	a.href = i, a.download = `${r}.json`, a.click(), URL.revokeObjectURL(i);
}
function Ps(e) {
	let t = JSON.stringify(e), n = new Blob([t], { type: "application/json" });
	return new File([n], `${e.name}.json`, { type: "application/json" });
}
async function Fs(e) {
	return new Promise((t) => {
		let n = new FileReader();
		n.onload = (e) => {
			try {
				if (e.target) {
					let n = JSON.parse(e.target.result);
					if (!Is(n)) throw Error("Json is invalid");
					t({
						direction: n.direction,
						name: `${Dn("teiaviewer:teia.widgets.floor_plan_widget.import_tab.import_suffix.text")} - ${n.name}`,
						floorPlanLayers: n.floorPlanLayers,
						status: "success"
					});
				}
			} catch (e) {
				t({
					direction: [
						0,
						0,
						0
					],
					name: `Error while loading the file: ${e}`,
					floorPlanLayers: [],
					status: "error"
				});
			}
		}, n.readAsText(e);
	});
}
function Is(e) {
	if (typeof e.name == "string" && typeof e.direction == "object" && typeof e.floorPlanLayers == "object") {
		for (let t of e.floorPlanLayers) if (typeof t.rule != "object" || typeof t.order != "number" || typeof t.lineColor != "string" || typeof t.lineType != "string" || typeof t.lineWidth != "number" || typeof t.name != "string") return !1;
		return !0;
	}
	return !1;
}
//#endregion
//#region src/widgets/floorPlan/addPlanComponents/LayerElement.tsx
var Ls = (t) => {
	let { layer: n, setActiveSection: r, index: i, setWarning: a, setCurrentLayerIndex: o } = t, { t: s } = h("teiaviewer"), { newPlanConfig: c, setNewPlanConfig: l } = $o(), u = () => {
		if (c.floorPlanLayers.length === 1) {
			a(s("teia.widgets.floor_plan_widget.add_tab.warnings.at_least_one_layer.text"));
			return;
		}
		let e = { ...c };
		e.floorPlanLayers.splice(i, 1), l(e);
	}, d = () => {
		let e = { ...c }, t = {
			...Ds(n),
			name: `${s("teia.widgets.floor_plan_widget.add_tab.copy.text")} - ${n.name}`
		}, r = i + 1;
		e.floorPlanLayers.splice(r, 0, t), l(e);
	}, f = () => {
		o(i), r(1);
	}, p = (e) => {
		let t = { ...c }, r = t.floorPlanLayers.indexOf(n);
		if (r >= 0) {
			t.floorPlanLayers.splice(r, 1);
			let i = e === "up" ? r - 1 : r + 1;
			t.floorPlanLayers.splice(i, 0, n);
		}
		l(t);
	};
	return /* @__PURE__ */ K(e, {
		spacing: 2,
		children: [/* @__PURE__ */ G(S, { children: s("teia.widgets.floor_plan_widget.add_tab.layer.text") }), /* @__PURE__ */ K(e, {
			direction: "row",
			sx: {
				alignItems: "center",
				justifyContent: "space-between"
			},
			children: [/* @__PURE__ */ K(e, {
				direction: "row",
				sx: { alignItems: "center" },
				children: [/* @__PURE__ */ K(e, { children: [/* @__PURE__ */ G(v, {
					icon: tn,
					"aria-label": s("teia.widgets.floor_plan_widget.add_tab.drag.text"),
					"data-dd-action-name": "teia.widgets.floor_plan_widget.layer.reorder",
					variant: "info",
					onClick: () => p("up"),
					"data-testid": "floor-plan-layer-up-button",
					sx: {
						marginRight: "20px",
						padding: 0
					},
					disabled: i === 0
				}), /* @__PURE__ */ G(v, {
					icon: Qt,
					"aria-label": s("teia.widgets.floor_plan_widget.add_tab.drag.text"),
					"data-dd-action-name": "teia.widgets.floor_plan_widget.layer.reorder",
					variant: "info",
					onClick: () => p("down"),
					"data-testid": "floor-plan-layer-down-button",
					sx: {
						marginRight: "20px",
						padding: 0
					},
					disabled: i === c.floorPlanLayers.length - 1
				})] }), /* @__PURE__ */ G(S, { children: n.name })]
			}), /* @__PURE__ */ K("div", { children: [
				/* @__PURE__ */ G(v, {
					icon: dr,
					variant: "primary",
					"data-dd-action-name": "teia.widgets.floor_plan_widget.layer.duplicate",
					sx: {
						width: "30px",
						marginRight: "10px"
					},
					"aria-label": s("teia.widgets.floor_plan_widget.add_tab.params.text"),
					onClick: f,
					"data-testid": "floor-plan-layer-settings-button"
				}),
				/* @__PURE__ */ G(v, {
					icon: Ts,
					variant: "primary",
					sx: {
						width: "30px",
						marginRight: "10px",
						"& svg": { fill: (e) => e.palette.primary.main },
						"&:hover": { "& svg": { fill: "white" } },
						"&:focus": { "& svg": { fill: "white" } }
					},
					"aria-label": s("teia.widgets.floor_plan_widget.add_tab.duplicate.text"),
					onClick: d,
					"data-testid": "floor-plan-layer-duplicate-button"
				}),
				/* @__PURE__ */ G(v, {
					icon: zr,
					variant: "error",
					"data-dd-action-name": "teia.widgets.floor_plan_widget.layer.delete",
					sx: { width: "30px" },
					"aria-label": s("teia.widgets.floor_plan_widget.add_tab.delete.text"),
					onClick: u,
					"data-testid": "floor-plan-layer-delete-button"
				})
			] })]
		})]
	});
}, Rs = (t) => {
	let { value: n, Icon: r } = t;
	return /* @__PURE__ */ K(e, {
		direction: "row",
		sx: {
			alignItems: "center",
			justifyContent: "flex-start",
			marginRight: "20px"
		},
		children: [/* @__PURE__ */ G(On, { value: n }), /* @__PURE__ */ G(Y, {
			component: r,
			fontSize: "small",
			sx: { fill: (e) => e.palette.primary.main }
		})]
	});
}, zs = (t) => {
	let { setActiveSection: n, setCurrentLayerIndex: r } = t, { t: i } = h("teiaviewer"), a = ea(), { viewer: o } = H(), { mutateAsync: s } = Ss(a), { mutateAsync: c } = Cs(a), [l, u] = f(!1), { newPlanConfig: d, setNewPlanConfig: p, setSelectedTabIndex: g, updatedId: _, setUpdatedId: v, floorPlans: y, setFloorPlans: b } = $o(), [x, C] = f(""), w = async () => {
		if (d.name === "") {
			C(i("teia.widgets.floor_plan_widget.add_tab.warnings.must_have_a_name.text"));
			return;
		}
		let e = 1;
		for (let t of d.floorPlanLayers) {
			if (t.order = e, Object.values(t.rule).length === 0) {
				C(`${t.name} ${i("teia.widgets.floor_plan_widget.add_tab.warnings.must_have_filter.text")}`);
				return;
			}
			e += 1;
		}
		if (_ == null) await s({ plan: d });
		else {
			let e = y.get(_);
			b((e) => {
				let t = new Map(e);
				return t.delete(_), t;
			}), e && new Mt(o, e).execute();
			let t = {
				name: d.name,
				direction: d.direction,
				floorPlanLayers: d.floorPlanLayers
			};
			await c({
				plan: t,
				floorPlanConfigurationId: _
			}), v(null);
		}
		g(0), p(Jo());
	}, T = (e) => {
		let t = { ...d };
		e.target.value === "X" ? t.direction = [
			1,
			0,
			0
		] : e.target.value === "Y" ? t.direction = [
			0,
			1,
			0
		] : e.target.value === "Z" && (t.direction = [
			0,
			0,
			1
		]), e.target.value == "custom" ? u(!0) : (u(!1), p(t));
	}, E = () => {
		C("");
		let e = { ...d }, t = e.floorPlanLayers.length, n = Yo();
		n.name = `Layer ${t + 1}`, e.floorPlanLayers.push(n), p(e);
	}, D = () => {
		let e = d.direction;
		return e[0] == 1 && e[1] === 0 && e[2] == 0 ? "X" : e[0] == 0 && e[1] === 1 && e[2] == 0 ? "Y" : e[0] == 0 && e[1] === 0 && e[2] == 1 ? "Z" : (l || u(!0), "custom");
	}, O = { name: d.name }, k = _ ? i("teia.widgets.floor_plan_widget.add_tab.titles.update.title", O) : i("teia.widgets.floor_plan_widget.add_tab.titles.create.title");
	return /* @__PURE__ */ K(W, { children: [
		/* @__PURE__ */ G(S, {
			variant: "overline",
			children: k
		}),
		/* @__PURE__ */ K(e, {
			spacing: 2,
			sx: {
				width: "100%",
				justifyContent: "space-between",
				marginTop: 2
			},
			divider: /* @__PURE__ */ G(Kt, {}),
			children: [
				/* @__PURE__ */ G(Bs, { setWarning: C }),
				/* @__PURE__ */ K(e, { children: [/* @__PURE__ */ G(S, { children: i("teia.widgets.floor_plan_widget.add_tab.point_of_view.text") }), /* @__PURE__ */ G(e, { children: /* @__PURE__ */ K(En, {
					row: !0,
					sx: { "& label": { marginRight: 0 } },
					onChange: T,
					value: D(),
					children: [
						/* @__PURE__ */ G(Rs, {
							value: "X",
							Icon: hs
						}),
						/* @__PURE__ */ G(Rs, {
							value: "Y",
							Icon: gs
						}),
						/* @__PURE__ */ G(Rs, {
							value: "Z",
							Icon: _s
						})
					]
				}) })] }),
				/* @__PURE__ */ G(e, {
					spacing: 2,
					children: d.floorPlanLayers.map((e, t) => /* @__PURE__ */ G(Ls, {
						layer: e,
						setActiveSection: n,
						index: t,
						setWarning: C,
						setCurrentLayerIndex: r
					}, `${e.name}${t}`))
				}),
				/* @__PURE__ */ G(Z, {
					variant: "info",
					"data-dd-action-name": "teia.widgets.floor_plan_widget.layer.add",
					sx: {
						width: "fit-content",
						backgroundColor: (e) => e.palette.primary.main,
						"&:hover": { backgroundColor: (e) => e.palette.primary.dark },
						color: "white",
						padding: 3,
						paddingTop: 1,
						paddingBottom: 1
					},
					onClick: E,
					"data-testid": "floor-plan-add-layer-button",
					children: i("teia.widgets.floor_plan_widget.add_tab.add_layer.text")
				})
			]
		}),
		/* @__PURE__ */ G(e, {
			direction: "row",
			sx: { justifyContent: "flex-end" },
			children: /* @__PURE__ */ G(Z, {
				variant: "info",
				onClick: w,
				"data-testid": "floor-plan-validate-button",
				"data-dd-action-name": _ == null ? void 0 : "teia.widgets.floor_plan_widget.plan.update",
				sx: {
					backgroundColor: (e) => e.palette.primary.main,
					"&:hover": { backgroundColor: (e) => e.palette.primary.dark },
					color: "white",
					padding: 3,
					paddingTop: 1,
					paddingBottom: 1,
					marginBottom: 2
				},
				children: i("teia.widgets.floor_plan_widget.add_tab.validate.text")
			})
		}),
		!!x && /* @__PURE__ */ G(m, {
			severity: "warning",
			"data-testid": "floor-plan-add-warning",
			sx: {
				marginTop: 3,
				marginBottom: 3
			},
			children: x
		})
	] });
}, Bs = (e) => {
	let { setWarning: t } = e, { t: n } = h("teiaviewer"), { newPlanConfig: r, setNewPlanConfig: i } = $o(), [a, o] = f(r.name);
	return /* @__PURE__ */ G(y, {
		value: a,
		onBlur: (e) => {
			t(""), i({
				...r,
				name: e.target.value
			});
		},
		onChange: (e) => {
			o(e.target.value);
		},
		label: n("teia.widgets.floor_plan_widget.add_tab.plan_name.label"),
		"data-testid": "floor-plan-name-input",
		sx: {
			width: "100%",
			backgroundColor: "white",
			marginTop: 1,
			borderRadius: "8px"
		}
	});
}, Vs = () => {
	let [t, n] = f(0), [r, i] = f(0);
	return /* @__PURE__ */ K(e, {
		direction: "row",
		sx: { position: "relative" },
		children: [/* @__PURE__ */ G(_, {
			sx: {
				width: "100%",
				position: "absolute",
				transition: "200ms ease-in-out",
				left: t === 0 ? 0 : "calc(-100% - 12px)"
			},
			children: /* @__PURE__ */ G(zs, {
				setActiveSection: n,
				setCurrentLayerIndex: i
			})
		}), /* @__PURE__ */ G(_, {
			sx: {
				width: "100%",
				position: "absolute",
				transition: "200ms ease-in-out",
				right: t === 1 ? 0 : "calc(-100% - 12px)"
			},
			children: t === 1 && /* @__PURE__ */ G(ps, {
				setActiveSection: n,
				currentLayerIndex: r
			})
		})]
	});
}, Hs = (t) => {
	let { text: n, color: r, sx: i } = t;
	return /* @__PURE__ */ G(e, {
		direction: "row",
		alignItems: "center",
		justifyContent: "center",
		sx: {
			border: "1px solid",
			borderColor: (e) => r === "success" ? e.palette.success.light : e.palette.error.light,
			borderRadius: 1,
			padding: "7px 8px",
			minWidth: "65px",
			fontSize: 14,
			...i
		},
		children: /* @__PURE__ */ G(S, { children: n })
	});
}, Us = (t) => {
	let { name: n, status: r, index: i, setImportedPlans: a, setShowWarningLength: o } = t, [s, c] = f(n), { t: l } = h("teiaviewer");
	return /* @__PURE__ */ K(e, {
		direction: "row",
		alignItems: "center",
		justifyContent: "space-between",
		sx: {
			marginTop: 3,
			marginBottom: 3
		},
		children: [
			r === "success" ? /* @__PURE__ */ G(y, {
				label: l("teia.widgets.floor_plan_widget.import_tab.file_name.label"),
				sx: { width: "100%" },
				value: s,
				onChange: (e) => {
					c(e.target.value);
				},
				onBlur: () => {
					a((e) => {
						let t = [...e];
						return t[i].name = s, t;
					});
				},
				"data-testid": "floor-plan-import-file-name-input"
			}) : /* @__PURE__ */ G(S, {
				sx: {
					width: "100%",
					marginLeft: "5px"
				},
				children: s
			}),
			/* @__PURE__ */ G(v, {
				icon: zr,
				variant: "error",
				sx: {
					width: 35,
					minWidth: 35,
					marginLeft: 2,
					marginRight: 2
				},
				"aria-label": l("teia.widgets.floor_plan_widget.import_tab.delete.text"),
				onClick: () => {
					a((e) => {
						let t = [...e];
						return t.splice(i, 1), t.length < 10 && o(!1), t;
					});
				},
				"data-testid": "floor-plan-import-file-delete-button"
			}),
			r === "success" ? /* @__PURE__ */ G(Hs, {
				text: l("teia.widgets.floor_plan_widget.import_tab.success.text"),
				color: "success"
			}) : /* @__PURE__ */ G(Hs, {
				text: l("teia.widgets.floor_plan_widget.import_tab.error.text"),
				color: "error"
			})
		]
	});
}, Ws = (e) => {
	let { open: t, setOpen: n, callback: r } = e, { t: i } = h("teiaviewer");
	return /* @__PURE__ */ K(Et, {
		open: t,
		onClose: () => n(!1),
		children: [
			/* @__PURE__ */ G(kt, { children: i("teia.widgets.floor_plan_widget.import_tab.modal.title") }),
			/* @__PURE__ */ G(Dt, { children: /* @__PURE__ */ G("p", { children: i("teia.widgets.floor_plan_widget.import_tab.modal.warning.text") }) }),
			/* @__PURE__ */ K(Ot, { children: [/* @__PURE__ */ G(Z, {
				onClick: () => {
					n(!1);
				},
				variant: "info",
				"data-testid": "floor-plan-import-modal-cancel-button",
				children: i("teia.widgets.floor_plan_widget.import_tab.modal.cancel.text")
			}), /* @__PURE__ */ G(Z, {
				onClick: () => {
					r(), n(!1);
				},
				variant: "primary",
				"data-testid": "floor-plan-import-modal-confirm-button",
				children: i("teia.widgets.floor_plan_widget.import_tab.modal.confirm.text")
			})] })
		]
	});
}, Gs = () => {
	let { t } = h("teiaviewer"), n = ea(), { plugin: r } = U("Teia"), { setSelectedTabIndex: i } = $o(), [a, o] = f(!1), [s, c] = f([]), l = d(null), [u, p] = f(!1), [g, _] = f(!1), v = () => {
		i(0);
	}, y = async () => {
		let e = [];
		for (let t of s) if (t.status === "success") {
			let n = Ps(t);
			e.push(n);
		}
		await at(r.twinApiClient).importConfiguration(n, e), i(0);
	}, b = () => {
		o(!0);
	}, x = () => {
		o(!1);
	}, C = (e) => {
		e.preventDefault();
	}, w = (e) => {
		let t = Array.from(e.dataTransfer.files);
		E(t), e.preventDefault();
	}, T = (e) => {
		if (e.target.files) {
			let t = Array.from(e.target.files);
			E(t);
		}
		e.preventDefault();
	}, E = (e) => {
		let t = [];
		for (let n of e) n?.type === "application/json" && t.push(Fs(n));
		Promise.all(t).then((e) => {
			c((t) => t.length + e.length > 10 ? (p(!0), [...t, ...e].slice(0, 9)) : (p(!1), [...t, ...e]));
		});
	};
	return /* @__PURE__ */ K(W, { children: [
		/* @__PURE__ */ G(Ws, {
			open: g,
			setOpen: _,
			callback: y
		}),
		/* @__PURE__ */ G("h4", { children: t("teia.widgets.floor_plan_widget.import_tab.title") }),
		/* @__PURE__ */ G("input", {
			type: "file",
			ref: l,
			accept: ".json",
			style: { display: "none" },
			onChange: T,
			"data-testid": "floor-plan-import-file-input"
		}),
		/* @__PURE__ */ K(e, {
			onDragEnter: b,
			onDragLeave: x,
			onDragOver: C,
			onDrop: w,
			onClick: () => {
				l.current?.click();
			},
			"data-testid": "floor-plan-import-drop-zone",
			alignItems: "center",
			justifyContent: "center",
			sx: {
				cursor: "pointer",
				marginTop: 2,
				marginBottom: 4,
				border: "2px dotted transparent",
				borderColor: (e) => a ? e.palette.grey[800] : e.palette.grey[400],
				borderRadius: 2,
				padding: "50px 10px",
				fontSize: 13,
				transition: "200ms",
				color: (e) => e.palette.grey[600]
			},
			children: [
				/* @__PURE__ */ G(Cr, { style: {
					height: 60,
					marginBottom: 10
				} }),
				/* @__PURE__ */ G(S, { children: t("teia.widgets.floor_plan_widget.import_tab.import.text") }),
				/* @__PURE__ */ G(S, { children: `(${t("teia.widgets.floor_plan_widget.import_tab.max_files.text")}).` })
			]
		}),
		s.map((e, t) => /* @__PURE__ */ G(Us, {
			name: e.name,
			status: e.status,
			index: t,
			setImportedPlans: c,
			setShowWarningLength: p
		}, `${t}-${e.name}`)),
		!!u && /* @__PURE__ */ G(m, {
			severity: "warning",
			"data-testid": "floor-plan-import-length-warning",
			children: t("teia.widgets.floor_plan_widget.import_tab.error_length.text")
		}),
		/* @__PURE__ */ K(e, {
			direction: "row",
			alignItems: "center",
			justifyContent: "flex-end",
			sx: {
				marginTop: 4,
				marginBottom: 4
			},
			children: [/* @__PURE__ */ G(Z, {
				sx: {
					marginRight: 2,
					backgroundColor: (e) => e.palette.error.main,
					"&:hover": { backgroundColor: (e) => e.palette.error.dark },
					color: "white",
					padding: 3,
					paddingTop: 1,
					paddingBottom: 1
				},
				variant: "info",
				onClick: v,
				"data-testid": "floor-plan-import-cancel-button",
				children: /* @__PURE__ */ G(S, { children: t("teia.widgets.floor_plan_widget.import_tab.button.cancel.text") })
			}), /* @__PURE__ */ G(Z, {
				variant: "info",
				onClick: () => _(!0),
				"data-testid": "floor-plan-import-submit-button",
				disabled: s.length === 0,
				sx: {
					backgroundColor: (e) => e.palette.primary.main,
					"&:hover": { backgroundColor: (e) => e.palette.primary.dark },
					"&:disabled": {
						color: "white",
						backgroundColor: (e) => e.palette.primary.light
					},
					color: "white",
					padding: 3,
					paddingTop: 1,
					paddingBottom: 1
				},
				children: /* @__PURE__ */ G(S, { children: t("teia.widgets.floor_plan_widget.import_tab.button.import.text") })
			})]
		})
	] });
}, Ks = (e) => /* @__PURE__ */ K("svg", {
	width: 221,
	height: 312,
	viewBox: "0 0 221 312",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", {
			d: "M109.111 235.96C108.571 235.766 107.993 235.607 107.61 235.507C107.427 235.46 107.259 235.418 107.119 235.384L6.0246 175.75L6.02079 175.748C4.61487 174.921 3.75 173.429 3.75 171.656V68.6624C3.75 66.8896 4.61487 65.3977 6.0208 64.5706L6.02459 64.5684L107.94 4.45059L107.981 4.42611L108.022 4.40057C108.658 4.00335 109.496 3.75 110.306 3.75C111.015 3.75 111.751 3.94519 112.719 4.47748L214.437 64.4166L214.439 64.418C215.845 65.2451 216.71 66.737 216.71 68.5098V171.503C216.71 173.276 215.845 174.768 214.439 175.595L214.435 175.598L112.52 235.715L112.515 235.719C112.462 235.727 112.392 235.738 112.296 235.753C112.128 235.778 111.847 235.82 111.554 235.878L111.467 235.896L111.38 235.918C111.004 236.012 110.672 236.134 110.473 236.21C110.388 236.243 110.298 236.277 110.228 236.305L110.187 236.321C110.095 236.284 109.978 236.239 109.852 236.193C109.653 236.12 109.402 236.035 109.111 235.96ZM205.585 169.85L207.428 168.761V166.621V118.252V83.3104V76.7439L201.772 80.0806L116.945 130.128L115.1 131.216V133.358V216.668V223.232L120.755 219.898L170.186 190.755L170.189 190.754L205.585 169.85ZM112.211 15.0797L110.306 13.9566L108.402 15.0797L23.2689 65.2796L17.7908 68.5098L23.2689 71.7401L108.402 121.94L110.306 123.063L112.211 121.94L197.344 71.7401L202.822 68.5098L197.344 65.2796L112.211 15.0797ZM18.8405 80.0806L13.185 76.7439V83.3104V134.273V166.621V168.761L15.028 169.85L50.4237 190.754L50.4261 190.755L99.858 219.898L105.512 223.232V216.668V133.358V131.216L103.668 130.128L18.8405 80.0806Z",
			fill: "#5368A5",
			stroke: "white",
			strokeWidth: 7.5
		}),
		/* @__PURE__ */ G("path", {
			d: "M165.5 280L112.5 312L45 273L150.5 211L169 220L116.5 248.5L165.5 280Z",
			fill: "#D8DDEB"
		}),
		/* @__PURE__ */ G("path", {
			d: "M167 221L121.5 249.5L167 279.5L216.5 249.5L167 221Z",
			fill: "#5D7DFF"
		}),
		/* @__PURE__ */ G("path", {
			d: "M70 209L3 247.5L43.5 271.5L109.5 232.5L70 209Z",
			fill: "#FFD9B6"
		}),
		/* @__PURE__ */ G("path", {
			d: "M140.559 263L116.5 249L140.559 235M152.588 270L164.617 277L212.5 249L164.617 221L151 228.924",
			stroke: "#5368A5",
			strokeWidth: 2,
			fill: "none"
		}),
		/* @__PURE__ */ G("path", {
			d: "M147 210L92 242.559M63.25 259.471L45 270.206",
			stroke: "#5368A5",
			strokeWidth: 2,
			fill: "none"
		}),
		/* @__PURE__ */ G("path", {
			d: "M110.5 309L212.5 249L147 210L110.5 231.5L73.5 210L8 249L110.5 309Z",
			stroke: "#5368A5",
			strokeWidth: 2,
			fill: "none"
		})
	]
});
//#endregion
//#region src/widgets/floorPlan/hooks/useFloorPlanVisibility.tsx
function qs(e) {
	return p((t) => e ? (e.signals.onVisibilityChanged.connect(t), () => {
		e.signals.onVisibilityChanged.disconnect(t);
	}) : () => null, () => e?.visible);
}
//#endregion
//#region src/widgets/floorPlan/listComponents/ActionButton.tsx
var Js = (e) => {
	let { text: t, onClick: n, disabled: r, "data-dd-action-name": i } = e;
	return /* @__PURE__ */ G(Z, {
		onClick: n,
		variant: "info",
		disabled: r,
		"data-dd-action-name": i,
		"data-testid": e["data-testid"],
		sx: {
			textAlign: "left",
			display: "block",
			fontSize: "14px",
			padding: "2px 10px"
		},
		children: t
	});
}, Ys = (t) => {
	let { text: n, callback: r, planConfig: i, status: a, fileType: o } = t, s = ea(), { plugin: c } = U("Teia"), l = xs(s), u = () => {
		As(c, s, i.id, i.name, o), r();
	}, d = async () => {
		await at(c.twinApiClient).addExport(s, i.id, o), l(), r();
	}, f = () => {
		a === void 0 ? d() : a === "Completed" && u();
	}, p = a === void 0 || a === "Completed", m;
	return a === void 0 ? m = "generate" : a === "Completed" && (m = "download"), /* @__PURE__ */ G(Z, {
		onClick: f,
		variant: "info",
		"data-testid": `floor-plan-download-${o.toLowerCase()}-button`,
		"data-dd-action-name": m ? `teia.widgets.floor_plan_widget.export.${m}.${o.toLowerCase()}` : void 0,
		sx: {
			textAlign: "left",
			display: "block",
			fontSize: "14px",
			padding: "2px 10px",
			pointerEvents: p ? "auto" : "none"
		},
		children: /* @__PURE__ */ K(e, {
			direction: "row",
			alignItems: "center",
			justifyContent: "space-between",
			spacing: 3,
			children: [
				/* @__PURE__ */ G(S, { children: n }),
				a === void 0 && /* @__PURE__ */ G(Y, {
					component: yn,
					sx: { color: (e) => e.palette.info.main }
				}),
				a === "Completed" && /* @__PURE__ */ G(Y, {
					component: Zt,
					sx: { color: (e) => e.palette.success.main }
				}),
				a === "Failed" && /* @__PURE__ */ G(Y, {
					component: Tn,
					sx: { color: (e) => e.palette.error.main }
				}),
				a === "InProgress" && /* @__PURE__ */ G(yt, { size: 20 }),
				a === "ToDo" && /* @__PURE__ */ G(Y, {
					component: on,
					sx: { color: (e) => e.palette.info.main }
				})
			]
		})
	});
}, Xs = (e) => {
	let { open: t, setOpen: n, callback: r, count: i } = e, { t: a } = h("teiaviewer");
	return /* @__PURE__ */ K(Et, {
		open: t,
		onClose: () => n(!1),
		children: [
			/* @__PURE__ */ G(kt, { children: a("teia.widgets.floor_plan_widget.list_tab.display_modal.title") }),
			/* @__PURE__ */ G(Dt, { children: /* @__PURE__ */ G("p", { children: a("teia.widgets.floor_plan_widget.list_tab.display_modal.warning.text", { count: i }) }) }),
			/* @__PURE__ */ K(Ot, { children: [/* @__PURE__ */ G(Z, {
				onClick: () => {
					n(!1);
				},
				variant: "info",
				"data-testid": "floor-plan-display-modal-cancel-button",
				children: a("teia.widgets.floor_plan_widget.list_tab.display_modal.cancel.text")
			}), /* @__PURE__ */ G(Z, {
				onClick: () => {
					r(), n(!1);
				},
				variant: "primary",
				"data-testid": "floor-plan-display-modal-confirm-button",
				children: a("teia.widgets.floor_plan_widget.list_tab.display_modal.confirm.text")
			})] })
		]
	});
}, Zs = (e) => {
	let { open: t, setOpen: n, callback: r } = e, { t: i } = h("teiaviewer");
	return /* @__PURE__ */ K(Et, {
		open: t,
		onClose: () => n(!1),
		children: [
			/* @__PURE__ */ G(kt, { children: i("teia.widgets.floor_plan_widget.list_tab.export_modal.title") }),
			/* @__PURE__ */ G(Dt, { children: /* @__PURE__ */ G("p", { children: i("teia.widgets.floor_plan_widget.list_tab.export_modal.warning.text") }) }),
			/* @__PURE__ */ K(Ot, { children: [/* @__PURE__ */ G(Z, {
				onClick: () => {
					n(!1);
				},
				variant: "info",
				"data-testid": "floor-plan-export-modal-cancel-button",
				children: i("teia.widgets.floor_plan_widget.list_tab.export_modal.cancel.text")
			}), /* @__PURE__ */ G(Z, {
				onClick: () => {
					r(), n(!1);
				},
				variant: "primary",
				"data-testid": "floor-plan-export-modal-confirm-button",
				children: i("teia.widgets.floor_plan_widget.list_tab.export_modal.confirm.text")
			})] })
		]
	});
}, Qs = { "&.Mui-disabled": { color: "info.main" } }, $s = (t) => {
	let { isLoading: n, onUpdatePlanConfig: r, onDuplicatePlanConfig: i, planConfig: a, floorPlan: o, setRowSelection: s, toggleIsVisible: c, setPagination: u, setIsDeleting: d } = t, { t: p } = h("teiaviewer"), { setFloorPlans: m } = $o(), [g, _] = f(null), [y, b] = f(null), x = ea(), { mutateAsync: S } = ws(x), C = l(), w = l(), { plugin: T } = U("Teia"), [E, D] = f(!1), O = qs(o), { viewer: k } = H(), { plugin: A } = U("FloorPlan"), [j, M] = f(!1), [N, P] = f(!1), F = xs(x), I = (e) => {
		_(e.currentTarget);
	}, R = (e) => {
		b(e.currentTarget);
	}, z = () => {
		_(null);
	}, B = () => {
		b(null);
	}, V = () => {
		z(), r();
	}, ee = () => {
		if (a.objectProjectedCount >= A.settings.objectCountWarningLevel.value) {
			P(!0);
			return;
		}
		c();
	}, te = () => {
		o && (new Lt(k, [o.uuid]).execute(), k.viewport?.transformController.attachObjects([o]));
	}, ne = async () => {
		z(), M(!0), await Ms(T, x, a.id, a.name), M(!1);
	}, re = async () => {
		z(), d(!0), await S({ floorPlanConfiguationId: a.id });
		let e = A.floorPlanController.getSceneFloorPlanWithConfigurationId(a.id);
		e && (new Mt(k, e).execute(), m((t) => {
			let n = new Map(t);
			return n.delete(e.id), n;
		})), s({}), u({
			pageIndex: 0,
			pageSize: 5
		}), d(!1);
	}, ie = () => {
		z(), Ns(T, x, a.id, a.name);
	}, ae = async () => {
		z(), await at(T.twinApiClient).restartExport(x, a.id), F();
	}, oe = !!g, se = !!y, ce = a.status, le = ce === "ToDo" || ce === "InProgressProjection", W = ce === "ProjectionCompleted" || ce === "ProjectionDegraded", ue = W && !n;
	return /* @__PURE__ */ K(e, {
		direction: "row",
		children: [
			/* @__PURE__ */ G(Zs, {
				open: E,
				setOpen: D,
				callback: ie
			}),
			/* @__PURE__ */ G(Xs, {
				open: N,
				setOpen: P,
				callback: c,
				count: a.objectProjectedCount
			}),
			/* @__PURE__ */ G(jn, {
				color: ue ? "primary" : "info",
				"aria-label": p("teia.widgets.floor_plan_widget.list_tab.actions.text"),
				"data-dd-action-name": `teia.widgets.floor_plan_widget.plan.${O ? "hide" : "show"}`,
				onClick: ee,
				"data-testid": "floor-plan-visibility-button",
				disabled: !ue,
				sx: Qs,
				children: O ? /* @__PURE__ */ G(Y, { component: ln }) : n ? /* @__PURE__ */ G(yt, { size: 20 }) : /* @__PURE__ */ G(Y, { component: un })
			}),
			/* @__PURE__ */ G(v, {
				icon: vn,
				"aria-label": p("teia.widgets.floor_plan_widget.list_tab.update.text"),
				onClick: V,
				"data-testid": "floor-plan-update-button"
			}),
			/* @__PURE__ */ G(v, {
				icon: xn,
				"aria-label": p("teia.widgets.floor_plan_widget.list_tab.select.text"),
				"data-dd-action-name": "teia.widgets.floor_plan_widget.plan.select",
				onClick: te,
				"data-testid": "floor-plan-select-button",
				disabled: !O,
				sx: Qs
			}),
			/* @__PURE__ */ G(v, {
				icon: qt,
				"aria-label": p("teia.widgets.floor_plan_widget.list_tab.download.text"),
				onClick: R,
				"data-testid": "floor-plan-download-button",
				disabled: !W,
				"aria-describedby": w,
				sx: Qs
			}),
			/* @__PURE__ */ G(Mn, {
				id: w,
				open: se,
				anchorEl: y,
				onClose: B,
				anchorOrigin: {
					vertical: "bottom",
					horizontal: "right"
				},
				transformOrigin: {
					vertical: "top",
					horizontal: "right"
				},
				children: /* @__PURE__ */ K(e, {
					direction: "column",
					children: [
						/* @__PURE__ */ G(Ys, {
							text: "SVG",
							planConfig: a,
							callback: B,
							status: a.exports.find((e) => e.fileType == "Svg")?.status,
							fileType: "Svg"
						}),
						/* @__PURE__ */ G(Ys, {
							text: "PDF",
							planConfig: a,
							callback: B,
							status: a.exports.find((e) => e.fileType == "Pdf")?.status,
							fileType: "Pdf"
						}),
						/* @__PURE__ */ G(Ys, {
							text: "DXF",
							planConfig: a,
							callback: B,
							status: a.exports.find((e) => e.fileType == "Dxf")?.status,
							fileType: "Dxf"
						})
					]
				})
			}),
			/* @__PURE__ */ G(v, {
				icon: cn,
				variant: le ? "info" : "primary",
				"aria-label": p("teia.widgets.floor_plan_widget.list_tab.actions.text"),
				onClick: I,
				"data-testid": "floor-plan-more-button",
				"aria-describedby": C,
				disabled: le,
				sx: Qs
			}),
			/* @__PURE__ */ G(Mn, {
				id: C,
				open: oe,
				anchorEl: g,
				onClose: z,
				anchorOrigin: {
					vertical: "bottom",
					horizontal: "right"
				},
				transformOrigin: {
					vertical: "top",
					horizontal: "right"
				},
				children: /* @__PURE__ */ K(e, {
					direction: "column",
					children: [
						/* @__PURE__ */ G(Js, {
							onClick: i,
							"data-testid": "floor-plan-duplicate-button",
							"data-dd-action-name": "teia.widgets.floor_plan_widget.configuration.duplicate",
							text: p("teia.widgets.floor_plan_widget.list_tab.duplicate.text")
						}),
						/* @__PURE__ */ G(Js, {
							onClick: () => D(!0),
							"data-testid": "floor-plan-export-button",
							"data-dd-action-name": "teia.widgets.floor_plan_widget.configuration.export",
							text: p("teia.widgets.floor_plan_widget.list_tab.export.text")
						}),
						/* @__PURE__ */ G(Js, {
							onClick: ne,
							"data-testid": "floor-plan-analyze-button",
							"data-dd-action-name": "teia.widgets.floor_plan_widget.export.download_analysis",
							disabled: j,
							text: p("teia.widgets.floor_plan_widget.list_tab.analyze.text")
						}),
						/* @__PURE__ */ G(Js, {
							onClick: re,
							"data-testid": "floor-plan-delete-button",
							"data-dd-action-name": "teia.widgets.floor_plan_widget.configuration.delete",
							text: p("teia.widgets.floor_plan_widget.list_tab.delete.text")
						}),
						/* @__PURE__ */ G(Js, {
							onClick: ae,
							"data-testid": "floor-plan-restart-button",
							"data-dd-action-name": "teia.widgets.floor_plan_widget.export.restart",
							text: p("teia.widgets.floor_plan_widget.list_tab.restart.text"),
							disabled: ce !== "Expired" && ce !== "ProjectionFailed"
						})
					]
				})
			})
		]
	});
}, ec = (e) => /* @__PURE__ */ K("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ G("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 17.9346C14.4183 17.9346 18 14.3528 18 9.93457C18 5.51629 14.4183 1.93457 10 1.93457C5.58172 1.93457 2 5.51629 2 9.93457C2 14.3528 5.58172 17.9346 10 17.9346ZM10 19.4346C15.2467 19.4346 19.5 15.1813 19.5 9.93457C19.5 4.68787 15.2467 0.43457 10 0.43457C4.75329 0.43457 0.5 4.68787 0.5 9.93457C0.5 15.1813 4.75329 19.4346 10 19.4346Z",
		fill: "#C3C3C4"
	}), /* @__PURE__ */ G("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.5 0.447502C10.3344 0.438916 10.1677 0.43457 10 0.43457C4.92101 0.43457 0.772939 4.42029 0.512932 9.43457H2.01537C2.27347 5.24921 5.74965 1.93457 10 1.93457C10.1679 1.93457 10.3346 1.93974 10.5 1.94994V0.447502Z",
		fill: "#2953FF"
	})]
}), tc = () => {
	let { t } = h("teiaviewer");
	return /* @__PURE__ */ K(e, {
		direction: "row",
		style: {
			justifyContent: "flex-start",
			alignItems: "center",
			minWidth: "490px",
			marginTop: "10px"
		},
		children: [
			/* @__PURE__ */ G(Y, {
				component: on,
				sx: {
					color: (e) => e.palette.info.main,
					marginRight: 1
				}
			}),
			t("teia.widgets.floor_plan_widget.list_tab.caption.waiting.text"),
			/* @__PURE__ */ G(ec, { style: {
				width: "18px",
				height: "20px",
				marginRight: "4px",
				marginLeft: "8px"
			} }),
			t("teia.widgets.floor_plan_widget.list_tab.caption.loading.text"),
			/* @__PURE__ */ G(Y, {
				component: rn,
				sx: {
					color: (e) => e.palette.success.main,
					marginRight: 1,
					marginLeft: 2
				}
			}),
			t("teia.widgets.floor_plan_widget.list_tab.caption.completed.text"),
			/* @__PURE__ */ G(Y, {
				component: nn,
				sx: {
					color: (e) => e.palette.warning.main,
					marginRight: 1,
					marginLeft: 2
				}
			}),
			t("teia.widgets.floor_plan_widget.list_tab.caption.expired.text"),
			/* @__PURE__ */ G(Y, {
				component: an,
				sx: {
					color: (e) => e.palette.error.main,
					marginRight: 1,
					marginLeft: 2
				}
			}),
			t("teia.widgets.floor_plan_widget.list_tab.caption.error.text")
		]
	});
}, nc = (t) => {
	let { searchName: n, setSearchName: r, rowSelection: i, plansConfig: a, setRowSelection: o, setIsDeleting: s, setPagination: u, setFloorPlans: d } = t, { t: p } = h("teiaviewer"), m = l(), { plugin: g } = U("Teia"), _ = ea(), [b, x] = f(null), { mutateAsync: S } = ws(_), [C, w] = f(!1), { setSelectedTabIndex: T } = $o(), { viewer: E } = H(), [D, O] = f(E.scene.bimMeshController.hasVisibleObjects), { plugin: k } = U("FloorPlan"), A = (e) => {
		x(e.currentTarget);
	}, j = () => {
		x(null);
	}, M = async () => {
		if (s(!0), j(), !a) return;
		let e = [], t = [], n = Object.keys(i);
		for (let r of n) if (i[r]) {
			let n = a[Number(r)];
			await S({ floorPlanConfiguationId: n.id });
			let i = k.floorPlanController.getSceneFloorPlanWithConfigurationId(n.id);
			i && (e.push(new Mt(E, i)), t.push(i));
		}
		new Nt(E, e).execute(), d((e) => {
			let n = new Map(e);
			for (let e of t) n.delete(e.id);
			return n;
		}), s(!1), o({}), u({
			pageIndex: 0,
			pageSize: 5
		});
	}, N = () => {
		if (j(), !a) return;
		let e = Object.keys(i);
		for (let t of e) if (i[t]) {
			let e = a[Number(t)];
			e.status === "Expired" && at(g.twinApiClient).restartExport(_, e.id);
		}
	}, P = (e) => {
		if (j(), !a) return;
		let t = Object.keys(i);
		for (let n of t) if (i[n]) {
			let t = a[Number(n)];
			t.exports.find((t) => t.fileType === e) && As(g, _, t.id, t.name, e);
		}
	}, F = () => {
		if (j(), !a) return;
		let e = Object.keys(i);
		for (let t of e) if (i[t]) {
			let e = a[Number(t)];
			Ns(g, _, e.id, e.name);
		}
	}, I = () => {
		T(2);
	}, R = () => {
		let e = !D, t = E.scene.bimMeshController.getAllObjectUuids();
		new Q(E, t, e).execute(), O(e);
	};
	c(() => {
		let e = () => {
			O(E.scene.bimMeshController.hasVisibleObjects);
		};
		return E.signals.onLoadingFinished.connect(e), () => {
			E.signals.onLoadingFinished.disconnect(e);
		};
	});
	let z = !!b, B = Object.values(i).length !== 0;
	return /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 2,
		sx: {
			width: "100%",
			justifyContent: "space-between",
			marginTop: 2
		},
		children: [
			/* @__PURE__ */ G(Zs, {
				open: C,
				setOpen: w,
				callback: F
			}),
			/* @__PURE__ */ G(y, {
				value: n,
				onChange: (e) => r(e.target.value),
				label: p("teia.widgets.floor_plan_widget.list_tab.search.label"),
				"data-testid": "floor-plan-search-input",
				sx: { width: "100%" }
			}),
			/* @__PURE__ */ G(v, {
				icon: cn,
				variant: "info",
				"aria-label": p("teia.widgets.floor_plan_widget.list_tab.actions.text"),
				sx: { minWidth: "40px" },
				onClick: A,
				"data-testid": "floor-plan-global-actions-button"
			}),
			/* @__PURE__ */ G(v, {
				icon: D ? un : Xt,
				variant: "info",
				"aria-label": p("teia.widgets.floor_plan_widget.list_tab.actions.text"),
				"data-dd-action-name": `teia.widgets.floor_plan_widget.twin.${D ? "hide" : "show"}`,
				sx: { minWidth: "40px" },
				onClick: R,
				"data-testid": "floor-plan-twin-visibility-button"
			}),
			/* @__PURE__ */ G(Mn, {
				id: m,
				open: z,
				anchorEl: b,
				onClose: j,
				anchorOrigin: {
					vertical: "center",
					horizontal: "right"
				},
				transformOrigin: {
					vertical: "top",
					horizontal: "left"
				},
				children: /* @__PURE__ */ K(e, {
					direction: "column",
					children: [
						/* @__PURE__ */ G(Js, {
							onClick: () => P("Svg"),
							"data-testid": "floor-plan-download-all-svg-button",
							"data-dd-action-name": "teia.widgets.floor_plan_widget.multiple_actions.download_svg",
							text: p("teia.widgets.floor_plan_widget.list_tab.download_svg.text"),
							disabled: !B
						}),
						/* @__PURE__ */ G(Js, {
							onClick: () => P("Pdf"),
							"data-testid": "floor-plan-download-all-pdf-button",
							"data-dd-action-name": "teia.widgets.floor_plan_widget.multiple_actions.download_pdf",
							text: p("teia.widgets.floor_plan_widget.list_tab.download_pdf.text"),
							disabled: !B
						}),
						/* @__PURE__ */ G(Js, {
							onClick: () => P("Dxf"),
							"data-testid": "floor-plan-download-all-dxf-button",
							"data-dd-action-name": "teia.widgets.floor_plan_widget.multiple_actions.download_dxf",
							text: p("teia.widgets.floor_plan_widget.list_tab.download_dxf.text"),
							disabled: !B
						}),
						/* @__PURE__ */ G(Js, {
							onClick: I,
							"data-testid": "floor-plan-import-button",
							"data-dd-action-name": "teia.widgets.floor_plan_widget.multiple_actions.import_configuration",
							text: p("teia.widgets.floor_plan_widget.list_tab.import.text")
						}),
						/* @__PURE__ */ G(Js, {
							onClick: () => w(!0),
							"data-testid": "floor-plan-export-all-button",
							"data-dd-action-name": "teia.widgets.floor_plan_widget.multiple_actions.export_configuration",
							text: p("teia.widgets.floor_plan_widget.list_tab.export.text"),
							disabled: !B
						}),
						/* @__PURE__ */ G(Js, {
							onClick: M,
							"data-testid": "floor-plan-delete-all-button",
							"data-dd-action-name": "teia.widgets.floor_plan_widget.multiple_actions.delete_configuration",
							text: p("teia.widgets.floor_plan_widget.list_tab.delete.text"),
							disabled: !B
						}),
						/* @__PURE__ */ G(Js, {
							onClick: N,
							"data-testid": "floor-plan-restart-all-button",
							"data-dd-action-name": "teia.widgets.floor_plan_widget.multiple_actions.restart_export",
							text: p("teia.widgets.floor_plan_widget.list_tab.restart.text"),
							disabled: !B
						})
					]
				})
			})
		]
	});
}, rc = (e) => {
	let { planConfig: t } = e, n = t.status, r = n;
	if (n === "InProgressProjection") {
		let e = Math.trunc(t.objectProjectedCount / t.totalObjectCount * 100);
		r = `${t.objectProjectedCount} / ${t.totalObjectCount} (${e}%)`;
	}
	return /* @__PURE__ */ G(b, {
		title: r.replace("Projection", ""),
		placement: "top",
		children: /* @__PURE__ */ K("span", { children: [
			n === "ToDo" && /* @__PURE__ */ G(Y, {
				component: on,
				sx: { color: (e) => e.palette.info.main }
			}),
			n === "ProjectionCompleted" && /* @__PURE__ */ G(Y, {
				component: rn,
				sx: { color: (e) => e.palette.success.main }
			}),
			n === "ProjectionFailed" && /* @__PURE__ */ G(Y, {
				component: an,
				sx: { color: (e) => e.palette.error.main }
			}),
			(n === "Expired" || n === "ProjectionDegraded") && /* @__PURE__ */ G(Y, {
				component: nn,
				sx: { color: (e) => e.palette.warning.main }
			}),
			n === "InProgressProjection" && /* @__PURE__ */ G(yt, { size: "15px" })
		] })
	});
}, ic = /* @__PURE__ */ new Ht(), ac = () => {
	let { setSelectedTabIndex: t, setNewPlanConfig: n, setUpdatedId: r, floorPlans: i, setFloorPlans: a } = $o(), { t: o } = h("teiaviewer"), s = ea(), [l, u] = f(""), [d, p] = f(!1), [g, v] = f({}), [y, b] = f({
		pageIndex: 0,
		pageSize: 5
	}), { viewer: x } = H(), [C, w] = f([]), [T, E] = f(!1), { plugin: D } = U("FloorPlan"), { data: O, isLoading: k } = bs(s, y.pageIndex + 1, y.pageSize, d, l, Array.from(Be)), A = An(), j = [
		A.accessor("name", { header: o("teia.widgets.floor_plan_widget.list_tab.table.plan_name.text") }),
		A.accessor("statusComponent", { header: o("teia.widgets.floor_plan_widget.list_tab.table.status.text") }),
		A.accessor("actionsComponent", { header: o("teia.widgets.floor_plan_widget.list_tab.table.actions.text") })
	], M = async (e) => {
		let t = i.get(e.id);
		if (t) {
			let e = new Q(x, [t.uuid], !t.visible), n = new Rt(x, t.uuid, ic.identity()), r = new Nt(x, [e, n]);
			r.isUndoable = !0, await r.execute(), t.selected && x.viewport?.transformController.detachObjects();
		} else {
			w((t) => {
				let n = [...t];
				return n.push(e.id), n;
			});
			let t = await new ue(x, s, e).execute();
			w((t) => {
				let n = [...t];
				return n.remove(e.id), n;
			}), a((e) => {
				let n = new Map(e);
				return n.set(t.id, t), n;
			});
		}
	}, N = (e) => {
		n(ks(e)), r(e.id), t(1);
	}, P = (e) => {
		let r = {
			...Os(e),
			name: `${o("teia.widgets.floor_plan_widget.list_tab.duplicate.text")} - ${e.name}`
		};
		n(r), t(1);
	}, F;
	if (O) {
		let e = !1;
		F = O.data.map((t) => {
			if (t.floorPlanLayers.sort((e, t) => e.order - t.order), !e && (t.status === "ToDo" || t.status === "InProgressProjection")) e = 5e3;
			else if (t.exports.length > 0) {
				for (let n of t.exports) if (n.status === "ToDo" || n.status === "InProgress") {
					e = 5e3;
					break;
				}
			}
			return {
				...t,
				statusComponent: /* @__PURE__ */ G(rc, { planConfig: t }),
				actionsComponent: /* @__PURE__ */ G($s, {
					setIsDeleting: E,
					isLoading: C.includes(t.id),
					floorPlan: i.get(t.id),
					planConfig: t,
					toggleIsVisible: () => M(t),
					onUpdatePlanConfig: () => N(t),
					onDuplicatePlanConfig: () => P(t),
					setPagination: b,
					setRowSelection: v
				})
			};
		}), d !== e && p(e);
	}
	c(() => {
		let e = (e) => {
			a((t) => {
				let n = new Map(t);
				return n.set(e.id, e), n;
			});
		};
		return D.floorPlanController.signals.onObjectAdded.connect(e), () => {
			D.floorPlanController.signals.onObjectAdded.disconnect(e);
		};
	}, [D.floorPlanController.signals.onObjectAdded, a]), c(() => {
		let e = (e) => {
			a((t) => {
				let n = new Map(t);
				return n.delete(e.id), n;
			});
		};
		return D.floorPlanController.signals.onObjectRemoved.connect(e), () => {
			D.floorPlanController.signals.onObjectRemoved.disconnect(e);
		};
	}, [D.floorPlanController.signals.onObjectRemoved, a]), c(() => {
		let e = D.floorPlanController.getAllObjects(), t = /* @__PURE__ */ new Map();
		for (let n of e) t.set(n.id, n);
		a(t);
	}, [a, D.floorPlanController]), c(() => {
		v({});
	}, [y.pageIndex]);
	let I = k || T;
	return /* @__PURE__ */ K(W, { children: [
		/* @__PURE__ */ G(S, { children: o("teia.widgets.floor_plan_widget.list_tab.title") }),
		/* @__PURE__ */ G(nc, {
			setPagination: b,
			setIsDeleting: E,
			searchName: l,
			setSearchName: u,
			rowSelection: g,
			plansConfig: O?.data,
			setRowSelection: v,
			setFloorPlans: a
		}),
		!!I && /* @__PURE__ */ G(yt, { sx: {
			margin: 5,
			marginLeft: 3
		} }),
		!I && !!F && F.length > 0 && /* @__PURE__ */ K(_, {
			sx: { marginTop: 2 },
			children: [/* @__PURE__ */ G(kn, { tableOptions: {
				columns: j,
				data: F,
				enableRowSelection: !0,
				enableSorting: !1,
				enableFilters: !1,
				enableGrouping: !1,
				enableColumnActions: !1,
				enableGlobalFilter: !1,
				enableColumnPinning: !1,
				enableColumnResizing: !0,
				enableHiding: !1,
				manualPagination: !0,
				enableTopToolbar: !1,
				onPaginationChange: b,
				onRowSelectionChange: v,
				rowCount: O?.totalRecords,
				state: {
					rowSelection: g,
					isLoading: I,
					pagination: y
				}
			} }), /* @__PURE__ */ G(tc, {})]
		}),
		!!F && F.length === 0 && /* @__PURE__ */ K(e, {
			sx: {
				marginTop: 2,
				justifyContent: "center",
				alignItems: "center",
				width: "100%",
				"& div": {
					width: "100%",
					padding: 2
				},
				"& div div p": { fontSize: "14px" }
			},
			children: [/* @__PURE__ */ G(m, {
				severity: "info",
				"data-testid": "floor-plan-empty-list-alert",
				children: o(l === "" ? "teia.widgets.floor_plan_widget.list_tab.empty_list.text" : "teia.widgets.floor_plan_widget.list_tab.empty_list.search.text")
			}), /* @__PURE__ */ G(Ks, { style: { marginTop: 5 } })]
		})
	] });
}, oc = [{
	id: "List",
	icon: Wo,
	tooltip: ""
}, {
	id: "Add",
	icon: Nr,
	tooltip: ""
}], sc = () => {
	let e = Qi(), { viewer: t } = H(), { selectedTabIndex: n, setSelectedTabIndex: r, setUpdatedId: i, setNewPlanConfig: a } = $o(), { t: o } = h("teiaviewer");
	return c(() => {
		let e = () => {
			a(Jo()), i(null), r(0);
		};
		return t.signals.onSceneClear.connect(e), () => {
			t.signals.onSceneClear.disconnect(e);
		};
	}, []), e?.sourceType === nt.Twin ? /* @__PURE__ */ K(_, {
		sx: {
			display: "flex",
			width: "100%",
			height: "100%"
		},
		children: [/* @__PURE__ */ G(F, {
			tabs: oc,
			selectedTabIndex: n,
			onTabSelected: (e) => {
				r(e), i(null), e === 0 && a(Jo());
			}
		}), /* @__PURE__ */ K(_, {
			sx: {
				padding: 3,
				paddingTop: 2,
				paddingBottom: 2,
				width: "100%",
				backgroundColor: n === 1 ? Gt[50] : "white",
				overflowY: "auto",
				overflowX: "hidden"
			},
			children: [
				n === 0 && /* @__PURE__ */ G(ac, {}),
				n === 1 && /* @__PURE__ */ G(Vs, {}),
				n === 2 && /* @__PURE__ */ G(Gs, {})
			]
		})]
	}) : /* @__PURE__ */ G(_, {
		sx: { padding: 2 },
		children: /* @__PURE__ */ G(m, {
			severity: "warning",
			"data-testid": "floor-plan-no-twin-alert",
			children: o("teia.widgets.floor_plan_widget.no_twin.text")
		})
	});
}, cc = class extends N {
	constructor(e, t = {}) {
		super(e, {
			...t,
			isResizable: !0,
			width: 575,
			minWidth: 575,
			height: 450,
			minHeight: 450,
			useFooter: !1
		}), this.type = "FloorPlan", this.Header = () => {
			let { t: e } = h("teiaviewer");
			return /* @__PURE__ */ G(te, {
				icon: ta,
				children: e("teia.widgets.floor_plan_widget.title")
			});
		}, this.ContextProvider = (e) => /* @__PURE__ */ G(Qo, { ...e }), this.Content = () => /* @__PURE__ */ G(sc, {});
	}
}, lc = "Model", uc = () => {
	let { plugin: e } = U("Teia");
	return Pe(e.twinApiClient);
}, dc = (e, t) => {
	let n = uc();
	return mt({
		queryKey: [
			lc,
			e.modelId,
			e.version,
			t,
			"getObjectDetails"
		],
		queryFn: () => n.getObjectDetails(e, t)
	});
}, fc = (e) => /* @__PURE__ */ G("svg", {
	id: "Calque_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...e,
	children: /* @__PURE__ */ K("g", { children: [
		/* @__PURE__ */ G("path", { d: "M6.6,16.2c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C7.4,16,6.9,16,6.6,16.2z" }),
		/* @__PURE__ */ G("path", { d: "M8.6,18.4c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C9.4,18.1,8.9,18.1,8.6,18.4z" }),
		/* @__PURE__ */ G("path", { d: "M6.3,18.6c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C7,18.3,6.6,18.3,6.3,18.6z" }),
		/* @__PURE__ */ G("path", { d: "M15.2,6.1c0.3-0.3,0.3-0.7,0-1c-0.3-0.3-0.7-0.3-1,0s-0.3,0.7,0,1C14.4,6.4,14.9,6.4,15.2,6.1z" }),
		/* @__PURE__ */ G("path", { d: "M22,2.5c-2.5-2.6-6.7-2.8-9.3-0.3L2.2,12.2c-2.6,2.5-2.8,6.7-0.3,9.3c2.5,2.6,6.7,2.8,9.3,0.3l10.5-9.9 C24.4,9.3,24.5,5.1,22,2.5z M20.7,10.7l-10.5,9.9c-2,1.9-5.3,1.8-7.2-0.2c-1.9-2-1.8-5.3,0.2-7.2l10.5-9.9c2-1.9,5.3-1.8,7.2,0.2 C22.9,5.6,22.8,8.8,20.7,10.7z" }),
		/* @__PURE__ */ G("path", { d: "M4.3,16.4c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C5,16.2,4.5,16.2,4.3,16.4z" }),
		/* @__PURE__ */ G("path", { d: "M4.6,14.1c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C5.3,13.8,4.9,13.8,4.6,14.1z" }),
		/* @__PURE__ */ G("path", { d: "M18.2,9.3c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C19,9,18.5,9,18.2,9.3z" }),
		/* @__PURE__ */ G("path", { d: "M18.6,6.9c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C19.3,6.7,18.9,6.7,18.6,6.9z" }),
		/* @__PURE__ */ G("path", { d: "M16.5,4.8c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C17.3,4.5,16.8,4.5,16.5,4.8z" }),
		/* @__PURE__ */ G("path", { d: "M13.7,7.7c-0.8-0.8-2-0.8-2.8-0.1L7.3,11c-0.8,0.8-0.8,2-0.1,2.8l2.5,2.7c0.8,0.8,2,0.8,2.8,0.1l3.6-3.4 c0.8-0.8,0.8-2,0.1-2.8L13.7,7.7z M15.1,12.1l-3.6,3.4c-0.2,0.2-0.5,0.2-0.7,0l-2.5-2.7c-0.2-0.2-0.2-0.5,0-0.7l3.6-3.4 c0.2-0.2,0.5-0.2,0.7,0l2.5,2.7C15.4,11.6,15.3,11.9,15.1,12.1z" }),
		/* @__PURE__ */ G("path", { d: "M16.2,7.2c-0.3,0.3-0.3,0.7,0,1c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1C17,6.9,16.5,6.9,16.2,7.2z" })
	] })
}), pc = 20, mc = Nn(), hc = [mc.accessor((e) => e.name, {
	size: 2 ** 53 - 1,
	id: "key",
	header: "key",
	cell: (e) => /* @__PURE__ */ G(P, { value: e.getValue() })
}), mc.accessor((e) => e, {
	size: 2 ** 53 - 1,
	id: "value",
	header: "value",
	cell: (e) => {
		let { value: t, unit: n, isPatched: r = !1 } = e.getValue();
		return /* @__PURE__ */ G(ee, {
			hasPatchData: r,
			value: t,
			unit: n
		});
	}
})], gc = (t) => {
	let { data: n, isLoading: r, mapper: i, groupSort: a } = t, [o, s] = f(/* @__PURE__ */ new Set()), [c, l] = f(""), { t: u } = h("teiaviewer");
	if (r) return /* @__PURE__ */ G(yt, {});
	if (!n) return /* @__PURE__ */ G(m, {
		severity: "info",
		children: u("teia.widgets.infobox_widget.tabs.alerts.nodata.text")
	});
	let d = vc(n, c, i), p = (e) => {
		s((t) => {
			let n = new Set(t);
			return n.has(e) ? n.delete(e) : n.add(e), n;
		});
	}, g = (e) => {
		e === "" && s(/* @__PURE__ */ new Set()), l(e);
	}, v = c !== "", y = Array.from(d.keys());
	return a && y.sort(a), /* @__PURE__ */ K(_, {
		sx: {
			display: "flex",
			flexDirection: "column",
			alignItems: "stretch"
		},
		children: [n.length > 0 && /* @__PURE__ */ G(T, {
			onSearchChange: g,
			searchValue: c
		}), /* @__PURE__ */ G(e, {
			spacing: 1,
			children: y.length > 0 ? y.map((e) => {
				let t = d.get(e);
				return /* @__PURE__ */ G(_, { children: /* @__PURE__ */ K(Fn, {
					color: "white",
					defaultExpanded: v || o.has(e),
					onChange: () => p(e),
					sx: {
						padding: 0,
						minHeight: "24px"
					},
					children: [/* @__PURE__ */ K(Ln, { children: [e, _c(t) && /* @__PURE__ */ G(_, {
						sx: {
							display: "flex",
							flexShrink: 0,
							marginLeft: "auto"
						},
						children: /* @__PURE__ */ G(b, {
							title: u("teia.widgets.infobox_widget.icon.tooltip"),
							placement: "top",
							children: /* @__PURE__ */ G(Y, {
								component: fc,
								fontSize: "small",
								sx: {
									display: "block",
									fill: (e) => e.palette.secondary.dark,
									width: "20px"
								}
							})
						}, e)
					})] }), /* @__PURE__ */ G(In, {
						sx: {
							paddingX: 1,
							paddingY: 0
						},
						children: /* @__PURE__ */ K(I, {
							data: t,
							columns: hc,
							pageSize: pc,
							children: [/* @__PURE__ */ G(R, { showColumnHeaders: !1 }), t.length > pc && /* @__PURE__ */ K(z, { children: [
								/* @__PURE__ */ G(O, {}),
								/* @__PURE__ */ G(k, {}),
								/* @__PURE__ */ G(A, {})
							] })]
						})
					})]
				}) }, `accordion-${e}-${v}`);
			}) : /* @__PURE__ */ G(m, {
				severity: "info",
				children: u("teia.widgets.infobox_widget.tabs.alerts.nodata-search.text")
			})
		})]
	});
};
function _c(e) {
	return e.some((e) => !!e.isPatched);
}
function vc(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	for (let i of e) {
		let e = n(i), a = t.toLowerCase();
		if (e.group.toLowerCase().includes(a) || e.name.toLocaleLowerCase().includes(a) || e.value.toLocaleLowerCase().includes(a)) {
			let t = r.get(e.group);
			t ? t.push(e) : r.set(e.group, [e]);
		}
	}
	for (let e of r.values()) e.sort((e, t) => e.name.localeCompare(t.name));
	return r;
}
//#endregion
//#region src/widgets/infobox/FileObjectIfcDataInfoboxTab.tsx
var yc = Nn(), bc = {
	id: Pn(),
	icon: rr,
	Title: xc,
	Content: Sc,
	tooltip: Dn("teiaviewer:teia.widgets.infobox_widget.tabs.ifcdata_tab.tooltip"),
	hidden: async (e) => e.getPlugin("Teia").currentSource?.sourceType !== nt.File
};
function xc() {
	let { t: e } = h("teiaviewer");
	return /* @__PURE__ */ G(S, { children: e("teia.widgets.infobox_widget.tabs.ifcdata_tab.title") });
}
function Sc() {
	let { uuid: e } = ie(), { plugin: t } = U("Teia");
	return t.currentSource?.sourceType === nt.File ? /* @__PURE__ */ G(Cc, {
		uuid: e,
		source: t.currentSource,
		columnHelper: yc
	}) : /* @__PURE__ */ G(m, {
		severity: "error",
		children: "Current scene is not from a File"
	});
}
var Cc = (e) => {
	let { source: t, uuid: n } = e, { data: r, isLoading: i } = dc(t, n);
	return /* @__PURE__ */ G(gc, {
		...e,
		data: r,
		isLoading: i,
		mapper: wc
	});
};
function wc(e) {
	return {
		name: e.name ?? "",
		group: e.propertySetName ?? "",
		unit: e.unit ?? void 0,
		value: e.value ?? ""
	};
}
//#endregion
//#region src/widgets/infobox/TwinObjectBimDataInfoboxTab.tsx
var Tc = {
	id: "twin-object-bim-data-infobox-tab",
	icon: rr,
	order: 0,
	Title: Ec,
	Content: Dc,
	tooltip: Dn("teiaviewer:teia.widgets.infobox_widget.tabs.bimdata_tab.tooltip"),
	hidden: async (e) => e.getPlugin("Teia").currentSource?.sourceType !== nt.Twin
};
function Ec() {
	let { t: e } = h("teiaviewer"), { uuid: t } = ie(), { data: n, isLoading: r } = ii({
		twin: ea(),
		uuid: t,
		families: ["TwinBimData"]
	}), i = n?.fields.some((e) => !!e.twinPatchDataId);
	return /* @__PURE__ */ K(_, {
		sx: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			gap: 1
		},
		children: [/* @__PURE__ */ G(S, { children: e("teia.widgets.infobox_widget.tabs.bimdata_tab.title") }), !r && !!i && /* @__PURE__ */ G(b, {
			title: e("teia.widgets.infobox_widget.icon.tooltip"),
			placement: "top",
			children: /* @__PURE__ */ G(Y, {
				component: fc,
				fontSize: "small",
				sx: {
					display: "block",
					fill: (e) => e.palette.secondary.dark,
					marginRight: "1rem",
					width: "20px"
				}
			})
		})]
	});
}
function Dc() {
	let { uuid: e } = ie(), { data: t, isLoading: n } = ii({
		twin: ea(),
		uuid: e,
		families: ["TwinBimData"]
	});
	return n ? /* @__PURE__ */ G(yt, {}) : /* @__PURE__ */ G(gc, {
		data: t?.fields,
		isLoading: n,
		mapper: (e) => ({
			name: e.name,
			group: e.propertyName,
			unit: e.unit,
			isPatched: !!e.twinPatchDataId,
			value: e.value
		}),
		groupSort: Oc
	});
}
function Oc(e, t) {
	return e == "Element Specific" ? -1 : t == "Element Specific" ? 1 : e.localeCompare(t);
}
//#endregion
//#region src/hooks/TwinDocDataApiHooks.ts
var kc = "TwinDocData", Ac = () => {
	let { plugin: e } = U("Teia");
	return it(e.twinApiClient);
}, jc = (e, t) => {
	let n = Ac();
	return mt({
		queryKey: [
			kc,
			e.projectId,
			e.type,
			t
		],
		queryFn: async () => await n.download(e, t),
		placeholderData: pt
	});
}, Mc = {
	id: Pn(),
	icon: xr,
	Title: Nc,
	Content: Pc,
	tooltip: Dn("teiaviewer:teia.widgets.infobox_widget.tabs.docdata_tab.tooltip"),
	hidden: async (e, t) => {
		let n = e.getPlugin("Teia"), r = ot(n.twinApiClient);
		if (!t || n.currentSource?.sourceType !== nt.Twin) return !0;
		let i = n.currentSource;
		return (await n.queryClient.fetchQuery({
			queryKey: [
				Qr.GetObject,
				i,
				t
			],
			queryFn: () => r.getTwinObject(i, t, ["Primitive"])
		})).type != "Byte";
	}
};
function Nc() {
	let { t: e } = h("teiaviewer");
	return /* @__PURE__ */ G(S, { children: e("teia.widgets.infobox_widget.tabs.docdata_tab.title") });
}
function Pc() {
	let { uuid: e } = ie(), t = ea(), { t: n } = h("teiaviewer"), { data: r, isLoading: i } = jc(t, e);
	return i ? /* @__PURE__ */ G(yt, {}) : r ? /* @__PURE__ */ G(Rn, { ...r }) : /* @__PURE__ */ G(m, {
		severity: "info",
		children: n("teia.widgets.infobox_widget.tabs.docdata_tab.alerts.error.download.text")
	});
}
//#endregion
//#region src/widgets/infobox/TwinObjectOpenDataInfoboxTab.tsx
var Fc = {
	id: Pn(),
	icon: (e) => /* @__PURE__ */ K("svg", {
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg",
		...e,
		children: [/* @__PURE__ */ G("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.29003 17.8399C3.7391 17.3616 3.5 16.8699 3.5 16.4395V15.5469C3.86762 15.8378 4.28308 16.0942 4.72323 16.3143C4.82539 16.3654 4.92989 16.4151 5.03662 16.4634L6.18525 15.3148C5.90347 15.2096 5.63903 15.0952 5.39405 14.9727C4.04738 14.2993 3.5 13.5079 3.5 12.8567V11.9641C3.86762 12.255 4.28308 12.5114 4.72323 12.7315C5.59528 13.1675 6.6378 13.5032 7.7865 13.7135L9.11197 12.388C7.65268 12.2379 6.36928 11.8775 5.39405 11.3899C4.04738 10.7165 3.5 9.92509 3.5 9.27391V8.3813C3.86762 8.67216 4.28308 8.92862 4.72323 9.14869C6.27421 9.92418 8.36439 10.3822 10.6322 10.3822C10.7975 10.3822 10.9618 10.3798 11.1251 10.3749L12.7727 8.72735C12.0991 8.82753 11.3807 8.88219 10.6322 8.88219C8.54677 8.88219 6.69586 8.45795 5.39405 7.80705C4.04738 7.13371 3.5 6.34228 3.5 5.69109C3.5 5.03991 4.04738 4.24847 5.39405 3.57514C6.69586 2.92424 8.54677 2.5 10.6322 2.5C12.7176 2.5 14.5685 2.92424 15.8703 3.57514C16.3962 3.83809 16.8002 4.11906 17.0974 4.40265L18.157 3.34297C17.7053 2.90776 17.1466 2.53621 16.5411 2.2335C14.9902 1.45801 12.9 1 10.6322 1C8.36439 1 6.27421 1.45801 4.72323 2.2335C3.21711 2.98656 2 4.16567 2 5.69109V16.4395C2 17.6726 2.79525 18.6793 3.89557 19.4177L4.29003 17.8399ZM13.8407 19.2708L11.9421 21.0789C13.6984 20.9389 15.2941 20.5207 16.5411 19.8971C18.0473 19.1441 19.2644 17.965 19.2644 16.4395V14.1054L17.6898 15.605C17.7148 15.5858 17.7397 15.5664 17.7644 15.5469V16.4395C17.7644 17.0907 17.217 17.8822 15.8703 18.5555C15.2927 18.8443 14.607 19.0885 13.8407 19.2708Z"
		}), /* @__PURE__ */ G("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.6299 5.7459C21.0833 5.19928 20.1971 5.19928 19.6505 5.7459L18.2461 7.15028L20.2255 9.12974L21.6299 7.72535C22.1765 7.17874 22.1765 6.29251 21.6299 5.7459ZM19.1649 10.1904L17.1854 8.21094L7.47618 17.9202C6.95816 18.4382 6.57738 19.0771 6.36824 19.7792L5.84709 21.5287L7.59661 21.0076C8.29871 20.7984 8.93763 20.4176 9.45565 19.8996L19.1649 10.1904ZM18.5898 4.68524C19.7222 3.55284 21.5582 3.55284 22.6906 4.68524C23.823 5.81763 23.823 7.65362 22.6906 8.78601L10.5163 20.9603C9.82207 21.6545 8.96579 22.1648 8.02484 22.4451L4.94662 23.3621C4.68269 23.4407 4.3969 23.3684 4.20217 23.1736C4.00744 22.9789 3.93509 22.6931 4.01371 22.4292L4.93066 19.351C5.21095 18.41 5.72128 17.5538 6.41551 16.8595L18.5898 4.68524Z"
		})]
	}),
	Title: Ic,
	Content: Lc,
	tooltip: Dn("teiaviewer:teia.widgets.infobox_widget.tabs.opendata_tab.tooltip"),
	hidden: async (e) => e.getPlugin("Teia").currentSource?.sourceType !== nt.Twin
};
function Ic() {
	let { t: e } = h("teiaviewer");
	return /* @__PURE__ */ G(S, { children: e("teia.widgets.infobox_widget.tabs.opendata_tab.title") });
}
function Lc() {
	let { uuid: e } = ie(), { data: t, isLoading: n } = ii({
		twin: ea(),
		uuid: e,
		families: ["TwinOpenData"]
	});
	return n ? /* @__PURE__ */ G(yt, {}) : /* @__PURE__ */ G(gc, {
		data: t?.fields,
		isLoading: n,
		mapper: (e) => ({
			name: e.key,
			group: "Open Data",
			value: e.value
		})
	});
}
//#endregion
//#region src/widgets/infobox/TwinObjectUserDataInfoboxTab.tsx
var Rc = {
	id: Pn(),
	icon: lr,
	Title: zc,
	Content: Bc,
	tooltip: Dn("teiaviewer:teia.widgets.infobox_widget.tabs.userdata_tab.tooltip"),
	hidden: async (e) => e.getPlugin("Teia").currentSource?.sourceType !== nt.Twin
};
function zc() {
	let { t: e } = h("teiaviewer");
	return /* @__PURE__ */ G(S, { children: e("teia.widgets.infobox_widget.tabs.userdata_tab.title") });
}
function Bc() {
	let { uuid: e } = ie(), { data: t, isLoading: n } = ii({
		twin: ea(),
		uuid: e,
		families: ["TwinUserData"]
	});
	return n ? /* @__PURE__ */ G(yt, {}) : /* @__PURE__ */ G(gc, {
		data: t?.fields,
		isLoading: n,
		mapper: (e) => ({
			name: e.key,
			group: e.applicationName,
			value: e.value
		})
	});
}
//#endregion
//#region ../../resources/icons/FontSizeIcon.svg?react
var Vc = (e) => /* @__PURE__ */ G("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ G("path", { d: "M5 4.81152H19V8.64682H18.3158L17.5526 6.17623C17.5 5.98799 17.4386 5.85466 17.3684 5.77623C17.3158 5.68211 17.2018 5.62721 17.0263 5.61152C16.8509 5.58015 16.5526 5.56446 16.1316 5.56446H13.1579V18.9056C13.1579 19.4547 13.1842 19.7762 13.2368 19.8703C13.2895 19.9645 13.4561 20.0272 13.7368 20.0586L15.1842 20.1998V20.8115H8.84211V20.1998L10.2895 20.0586C10.5702 20.0272 10.7368 19.9645 10.7895 19.8703C10.8421 19.7762 10.8684 19.4547 10.8684 18.9056V5.56446H7.86842C7.46491 5.56446 7.16667 5.58015 6.97368 5.61152C6.79825 5.62721 6.67544 5.68211 6.60526 5.77623C6.55263 5.85466 6.5 5.98799 6.44737 6.17623L5.68421 8.64682H5V4.81152Z" })
}), Hc = {
	advancedSearchCriteria: {},
	displayBackground: !0,
	displayBorders: !0,
	lineColor: "#000000",
	lineType: Ve.Solid,
	lineWidth: 1,
	fillColor: "#FFFFFF",
	annotation: "",
	name: "Layer 1",
	fontSize: .4,
	order: 1
}, Uc = {
	direction: [
		0,
		1,
		0
	],
	name: "",
	createTwinProjectionLayerCommandRequests: [{ ...Hc }]
}, Wc = () => {
	let e = { ...Uc };
	return e.createTwinProjectionLayerCommandRequests = [{ ...Hc }], e;
}, Gc = () => ({ ...Hc }), Kc = i(null), qc = (e) => {
	let { children: t } = e, [n, r] = f(0), [i, a] = f(null), [o, s] = f(null), [c, l] = f(Wc()), d = u(() => ({
		newProjectionConfig: c,
		setNewProjectionConfig: l,
		selectedTabIndex: n,
		setSelectedTabIndex: r,
		updatedId: i,
		setUpdatedId: a,
		analyzedProjection: o,
		setAnalyzedProjection: s
	}), [
		c,
		n,
		i
	]);
	return /* @__PURE__ */ G(Kc.Provider, {
		value: d,
		children: t
	});
}, Jc = () => {
	let e = s(Kc);
	if (e === null) throw Error("useProjectionContext must be used within a ProjectionWidgetProvider");
	return e;
}, Yc = [{
	type: Ve.Solid,
	display: "______"
}, {
	type: Ve.Dash,
	display: "_ _ _ _"
}], Xc = (t) => {
	let { type: n, enableValue: r, formValues: i, setFormValues: a } = t, { t: o } = h("teiaviewer"), s = (e) => {
		a((t) => {
			let r = { ...t };
			return r[`${n}Color`] = e, r;
		});
	}, c = (e) => {
		a((t) => {
			let n = { ...t };
			return n[r] = !!e.target.checked, n;
		});
	}, l = (e) => {
		let t = Math.round(e);
		a((e) => ({
			...e,
			lineWidth: t
		}));
	}, u = (e) => {
		e && a((t) => ({
			...t,
			lineType: e.type
		}));
	}, d = i[r], f = Yc.find((e) => e.type === i.lineType);
	return /* @__PURE__ */ K(e, {
		direction: "row",
		sx: {
			alignItems: "center",
			margin: "3px 0px"
		},
		children: [/* @__PURE__ */ G(zn, {
			onChange: c,
			checked: d,
			"data-testid": `projection-style-${n}-checkbox`
		}), /* @__PURE__ */ K(e, {
			direction: "row",
			sx: {
				pointerEvents: d ? "auto" : "none",
				opacity: d ? 1 : .5,
				alignItems: "center"
			},
			children: [
				n === "fill" && /* @__PURE__ */ G(S, { children: o("teia.widgets.projection_widget.add_layer_tab.background.text") }),
				n === "line" && /* @__PURE__ */ K(W, { children: [
					/* @__PURE__ */ G(S, { children: o("teia.widgets.projection_widget.add_layer_tab.line.text") }),
					/* @__PURE__ */ G(dt, {
						value: f,
						onChange: u,
						options: Yc,
						sx: {
							backgroundColor: "white",
							borderRadius: "10px",
							marginLeft: 2,
							width: "150px"
						},
						getOptionLabel: (e) => e.display,
						"data-testid": "projection-style-line-type-select"
					}),
					/* @__PURE__ */ G(E, {
						value: i.lineWidth,
						sx: {
							backgroundColor: "white",
							borderRadius: "10px",
							marginLeft: 2,
							width: "100px"
						},
						onChange: l,
						"data-testid": "projection-style-line-width-input"
					})
				] }),
				/* @__PURE__ */ G(_, {
					sx: {
						backgroundColor: "white",
						borderRadius: "10px",
						marginLeft: 2
					},
					"data-testid": `projection-style-${n}-color`,
					children: /* @__PURE__ */ G(w, {
						onChange: (e) => s(e),
						color: i[`${n}Color`]
					})
				})
			]
		})]
	});
}, Zc = (t) => {
	let { setActiveSection: n, currentLayerIndex: r } = t, { t: i } = h("teiaviewer"), a = ea(), { setNewProjectionConfig: s, newProjectionConfig: c } = Jc(), l = c.createTwinProjectionLayerCommandRequests[r], [u, d] = f(!1), [p, g] = f(Object.keys(l.advancedSearchCriteria).length > 0), [v, b] = f({
		name: l.name,
		annotation: l.annotation,
		displayBackground: l.displayBackground,
		displayBorders: l.displayBorders,
		lineColor: l.lineColor,
		lineType: l.lineType,
		lineWidth: l.lineWidth,
		fillColor: l.fillColor,
		fontSize: l.fontSize
	}), [x, C] = f({
		filter: structuredClone(l.advancedSearchCriteria),
		isValid: !0,
		showErrors: !1
	}), { data: w } = ni(a), T = (e) => {
		b((t) => ({
			...t,
			name: e.target.value
		}));
	}, D = (e) => {
		b((t) => ({
			...t,
			fontSize: e
		}));
	}, O = (e) => {
		b((t) => ({
			...t,
			annotation: e ?? ""
		}));
	}, k = () => {
		g((e) => (e && C({
			showErrors: !1,
			filter: {},
			isValid: !1
		}), !e));
	}, A = () => {
		n(0);
	}, j = () => {
		let e = { ...c };
		Object.assign(l, v);
		let t = x.filter;
		x.isValid && t.rules?.length !== 0 ? (l.advancedSearchCriteria = structuredClone(x.filter), s(e), n(0), d(!1)) : d(!0);
	}, M = o((e, t) => {
		C({
			showErrors: !1,
			filter: e,
			isValid: t
		});
	}, [C]);
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G("h4", {
		style: {
			fontSize: "16px",
			margin: 0
		},
		children: i("teia.widgets.projection_widget.add_layer_tab.title", { name: v.name })
	}), /* @__PURE__ */ K(e, {
		spacing: 2,
		sx: {
			width: "100%",
			justifyContent: "space-between",
			marginTop: 2
		},
		divider: /* @__PURE__ */ G(Kt, {}),
		children: [
			/* @__PURE__ */ K(e, { children: [
				/* @__PURE__ */ K(e, {
					direction: "row",
					sx: { alignItems: "center" },
					children: [/* @__PURE__ */ G(Y, {
						component: dr,
						fontSize: "small",
						sx: {
							color: (e) => e.palette.primary.main,
							marginRight: 3
						}
					}), /* @__PURE__ */ G(y, {
						label: i("teia.widgets.projection_widget.add_layer_tab.layer_name.label"),
						sx: {
							width: "100%",
							backgroundColor: "white",
							borderRadius: "8px"
						},
						onChange: T,
						"data-testid": "projection-layer-name-input",
						value: v.name
					})]
				}),
				/* @__PURE__ */ G(S, {
					sx: { marginTop: "15px" },
					children: i("teia.widgets.projection_widget.add_layer_tab.properties.title")
				}),
				/* @__PURE__ */ K(e, {
					sx: {
						marginTop: 2,
						alignItems: "center"
					},
					direction: "row",
					children: [/* @__PURE__ */ G(Y, {
						component: To,
						fontSize: "small",
						sx: {
							fill: (e) => e.palette.primary.main,
							marginRight: 3
						}
					}), /* @__PURE__ */ G(Z, {
						variant: "info",
						sx: {
							backgroundColor: (e) => e.palette.primary.main,
							"&:hover": { backgroundColor: (e) => e.palette.primary.dark },
							color: "white",
							paddingTop: 1,
							paddingBottom: 1,
							width: "200px"
						},
						onClick: k,
						"data-testid": "projection-layer-advanced-search-button",
						children: i("teia.widgets.projection_widget.add_layer_tab.advanced_search.text")
					})]
				}),
				!!p && /* @__PURE__ */ G(_, {
					sx: {
						backgroundColor: "white",
						borderRadius: "10px",
						marginTop: 2,
						border: "1px solid #80808070"
					},
					children: /* @__PURE__ */ G(Zi, {
						twin: a,
						defaultFilter: x.filter,
						onChange: M,
						showErrors: x.showErrors
					})
				})
			] }),
			/* @__PURE__ */ K(e, { children: [
				/* @__PURE__ */ G(S, { children: i("teia.widgets.projection_widget.add_layer_tab.customize_style.text") }),
				/* @__PURE__ */ G(Xc, {
					type: "fill",
					enableValue: "displayBackground",
					formValues: v,
					setFormValues: b
				}),
				/* @__PURE__ */ G(Xc, {
					type: "line",
					enableValue: "displayBorders",
					formValues: v,
					setFormValues: b
				})
			] }),
			/* @__PURE__ */ K(e, { children: [
				/* @__PURE__ */ G(S, { children: i("teia.widgets.projection_widget.add_layer_tab.annotations_to_display.text") }),
				!!w && /* @__PURE__ */ G(dt, {
					value: v.annotation,
					onChange: O,
					"data-testid": "projection-layer-annotation-select",
					options: w,
					sx: {
						backgroundColor: "white",
						borderRadius: "10px",
						marginTop: 2,
						marginBottom: 1
					},
					label: i("teia.widgets.projection_widget.add_layer_tab.available_annotation_list.text")
				}),
				/* @__PURE__ */ K(e, {
					sx: {
						fill: (e) => e.palette.primary.main,
						alignItems: "center",
						marginTop: "5px",
						marginBottom: "3px"
					},
					direction: "row",
					children: [/* @__PURE__ */ G(Vc, { style: {
						fill: "inherit",
						marginRight: "10px"
					} }), /* @__PURE__ */ G(E, {
						value: v.fontSize,
						sx: {
							backgroundColor: "white",
							borderRadius: 2,
							maxWidth: "80px"
						},
						onChange: D,
						"data-testid": "projection-layer-font-size-input",
						step: .1
					})]
				})
			] }),
			!!u && /* @__PURE__ */ G(m, {
				severity: "warning",
				"data-testid": "projection-layer-filter-warning",
				children: i("teia.widgets.projection_widget.add_layer_tab.warnings.invalid_filter.text")
			}),
			/* @__PURE__ */ K(e, {
				direction: "row",
				sx: {
					justifyContent: "flex-end",
					margin: "10px 0px"
				},
				children: [/* @__PURE__ */ G(Z, {
					variant: "info",
					onClick: A,
					"data-testid": "projection-layer-cancel-button",
					sx: {
						marginBottom: 2,
						marginRight: 2,
						backgroundColor: (e) => e.palette.error.main,
						"&:hover": { backgroundColor: (e) => e.palette.error.dark },
						color: "white",
						padding: 3,
						paddingTop: 1,
						paddingBottom: 1
					},
					children: i("teia.widgets.projection_widget.add_layer_tab.cancel.text")
				}), /* @__PURE__ */ G(Z, {
					variant: "info",
					onClick: j,
					"data-testid": "projection-layer-validate-button",
					sx: {
						marginBottom: 2,
						backgroundColor: (e) => e.palette.primary.main,
						"&:hover": { backgroundColor: (e) => e.palette.primary.dark },
						color: "white",
						padding: 3,
						paddingTop: 1,
						paddingBottom: 1
					},
					children: i("teia.widgets.projection_widget.add_layer_tab.validate.text")
				})]
			})
		]
	})] });
}, Qc = (e) => /* @__PURE__ */ K("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ G("g", {
		clipPath: "url(#clip0_595_3282)",
		children: /* @__PURE__ */ G("path", { d: "M15.75 10.5L20.4697 5.78033C20.9421 5.30786 21.75 5.64248 21.75 6.31066V17.6893C21.75 18.3575 20.9421 18.6921 20.4697 18.2197L15.75 13.5M4.5 18.75H13.5C14.7426 18.75 15.75 17.7426 15.75 16.5V7.5C15.75 6.25736 14.7426 5.25 13.5 5.25H4.5C3.25736 5.25 2.25 6.25736 2.25 7.5V16.5C2.25 17.7426 3.25736 18.75 4.5 18.75Z" })
	}), /* @__PURE__ */ G("defs", { children: /* @__PURE__ */ G("clipPath", {
		id: "clip0_595_3282",
		children: /* @__PURE__ */ G("rect", {
			width: 24,
			height: 24
		})
	}) })]
}), $c = "TwinProjection", el = () => {
	let { plugin: e } = U("Teia");
	return st(e.twinApiClient);
}, tl = (e, t, n, r, i, a) => {
	let o = el();
	return mt({
		queryKey: [
			$c,
			e.projectId,
			e.type,
			"GetProjectionsConfig",
			t,
			n
		],
		queryFn: () => o.getTwinProjections(e, t, n, i, a),
		refetchInterval: r
	});
}, nl = (e) => {
	let t = el(), n = ht();
	return J({
		mutationFn: async (n) => {
			await t.addProjection(e, n.projection);
		},
		onSuccess: () => n.invalidateQueries({ queryKey: [
			$c,
			e.projectId,
			e.type
		] })
	});
}, rl = (e) => {
	let t = el(), n = ht();
	return J({
		mutationFn: async (n) => {
			await t.updateProjection(e, n.twinProjectionConfigurationId, n.projection);
		},
		onSuccess: () => n.invalidateQueries({ queryKey: [
			$c,
			e.projectId,
			e.type
		] })
	});
}, il = (e) => {
	let t = el(), n = ht();
	return J({
		mutationFn: async (e) => {
			await t.deleteProjection(e.projectId, e.twinProjectionConfigurationId);
		},
		onSuccess: () => n.invalidateQueries({ queryKey: [
			$c,
			e.projectId,
			e.type
		] })
	});
}, al = (e, t, n, r) => {
	let i = el();
	return mt({
		queryKey: [
			$c,
			e.projectId,
			e.type,
			"GetAnalysisProjection"
		],
		queryFn: () => i.getAnalysis(e, t, n, r),
		refetchInterval: 1e4
	});
}, ol = (t) => {
	let { value: n, SvgComponent: r, onChange: i } = t;
	return /* @__PURE__ */ K(e, {
		direction: "row",
		sx: { alignItems: "center" },
		spacing: 2,
		children: [/* @__PURE__ */ G(Y, {
			component: r,
			fontSize: "small",
			sx: { fill: (e) => e.palette.primary.main }
		}), /* @__PURE__ */ G(E, {
			sx: {
				maxWidth: "80px",
				backgroundColor: "white",
				borderRadius: "8px"
			},
			value: n,
			onChange: i,
			"data-testid": "projection-direction-input"
		})]
	});
}, sl = (t) => {
	let { layer: n, setActiveSection: r, index: i, setWarning: a, setCurrentLayerIndex: o } = t, { t: s } = h("teiaviewer"), { newProjectionConfig: c, setNewProjectionConfig: l } = Jc(), u = () => {
		if (c.createTwinProjectionLayerCommandRequests.length === 1) {
			a(s("teia.widgets.projection_widget.add_tab.warnings.at_least_one_layer.text"));
			return;
		}
		let e = { ...c };
		e.createTwinProjectionLayerCommandRequests.splice(i, 1), l(e);
	}, d = () => {
		let e = { ...c }, t = { ...n };
		t.name = `${s("teia.widgets.projection_widget.add_tab.copy.text")} - ${n.name}`;
		let r = i + 1;
		e.createTwinProjectionLayerCommandRequests.splice(r, 0, t), l(e);
	}, f = () => {
		o(i), r(1);
	}, p = (e) => {
		let t = { ...c }, r = t.createTwinProjectionLayerCommandRequests.indexOf(n);
		if (r >= 0) {
			t.createTwinProjectionLayerCommandRequests.splice(r, 1);
			let i = e === "up" ? r - 1 : r + 1;
			t.createTwinProjectionLayerCommandRequests.splice(i, 0, n);
		}
		l(t);
	};
	return /* @__PURE__ */ K(e, {
		spacing: 2,
		children: [/* @__PURE__ */ G(S, { children: s("teia.widgets.projection_widget.add_tab.layer.text") }), /* @__PURE__ */ K(e, {
			direction: "row",
			sx: {
				alignItems: "center",
				justifyContent: "space-between"
			},
			children: [/* @__PURE__ */ K(e, {
				direction: "row",
				sx: { alignItems: "center" },
				children: [/* @__PURE__ */ K(e, { children: [/* @__PURE__ */ G(v, {
					icon: tn,
					"aria-label": s("teia.widgets.projection_widget.add_tab.drag.text"),
					variant: "info",
					onClick: () => p("up"),
					"data-testid": "projection-layer-up-button",
					sx: {
						marginRight: "20px",
						padding: 0
					},
					disabled: i === 0
				}), /* @__PURE__ */ G(v, {
					icon: Qt,
					"aria-label": s("teia.widgets.projection_widget.add_tab.drag.text"),
					variant: "info",
					onClick: () => p("down"),
					"data-testid": "projection-layer-down-button",
					sx: {
						marginRight: "20px",
						padding: 0
					},
					disabled: i === c.createTwinProjectionLayerCommandRequests.length - 1
				})] }), /* @__PURE__ */ G(S, {
					"data-testid": "projection-layer-name",
					children: n.name
				})]
			}), /* @__PURE__ */ K("div", { children: [
				/* @__PURE__ */ G(v, {
					icon: dr,
					variant: "primary",
					sx: {
						width: "30px",
						marginRight: "10px"
					},
					"aria-label": s("teia.widgets.projection_widget.add_tab.params.text"),
					onClick: f,
					"data-testid": "projection-layer-params-button"
				}),
				/* @__PURE__ */ G(v, {
					icon: Ts,
					variant: "primary",
					sx: {
						width: "30px",
						marginRight: "10px",
						"& svg": { fill: (e) => e.palette.primary.main },
						"&:hover": { "& svg": { fill: "white" } },
						"&:focus": { "& svg": { fill: "white" } }
					},
					"aria-label": s("teia.widgets.projection_widget.add_tab.duplicate.text"),
					onClick: d,
					"data-testid": "projection-layer-duplicate-button"
				}),
				/* @__PURE__ */ G(v, {
					icon: zr,
					variant: "error",
					sx: { width: "30px" },
					"aria-label": s("teia.widgets.projection_widget.add_tab.delete.text"),
					onClick: u,
					"data-testid": "projection-layer-delete-button"
				})
			] })]
		})]
	});
}, cl = (t) => {
	let { value: n, SvgComponent: r } = t;
	return /* @__PURE__ */ K(e, {
		direction: "row",
		sx: {
			alignItems: "center",
			justifyContent: "flex-start",
			marginRight: "20px"
		},
		children: [/* @__PURE__ */ G(On, {
			value: n,
			"data-testid": `projection-point-of-view-${n}-radio`
		}), /* @__PURE__ */ G(Y, {
			component: r,
			fontSize: "small",
			sx: { fill: (e) => e.palette.primary.main }
		})]
	});
}, ll = (t) => {
	let { setActiveSection: n, setCurrentLayerIndex: r } = t, { t: i } = h("teiaviewer"), a = ea(), { mutateAsync: o } = nl(a), { mutateAsync: s } = rl(a), [c, l] = f(!1), { newProjectionConfig: u, setNewProjectionConfig: d, setSelectedTabIndex: p, updatedId: g, setUpdatedId: _ } = Jc(), [v, b] = f(""), { viewer: C } = H(), { plugin: w } = U("Projection"), T = () => {
		if (u.name === "") {
			b(i("teia.widgets.projection_widget.add_tab.warnings.must_have_a_name.text"));
			return;
		}
		let e = 1;
		for (let t of u.createTwinProjectionLayerCommandRequests) {
			if (t.order = e, Object.values(t.advancedSearchCriteria).length === 0) {
				b(`${t.name} ${i("teia.widgets.projection_widget.add_tab.warnings.must_have_filter.text")}`);
				return;
			}
			e += 1;
		}
		if (g == null) o({ projection: u });
		else {
			let e = {
				name: u.name,
				direction: u.direction,
				updateTwinProjectionLayerCommandRequests: u.createTwinProjectionLayerCommandRequests
			};
			s({
				projection: e,
				twinProjectionConfigurationId: g
			});
			let t = w.projectionController.getSceneProjectionWithConfigurationId(g);
			t && new Mt(C, t).execute(), _(null);
		}
		p(0), d(Wc());
	}, E = (e) => {
		let t = { ...u };
		e.target.value === "X" ? t.direction = [
			1,
			0,
			0
		] : e.target.value === "Y" ? t.direction = [
			0,
			1,
			0
		] : e.target.value === "Z" && (t.direction = [
			0,
			0,
			1
		]), e.target.value == "custom" ? l(!0) : (l(!1), d(t));
	}, D = (e) => {
		b(""), d({
			...u,
			name: e.target.value
		});
	}, O = (e, t) => {
		let n = { ...u }, r = n.direction;
		r[t] = e, d(n);
	}, k = () => {
		b("");
		let e = { ...u }, t = e.createTwinProjectionLayerCommandRequests.length, n = Gc();
		n.name = `Layer ${t + 1}`, e.createTwinProjectionLayerCommandRequests.push(n), d(e);
	}, A = { name: u.name }, j = g ? i("teia.widgets.projection_widget.add_tab.titles.update.title", A) : i("teia.widgets.projection_widget.add_tab.titles.create.title");
	return /* @__PURE__ */ K(W, { children: [
		/* @__PURE__ */ G(x, {
			"data-testid": "projection-form-title",
			children: j
		}),
		/* @__PURE__ */ K(e, {
			spacing: 2,
			sx: {
				width: "100%",
				justifyContent: "space-between",
				marginTop: 2
			},
			divider: /* @__PURE__ */ G(Kt, {}),
			children: [
				/* @__PURE__ */ G(y, {
					value: u.name,
					onChange: D,
					"data-testid": "projection-name-input",
					label: i("teia.widgets.projection_widget.add_tab.projection_name.label"),
					sx: {
						width: "100%",
						backgroundColor: "white",
						borderRadius: "8px"
					}
				}),
				/* @__PURE__ */ K(e, { children: [/* @__PURE__ */ G(S, { children: i("teia.widgets.projection_widget.add_tab.point_of_view.text") }), /* @__PURE__ */ G(e, { children: /* @__PURE__ */ K(En, {
					row: !0,
					sx: { "& label": { marginRight: 0 } },
					onChange: E,
					defaultValue: "Y",
					children: [
						/* @__PURE__ */ G(cl, {
							value: "X",
							SvgComponent: hs
						}),
						/* @__PURE__ */ G(cl, {
							value: "Y",
							SvgComponent: gs
						}),
						/* @__PURE__ */ G(cl, {
							value: "Z",
							SvgComponent: _s
						}),
						/* @__PURE__ */ G(cl, {
							value: "custom",
							SvgComponent: Qc
						})
					]
				}) })] }),
				/* @__PURE__ */ K(e, {
					sx: {
						opacity: c ? 1 : .5,
						pointerEvents: c ? "auto" : "none"
					},
					children: [/* @__PURE__ */ G(S, { children: i("teia.widgets.projection_widget.add_tab.custom_point_of_view.text") }), /* @__PURE__ */ K(e, {
						direction: "row",
						spacing: 2,
						sx: { marginTop: 2 },
						children: [
							/* @__PURE__ */ G(ol, {
								onChange: (e) => O(e, 0),
								value: u.direction[0],
								SvgComponent: hs
							}),
							/* @__PURE__ */ G(ol, {
								onChange: (e) => O(e, 1),
								value: u.direction[1],
								SvgComponent: gs
							}),
							/* @__PURE__ */ G(ol, {
								onChange: (e) => O(e, 2),
								value: u.direction[2],
								SvgComponent: _s
							})
						]
					})]
				}),
				/* @__PURE__ */ G(e, {
					spacing: 2,
					children: u.createTwinProjectionLayerCommandRequests.map((e, t) => /* @__PURE__ */ G(sl, {
						layer: e,
						setActiveSection: n,
						index: t,
						setWarning: b,
						setCurrentLayerIndex: r
					}, `${e.name}${t}`))
				}),
				/* @__PURE__ */ G(Z, {
					variant: "info",
					sx: {
						width: "fit-content",
						backgroundColor: (e) => e.palette.primary.main,
						"&:hover": { backgroundColor: (e) => e.palette.primary.dark },
						color: "white",
						padding: 3,
						paddingTop: 1,
						paddingBottom: 1
					},
					onClick: k,
					"data-testid": "projection-add-layer-button",
					children: i("teia.widgets.projection_widget.add_tab.add_layer.text")
				})
			]
		}),
		/* @__PURE__ */ G(e, {
			direction: "row",
			sx: { justifyContent: "flex-end" },
			children: /* @__PURE__ */ G(Z, {
				variant: "info",
				onClick: T,
				"data-testid": "projection-validate-button",
				sx: {
					backgroundColor: (e) => e.palette.primary.main,
					"&:hover": { backgroundColor: (e) => e.palette.primary.dark },
					color: "white",
					padding: 3,
					paddingTop: 1,
					paddingBottom: 1,
					marginBottom: 2
				},
				children: i("teia.widgets.projection_widget.add_tab.validate.text")
			})
		}),
		!!v && /* @__PURE__ */ G(m, {
			severity: "warning",
			"data-testid": "projection-warning",
			sx: {
				marginTop: 3,
				marginBottom: 3
			},
			children: v
		})
	] });
}, ul = () => {
	let [t, n] = f(0), [r, i] = f(0);
	return /* @__PURE__ */ K(e, {
		direction: "row",
		sx: { position: "relative" },
		children: [/* @__PURE__ */ G(_, {
			sx: {
				width: "100%",
				position: "absolute",
				transition: "200ms ease-in-out",
				left: t === 0 ? 0 : "calc(-100% - 12px)"
			},
			children: /* @__PURE__ */ G(ll, {
				setActiveSection: n,
				setCurrentLayerIndex: i
			})
		}), /* @__PURE__ */ G(_, {
			sx: {
				width: "100%",
				position: "absolute",
				transition: "200ms ease-in-out",
				right: t === 1 ? 0 : "calc(-100% - 12px)"
			},
			children: t === 1 && /* @__PURE__ */ G(Zc, {
				setActiveSection: n,
				currentLayerIndex: r
			})
		})]
	});
}, dl = () => {
	let t = ea(), { analyzedProjection: n } = Jc(), { setSelectedTabIndex: r, setAnalyzedProjection: i } = Jc(), { plugin: a } = U("Teia"), { t: o } = h("teiaviewer"), s = n?.id ?? 0, { data: c, isLoading: l } = al(t, s, 1, 10), [u, d] = f(!1), [p, g] = f(!1), [y, x] = f(!1), S = () => {
		i(null), r(0);
	}, C = (e) => n?.twinProjectionLayerDtos.find((t) => t.id === e.id)?.name ?? e.id.toString();
	return /* @__PURE__ */ K(e, { children: [
		/* @__PURE__ */ G("h4", { children: n?.name }),
		/* @__PURE__ */ K(e, {
			sx: {
				padding: "15px 0",
				justifyContent: "space-between",
				alignItems: "center"
			},
			direction: "row",
			children: [/* @__PURE__ */ G("h4", {
				style: { fontWeight: "bold" },
				children: o("teia.widgets.projection_widget.analysis_tab.title.text")
			}), /* @__PURE__ */ K(e, {
				direction: "row",
				children: [
					!!p && /* @__PURE__ */ G(yt, {
						size: "20px",
						sx: { marginTop: "6px" }
					}),
					!p && /* @__PURE__ */ G(b, {
						title: o("teia.widgets.projection_widget.analysis_tab.generate_label.text"),
						children: /* @__PURE__ */ G(v, {
							icon: yr,
							"aria-label": o("teia.widgets.projection_widget.analysis_tab.generate_label.text"),
							variant: "primary",
							onClick: async () => {
								try {
									x(!1), g(!0), await st(a.twinApiClient).generateReport(t, s);
									let e = setInterval(async () => {
										await fl(a, t, s) && (clearInterval(e), d(!0), g(!1));
									}, 2e3);
								} catch {
									d(!1), g(!1), x(!0);
								}
							},
							"data-testid": "projection-analysis-generate-button",
							sx: {
								width: "30px",
								padding: 0
							}
						})
					}),
					/* @__PURE__ */ G(b, {
						title: o("teia.widgets.projection_widget.analysis_tab.download_label.text"),
						children: /* @__PURE__ */ G(v, {
							icon: _r,
							"aria-label": o("teia.widgets.projection_widget.analysis_tab.download_label.text"),
							disabled: !u,
							variant: "primary",
							onClick: async () => {
								try {
									x(!1), await pl(a, t, s, `projection-analysis-${s}`);
								} catch {
									x(!0);
								}
							},
							"data-testid": "projection-analysis-download-button",
							sx: {
								marginLeft: "5px",
								width: "30px",
								padding: 0
							}
						})
					})
				]
			})]
		}),
		/* @__PURE__ */ G(Kt, {}),
		/* @__PURE__ */ G("h5", {
			style: {
				padding: "10px",
				paddingTop: "30px",
				paddingBottom: "0px"
			},
			children: o("teia.widgets.projection_widget.analysis_tab.layer_list.text")
		}),
		!!l && /* @__PURE__ */ G(yt, {
			sx: {
				marginTop: "15px",
				marginLeft: "15px"
			},
			size: "25px"
		}),
		!l && /* @__PURE__ */ G(e, {
			sx: { padding: "0 10px" },
			divider: /* @__PURE__ */ G(Kt, {}),
			children: c?.data.map((e) => /* @__PURE__ */ K(_, {
				sx: {
					padding: "20px 0",
					color: (e) => e.palette.grey[700],
					"& p": { marginLeft: "15px" }
				},
				"data-testid": "projection-analysis-layer",
				children: [
					/* @__PURE__ */ G("p", {
						style: {
							fontWeight: "bold",
							marginLeft: "0",
							marginBottom: "5px"
						},
						children: C(e)
					}),
					/* @__PURE__ */ G("p", { children: `${o("teia.widgets.projection_widget.analysis_tab.processed_objects.text")} ${e.totalProjectionTwinObjectProcessed}` }),
					/* @__PURE__ */ G("p", { children: `${o("teia.widgets.projection_widget.analysis_tab.succeeded_objects.text")} ${e.succeededObjectCount}` }),
					/* @__PURE__ */ G("p", { children: `${o("teia.widgets.projection_widget.analysis_tab.deprecated_objects.text")} ${e.deprecatedObjectCount}` }),
					/* @__PURE__ */ G("p", { children: `${o("teia.widgets.projection_widget.analysis_tab.failed_objects.text")} ${e.failedObjectCount}` })
				]
			}, e.id))
		}),
		!!y && /* @__PURE__ */ G(m, {
			sx: { margin: "10px" },
			severity: "warning",
			"data-testid": "projection-analysis-error",
			children: o("teia.widgets.projection_widget.analysis_tab.error.text")
		}),
		/* @__PURE__ */ G(e, {
			direction: "row",
			sx: {
				justifyContent: "flex-end",
				paddingRight: "10px"
			},
			children: /* @__PURE__ */ G(Z, {
				onClick: S,
				variant: "info",
				"data-testid": "projection-analysis-back-button",
				children: o("teia.widgets.projection_widget.analysis_tab.back_button.text")
			})
		})
	] });
}, fl = async (e, t, n) => {
	try {
		return await st(e.twinApiClient).downloadReport(t, n), !0;
	} catch {
		return !1;
	}
}, pl = async (e, t, n, r) => {
	let i = await st(e.twinApiClient).downloadReport(t, n), a = document.createElement("a");
	a.href = i, a.download = `${r}.xlsx`, a.click(), URL.revokeObjectURL(i);
};
//#endregion
//#region src/widgets/projection/helpers.ts
async function ml(e, t, n, r, i) {
	let a = await st(e.twinApiClient).downloadExport(t, n, r), o = document.createElement("a");
	o.href = a, o.download = `${i}.${r}`, o.click(), URL.revokeObjectURL(a);
}
async function hl(e, t, n, r) {
	let i = await st(e.twinApiClient).downloadConfiguration(t, n), a = document.createElement("a");
	a.href = i, a.download = `${r}.json`, a.click(), URL.revokeObjectURL(i);
}
async function gl(e, t, n, r) {
	let i = [];
	for (let a of r) {
		let r = await st(e.twinApiClient).downloadConfiguration(t, a), o = await (await fetch(r)).json();
		o.name = `${n} - ${o.name}`;
		let s = _l(o);
		i.push(s);
	}
	await st(e.twinApiClient).importConfiguration(t, i);
}
function _l(e) {
	let t = JSON.stringify(e), n = new Blob([t], { type: "application/json" });
	return new File([n], `${e.name}.json`, { type: "application/json" });
}
async function vl(e) {
	return new Promise((t) => {
		let n = new FileReader();
		n.onload = (e) => {
			try {
				if (e.target) {
					let n = JSON.parse(e.target.result);
					if (!yl(n)) throw Error("Json is invalid");
					t({
						direction: n.direction,
						name: `${Dn("teiaviewer:teia.widgets.projection_widget.import_tab.import_suffix.text")} - ${n.name}`,
						createTwinProjectionLayerCommands: n.createTwinProjectionLayerCommands,
						status: "success"
					});
				}
			} catch (e) {
				t({
					direction: [
						0,
						0,
						0
					],
					name: `Error while loading the file: ${e}`,
					createTwinProjectionLayerCommands: [],
					status: "error"
				});
			}
		}, n.readAsText(e);
	});
}
function yl(e) {
	if (typeof e.name == "string" && typeof e.direction == "object" && typeof e.createTwinProjectionLayerCommands == "object") {
		for (let t of e.createTwinProjectionLayerCommands) if (typeof t.advancedSearchCriteria != "object" || typeof t.annotation != "string" || typeof t.displayBackground != "boolean" || typeof t.displayBorders != "boolean" || typeof t.fillColor != "string" || typeof t.fontSize != "number" || typeof t.lineColor != "string" || typeof t.lineType != "string" || typeof t.lineWidth != "number" || typeof t.name != "string") return !1;
		return !0;
	}
	return !1;
}
//#endregion
//#region src/widgets/projection/importProjectionComponents/LabelImport.tsx
var bl = (t) => {
	let { text: n, color: r, sx: i } = t;
	return /* @__PURE__ */ G(e, {
		direction: "row",
		alignItems: "center",
		justifyContent: "center",
		sx: {
			border: "1px solid",
			borderColor: (e) => r === "success" ? e.palette.success.light : e.palette.error.light,
			borderRadius: 1,
			padding: "7px 8px",
			minWidth: "65px",
			fontSize: 14,
			...i
		},
		children: /* @__PURE__ */ G("p", { children: n })
	});
}, xl = (t) => {
	let { name: n, status: r, index: i, setImportedProjections: a, setShowWarningLength: o } = t, [s, c] = f(n), { t: l } = h("teiaviewer");
	return /* @__PURE__ */ K(e, {
		direction: "row",
		alignItems: "center",
		justifyContent: "space-between",
		sx: {
			marginTop: 3,
			marginBottom: 3
		},
		children: [
			r === "success" ? /* @__PURE__ */ G(y, {
				label: l("teia.widgets.projection_widget.import_tab.file_name.label"),
				sx: { width: "100%" },
				value: s,
				onChange: (e) => {
					c(e.target.value);
				},
				onBlur: () => {
					a((e) => {
						let t = [...e];
						return t[i].name = s, t;
					});
				},
				"data-testid": "projection-import-file-name-input"
			}) : /* @__PURE__ */ G("p", {
				style: {
					width: "100%",
					marginLeft: "5px"
				},
				"data-testid": "projection-import-file-error-name",
				children: s
			}),
			/* @__PURE__ */ G(v, {
				icon: zr,
				variant: "error",
				sx: {
					width: 35,
					minWidth: 35,
					marginLeft: 2,
					marginRight: 2
				},
				"aria-label": l("teia.widgets.projection_widget.import_tab.delete.text"),
				onClick: () => {
					a((e) => {
						let t = [...e];
						return t.splice(i, 1), t.length < 10 && o(!1), t;
					});
				},
				"data-testid": "projection-import-file-delete-button"
			}),
			r === "success" ? /* @__PURE__ */ G(bl, {
				text: l("teia.widgets.projection_widget.import_tab.success.text"),
				color: "success"
			}) : /* @__PURE__ */ G(bl, {
				text: l("teia.widgets.projection_widget.import_tab.error.text"),
				color: "error"
			})
		]
	});
}, Sl = (e) => {
	let { open: t, setOpen: n, callback: r } = e, { t: i } = h("teiaviewer");
	return /* @__PURE__ */ K(Et, {
		open: t,
		onClose: () => n(!1),
		children: [
			/* @__PURE__ */ G(kt, { children: i("teia.widgets.projection_widget.import_tab.modal.title") }),
			/* @__PURE__ */ G(Dt, { children: /* @__PURE__ */ G("p", { children: i("teia.widgets.projection_widget.import_tab.modal.warning.text") }) }),
			/* @__PURE__ */ K(Ot, { children: [/* @__PURE__ */ G(Z, {
				onClick: () => {
					n(!1);
				},
				variant: "info",
				"data-testid": "projection-import-modal-cancel-button",
				children: i("teia.widgets.projection_widget.import_tab.modal.cancel.text")
			}), /* @__PURE__ */ G(Z, {
				onClick: () => {
					r(), n(!1);
				},
				variant: "primary",
				"data-testid": "projection-import-modal-confirm-button",
				children: i("teia.widgets.projection_widget.import_tab.modal.confirm.text")
			})] })
		]
	});
}, Cl = () => {
	let { t } = h("teiaviewer"), n = ea(), { plugin: r } = U("Teia"), { setSelectedTabIndex: i } = Jc(), [a, o] = f(!1), [s, c] = f([]), l = d(null), [u, p] = f(!1), [g, _] = f(!1), v = () => {
		i(0);
	}, y = async () => {
		let e = [];
		for (let t of s) if (t.status === "success") {
			let n = _l(t);
			e.push(n);
		}
		await st(r.twinApiClient).importConfiguration(n, e), i(0);
	}, b = () => {
		o(!0);
	}, x = () => {
		o(!1);
	}, S = (e) => {
		e.preventDefault();
	}, C = (e) => {
		let t = Array.from(e.dataTransfer.files);
		T(t), e.preventDefault();
	}, w = (e) => {
		if (e.target.files) {
			let t = Array.from(e.target.files);
			T(t);
		}
		e.preventDefault();
	}, T = (e) => {
		let t = [];
		for (let n of e) n?.type === "application/json" && t.push(vl(n));
		Promise.all(t).then((e) => {
			c((t) => t.length + e.length > 10 ? (p(!0), [...t, ...e].slice(0, 9)) : (p(!1), [...t, ...e]));
		});
	};
	return /* @__PURE__ */ K(W, { children: [
		/* @__PURE__ */ G(Sl, {
			open: g,
			setOpen: _,
			callback: y
		}),
		/* @__PURE__ */ G("h4", { children: t("teia.widgets.projection_widget.import_tab.title") }),
		/* @__PURE__ */ G("input", {
			type: "file",
			ref: l,
			accept: ".json",
			style: { display: "none" },
			onChange: w,
			"data-testid": "projection-import-file-input"
		}),
		/* @__PURE__ */ K(e, {
			onDragEnter: b,
			onDragLeave: x,
			onDragOver: S,
			onDrop: C,
			onClick: () => {
				l.current?.click();
			},
			"data-testid": "projection-import-dropzone",
			alignItems: "center",
			justifyContent: "center",
			sx: {
				cursor: "pointer",
				marginTop: 2,
				marginBottom: 4,
				border: "2px dotted transparent",
				borderColor: (e) => a ? e.palette.grey[800] : e.palette.grey[400],
				borderRadius: 2,
				padding: "50px 10px",
				fontSize: 13,
				transition: "200ms",
				color: (e) => e.palette.grey[600]
			},
			children: [
				/* @__PURE__ */ G(Cr, { style: {
					height: 60,
					marginBottom: 10
				} }),
				/* @__PURE__ */ G("p", { children: t("teia.widgets.projection_widget.import_tab.import.text") }),
				/* @__PURE__ */ G("p", { children: `(${t("teia.widgets.projection_widget.import_tab.max_files.text")}).` })
			]
		}),
		s.map((e, t) => /* @__PURE__ */ G(xl, {
			name: e.name,
			status: e.status,
			index: t,
			setImportedProjections: c,
			setShowWarningLength: p
		}, `${t}-${e.name}`)),
		!!u && /* @__PURE__ */ G(m, {
			severity: "warning",
			"data-testid": "projection-import-length-warning",
			children: t("teia.widgets.projection_widget.import_tab.error_length.text")
		}),
		/* @__PURE__ */ K(e, {
			direction: "row",
			alignItems: "center",
			justifyContent: "flex-end",
			sx: {
				marginTop: 4,
				marginBottom: 4
			},
			children: [/* @__PURE__ */ G(Z, {
				sx: { marginRight: 2 },
				variant: "info",
				onClick: v,
				"data-testid": "projection-import-cancel-button",
				children: /* @__PURE__ */ G("p", { children: t("teia.widgets.projection_widget.import_tab.button.cancel.text") })
			}), /* @__PURE__ */ G(Z, {
				variant: "primary",
				onClick: () => _(!0),
				disabled: s.length === 0,
				"data-testid": "projection-import-button",
				children: /* @__PURE__ */ G("p", { children: t("teia.widgets.projection_widget.import_tab.button.import.text") })
			})]
		})
	] });
}, wl = (e) => {
	let { text: t, onClick: n, disabled: r, "data-testid": i } = e;
	return /* @__PURE__ */ G(Z, {
		onClick: n,
		variant: "info",
		disabled: r,
		"data-testid": i,
		sx: {
			color: (e) => e.palette.text.primary,
			textAlign: "left",
			textTransform: "none",
			display: "block",
			borderRadius: 0,
			fontSize: "14px",
			padding: "2px 10px",
			"&:hover": { backgroundColor: (e) => e.palette.grey[200] }
		},
		children: t
	});
}, Tl = (e) => {
	let { open: t, setOpen: n, callback: r } = e, { t: i } = h("teiaviewer");
	return /* @__PURE__ */ K(Et, {
		open: t,
		onClose: () => n(!1),
		children: [
			/* @__PURE__ */ G(kt, { children: i("teia.widgets.projection_widget.list_tab.export_modal.title") }),
			/* @__PURE__ */ G(Dt, { children: /* @__PURE__ */ G("p", { children: i("teia.widgets.projection_widget.list_tab.export_modal.warning.text") }) }),
			/* @__PURE__ */ K(Ot, { children: [/* @__PURE__ */ G(Z, {
				onClick: () => {
					n(!1);
				},
				variant: "info",
				"data-testid": "projection-export-modal-cancel-button",
				children: i("teia.widgets.projection_widget.list_tab.export_modal.cancel.text")
			}), /* @__PURE__ */ G(Z, {
				onClick: () => {
					r(), n(!1);
				},
				variant: "primary",
				"data-testid": "projection-export-modal-confirm-button",
				children: i("teia.widgets.projection_widget.list_tab.export_modal.confirm.text")
			})] })
		]
	});
}, El = () => [{
	format: "svg",
	translation: Dn("teiaviewer:teia.widgets.projection_widget.list_tab.download_svg.text")
}, {
	format: "pdf",
	translation: Dn("teiaviewer:teia.widgets.projection_widget.list_tab.download_pdf.text")
}], Dl = (t) => {
	let { searchName: n, setSearchName: r, rowSelection: i, projectionsConfig: a, setRowSelection: o, setPagination: s } = t, { t: u } = h("teiaviewer"), d = l(), { plugin: p } = U("Teia"), m = ea(), [g, _] = f(null), { mutateAsync: b } = il(m), { setSelectedTabIndex: x } = Jc(), { viewer: S } = H(), [C, w] = f(S.scene.bimMeshController.hasVisibleObjects), [T, E] = f(!1), D = ht(), O = (e) => {
		_(e.currentTarget);
	}, k = () => {
		_(null);
	}, A = () => {
		let e = !C, t = S.scene.bimMeshController.getAllObjectUuids();
		new Q(S, t, e).execute(), w(e);
	}, j = () => {
		if (k(), !a) return;
		let e = Object.keys(i);
		for (let t of e) if (i[t]) {
			let e = a[Number(t)];
			b({
				projectId: m.projectId,
				twinProjectionConfigurationId: e.id
			});
		}
		o({});
	}, M = (e) => {
		if (k(), !a) return;
		let t = Object.keys(i);
		for (let n of t) if (i[n]) {
			let t = a[Number(n)];
			ml(p, m, t.id, e, t.name);
		}
	}, N = () => {
		if (k(), !a) return;
		let e = Object.keys(i);
		for (let t of e) if (i[t]) {
			let e = a[Number(t)];
			hl(p, m, e.id, e.name);
		}
	}, P = async () => {
		if (k(), !a) return;
		let e = Object.keys(i), t = [];
		for (let n of e) if (i[n]) {
			let e = a[Number(n)];
			t.push(e.id);
		}
		await gl(p, m, u("teia.widgets.projection_widget.list_tab.copy.text"), t), D.invalidateQueries({ queryKey: [
			$c,
			m.projectId,
			m.type
		] }), o({}), s({
			pageIndex: 0,
			pageSize: 5
		});
	}, F = () => {
		x(3);
	}, I = !!g, R = Object.values(i).length !== 0;
	return c(() => {
		let e = () => {
			w(S.scene.bimMeshController.hasVisibleObjects);
		};
		return S.signals.onLoadingFinished.connect(e), () => {
			S.signals.onLoadingFinished.disconnect(e);
		};
	}), /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 2,
		sx: {
			width: "100%",
			justifyContent: "space-between",
			marginTop: 2
		},
		children: [
			/* @__PURE__ */ G(Tl, {
				open: T,
				setOpen: E,
				callback: N
			}),
			/* @__PURE__ */ G(y, {
				value: n,
				onChange: (e) => r(e.target.value),
				label: u("teia.widgets.projection_widget.list_tab.search.label"),
				"data-testid": "projection-search-input",
				sx: { width: "100%" }
			}),
			/* @__PURE__ */ G(v, {
				icon: cn,
				variant: "info",
				"aria-label": u("teia.widgets.projection_widget.list_tab.actions.text"),
				sx: { minWidth: "40px" },
				onClick: O,
				"data-testid": "projection-global-actions-button"
			}),
			/* @__PURE__ */ G(v, {
				icon: C ? un : Xt,
				variant: "info",
				"aria-label": u("teia.widgets.projection_widget.list_tab.actions.text"),
				sx: { minWidth: "40px" },
				onClick: A,
				"data-testid": "projection-twin-visibility-button"
			}),
			/* @__PURE__ */ G(Mn, {
				id: d,
				open: I,
				anchorEl: g,
				onClose: k,
				anchorOrigin: {
					vertical: "center",
					horizontal: "right"
				},
				transformOrigin: {
					vertical: "top",
					horizontal: "left"
				},
				children: /* @__PURE__ */ K(e, {
					direction: "column",
					children: [
						El().map((e) => /* @__PURE__ */ G(wl, {
							onClick: () => M(e.format),
							"data-testid": "projection-global-download-export-button",
							text: e.translation,
							disabled: !R
						}, e.format)),
						/* @__PURE__ */ G(wl, {
							onClick: P,
							"data-testid": "projection-global-duplicate-button",
							text: u("teia.widgets.projection_widget.list_tab.duplicate.text"),
							disabled: !R
						}),
						/* @__PURE__ */ G(wl, {
							onClick: F,
							"data-testid": "projection-global-import-button",
							text: u("teia.widgets.projection_widget.list_tab.import.text")
						}),
						/* @__PURE__ */ G(wl, {
							onClick: () => E(!0),
							"data-testid": "projection-global-export-button",
							text: u("teia.widgets.projection_widget.list_tab.export.text"),
							disabled: !R
						}),
						/* @__PURE__ */ G(wl, {
							onClick: j,
							"data-testid": "projection-global-delete-button",
							text: u("teia.widgets.projection_widget.list_tab.delete.text"),
							disabled: !R
						})
					]
				})
			})
		]
	});
}, Ol = { "&.Mui-disabled": { color: "info.main" } }, kl = (t) => {
	let { visibleProjections: n, setVisibleProjections: r, toggleIsVisible: i, onUpdateProjectionConfig: a, isLoading: o, projectionConfig: s, setPagination: u, setRowSelection: d } = t, { t: p } = h("teiaviewer"), [m, g] = f(null), _ = ea(), { setSelectedTabIndex: y, setAnalyzedProjection: b } = Jc(), { mutateAsync: x } = il(_), S = l(), { viewer: C } = H(), { plugin: w } = U("Projection"), { plugin: T } = U("Teia"), [E, D] = f(!1), O = ht(), k = (e) => {
		g(e.currentTarget);
	}, A = () => {
		g(null);
	}, j = () => {
		A(), b(s), y(2);
	}, M = () => {
		A(), a();
	}, N = () => {
		A(), x({
			projectId: _.projectId,
			twinProjectionConfigurationId: s.id
		});
		let e = w.projectionController.getSceneProjectionWithConfigurationId(s.id);
		e && new Mt(C, e).execute(), d({});
	}, P = async (e) => {
		A(), ml(T, _, s.id, e, s.name);
	}, F = () => {
		A(), hl(T, _, s.id, s.name);
	}, I = async () => {
		A(), await gl(T, _, p("teia.widgets.projection_widget.list_tab.copy.text"), [s.id]), O.invalidateQueries({ queryKey: [
			$c,
			_.projectId,
			_.type
		] }), u({
			pageIndex: 0,
			pageSize: 5
		});
	}, R = () => {
		let e = n.get(s.id);
		e && new Lt(C, [e.sceneProjectionId]).execute();
	}, z = !!m, B = s.status, V = B === "ToDo" || B === "InProgress", ee = B === "ToDo" || B === "InProgress" || B === "Failed", te = n.get(s.id)?.isVisible ?? !1;
	return c(() => {
		let e = n.get(s.id), t = null;
		e && (t = w.projectionController.getObjectByUUID(e?.sceneProjectionId));
		let i = () => {
			r((e) => {
				let n = new Map(e);
				return n.set(s.id, {
					isVisible: t?.visible ?? !1,
					sceneProjectionId: t?.uuid ?? ""
				}), n;
			});
		};
		return t?.signals.onVisibilityChanged.connect(i), () => {
			t?.signals.onVisibilityChanged.disconnect(i);
		};
	}, [
		n,
		s.id,
		r
	]), o ? /* @__PURE__ */ G(yt, {
		size: "15px",
		sx: { margin: "7.5px" }
	}) : /* @__PURE__ */ K(e, {
		direction: "row",
		children: [
			/* @__PURE__ */ G(Tl, {
				open: E,
				setOpen: D,
				callback: F
			}),
			/* @__PURE__ */ G(v, {
				icon: te ? ln : un,
				variant: ee ? "info" : "primary",
				"aria-label": p("teia.widgets.projection_widget.list_tab.actions.text"),
				onClick: i,
				disabled: ee,
				"data-testid": "projection-visibility-button",
				sx: Ol
			}),
			/* @__PURE__ */ G(v, {
				icon: vn,
				"aria-label": p("teia.widgets.projection_widget.list_tab.update.text"),
				onClick: M,
				"data-testid": "projection-update-button"
			}),
			/* @__PURE__ */ G(v, {
				icon: xn,
				"aria-label": p("teia.widgets.projection_widget.list_tab.select.text"),
				onClick: R,
				disabled: !te,
				"data-testid": "projection-select-button",
				sx: Ol
			}),
			/* @__PURE__ */ G(v, {
				icon: cn,
				variant: V ? "info" : "primary",
				"aria-label": p("teia.widgets.projection_widget.list_tab.actions.text"),
				onClick: k,
				"aria-describedby": S,
				disabled: V,
				"data-testid": "projection-actions-button",
				sx: Ol
			}),
			/* @__PURE__ */ G(Mn, {
				id: S,
				open: z,
				anchorEl: m,
				onClose: A,
				anchorOrigin: {
					vertical: "bottom",
					horizontal: "right"
				},
				transformOrigin: {
					vertical: "top",
					horizontal: "right"
				},
				children: /* @__PURE__ */ K(e, {
					direction: "column",
					children: [
						B === "Degraded" && /* @__PURE__ */ G(wl, {
							onClick: j,
							"data-testid": "projection-analyze-button",
							text: p("teia.widgets.projection_widget.list_tab.analyze.text")
						}),
						B !== "Failed" && El().map((e) => /* @__PURE__ */ G(wl, {
							onClick: () => P(e.format),
							"data-testid": "projection-download-export-button",
							text: e.translation
						}, e.format)),
						/* @__PURE__ */ G(wl, {
							onClick: I,
							"data-testid": "projection-duplicate-button",
							text: p("teia.widgets.projection_widget.list_tab.duplicate.text")
						}),
						/* @__PURE__ */ G(wl, {
							onClick: () => D(!0),
							"data-testid": "projection-export-button",
							text: p("teia.widgets.projection_widget.list_tab.export.text")
						}),
						/* @__PURE__ */ G(wl, {
							onClick: N,
							"data-testid": "projection-delete-button",
							text: p("teia.widgets.projection_widget.list_tab.delete.text")
						})
					]
				})
			})
		]
	});
}, Al = () => {
	let { t } = h("teiaviewer");
	return /* @__PURE__ */ K(e, {
		direction: "row",
		style: {
			justifyContent: "flex-start",
			alignItems: "center",
			minWidth: "490px"
		},
		children: [
			/* @__PURE__ */ G(Y, {
				component: on,
				sx: {
					color: (e) => e.palette.info.main,
					marginRight: 1
				}
			}),
			t("teia.widgets.projection_widget.list_tab.caption.waiting.text"),
			/* @__PURE__ */ G(ec, { style: {
				width: "18px",
				height: "20px",
				marginRight: "4px",
				marginLeft: "8px"
			} }),
			t("teia.widgets.projection_widget.list_tab.caption.loading.text"),
			/* @__PURE__ */ G(Y, {
				component: rn,
				sx: {
					color: (e) => e.palette.success.main,
					marginRight: 1,
					marginLeft: 2
				}
			}),
			t("teia.widgets.projection_widget.list_tab.caption.completed.text"),
			/* @__PURE__ */ G(Y, {
				component: nn,
				sx: {
					color: (e) => e.palette.warning.main,
					marginRight: 1,
					marginLeft: 2
				}
			}),
			t("teia.widgets.projection_widget.list_tab.caption.degraded.text"),
			/* @__PURE__ */ G(Y, {
				component: an,
				sx: {
					color: (e) => e.palette.error.main,
					marginRight: 1,
					marginLeft: 2
				}
			}),
			t("teia.widgets.projection_widget.list_tab.caption.error.text")
		]
	});
}, jl = (e) => {
	let { status: t } = e;
	return t === "ToDo" ? /* @__PURE__ */ G(Y, {
		component: on,
		sx: { color: (e) => e.palette.info.main }
	}) : t === "Completed" ? /* @__PURE__ */ G(Y, {
		component: rn,
		sx: { color: (e) => e.palette.success.main }
	}) : t === "Failed" ? /* @__PURE__ */ G(Y, {
		component: an,
		sx: { color: (e) => e.palette.error.main }
	}) : t === "Degraded" ? /* @__PURE__ */ G(Y, {
		component: nn,
		sx: { color: (e) => e.palette.warning.main }
	}) : t === "InProgress" ? /* @__PURE__ */ G(yt, { size: "15px" }) : /* @__PURE__ */ G(W, {});
}, Ml = /* @__PURE__ */ new Ht(), Nl = () => {
	let { setSelectedTabIndex: t, setNewProjectionConfig: n, setUpdatedId: r } = Jc(), { t: i } = h("teiaviewer"), a = ea(), { viewer: s } = H(), { plugin: l } = U("Projection"), [u, d] = f(""), [p, g] = f(!1), [v, y] = f(/* @__PURE__ */ new Map()), [b, S] = f({}), [C, w] = f({
		pageIndex: 0,
		pageSize: 5
	}), [T, E] = f([]), { data: D, isLoading: O } = tl(a, C.pageIndex + 1, C.pageSize, p, u, [
		"Completed",
		"Degraded",
		"Failed",
		"InProgress",
		"ToDo"
	]), k = An(), A = [
		k.accessor("name", { header: i("teia.widgets.projection_widget.list_tab.table.projection_name.text") }),
		k.accessor("statusComponent", { header: i("teia.widgets.projection_widget.list_tab.table.status.text") }),
		k.accessor("actionsComponent", { header: i("teia.widgets.projection_widget.list_tab.table.actions.text") })
	], j = (e) => {
		let i = {
			name: e.name,
			direction: e.direction,
			createTwinProjectionLayerCommandRequests: e.twinProjectionLayerDtos
		};
		n(i), r(e.id), t(1);
	}, M = async (e) => {
		let t = v.get(e.id);
		if (!t) E((t) => [...t, e.id]), await new fe(s, a, e).execute(), E((t) => t.filter((t) => t !== e.id));
		else {
			let e = s.scene.getObjectByUUID(t.sceneProjectionId);
			if (e) {
				e.getInitialMatrix(Ml);
				let n = new Q(s, [t.sceneProjectionId], !t.isVisible), r = new Rt(s, t.sceneProjectionId, Ml), i = new Nt(s, [n, r]);
				i.isUndoable = !0, await i.execute();
			}
		}
	}, N;
	if (D) {
		let e = !1;
		N = D.data.map((t) => (t.twinProjectionLayerDtos.sort((e, t) => e.order - t.order), !e && (t.status === "ToDo" || t.status === "InProgress") && (e = 1e4), {
			...t,
			statusComponent: /* @__PURE__ */ G(jl, { status: t.status }),
			actionsComponent: /* @__PURE__ */ G(kl, {
				visibleProjections: v,
				setVisibleProjections: y,
				toggleIsVisible: () => M(t),
				projectionConfig: t,
				onUpdateProjectionConfig: () => j(t),
				isLoading: T.includes(t.id),
				setPagination: w,
				setRowSelection: S
			})
		})), p !== e && g(e);
	}
	let P = o((e) => {
		let t = new Map(v);
		t.set(e.twinProjectionConfigurationId, {
			sceneProjectionId: e.uuid,
			isVisible: !0
		}), y(t);
	}, [y, v]), F = o((e) => {
		let t = new Map(v);
		t.delete(e.twinProjectionConfigurationId), y(t);
	}, [y, v]);
	return c(() => (l.projectionController.signals.onObjectAdded.connect(P), () => {
		l.projectionController.signals.onObjectAdded.disconnect(P);
	}), [P]), c(() => (l.projectionController.signals.onObjectRemoved.connect(F), () => {
		l.projectionController.signals.onObjectRemoved.disconnect(F);
	}), [F]), c(() => {
		S({});
	}, [C.pageIndex]), c(() => {
		let e = l.projectionController.getAllObjects(), t = /* @__PURE__ */ new Map();
		for (let n of e) t.set(n.twinProjectionConfigurationId, {
			sceneProjectionId: n.uuid,
			isVisible: n.visible
		});
		y(t);
	}, []), /* @__PURE__ */ K(W, { children: [
		/* @__PURE__ */ G(x, { children: i("teia.widgets.projection_widget.list_tab.title") }),
		/* @__PURE__ */ G(Dl, {
			searchName: u,
			setSearchName: d,
			rowSelection: b,
			projectionsConfig: D?.data,
			setRowSelection: S,
			setPagination: w
		}),
		!!N && N.length > 0 && /* @__PURE__ */ K(_, {
			sx: { marginTop: 2 },
			children: [/* @__PURE__ */ G(kn, { tableOptions: {
				columns: A,
				data: N,
				enableRowSelection: !0,
				enableSorting: !1,
				enableFilters: !1,
				enableGrouping: !1,
				enableColumnActions: !1,
				enableGlobalFilter: !1,
				enableColumnPinning: !1,
				enableColumnResizing: !0,
				enableHiding: !1,
				manualPagination: !0,
				enableTopToolbar: !1,
				onPaginationChange: w,
				onRowSelectionChange: S,
				rowCount: D?.totalRecords,
				state: {
					rowSelection: b,
					isLoading: O,
					pagination: C
				}
			} }), /* @__PURE__ */ G(Al, {})]
		}),
		!!N && N.length === 0 && /* @__PURE__ */ K(e, {
			sx: {
				marginTop: 2,
				justifyContent: "center",
				alignItems: "center",
				width: "100%",
				"& div": {
					width: "100%",
					padding: 2
				},
				"& div div p": { fontSize: "14px" }
			},
			children: [/* @__PURE__ */ G(m, {
				severity: "info",
				"data-testid": "projection-list-empty",
				children: i(u === "" ? "teia.widgets.projection_widget.list_tab.empty_list.text" : "teia.widgets.projection_widget.list_tab.empty_list.search.text")
			}), /* @__PURE__ */ G(Ks, { style: { marginTop: 5 } })]
		})
	] });
}, Pl = [{
	id: "List",
	icon: Wo
}, {
	id: "Add",
	icon: Nr
}], Fl = () => {
	let e = Qi(), { viewer: t } = H(), { selectedTabIndex: n, setSelectedTabIndex: r, setUpdatedId: i, setNewProjectionConfig: a } = Jc(), { t: o } = h("teiaviewer");
	return c(() => {
		let e = () => {
			a(Wc()), i(null), r(0);
		};
		return t.signals.onSceneClear.connect(e), () => {
			t.signals.onSceneClear.disconnect(e);
		};
	}, []), e?.sourceType === nt.Twin ? /* @__PURE__ */ K(_, {
		sx: {
			display: "flex",
			width: "100%",
			height: "100%"
		},
		children: [/* @__PURE__ */ G(F, {
			tabs: Pl,
			selectedTabIndex: n,
			onTabSelected: (e) => {
				r(e), i(null), e === 0 && a(Wc());
			}
		}), /* @__PURE__ */ K(_, {
			sx: {
				padding: 3,
				paddingTop: 2,
				paddingBottom: 2,
				width: "100%",
				backgroundColor: n === 1 ? Gt[50] : "white",
				overflowY: "auto",
				overflowX: "hidden"
			},
			children: [
				n === 0 && /* @__PURE__ */ G(Nl, {}),
				n === 1 && /* @__PURE__ */ G(ul, {}),
				n === 2 && /* @__PURE__ */ G(dl, {}),
				n === 3 && /* @__PURE__ */ G(Cl, {})
			]
		})]
	}) : /* @__PURE__ */ G(_, {
		sx: { padding: 2 },
		children: /* @__PURE__ */ G(m, {
			severity: "info",
			"data-testid": "projection-no-twin",
			children: o("teia.widgets.projection_widget.no_twin.text")
		})
	});
}, Il = class extends N {
	constructor(e, t = {}) {
		super(e, {
			...t,
			isResizable: !0,
			width: 575,
			minWidth: 575,
			height: 450,
			minHeight: 450,
			useFooter: !1
		}), this.type = "Projection", this.Header = () => {
			let { t: e } = h("teiaviewer");
			return /* @__PURE__ */ G(te, {
				icon: Co,
				children: e("teia.widgets.projection_widget.title")
			});
		}, this.ContextProvider = (e) => /* @__PURE__ */ G(qc, { ...e }), this.Content = () => /* @__PURE__ */ G(Fl, {});
	}
}, Ll = (e) => /* @__PURE__ */ K("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", { d: "M11.6505 11.2549H12.5835V9.85488H11.6505V4.36488L15.2107 4.41488L10.7175 0.754883L6.35928 4.30488L9.93178 4.34488V9.85488H8.98648V11.2549H9.93178V16.6349L6.35928 16.5849L10.8525 20.2449L15.2107 16.6949L11.6505 16.6549V11.2549Z" }),
		/* @__PURE__ */ G("path", { d: "M0.61383 9.85488H0V11.2549H0.61383V9.85488Z" }),
		/* @__PURE__ */ G("path", { d: "M3.00777 9.85488H1.81694V11.2549H3.00777V9.85488Z" }),
		/* @__PURE__ */ G("path", { d: "M7.78337 9.85488H6.59254V11.2549H7.78337V9.85488Z" }),
		/* @__PURE__ */ G("path", { d: "M5.38943 9.85488H4.1986V11.2549H5.38943V9.85488Z" }),
		/* @__PURE__ */ G("path", { d: "M14.9652 9.85488H13.7744V11.2549H14.9652V9.85488Z" }),
		/* @__PURE__ */ G("path", { d: "M19.7531 9.85488H18.5622V11.2549H19.7531V9.85488Z" }),
		/* @__PURE__ */ G("path", { d: "M17.3714 9.85488H16.1683V11.2549H17.3714V9.85488Z" }),
		/* @__PURE__ */ G("path", { d: "M21.57 9.85488H20.9562V11.2549H21.57V9.85488Z" })
	]
}), Rl = (e) => /* @__PURE__ */ K("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ G("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.5 19.6C15.5258 19.6 19.6 15.5258 19.6 10.5C19.6 5.47421 15.5258 1.4 10.5 1.4C5.47421 1.4 1.4 5.47421 1.4 10.5C1.4 15.5258 5.47421 19.6 10.5 19.6ZM10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z"
	}), /* @__PURE__ */ G("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20 11H1V9.60001H20V11Z"
	})]
}), zl = (e) => /* @__PURE__ */ K("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ G("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.6 10.5C19.6 5.47421 15.5258 1.4 10.5 1.4C5.47421 1.4 1.4 5.47421 1.4 10.5C1.4 15.5258 5.47421 19.6 10.5 19.6C15.5258 19.6 19.6 15.5258 19.6 10.5ZM21 10.5C21 4.70101 16.299 -2.53482e-07 10.5 0C4.70101 2.53482e-07 -2.53482e-07 4.70101 0 10.5C2.53482e-07 16.299 4.70101 21 10.5 21C16.299 21 21 16.299 21 10.5Z"
	}), /* @__PURE__ */ G("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.0001 1L11.0001 20H9.6001V1L11.0001 1Z"
	})]
}), Bl = (e) => /* @__PURE__ */ G("svg", {
	width: 24,
	height: 24,
	viewBox: "-1 -3 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ G("path", { d: "M16 8.375V6.275L16.2 6.475C16.5 6.775 16.9 6.775 17.1 6.475C17.3 6.175 17.4 5.775 17.1 5.575L15.8 4.275L11.9 0.375C11.4 -0.125 10.5 -0.125 10.1 0.375L4.9 5.475C4.6 5.775 4.6 6.175 4.9 6.375C5.2 6.575 5.6 6.675 5.8 6.375L6 6.275V8.475C2.5 9.175 0 10.475 0 12.075C0 14.275 4.9 16.075 11 16.075C17.1 16.075 22 14.275 22 12.075C22 10.375 19.6 9.075 16 8.375ZM7.3 4.975L11 1.175L14.7 4.975V8.275V10.675H13.6H13V8.375C13 8.275 13 8.175 13 8.075C12.8 7.475 12.3 7.075 11.7 7.075H10.4C9.8 7.075 9.3 7.475 9.1 8.075C9.1 8.175 9.1 8.275 9.1 8.375V10.575H7.3V8.175V4.975ZM10.3 8.375H11.6V10.575H10.3V8.375Z" })
}), Vl = (e) => /* @__PURE__ */ G("svg", {
	width: 24,
	height: 24,
	viewBox: "-1 -3 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ G("path", { d: "M19 7.975H16V6.275L16.2 6.475C16.5 6.775 16.9 6.775 17.1 6.475C17.3 6.175 17.4 5.775 17.1 5.575L15.8 4.275L11.9 0.375C11.4 -0.125 10.5 -0.125 10.1 0.375L4.9 5.475C4.6 5.775 4.6 6.175 4.9 6.375C5.2 6.575 5.6 6.675 5.8 6.375L6 6.275V7.975H3L0 15.975H22L19 7.975ZM11.6 10.575H10.3V8.375H11.6V10.575ZM14.7 7.975V10.575H13.6H13V8.375C13 8.275 13 8.175 13 8.075C12.8 7.475 12.3 7.075 11.7 7.075H10.4C9.8 7.075 9.3 7.475 9.1 8.075C9.1 8.175 9.1 8.275 9.1 8.375V10.575H7.2V7.975V5.075L11 1.175L14.7 4.975V7.975Z" })
}), Hl = (e) => /* @__PURE__ */ G("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ G("path", { d: "M14.2033 0C10.3803 0 7.03981 2.4656 5.86444 6.0352H5.81495L5.80258 6.09653C2.3631 7.34773 0 10.6229 0 14.2784C0 19.0869 3.94675 23.0123 8.80904 23.0123C12.6321 23.0123 15.9726 20.5467 17.1479 16.9771H17.1974L17.2098 16.9157C20.6369 15.6645 23.0124 12.3893 23.0124 8.74613C23.0124 3.9376 19.0656 0.0122667 14.2033 0.0122667V0ZM12.7682 8.47627L8.56159 12.9536C8.23991 12.5243 7.95535 12.0704 7.73265 11.5797L11.333 7.74027C11.8402 7.93653 12.3228 8.18187 12.7558 8.47627H12.7682ZM15.8736 14.2784C15.8736 14.6464 15.8241 15.0389 15.7622 15.4192C15.7622 15.4683 15.7499 15.5051 15.7375 15.5541C15.6261 15.5787 15.5148 15.6155 15.3911 15.6277C15.3045 15.64 15.2055 15.6645 15.1189 15.6768C14.8096 15.7136 14.5003 15.7381 14.191 15.7381C13.8569 15.7381 13.5476 15.7136 13.2259 15.6645L15.7499 12.9781C15.8241 13.3952 15.8736 13.8245 15.8736 14.2661V14.2784ZM11.3577 15.1493C10.7886 14.904 10.2442 14.5728 9.7617 14.1925L14.0672 9.61707C14.4879 10.0832 14.8343 10.5861 15.1189 11.1504L11.3577 15.1616V15.1493ZM7.18827 9.62933C7.15116 9.33493 7.12641 9.02827 7.12641 8.7216C7.12641 8.34133 7.1759 7.96107 7.23776 7.56853C7.23776 7.53173 7.25013 7.48267 7.26251 7.44587C7.37386 7.42133 7.48521 7.38453 7.60893 7.37227C7.69554 7.36 7.79451 7.33547 7.88112 7.3232C8.19042 7.2864 8.49973 7.26187 8.80904 7.26187C9.00699 7.26187 9.20495 7.27413 9.39053 7.2864L7.18827 9.62933ZM17.581 14.8795C17.5933 14.6709 17.6057 14.4747 17.6057 14.2784C17.6057 9.46987 13.659 5.54453 8.79667 5.54453C8.48736 5.54453 8.17805 5.5568 7.86875 5.5936C9.04411 3.25067 11.4691 1.71733 14.191 1.71733C18.0882 1.71733 21.2679 4.8576 21.2679 8.73387C21.2679 11.3099 19.808 13.6773 17.581 14.8795Z" })
}), Ul = (e) => /* @__PURE__ */ K("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", { d: "M10.48 0.714844H9.08V1.21484H10.48V0.714844Z" }),
		/* @__PURE__ */ G("path", { d: "M10.48 2.19484H9.08V3.16484H10.48V2.19484Z" }),
		/* @__PURE__ */ G("path", { d: "M10.48 6.08484H9.08V7.05484H10.48V6.08484Z" }),
		/* @__PURE__ */ G("path", { d: "M10.48 4.13484H9.08V5.10484H10.48V4.13484Z" }),
		/* @__PURE__ */ G("path", { d: "M10.48 10.2048H9.08V11.1748H10.48V10.2048Z" }),
		/* @__PURE__ */ G("path", { d: "M10.48 8.03484H9.08V9.01484H10.48V8.03484Z" }),
		/* @__PURE__ */ G("path", { d: "M10.48 15.8348H9.08V16.8048H10.48V15.8348Z" }),
		/* @__PURE__ */ G("path", { d: "M10.48 13.8848H9.08V14.8648H10.48V13.8848Z" }),
		/* @__PURE__ */ G("path", { d: "M10.48 17.7848H9.08V18.2848H10.48V17.7848Z" }),
		/* @__PURE__ */ G("path", { d: "M15.86 6.25484L16.68 3.58484L12.15 6.07484L14.57 10.4748L15.42 7.69484L15.45 7.58484C17.15 8.14484 17.93 8.86484 17.93 9.35484C17.93 10.3948 14.82 11.8948 9.94 11.9248H9.64C4.76 11.8948 1.65 10.3948 1.65 9.35484C1.65 8.59484 3.34 7.51484 6.46 7.02484L6.24 5.64484C2.49 6.23484 0.25 7.62484 0.25 9.35484C0.25 11.9348 5.17 13.3348 9.79 13.3348C14.41 13.3348 19.33 11.9448 19.33 9.35484C19.33 8.07484 18.09 6.97484 15.86 6.24484V6.25484Z" })
	]
}), Wl = (e) => /* @__PURE__ */ K("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ G("path", { d: "M15.36 0.67H14.44V1.57H15.36V0.67Z" }),
		/* @__PURE__ */ G("path", { d: "M17.2 0.67H16.28V1.57H17.2V0.67Z" }),
		/* @__PURE__ */ G("path", { d: "M13.52 0.67H12.6V1.57H13.52V0.67Z" }),
		/* @__PURE__ */ G("path", { d: "M9.84 0.67H8.92V1.57H9.84V0.67Z" }),
		/* @__PURE__ */ G("path", { d: "M8 0.67H7.08V1.57H8V0.67Z" }),
		/* @__PURE__ */ G("path", {
			d: "M11.68 0.67H10.76V1.57H11.68V0.67Z",
			fill: "#5D7DFF"
		}),
		/* @__PURE__ */ G("path", { d: "M19.02 1.12C19.02 0.87 18.82 0.67 18.57 0.67H18.12V1.57H19.02V1.12Z" }),
		/* @__PURE__ */ G("path", { d: "M19.02 4.33H18.12V5.25H19.02V4.33Z" }),
		/* @__PURE__ */ G("path", { d: "M19.02 6.17H18.12V7.09H19.02V6.17Z" }),
		/* @__PURE__ */ G("path", { d: "M19.02 2.49H18.12V3.41H19.02V2.49Z" }),
		/* @__PURE__ */ G("path", { d: "M19.02 11.69H18.12V12.61H19.02V11.69Z" }),
		/* @__PURE__ */ G("path", { d: "M19.02 9.85H18.12V10.77H19.02V9.85Z" }),
		/* @__PURE__ */ G("path", { d: "M19.02 8.01H18.12V8.93H19.02V8.01Z" }),
		/* @__PURE__ */ G("path", { d: "M19.63 15.93L16.08 12.38L16.04 15.38H4.3V3.61L7.21 3.66L3.55 0L0 3.55L2.9 3.59V16.78H16.02L15.97 19.58L19.63 15.93Z" })
	]
}), Gl = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCABJAEgDAREAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD+sr48ftReIJ/Fmq+FfAmpy6fonh3UrXw5qkljb3kWqX+tapezaTHc/wBpRRzk6eVZ7jQobGE2Us9nJda/eyW89ppL+NWxsK0cTSm50KbpYiphsTSrQviYYSnz4jlXPSdKNOaVOrzVY1KlKfNhouf7yn7OHwXIqdSSjObcOanODap+0aULq0uaTV5L3WoyVpNJWl4xbeNPEmp+HriDw5d67q+pxi/aG7fxE2qC90zWtQj/ALQj16W9vW0q2stC1UPbebLfQ3mmReHnto7qa2utRstR+ZpV8XSrr6xUeGhy01Xrv22HVGvhabnTqUE4+0lUxmEUZpezdOrLG+25IThSnR9WdKi4+7GMnd8sOWEuaM3ZxlbRKnO63vFU+W7Tal6t8KdF8eeH00fxX4j8bappPhfRraaTVR4n1u71COexuLdBf6Zfa3q15c3OpiVxPql1emM3lpqrJHp2rXmgRrLdOWMrYnE1vYJ13XqQpKrTjUoUqvJVbTweAowg41HSf1WlGMVGWGvUqYOGJqKpRzlSpRhFOMYuKclFqMpx93/l5Vd1y83vybfxKyqOC5ZWviJ8cx8PpLq18FWOpX9zeWkN9F4jv4r+5huLa+tLmaxn0ez3LLcpf3Hlw6X5Vjb2Gr6pfLa2mvveXMwg2p4TERqwp1MVKnKdrKVdzruKnCDTqTl9Xw0aUHVliLOvisHToVKtbC8kUnK9nODk6cWo3VlTSinZvVRXPNtqPJ8EKjlGMZnjfhXXfip448STT6l4w1OW40+aYXmlyvND5FleXer6dNrKi0v0tNMgg1rR7zRNJhmn1bV7mPTPEcirf2uoC80VZgp0cCpUva0oYhxUcQ8ZW55VqUMPW+rTjOm6tabw2IpYrFKMMHhoVK+A9yjUoyhitKSp+0s4QbhryKlBpRlzR5001GK54uENak3GNS7kpJ0/XdM8b694bhvtP1W+1K6nimYWsX9pXDyrJ/y08xmkYpav8skTH52Lkxxujs8fzSxWIjdOvWfb97P/AOS2Ot0KUrNU4LT+SP8AluUG1nxJ4m09otK1zVNP1yyD/ZWg1CYn7LNLiKaJLuWSB5dGupY3iFxHJF9me3EjzyrIo0o4zERqU6ntKlT2c4ylSlWqqFWCa5qcnCcZcs43hO0k+STs76ilRpWlFwglJP3lCN4u2jV42v1W+qK+j+JNVj+weG/FGt6hbXXhvVrePydIu9UsfsssdgIrO6k1c6jHdXWm3UV5LdQk2y3yrLC95qU97ZXMtz7WLzWpRr1K+H+sR+vUm1Vr1o1oSpzqKUnGlyKNOrTq01RmlJ004T5KMKdSEIcsMLCUVGSptU38MYcruk0k5XvKLi+ZXV9VeTkm39NeEPjYdC8RaZ4T124ur+xvp7ax+1TAs+jyXOEs389/3tzau7wpNGS6W0B82F1MT28uuVZ9XpYinhsZVnXpVpqCqVG51KU5u0ZObvKcG2lJSb5V70WrOMuXGZbCdKVahGNOcE5OMdIzS1aUVpGSV2rJXej3uvkST4a6MmqNqXizUBc6hqNvpovfDNhc2aaTd3rLf2b3Wo6te6da6jt1BL1NLE8cukTapZactg8OoxSNpUfn0MXUp01hsLTqYmrGdapSryjW9tCm50qsFHD0q86PLSqUpYiPtlXhTrVp1aUYVYqtL0JRTfPJqnFqMXFOPK2lKL95xUryTUXy8rcYqMm46Hqv9mWPhPTLfUrrTtG0ywt/Lvv7Hms7zSrDSneVNjf8I1Z2VrqWoarO6rbxQXraVqUlzLZS6ZAWnks3tUYuq3mNericSly0sPTrU6kUoxbUsRjp1JUaFCCfPePt/cjU9p9Wj+8M+dtWoxUIX96o4tN/9e6ajzTk2ra8urVufY8/8ReNNU1+5kminultYZLQ6ffOTFthCSs0Fp4fuLBLDw4uWKW09uh8QmBWkub+3u2lROXEY5JKFKNO/LUp1IxppU6d3FRVOvTq8+IVo8041f8AZXP4KE4qM3tTodZX1akrtuUtNXJOPuvWyt76W8k7pYv9hxeM/CiaBO16dc8Ei91HwvJBNKL7xN4XuFv59b8EpPDC959v8PRztq/hGHTpbbUlW1itNNmjP9rXbevgMwrYijXinR+sVYxpyqV6UJU8PWvS5cW/aP2ajjHS5MdKrGpTcpVatWMpSw1Nc1ajGlUhK0vZ3b5Yt3kkpe7pr+75v3ai07WjFq027SQXPgyzGmaTKIrbVoLbUJL63d3N6z28cX2lbmYfa5Lp4o4orm+upHv7pYYJJXQbQ3zmKq4mdWf1mpOdVOUZcz0g+eUpQpxVo04RnKVoQUYRbfLFI7qcabiuSKSVreeis295NpLV3fmzPsNNv9WuDFZwSXEhO6R+dibiTvmlb5UBOeXbLHIXc3FcyTbsjRtJallft/hzV8Ntju7KYHq5ikBH3vuhngnhdlJChzDK4Xy5CGU1i/Nf1/XkGkl6nZ+K9JTxFpdr4o0DTxd6wqWdvLGJUtrm70mO7mW7spXbdDNNpEl1e39nESfMnS6tLS4iTUpZX76co1qToVazp0YqtWpNwdRQxDpx05Y+9H6x7GnQqSjdL3KkoT9lFLn1hK6jdtxjLVK8b766e7zOSTt1V1cx7GafRNQ0/UdetzfGezzYqZkubu2EIX7HIkRkKoGIVYi+cb2kQ+bG6nj96nJc6aa6P4oteT2afR7eps7Si1Hbr2d99eppW+heH/BiTR+Er+6/tmwTUmuPHHjXULHXvFWlW91NKb3XvC0N00kWg2VxLqENlrME66PrGr6faSJDb6Zq8SXN99hzycadL6vVmq8KapQwtKvRoVqjUuWk5OEalWryU5Tw+Jh9Zo0qvJUk50qlaMfHgotzkqsGoTlGopThOUHFq6nZtRs5R9pTfJJrT4lFvwbxF4t8b6r4n1K21LTtHttV0iG5e8vf7S1PX7Sy0vVNL0LU7E6X/wASrQ7MyvcPeXOt2WjXPiS8ms7PwjdarcWj6/p0dhhiMFgaeCwlT6xi6tKvWlCdF+wwkquLw9erSjKVFVMVU5KlJ1FRxGMlhVSlUxMKEJ+xxEZdVKpVdWpHkguWCcZ2lNKEoxk0pWhG8Xy3hTU+ZRi5NNxt65LrmmXPh1tUvTZ+GvCtlJG08dzIkaw3DSLDCdR1BBdNdXlx5iGys9L+2XF8lxa/PDDd2t3J4cMvxVbErB0aLq1WuaMKakk4qHPKcnUUHCMIpuo6ig6XLJVeRxlbpdWEIupKVls27b3tZJXvd7WvfRxvc4qTUdaub3fpML+FYdG1Y3uh67DeQ3uuagyW72puUsbjTnTwrZ3drdXtjIlhqU3iS40+dkn1fTbg7I+6lisBlXJLDyWZ4irSisXGrSqUcHQaqRqeyouOI5sbOE6dKoqleisKqkF+4xUEpPOVOriOZVF7GCb5OWSlUkrNc0rxtTTUpK0Zc9nvB6Htd5YaX4k0O2vdDt5be01ifUr5LKS4S7PhTxSsdrfar4Wup/tVzIkWpG8uNY0xBtto7B1MJFstjDUZhD6zTji04P3KUVKEPZqvCPtKSqxj7OmrU3ThQnL45TtzJ1KdaRNCTpydNp3Tbd3e17Ozd3q7uXZa7KUUcJ4d1WbQNTWSdZEtZXNreoysMbGAZtuP9bauQxUDftLx4HmV4sZcr8tn/XkdklzLz3X9eZ2/jvT7W5sIdVSaFLiAIiEuo+120hyEi5/ePGX82PbnMZl65XGlRKyfX80RTbTt0/I8w+HvxM028vdb0jQXk1iTS/EMXhrV7a5iv9DTStbMVlKJzNrNja/btKl0+7tpYdV0OHWLHU45LJtLnuYUuZYuuGEqUfZyxjlhqFWNb2VR05VPaToxg3TpRVlJt1KcedzjR96/tfdaInNTv7O05R5bpNK0ZOWsnq18L923Mrax1R6Vq3gsDRwtiC97bXN7eRwKzNCkWoXU19dafZmUmVbSG6uJpbCCWRktUdrO0S2shbWltONqvFVPate9GnSpc1kp1I0oRpQnVtaLquEY88kk5tOdRzqynUmUv3a5ejbdukXJ3aV9eW7dl0WitFKK8ak0PQX1DRr3xBB5Hg7xIbVS661q2kajpXiuDUYNP8L+I9QdbpP7R163mlsPCmpaqby9m07V9E0XVIpYLHxNPbSfplCvU4hyTE5bh6kq+c5NCpjMstRhOOOyeNOpjs1yfDypKFSjSw84VuIMswjjCFSnVzLCclTF4TCuHxmMpxyTNaeYSh7PK82q0sLmtpyUcJmUnDDZdms1K8LV06eVZhWTbTWX4iUoUI4iTpa98GtB8DR6c+kX3itNI0aCCGLTEvtb1KDUPCtjJYxHRbi8n1n7LFqGhm91nVINSubGS/h8OvLc2f21/DV4w+bo5pUxtLlnRw06jhGjVqVaslOlUk603jIUEuarOsqeGpycajlVxkHCs+fMoxqfRPCwpy0lUSu5RUUrNJRSpuWyUbzeqsoO60pNqt4k03QNO/sZo7i+1CC60nTNEudDuta/te38Ot4l1yS01Wxu0tLAQaUbS71G/S61PUm0y/1BJLyW+1iDw/4MnsrTqp0MTjMHiMPT9nh5UMRWxmGxkaDoPG/UcKquHrKVSs54qNanSpSp0aKxFKjJUvY4aeMzKFSqKUKM4SfNNSgqc6blzuHtZ2nF2ilBxk3eUuSUk3zTVOi4r0LVfDE3hqw0i3ub2XULxoJYbq6kVT9oa2cJDctLFbWkJuLiAxyXccdvFGtz5rQxpA8aJ8LifZurKdKPJCb5lBRcYwcrOUIKVSrJU4SbjT56tSfIoucnJs9Wm21aWrWl7pt9m7KKu93aKV27JIu+D76Kxvb/AE7UUaLwv4ohS38T6jHdS2cvh06Xb3d3pPjOC5DeRZtoF0gS/vpTar9hnQyXsk9jpmn3XrZTUrTTpO8oU3zYaMqcalOpiKs6dOWE5H79Z4mDfLQp+1lK00qUYVq9aHNi4x0ktJfas2moJN819ocrXxuy21bjGL6nxjexxaBqiajYCO40bXLzSrq5iXFt9rtJXDahprxfaFvoL9SFMFrNdS297LPpN3IdU0+7hj5cZg50qkKcEp+1p0q0FzLmpxqq6Va6hycr2qTjThVpOniqa+r1qU5XRqKScr2s5RemkuX+Xe9+yu4yUoP34yR836lrGva3qKQw+L/B/hvRI9GtLGW08XaxJY6zZ32o3s01kbiK0kNzoNhdWFg6wgXVlrkpGoWkL+HrmCbUoezC0MPQhONfDyxlfnvTq00quEpxjGKTjflWImqrlo1LCS5IXWLpVWo5Vqk3JOnUjTjZqUJNxm5O7d0k3FcttrTV3bklHWfTUl8NaFPHaeNPgbqOsyeIWudJ0TRdeuV/tiwjuNUiv7O7uXaSfWPEdzHZaB4ej1SS1sQ8dvfXWqapJfi0nHU8C8XOWJq0cVOnzQjWryj+4oSxEpRpyqKm5OkvcnKMIxSUaclGm1FJYLESgvZxqUYyveMVfmlGFnJJtWfxR1bd777s9o8LeIn8XaLZT63qWg65bWF5ZWOq23hTUW1LSLmS6t7Swa6vtRjuZbbWbTT9ZOo2Wq6epbT4tslxeNeNpsbXGPsZYOpVoU4VKGL9lVnCrXUedexqVpOnh4uPtMNWlRhBRnU5cUqsHCMaUcQmtVNVYxm5RnC8U1C9ryUVeTvaUVJt2V4crTbk4HO6ZodzqOk61qMv2OfSra686TSnaO4vUuoxHY31/eC9t3tdO0q40iAfbre3h125vdJaLV9Hs7PxTpdlb3e2TY2rgKmClQxFSniVJTw+IpKcFRlGft6NOnOnONSriYYpqVHneFp0sRejia1TAYirKEY/DUcXSxFCvRhVoVac6VelUtKNWnUg6dRTi00qc6TcZ255Sg+aMY1YRTk8H+OL3WfC8/hgXb6r448Nxqmk6kiWd3dazFZNaWVnrps7e5s4rmS3vbxfD3jeG2vLHStP1OLWNMv9d022uYLqT6PiXLMKswo59gMPDDZLnEpPMcLerTwuT5jP2tXGZZCpKFWapVqdN5pkMXCrXngquHUaNWvhasTw8ixGIpUq2TY6tKvjctUVg8TJxlWzLLfdjhMZNJq9ei39QzKXuxeKpTre5SxNM4rx/wDDsabpM+mavPcQ+G/E9yn9saedVuNc0WKbT49LTS49Wu9QstMvf+Eca18O6Xpup6RY3Gh6bqEt3aveWGra1NrPi6vFw+cYpTp/UGpYnAQk8JUhh4YTG1aVd1/rUMLDDzrUljaNXHV8RhatSniq1KhGUaFShhMLRy8950KbUvapqNVr2icnOnGUeVwc3JRl7OUacYTScIuXxKU6kqp2HhrxVPH4DtrHxjbPay6Rr1x4e097uy1HWNW1+DTLy6tY7fTdOurm01yLUxp9rMRr+qC40RtO+x+JYtR8RaHeS6kObMcJh3iVVfJN4jB08bWpRq0MPTw06tKE3Vq1aUZ4b2Tq1IqWEw8qWKjXdXATo4HFwjhyqU58rjG65KjpqXLKTkoya5UnyzuktJyUoOPLVjKrB8xmXFxqOp2dxpM6f2T4b+0ytHolpqt5f3upwyT5D+LtWlYXN08xtZLVvDsEg0OHTll0adtb0pLVLbzsTi5UnSq0YSjUlSUViJYanh6VO0ZQ5cvoQXs6ajd1Fi5RWKnW5cVGOGxDnOpvTpxfNGUlK0tYqblJ6p3qyfvNu1nC/Io3g+eNku0srmx8U6UbDVIFvvGngPR7q+8Pi2C2+oav8OrafTLS/Jne1ZJb/wAGyXsdnLFbSJd6h4evbSwubl11fWFufVoYmpjcJUqSq8tKtUjRzV1nz0pYmpDEVKNXlVRNfWI05VHOcXCjXpTr04x+p4b2fLOmqFWKiujlQUdJRS5IyjtZ8t0kk05JqLb9pO/KQxeHbeW11K80fQZdXa20+RNRvtI0vWrm60yW8KXcfhC18u21bX7KNtQkhPinUk0nwpZf27Hq3l6wg1PTa4Y4adGM5/W6jwsZV6VOT5sOqU4QnKh9Zc4VadGtJRlUWCpSxGKq+wq0oxpqdLEvWTjOSXso+0fJKW020373K003HVL2jUILmUm3aUDhbxPh9qOqx+A72w8E/wBqjSNR8TDwbdWvh6+17U/C95r91brrus2txaf2heaQmuX2r2q2djDaeCrG41W50S10qWLT7KWMr5vi+R/VZzjTXsGqztTnTnSjGm54WjCXLQUpQpRli3Gpjq1Sj7Sri1PEYilJwwdG96kE3eStq4u75uWc2vedm37O6pqMrKm4wjI9s0z+xrTQtNvtB0nRNJ1Pw+z6eNG0vS9L02PXrC/8yS48P2VvCLC0jm1mdUvLbJigTWLOOa6KWTXTty4erXxfNTqVKs7fvfaSqVOTDyjJN4qpZTfIouUajSbtLmipTjTi6nCFH4Yxim7WSV5X+wttdmvSzsm2uC0SZ/C1wus3OqaxqMUEt3FqOmwR2tpa3HhuUi4SCS30+KMahf6NMPN0pxbRTmxiutK8xm1zU7maqWJoYiKwX1elh1iJUX7Z1J1OTGQTpqqp1pSlRoYlSUcXTU+V1OTEylOGGw+Gp1OnKN6nM5cil7qSV4PXltGylKFv3bava8Ek5Sm/WvE0+m2w0LUNCltDrVzcJeeHvsEa3EOpWs0NnDqSzNbSQ28ujXmlJab7ma7gt4rmDSJ7eS4uksrWX1slxywazHA5nTqVMnxWHdDMMN7SFHEUMTQ9vUy7EYP28Z+zx2ExkqloxpSlPC1sww81CliK9SPjZtl9TFvB4vA1KdHNMDW9rg69SM50Z0Kzpwx2FxUaTjKeFxWHik1zJQxNLCYlXnh6cX4nf+IPEkl/cv45ntrnw5q1rNp+sWltLdCz0m0mSa1m2WsslqblrX7U8tybK1gvtQ8NvrVnepLPpkN9qP1WSf2NxLSr5FlGChlOd4apHH8LYmSpyxeOzKh7NrAY7GyhOUpZhSpOGHhUrUcHRzdYZYeFHD4+pQw3gZs8y4dq4bPcXja+ZZdL/ZeI6PvRw2EwFTnccywGCpy5KUMurSi8TaOIxVXLXWnVq1q2FjOrmw6fe6HqPiA3VneajrX+k391ruo3x1TUte0y1WFdFja9LtcvIbDz7OODTrGOwbWNNuJdN0S10bXrPVV+LzD/AGr2Uqtb6rhYw5KeEhR9lSwGN5pfXMLKjaNmqt60Ks51K0sJUw8a9eVanUhT+ypT5Y3pQVZy991FJSdak4p0qkZptNSi7WS5edScY8sk3Xh1TxZeQ+INQj8D63p1ja3d/c6rqNzqNrJdnT9B0nS9NbUrDRh/aMslxB9lnsJo/Jiso/7E1G60hPFF0bew1a/7Pw7VGGKx3tK0YUHhsJBUpKtTrQ54Oc4V3KhzQdLlhyzrTvyfuXOM45/WakeaUMPyxbnz1G5e64tJpJ07Ss+e7uorf3rNPsrDXEOj+GNc8JRXVvrdu+ieJ7bU9Xims0juzDDcTaPqcFvBZz6v/aWmS3nh7X3kgstNg0+/uG0SxWct5GVPFQy7E1o14KdNqvhKmBofw6UJ80eeUqk6lsRQqKOIoxnOrUdejy4iUIpxqaum8RTi03FvlqKpP4m1Z6JJWi1eLaUVyyvFN2tk/FXU9S0K48O/ErRtKuYvhXrlgJdRg1nWNM0pPA99cXmtXPi3Sbtf9LkuLrw/qsVrcQAvNpd1Y6jqUmna/Y6RpVvBefYYHKcJxJltXI8FhKWK4kjjXjMvxuEnU9pmGX0cE1WwqpT5nXqyp0sO8Hh6WHw+Kc3evTxGJrTVH5vG43E5PmFPM8Ti5UsllhY4LGYatCLp4bHVcXBYTGKrCPNRpydatRxlSrUqUElQcJUYU5SqcKkPiS9v4/GOl/DbQbzVovDtjo7/ABBvNUsdOuZvDN1f/wBralZaNbW0WtahrWhWtybLWIYLLXDoN7f/AGm3ttbfVkt7e7+TjlmEUqWHrYqpGdScY/UoqmsV7T2rpzhXnOC+owhyScliIOcZclR4d05e0j9A8TXtKSpRaim/aXfs2uVOLjFSftJO9lyPbmjzXVn0Og3fi+eSZNQ8MHwdBJawxXOq3ev6T4g8V60lsLUR6frFlHoGl2egxPI97PPp9naNZAoskmnaXrctxcnPGVsDRpezozp13GdS2ChGpHBYarKck6sairVKmYTUElGrWryppONNPEUIRiXRjXqT5qkXBOK/eNp1JqytG3KlSXVqMU76+7Jtvr6+eO8ht4IrSaa5t0EVzcTrdT3ILG4mnRUSKSWdi0shgijigtwzlba2hgtoBHbwxRppUrVaqpqpUlNUYKlSi37tOnG7UIR+GCcm5y5UuacpTlecpScqEY81opczblZayb6t7vsr7JJLRJGf4y0nTPHl3oWnJpt7c6/p9+niZYrC+tLJLdls7/wrqGrTz3rx2lpYLpPibUknaZpr0maSfRtP1DVdPiWT2clxGJwVWeOozhh6ShPD1cTU9rpOpTnVpxw7op1frXNRU6Mo2pwqqm8RUpUZSmceNo0sRS+r1YuqpaqlaMlKPwSVRT910mpuM4u7lFtRUnocTrXw88I+IPE2saY0d5rV1pBttV0ib+09U03T9X8P2+vaZr19pNjcy/Z9Hm1NtYsbWXWNRN5dQJEnhnXrxETRoyn2tXGU8RlmHz/LZuhQUqeU8WwjXpV6+WZ7Wp45YLNVQo4iWNo4HMqHtJ3r4WjerHMcDhq9bnhKPx+X14Uc3xvDuNxFGrXip4/IvZqUfa5VB4dVsBW5qfsPruX1pKCjTrTlPDSw2JqUqXLUT7AfDPwp40n1aK8OoRSyXVxfaZpdjqt3p+nXM6wLbatY6xBYyWkWqX1zcLqUrNcQ29ray3dxHBp9pPAsrfGzzjEUb0aWHpYerGPLVqyjN1qvvuomnz2oxlT9nG1JtzinzVZ06jifWrBU3acqk5xvdJOPLG6t/L7zTvvs/spol0/4OQ6/5qqdVgsUWCJRJqd5b2iSWlibBg6Bi99cXEZMVwtws1tFbItjHBb2j3UN5yLMsQ4qMaVFW+JuMmm+llzaab73d23dmjwtJNtzqNvazSdvVRs/LTbQ9A8LX2naRquteH/FEax+FvHDJpviUXkzrYaJq0FtcWun+IpLU7olEy+ToOvXKCNn0r+zrq+uEsNBDR92T4/GKrQjhqtSjjsBW+vZXXoQviKGIp1oV+WnNK6jSqKWJo03eKqOvTpwlWxdpY5hg8NiMPWp4inCvhsTRlhsXRqu9OvQq05U5xnHS/PCXJJqztyttKGnlmoadfeEPHl34H8Vy3VxcwvNP4G1KVjCltpWn6fpMH9mWmpG+fUJvEXm2t/q8F+pTUXsLS7jsHttF8O2CRfTcTYZYjLsLxXkkI4bB4upGjxBgqfv/VuIFVrzxDrUVRVH+zatOph3hKcufDxpYqhSm6mKr4hHiZBiZ0q+IyDMqjrY3AR58BiZ+68bk1SywleMnJyeIpONTDYxpqo8ThqlZqFKpQcvVY/ENpc/8TGTTY4tYRVtNQvptnlm+jgR11HQ9JMcsV0Z0aJ57i/uLa006eZIrZtcurHUrVfiXHA01HESn7V1EqlLB09XFKTjKniqzcfY8sk/Z+zjUq16cedxwqq06j+lXtm3TS5Urp1Hs76pwVnzXW6bSi3a87NHITSx26GSZxGisqEtx87usccaj7zSSSMsUcagvJIyxorOyqfOhCdSShCLlJ3tFK70TbfkopNyb0STbaSbOltJXbsu46GOKO40tvFE8nh221W7mtNK8NTIT4s8Uo1rJLHcW8VneG58NafFCj31zLfQDWILOG5N7beHp7QvJ2VoYbAYbE4mtUhX+q0I4itWhNLCYO01HkqurS5MXVqTtQpQpS9jWrShDDzxzqxgcOIxlKhD2laaoU+ZxvU+Oq7NpU4xk5Xt73KouolrKNOzZeWxmv7G2sZIRoPh5bK1RPCdl5bSebHK82/xFrfn3dzr16hFq0zLcLBLerqD3lxrUV95g/P8742r4ipVpZdpatUf9oO8XUg4qK+pYX2dGGCpNuo4SnB1lTWFnQp5bVpSpv5LGZ1Vqv2eFToUVZNy1rVUulSd3aLVk4xk5O8lOpNSssbxDoc1/a6bqWjJBa+KvB00t54eYRxRW8sy2jQy6Jcn5QNB1238mK6tfM+zJJFYXVxDPJpiQVv4ecaLhDP6s8xjWxvC/EdD+yuKsCpynUxGV4mtGc8bQUrp5vlFdfXcBXajUdanUoRq06GNrSl8nm+BrV6dDEZfUjQzLAVoZhlGJkm40sVSuvY1rWcsPiIOeDxlPVTo1JSUW1TZNHqtvILDxNpskVjYXk4tLm0+7PoXim11OW0vba+nBaM3TarPBo1wZFtTLqCaNdn+0NS8WymH9V4gySeV4yphIVlj4woUcyyvNKL5sPnXDeKw1KvlmZYTrKlHB8taSi6zpUZ1aVR0o5dUR+i8O55Qz3LMPmFODw7quWHxuCqP97l+aUZunjMFW2tONa6i2oKqvZ1oKUcRBnsNv48sb7QU1HT3SSSaz1MRXdvANTs/7S07fbzRWtjbXlte6wsd8GSVLKWG0ElveabPq1nqsQtm8qnhakalKGIp1I1ZSoN4R3oYiVGraSqOdWnKlhac6bUo1q6so1aNb2U6E+devKSfM4NOK5l7T4oJx0taL5ptPRxh1jKN1JWOV8UeGdVnsb/U5EtbeO/NrFq8nkWt/rGp6WskTSWOqSXmmrbJplwEktrrTIbX7LHa38lzaW2k6xA2pNUsX7GMXFKUoNzhRhKpTwuGrcrhDEwdOsqmJxNNuE4VasuSM6UYVI4uhZDjBSdm3Zqzk7OU43u4PmjaEJK6cYq7Um04SKmp6c3xL8FtowvvsfxE8CWctx4avYbs3Ot6t4Ps47C2TVcanG6Xeo+Hbu7tdN1BbyTVrW7SHQtQ8Qm4ttWu9Lf6zh7NsNCOIjmFH2+TZpTpYPPaMqKVHD4u+IngcbRVCUJU3S5alROisNV+p1sywuD9nPD0sTH57O8vxDlh8ZgJcmZ5dUnXwH7xxeJw8/Zxx2XVnKLUqeKhGHJz88KeNo4PE1ObllTlwPhe91PxRbW8NjpMt1rkfk22s2NqzpZaRevB5jy3d7fx2j2+mTEGawkuLZNUvLU/utKa+hurG3+ezfhzE5NmeLwOLnGjRoVJ+xxNTlksTR5/3csOqEq0MRUlBxcvYVKmHi2pfWfYTp1p+xl+a4bM8DhsdhZOpDEU1NR5ZQlTla04VY1FGdGUJqUJwqxjVhOMoSpqpGUF9C/FT4S6x8PfEmp6n4c0+5vLLU7yfWNK8aa1ZWOraf4KN2Li3bQdC0mwh02HTrhUu72KO/uiLm4sL17V7+5s7ax0mz5uMMTU4dpvFwwFSthMRKpCSwXtqcKknUp1r5piZfWFShCfsVQp8vJXeH5qNOjiJ4nFHj1c49jh4Wpzq4hJJOok6NJxjyc/u8sm5JyfKuWT5pRdTkjCJ5ebTyfNnhaeW5e4lvJXuLme4kuppkijuFeW5lkZRMkEQVVZIY5YoXCbUKn8GxmaYvM63PjqvOnFU4RjCMKdCKk5QdOnBJXi5PnnLmq1YuXtKk5y5z56ri62KqSliaspqo+rfLSfR04L3YKOzUVrFyXxS5i3G6yIsiHKuAQeQeexB5BHRlIBUgggEEV50ouLcXo07P8A4D2afRrRrVHLKLi3GSs07Nf1unumtGtVoQT/ALphdDoi7Lgf3oMk7zxktbktIvP+racAFnXGlP306T3bvT8qlrcvpUSUX/eUHdJO+kPfTpPq70/KdrcvpUSUX/eUHsnfhryVPC3iN2jmSz8MeNLea01sWgeOXRPEsonj0/xOBFZy28FlrVvc3uleIb+5u7LypE0+6tor2/nmntf6D8Oc5nxZw3LgzGOpW4i4bnVzLgivVhKu8fl9/b5xwlKN5zqSouP9sZPRVCpTgv7WoVq2HpVMPF+ZhMW+HM6eZuXs8lzd0sJnycoU6eDxaSo5dnDnOUFDXly/GcsuepCeFqxhN4Zp9FoN3feH/ECtq15qOr6ppKCznvtUgsra6vdMu22tNDa6f5enwHzbSWweS3gtkN5pMtvEi6fBapSx1aTtUoU6eHweKk6nsKM6tRRq0m4zpV61dyrVatLn54qpVqKFOvTlBr2jP1ynBNNSblVgrc8lGN1JJqUYxSioytZtRTbi09j6Mjkt722WRCk9tdQhgcZSWGVOhUjoythlYAjlWAORXJo13TDb5HgWq3l54K8W203hy4Nxq2kXtlex28E0DINNupYVvdL14SuYYbHUtOmmtriKeKe9e0b+19Isbm/sbVoerCKeEmq9eHLhK8KsFKpGdq1oys8NyrmqVaFWMWnGUaPtFGhiqtOhXmplS1aDgnepFxfutXi7r4v5VKL7OVryhFyirfQ/wt+F/wDbPj2Hx54YsHh+Hni+wt9W1Q38tzY3Wm32n3Vy0mhJprkrPcy6jPch3WGFLJBqt613cTavBHX6EvZ57lGX0MdOX1vIsRTpYXERhCtTzLKasFKlRniVFTVbLfYxw0ak5zdfAVsBh1Cj/ZqVT42NKtlGZ454WMZYDNadTE1qTnyyy/NYyjGtVp0nJp0MzhUeInTpxiqOOoYqvJ1HmEnD7ou/+PS6/wCveb/0W1duI/gVv+vVT/0iRm9n6Hy1e/8AH5d/9fM//o16/HK/8et/19qf+ls5Hu/UoQfcb/rtcf8ApRLUz+Jf4Kf/AKbiVP4l/gp/+m4kp6H6VBK3PPG/13jf/rw0v/0zxV93w1/yPODP+xu//VgcOcf8i3NP+veI/wDTSOy1T/kLw/8AXjJ/6I0auzEfBX/7DZ/+kyPscP8ABR/68Q/KJ3Wk/wDIOtf9xv8A0Y9csdkaPd+pR1r/AF2mf9fJ/wDQ4aPtQ/xL80P7MvT9GfSdl/x52n/XtB/6KSvrofBH/DH8keLL4pf4n+YA/9k=", Kl = "data:image/jpeg;base64,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", ql = "data:image/jpeg;base64,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", Jl = "data:image/jpeg;base64,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", Yl = (/* @__PURE__ */ $(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? r(e) : typeof define == "function" && define.amd ? define(["exports"], r) : (n = typeof globalThis < "u" ? globalThis : n || self, r(n.leaflet = {}));
	})(e, (function(e) {
		var t = "1.9.4";
		function n(e) {
			for (var t, n = 1, r = arguments.length, i; n < r; n++) for (t in i = arguments[n], i) e[t] = i[t];
			return e;
		}
		var r = Object.create || (function() {
			function e() {}
			return function(t) {
				return e.prototype = t, new e();
			};
		})();
		function i(e, t) {
			var n = Array.prototype.slice;
			if (e.bind) return e.bind.apply(e, n.call(arguments, 1));
			var r = n.call(arguments, 2);
			return function() {
				return e.apply(t, r.length ? r.concat(n.call(arguments)) : arguments);
			};
		}
		var a = 0;
		function o(e) {
			return "_leaflet_id" in e || (e._leaflet_id = ++a), e._leaflet_id;
		}
		function s(e, t, n) {
			var r, i, a, o = function() {
				r = !1, i &&= (a.apply(n, i), !1);
			};
			return a = function() {
				r ? i = arguments : (e.apply(n, arguments), setTimeout(o, t), r = !0);
			}, a;
		}
		function c(e, t, n) {
			var r = t[1], i = t[0], a = r - i;
			return e === r && n ? e : ((e - i) % a + a) % a + i;
		}
		function l() {
			return !1;
		}
		function u(e, t) {
			if (t === !1) return e;
			var n = 10 ** (t === void 0 ? 6 : t);
			return Math.round(e * n) / n;
		}
		function d(e) {
			return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
		}
		function f(e) {
			return d(e).split(/\s+/);
		}
		function p(e, t) {
			for (var n in Object.prototype.hasOwnProperty.call(e, "options") || (e.options = e.options ? r(e.options) : {}), t) e.options[n] = t[n];
			return e.options;
		}
		function m(e, t, n) {
			var r = [];
			for (var i in e) r.push(encodeURIComponent(n ? i.toUpperCase() : i) + "=" + encodeURIComponent(e[i]));
			return (!t || t.indexOf("?") === -1 ? "?" : "&") + r.join("&");
		}
		var h = /\{ *([\w_ -]+) *\}/g;
		function g(e, t) {
			return e.replace(h, function(e, n) {
				var r = t[n];
				if (r === void 0) throw Error("No value provided for variable " + e);
				return typeof r == "function" && (r = r(t)), r;
			});
		}
		var _ = Array.isArray || function(e) {
			return Object.prototype.toString.call(e) === "[object Array]";
		};
		function v(e, t) {
			for (var n = 0; n < e.length; n++) if (e[n] === t) return n;
			return -1;
		}
		var y = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
		function b(e) {
			return window["webkit" + e] || window["moz" + e] || window["ms" + e];
		}
		var x = 0;
		function S(e) {
			var t = +/* @__PURE__ */ new Date(), n = Math.max(0, 16 - (t - x));
			return x = t + n, window.setTimeout(e, n);
		}
		var C = window.requestAnimationFrame || b("RequestAnimationFrame") || S, w = window.cancelAnimationFrame || b("CancelAnimationFrame") || b("CancelRequestAnimationFrame") || function(e) {
			window.clearTimeout(e);
		};
		function T(e, t, n) {
			if (n && C === S) e.call(t);
			else return C.call(window, i(e, t));
		}
		function E(e) {
			e && w.call(window, e);
		}
		var D = {
			__proto__: null,
			extend: n,
			create: r,
			bind: i,
			get lastId() {
				return a;
			},
			stamp: o,
			throttle: s,
			wrapNum: c,
			falseFn: l,
			formatNum: u,
			trim: d,
			splitWords: f,
			setOptions: p,
			getParamString: m,
			template: g,
			isArray: _,
			indexOf: v,
			emptyImageUrl: y,
			requestFn: C,
			cancelFn: w,
			requestAnimFrame: T,
			cancelAnimFrame: E
		};
		function O() {}
		O.extend = function(e) {
			var t = function() {
				p(this), this.initialize && this.initialize.apply(this, arguments), this.callInitHooks();
			}, i = t.__super__ = this.prototype, a = r(i);
			for (var o in a.constructor = t, t.prototype = a, this) Object.prototype.hasOwnProperty.call(this, o) && o !== "prototype" && o !== "__super__" && (t[o] = this[o]);
			return e.statics && n(t, e.statics), e.includes && (k(e.includes), n.apply(null, [a].concat(e.includes))), n(a, e), delete a.statics, delete a.includes, a.options && (a.options = i.options ? r(i.options) : {}, n(a.options, e.options)), a._initHooks = [], a.callInitHooks = function() {
				if (!this._initHooksCalled) {
					i.callInitHooks && i.callInitHooks.call(this), this._initHooksCalled = !0;
					for (var e = 0, t = a._initHooks.length; e < t; e++) a._initHooks[e].call(this);
				}
			}, t;
		}, O.include = function(e) {
			var t = this.prototype.options;
			return n(this.prototype, e), e.options && (this.prototype.options = t, this.mergeOptions(e.options)), this;
		}, O.mergeOptions = function(e) {
			return n(this.prototype.options, e), this;
		}, O.addInitHook = function(e) {
			var t = Array.prototype.slice.call(arguments, 1), n = typeof e == "function" ? e : function() {
				this[e].apply(this, t);
			};
			return this.prototype._initHooks = this.prototype._initHooks || [], this.prototype._initHooks.push(n), this;
		};
		function k(e) {
			if (typeof L < "u" && L && L.Mixin) {
				e = _(e) ? e : [e];
				for (var t = 0; t < e.length; t++) e[t] === L.Mixin.Events && console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", (/* @__PURE__ */ Error()).stack);
			}
		}
		var A = {
			on: function(e, t, n) {
				if (typeof e == "object") for (var r in e) this._on(r, e[r], t);
				else {
					e = f(e);
					for (var i = 0, a = e.length; i < a; i++) this._on(e[i], t, n);
				}
				return this;
			},
			off: function(e, t, n) {
				if (!arguments.length) delete this._events;
				else if (typeof e == "object") for (var r in e) this._off(r, e[r], t);
				else {
					e = f(e);
					for (var i = arguments.length === 1, a = 0, o = e.length; a < o; a++) i ? this._off(e[a]) : this._off(e[a], t, n);
				}
				return this;
			},
			_on: function(e, t, n, r) {
				if (typeof t != "function") {
					console.warn("wrong listener type: " + typeof t);
					return;
				}
				if (this._listens(e, t, n) === !1) {
					n === this && (n = void 0);
					var i = {
						fn: t,
						ctx: n
					};
					r && (i.once = !0), this._events = this._events || {}, this._events[e] = this._events[e] || [], this._events[e].push(i);
				}
			},
			_off: function(e, t, n) {
				var r, i, a;
				if (this._events && (r = this._events[e], r)) {
					if (arguments.length === 1) {
						if (this._firingCount) for (i = 0, a = r.length; i < a; i++) r[i].fn = l;
						delete this._events[e];
						return;
					}
					if (typeof t != "function") {
						console.warn("wrong listener type: " + typeof t);
						return;
					}
					var o = this._listens(e, t, n);
					if (o !== !1) {
						var s = r[o];
						this._firingCount && (s.fn = l, this._events[e] = r = r.slice()), r.splice(o, 1);
					}
				}
			},
			fire: function(e, t, r) {
				if (!this.listens(e, r)) return this;
				var i = n({}, t, {
					type: e,
					target: this,
					sourceTarget: t && t.sourceTarget || this
				});
				if (this._events) {
					var a = this._events[e];
					if (a) {
						this._firingCount = this._firingCount + 1 || 1;
						for (var o = 0, s = a.length; o < s; o++) {
							var c = a[o], l = c.fn;
							c.once && this.off(e, l, c.ctx), l.call(c.ctx || this, i);
						}
						this._firingCount--;
					}
				}
				return r && this._propagateEvent(i), this;
			},
			listens: function(e, t, n, r) {
				typeof e != "string" && console.warn("\"string\" type argument expected");
				var i = t;
				typeof t != "function" && (r = !!t, i = void 0, n = void 0);
				var a = this._events && this._events[e];
				if (a && a.length && this._listens(e, i, n) !== !1) return !0;
				if (r) {
					for (var o in this._eventParents) if (this._eventParents[o].listens(e, t, n, r)) return !0;
				}
				return !1;
			},
			_listens: function(e, t, n) {
				if (!this._events) return !1;
				var r = this._events[e] || [];
				if (!t) return !!r.length;
				n === this && (n = void 0);
				for (var i = 0, a = r.length; i < a; i++) if (r[i].fn === t && r[i].ctx === n) return i;
				return !1;
			},
			once: function(e, t, n) {
				if (typeof e == "object") for (var r in e) this._on(r, e[r], t, !0);
				else {
					e = f(e);
					for (var i = 0, a = e.length; i < a; i++) this._on(e[i], t, n, !0);
				}
				return this;
			},
			addEventParent: function(e) {
				return this._eventParents = this._eventParents || {}, this._eventParents[o(e)] = e, this;
			},
			removeEventParent: function(e) {
				return this._eventParents && delete this._eventParents[o(e)], this;
			},
			_propagateEvent: function(e) {
				for (var t in this._eventParents) this._eventParents[t].fire(e.type, n({
					layer: e.target,
					propagatedFrom: e.target
				}, e), !0);
			}
		};
		A.addEventListener = A.on, A.removeEventListener = A.clearAllEventListeners = A.off, A.addOneTimeEventListener = A.once, A.fireEvent = A.fire, A.hasEventListeners = A.listens;
		var j = O.extend(A);
		function M(e, t, n) {
			this.x = n ? Math.round(e) : e, this.y = n ? Math.round(t) : t;
		}
		var N = Math.trunc || function(e) {
			return e > 0 ? Math.floor(e) : Math.ceil(e);
		};
		M.prototype = {
			clone: function() {
				return new M(this.x, this.y);
			},
			add: function(e) {
				return this.clone()._add(P(e));
			},
			_add: function(e) {
				return this.x += e.x, this.y += e.y, this;
			},
			subtract: function(e) {
				return this.clone()._subtract(P(e));
			},
			_subtract: function(e) {
				return this.x -= e.x, this.y -= e.y, this;
			},
			divideBy: function(e) {
				return this.clone()._divideBy(e);
			},
			_divideBy: function(e) {
				return this.x /= e, this.y /= e, this;
			},
			multiplyBy: function(e) {
				return this.clone()._multiplyBy(e);
			},
			_multiplyBy: function(e) {
				return this.x *= e, this.y *= e, this;
			},
			scaleBy: function(e) {
				return new M(this.x * e.x, this.y * e.y);
			},
			unscaleBy: function(e) {
				return new M(this.x / e.x, this.y / e.y);
			},
			round: function() {
				return this.clone()._round();
			},
			_round: function() {
				return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
			},
			floor: function() {
				return this.clone()._floor();
			},
			_floor: function() {
				return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
			},
			ceil: function() {
				return this.clone()._ceil();
			},
			_ceil: function() {
				return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
			},
			trunc: function() {
				return this.clone()._trunc();
			},
			_trunc: function() {
				return this.x = N(this.x), this.y = N(this.y), this;
			},
			distanceTo: function(e) {
				e = P(e);
				var t = e.x - this.x, n = e.y - this.y;
				return Math.sqrt(t * t + n * n);
			},
			equals: function(e) {
				return e = P(e), e.x === this.x && e.y === this.y;
			},
			contains: function(e) {
				return e = P(e), Math.abs(e.x) <= Math.abs(this.x) && Math.abs(e.y) <= Math.abs(this.y);
			},
			toString: function() {
				return "Point(" + u(this.x) + ", " + u(this.y) + ")";
			}
		};
		function P(e, t, n) {
			return e instanceof M ? e : _(e) ? new M(e[0], e[1]) : e == null ? e : typeof e == "object" && "x" in e && "y" in e ? new M(e.x, e.y) : new M(e, t, n);
		}
		function F(e, t) {
			if (e) for (var n = t ? [e, t] : e, r = 0, i = n.length; r < i; r++) this.extend(n[r]);
		}
		F.prototype = {
			extend: function(e) {
				var t, n;
				if (!e) return this;
				if (e instanceof M || typeof e[0] == "number" || "x" in e) t = n = P(e);
				else if (e = I(e), t = e.min, n = e.max, !t || !n) return this;
				return !this.min && !this.max ? (this.min = t.clone(), this.max = n.clone()) : (this.min.x = Math.min(t.x, this.min.x), this.max.x = Math.max(n.x, this.max.x), this.min.y = Math.min(t.y, this.min.y), this.max.y = Math.max(n.y, this.max.y)), this;
			},
			getCenter: function(e) {
				return P((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, e);
			},
			getBottomLeft: function() {
				return P(this.min.x, this.max.y);
			},
			getTopRight: function() {
				return P(this.max.x, this.min.y);
			},
			getTopLeft: function() {
				return this.min;
			},
			getBottomRight: function() {
				return this.max;
			},
			getSize: function() {
				return this.max.subtract(this.min);
			},
			contains: function(e) {
				var t, n;
				return e = typeof e[0] == "number" || e instanceof M ? P(e) : I(e), e instanceof F ? (t = e.min, n = e.max) : t = n = e, t.x >= this.min.x && n.x <= this.max.x && t.y >= this.min.y && n.y <= this.max.y;
			},
			intersects: function(e) {
				e = I(e);
				var t = this.min, n = this.max, r = e.min, i = e.max, a = i.x >= t.x && r.x <= n.x, o = i.y >= t.y && r.y <= n.y;
				return a && o;
			},
			overlaps: function(e) {
				e = I(e);
				var t = this.min, n = this.max, r = e.min, i = e.max, a = i.x > t.x && r.x < n.x, o = i.y > t.y && r.y < n.y;
				return a && o;
			},
			isValid: function() {
				return !!(this.min && this.max);
			},
			pad: function(e) {
				var t = this.min, n = this.max, r = Math.abs(t.x - n.x) * e, i = Math.abs(t.y - n.y) * e;
				return I(P(t.x - r, t.y - i), P(n.x + r, n.y + i));
			},
			equals: function(e) {
				return e ? (e = I(e), this.min.equals(e.getTopLeft()) && this.max.equals(e.getBottomRight())) : !1;
			}
		};
		function I(e, t) {
			return !e || e instanceof F ? e : new F(e, t);
		}
		function R(e, t) {
			if (e) for (var n = t ? [e, t] : e, r = 0, i = n.length; r < i; r++) this.extend(n[r]);
		}
		R.prototype = {
			extend: function(e) {
				var t = this._southWest, n = this._northEast, r, i;
				if (e instanceof B) r = e, i = e;
				else if (e instanceof R) {
					if (r = e._southWest, i = e._northEast, !r || !i) return this;
				} else return e ? this.extend(V(e) || z(e)) : this;
				return !t && !n ? (this._southWest = new B(r.lat, r.lng), this._northEast = new B(i.lat, i.lng)) : (t.lat = Math.min(r.lat, t.lat), t.lng = Math.min(r.lng, t.lng), n.lat = Math.max(i.lat, n.lat), n.lng = Math.max(i.lng, n.lng)), this;
			},
			pad: function(e) {
				var t = this._southWest, n = this._northEast, r = Math.abs(t.lat - n.lat) * e, i = Math.abs(t.lng - n.lng) * e;
				return new R(new B(t.lat - r, t.lng - i), new B(n.lat + r, n.lng + i));
			},
			getCenter: function() {
				return new B((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
			},
			getSouthWest: function() {
				return this._southWest;
			},
			getNorthEast: function() {
				return this._northEast;
			},
			getNorthWest: function() {
				return new B(this.getNorth(), this.getWest());
			},
			getSouthEast: function() {
				return new B(this.getSouth(), this.getEast());
			},
			getWest: function() {
				return this._southWest.lng;
			},
			getSouth: function() {
				return this._southWest.lat;
			},
			getEast: function() {
				return this._northEast.lng;
			},
			getNorth: function() {
				return this._northEast.lat;
			},
			contains: function(e) {
				e = typeof e[0] == "number" || e instanceof B || "lat" in e ? V(e) : z(e);
				var t = this._southWest, n = this._northEast, r, i;
				return e instanceof R ? (r = e.getSouthWest(), i = e.getNorthEast()) : r = i = e, r.lat >= t.lat && i.lat <= n.lat && r.lng >= t.lng && i.lng <= n.lng;
			},
			intersects: function(e) {
				e = z(e);
				var t = this._southWest, n = this._northEast, r = e.getSouthWest(), i = e.getNorthEast(), a = i.lat >= t.lat && r.lat <= n.lat, o = i.lng >= t.lng && r.lng <= n.lng;
				return a && o;
			},
			overlaps: function(e) {
				e = z(e);
				var t = this._southWest, n = this._northEast, r = e.getSouthWest(), i = e.getNorthEast(), a = i.lat > t.lat && r.lat < n.lat, o = i.lng > t.lng && r.lng < n.lng;
				return a && o;
			},
			toBBoxString: function() {
				return [
					this.getWest(),
					this.getSouth(),
					this.getEast(),
					this.getNorth()
				].join(",");
			},
			equals: function(e, t) {
				return e ? (e = z(e), this._southWest.equals(e.getSouthWest(), t) && this._northEast.equals(e.getNorthEast(), t)) : !1;
			},
			isValid: function() {
				return !!(this._southWest && this._northEast);
			}
		};
		function z(e, t) {
			return e instanceof R ? e : new R(e, t);
		}
		function B(e, t, n) {
			if (isNaN(e) || isNaN(t)) throw Error("Invalid LatLng object: (" + e + ", " + t + ")");
			this.lat = +e, this.lng = +t, n !== void 0 && (this.alt = +n);
		}
		B.prototype = {
			equals: function(e, t) {
				return e ? (e = V(e), Math.max(Math.abs(this.lat - e.lat), Math.abs(this.lng - e.lng)) <= (t === void 0 ? 1e-9 : t)) : !1;
			},
			toString: function(e) {
				return "LatLng(" + u(this.lat, e) + ", " + u(this.lng, e) + ")";
			},
			distanceTo: function(e) {
				return te.distance(this, V(e));
			},
			wrap: function() {
				return te.wrapLatLng(this);
			},
			toBounds: function(e) {
				var t = 180 * e / 40075017, n = t / Math.cos(Math.PI / 180 * this.lat);
				return z([this.lat - t, this.lng - n], [this.lat + t, this.lng + n]);
			},
			clone: function() {
				return new B(this.lat, this.lng, this.alt);
			}
		};
		function V(e, t, n) {
			return e instanceof B ? e : _(e) && typeof e[0] != "object" ? e.length === 3 ? new B(e[0], e[1], e[2]) : e.length === 2 ? new B(e[0], e[1]) : null : e == null ? e : typeof e == "object" && "lat" in e ? new B(e.lat, "lng" in e ? e.lng : e.lon, e.alt) : t === void 0 ? null : new B(e, t, n);
		}
		var ee = {
			latLngToPoint: function(e, t) {
				var n = this.projection.project(e), r = this.scale(t);
				return this.transformation._transform(n, r);
			},
			pointToLatLng: function(e, t) {
				var n = this.scale(t), r = this.transformation.untransform(e, n);
				return this.projection.unproject(r);
			},
			project: function(e) {
				return this.projection.project(e);
			},
			unproject: function(e) {
				return this.projection.unproject(e);
			},
			scale: function(e) {
				return 256 * 2 ** e;
			},
			zoom: function(e) {
				return Math.log(e / 256) / Math.LN2;
			},
			getProjectedBounds: function(e) {
				if (this.infinite) return null;
				var t = this.projection.bounds, n = this.scale(e);
				return new F(this.transformation.transform(t.min, n), this.transformation.transform(t.max, n));
			},
			infinite: !1,
			wrapLatLng: function(e) {
				var t = this.wrapLng ? c(e.lng, this.wrapLng, !0) : e.lng, n = this.wrapLat ? c(e.lat, this.wrapLat, !0) : e.lat, r = e.alt;
				return new B(n, t, r);
			},
			wrapLatLngBounds: function(e) {
				var t = e.getCenter(), n = this.wrapLatLng(t), r = t.lat - n.lat, i = t.lng - n.lng;
				if (r === 0 && i === 0) return e;
				var a = e.getSouthWest(), o = e.getNorthEast();
				return new R(new B(a.lat - r, a.lng - i), new B(o.lat - r, o.lng - i));
			}
		}, te = n({}, ee, {
			wrapLng: [-180, 180],
			R: 6371e3,
			distance: function(e, t) {
				var n = Math.PI / 180, r = e.lat * n, i = t.lat * n, a = Math.sin((t.lat - e.lat) * n / 2), o = Math.sin((t.lng - e.lng) * n / 2), s = a * a + Math.cos(r) * Math.cos(i) * o * o, c = 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
				return this.R * c;
			}
		}), ne = 6378137, re = {
			R: ne,
			MAX_LATITUDE: 85.0511287798,
			project: function(e) {
				var t = Math.PI / 180, n = this.MAX_LATITUDE, r = Math.max(Math.min(n, e.lat), -n), i = Math.sin(r * t);
				return new M(this.R * e.lng * t, this.R * Math.log((1 + i) / (1 - i)) / 2);
			},
			unproject: function(e) {
				var t = 180 / Math.PI;
				return new B((2 * Math.atan(Math.exp(e.y / this.R)) - Math.PI / 2) * t, e.x * t / this.R);
			},
			bounds: (function() {
				var e = ne * Math.PI;
				return new F([-e, -e], [e, e]);
			})()
		};
		function ie(e, t, n, r) {
			if (_(e)) {
				this._a = e[0], this._b = e[1], this._c = e[2], this._d = e[3];
				return;
			}
			this._a = e, this._b = t, this._c = n, this._d = r;
		}
		ie.prototype = {
			transform: function(e, t) {
				return this._transform(e.clone(), t);
			},
			_transform: function(e, t) {
				return t ||= 1, e.x = t * (this._a * e.x + this._b), e.y = t * (this._c * e.y + this._d), e;
			},
			untransform: function(e, t) {
				return t ||= 1, new M((e.x / t - this._b) / this._a, (e.y / t - this._d) / this._c);
			}
		};
		function ae(e, t, n, r) {
			return new ie(e, t, n, r);
		}
		var oe = n({}, te, {
			code: "EPSG:3857",
			projection: re,
			transformation: function() {
				var e = .5 / (Math.PI * re.R);
				return ae(e, .5, -e, .5);
			}()
		}), H = n({}, oe, { code: "EPSG:900913" });
		function U(e) {
			return document.createElementNS("http://www.w3.org/2000/svg", e);
		}
		function se(e, t) {
			for (var n = "", r = 0, i, a = e.length, o, s, c; r < a; r++) {
				for (s = e[r], i = 0, o = s.length; i < o; i++) c = s[i], n += (i ? "L" : "M") + c.x + " " + c.y;
				n += t ? q.svg ? "z" : "x" : "";
			}
			return n || "M0 0";
		}
		var ce = document.documentElement.style, le = "ActiveXObject" in window, W = le && !document.addEventListener, G = "msLaunchUri" in navigator && !("documentMode" in document), K = He("webkit"), ue = He("android"), de = He("android 2") || He("android 3"), fe = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10), pe = ue && He("Google") && fe < 537 && !("AudioNode" in window), me = !!window.opera, he = !G && He("chrome"), ge = He("gecko") && !K && !me && !le, _e = !he && He("safari"), ve = He("phantom"), ye = "OTransition" in ce, be = navigator.platform.indexOf("Win") === 0, xe = le && "transition" in ce, Se = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !de, Ce = "MozPerspective" in ce, we = !window.L_DISABLE_3D && (xe || Se || Ce) && !ye && !ve, Te = typeof orientation < "u" || He("mobile"), Ee = Te && K, De = Te && Se, Oe = !window.PointerEvent && window.MSPointerEvent, ke = !!(window.PointerEvent || Oe), Ae = "ontouchstart" in window || !!window.TouchEvent, je = !window.L_NO_TOUCH && (Ae || ke), Me = Te && me, Ne = Te && ge, Pe = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1, Fe = function() {
			var e = !1;
			try {
				var t = Object.defineProperty({}, "passive", { get: function() {
					e = !0;
				} });
				window.addEventListener("testPassiveEventSupport", l, t), window.removeEventListener("testPassiveEventSupport", l, t);
			} catch {}
			return e;
		}(), Ie = function() {
			return !!document.createElement("canvas").getContext;
		}(), Le = !!(document.createElementNS && U("svg").createSVGRect), Re = !!Le && (function() {
			var e = document.createElement("div");
			return e.innerHTML = "<svg/>", (e.firstChild && e.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
		})(), ze = !Le && function() {
			try {
				var e = document.createElement("div");
				e.innerHTML = "<v:shape adj=\"1\"/>";
				var t = e.firstChild;
				return t.style.behavior = "url(#default#VML)", t && typeof t.adj == "object";
			} catch {
				return !1;
			}
		}(), Be = navigator.platform.indexOf("Mac") === 0, Ve = navigator.platform.indexOf("Linux") === 0;
		function He(e) {
			return navigator.userAgent.toLowerCase().indexOf(e) >= 0;
		}
		var q = {
			ie: le,
			ielt9: W,
			edge: G,
			webkit: K,
			android: ue,
			android23: de,
			androidStock: pe,
			opera: me,
			chrome: he,
			gecko: ge,
			safari: _e,
			phantom: ve,
			opera12: ye,
			win: be,
			ie3d: xe,
			webkit3d: Se,
			gecko3d: Ce,
			any3d: we,
			mobile: Te,
			mobileWebkit: Ee,
			mobileWebkit3d: De,
			msPointer: Oe,
			pointer: ke,
			touch: je,
			touchNative: Ae,
			mobileOpera: Me,
			mobileGecko: Ne,
			retina: Pe,
			passiveEvents: Fe,
			canvas: Ie,
			svg: Le,
			vml: ze,
			inlineSvg: Re,
			mac: Be,
			linux: Ve
		}, Ue = q.msPointer ? "MSPointerDown" : "pointerdown", We = q.msPointer ? "MSPointerMove" : "pointermove", Ge = q.msPointer ? "MSPointerUp" : "pointerup", Ke = q.msPointer ? "MSPointerCancel" : "pointercancel", qe = {
			touchstart: Ue,
			touchmove: We,
			touchend: Ge,
			touchcancel: Ke
		}, Je = {
			touchstart: it,
			touchmove: rt,
			touchend: rt,
			touchcancel: rt
		}, Ye = {}, Xe = !1;
		function Ze(e, t, n) {
			return t === "touchstart" && nt(), Je[t] ? (n = Je[t].bind(this, n), e.addEventListener(qe[t], n, !1), n) : (console.warn("wrong event specified:", t), l);
		}
		function Qe(e, t, n) {
			if (!qe[t]) {
				console.warn("wrong event specified:", t);
				return;
			}
			e.removeEventListener(qe[t], n, !1);
		}
		function $e(e) {
			Ye[e.pointerId] = e;
		}
		function et(e) {
			Ye[e.pointerId] && (Ye[e.pointerId] = e);
		}
		function tt(e) {
			delete Ye[e.pointerId];
		}
		function nt() {
			Xe ||= (document.addEventListener(Ue, $e, !0), document.addEventListener(We, et, !0), document.addEventListener(Ge, tt, !0), document.addEventListener(Ke, tt, !0), !0);
		}
		function rt(e, t) {
			if (t.pointerType !== (t.MSPOINTER_TYPE_MOUSE || "mouse")) {
				for (var n in t.touches = [], Ye) t.touches.push(Ye[n]);
				t.changedTouches = [t], e(t);
			}
		}
		function it(e, t) {
			t.MSPOINTER_TYPE_TOUCH && t.pointerType === t.MSPOINTER_TYPE_TOUCH && Jt(t), rt(e, t);
		}
		function at(e) {
			var t = {}, n, r;
			for (r in e) n = e[r], t[r] = n && n.bind ? n.bind(e) : n;
			return e = t, t.type = "dblclick", t.detail = 2, t.isTrusted = !1, t._simulated = !0, t;
		}
		var ot = 200;
		function st(e, t) {
			e.addEventListener("dblclick", t);
			var n = 0, r;
			function i(e) {
				if (e.detail !== 1) {
					r = e.detail;
					return;
				}
				if (!(e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents)) {
					var i = Xt(e);
					if (!i.some(function(e) {
						return e instanceof HTMLLabelElement && e.attributes.for;
					}) || i.some(function(e) {
						return e instanceof HTMLInputElement || e instanceof HTMLSelectElement;
					})) {
						var a = Date.now();
						a - n <= ot ? (r++, r === 2 && t(at(e))) : r = 1, n = a;
					}
				}
			}
			return e.addEventListener("click", i), {
				dblclick: t,
				simDblclick: i
			};
		}
		function ct(e, t) {
			e.removeEventListener("dblclick", t.dblclick), e.removeEventListener("click", t.simDblclick);
		}
		var lt = St([
			"transform",
			"webkitTransform",
			"OTransform",
			"MozTransform",
			"msTransform"
		]), ut = St([
			"webkitTransition",
			"transition",
			"OTransition",
			"MozTransition",
			"msTransition"
		]), dt = ut === "webkitTransition" || ut === "OTransition" ? ut + "End" : "transitionend";
		function ft(e) {
			return typeof e == "string" ? document.getElementById(e) : e;
		}
		function pt(e, t) {
			var n = e.style[t] || e.currentStyle && e.currentStyle[t];
			if ((!n || n === "auto") && document.defaultView) {
				var r = document.defaultView.getComputedStyle(e, null);
				n = r ? r[t] : null;
			}
			return n === "auto" ? null : n;
		}
		function J(e, t, n) {
			var r = document.createElement(e);
			return r.className = t || "", n && n.appendChild(r), r;
		}
		function mt(e) {
			var t = e.parentNode;
			t && t.removeChild(e);
		}
		function ht(e) {
			for (; e.firstChild;) e.removeChild(e.firstChild);
		}
		function Y(e) {
			var t = e.parentNode;
			t && t.lastChild !== e && t.appendChild(e);
		}
		function gt(e) {
			var t = e.parentNode;
			t && t.firstChild !== e && t.insertBefore(e, t.firstChild);
		}
		function _t(e, t) {
			if (e.classList !== void 0) return e.classList.contains(t);
			var n = yt(e);
			return n.length > 0 && RegExp("(^|\\s)" + t + "(\\s|$)").test(n);
		}
		function X(e, t) {
			if (e.classList !== void 0) for (var n = f(t), r = 0, i = n.length; r < i; r++) e.classList.add(n[r]);
			else if (!_t(e, t)) {
				var a = yt(e);
				Z(e, (a ? a + " " : "") + t);
			}
		}
		function vt(e, t) {
			e.classList === void 0 ? Z(e, d((" " + yt(e) + " ").replace(" " + t + " ", " "))) : e.classList.remove(t);
		}
		function Z(e, t) {
			e.className.baseVal === void 0 ? e.className = t : e.className.baseVal = t;
		}
		function yt(e) {
			return e.correspondingElement && (e = e.correspondingElement), e.className.baseVal === void 0 ? e.className : e.className.baseVal;
		}
		function bt(e, t) {
			"opacity" in e.style ? e.style.opacity = t : "filter" in e.style && xt(e, t);
		}
		function xt(e, t) {
			var n = !1, r = "DXImageTransform.Microsoft.Alpha";
			try {
				n = e.filters.item(r);
			} catch {
				if (t === 1) return;
			}
			t = Math.round(t * 100), n ? (n.Enabled = t !== 100, n.Opacity = t) : e.style.filter += " progid:" + r + "(opacity=" + t + ")";
		}
		function St(e) {
			for (var t = document.documentElement.style, n = 0; n < e.length; n++) if (e[n] in t) return e[n];
			return !1;
		}
		function Ct(e, t, n) {
			var r = t || new M(0, 0);
			e.style[lt] = (q.ie3d ? "translate(" + r.x + "px," + r.y + "px)" : "translate3d(" + r.x + "px," + r.y + "px,0)") + (n ? " scale(" + n + ")" : "");
		}
		function wt(e, t) {
			e._leaflet_pos = t, q.any3d ? Ct(e, t) : (e.style.left = t.x + "px", e.style.top = t.y + "px");
		}
		function Tt(e) {
			return e._leaflet_pos || new M(0, 0);
		}
		var Et, Dt, Ot;
		if ("onselectstart" in document) Et = function() {
			Q(window, "selectstart", Jt);
		}, Dt = function() {
			Bt(window, "selectstart", Jt);
		};
		else {
			var kt = St([
				"userSelect",
				"WebkitUserSelect",
				"OUserSelect",
				"MozUserSelect",
				"msUserSelect"
			]);
			Et = function() {
				if (kt) {
					var e = document.documentElement.style;
					Ot = e[kt], e[kt] = "none";
				}
			}, Dt = function() {
				kt && (document.documentElement.style[kt] = Ot, Ot = void 0);
			};
		}
		function At() {
			Q(window, "dragstart", Jt);
		}
		function jt() {
			Bt(window, "dragstart", Jt);
		}
		var Mt, Nt;
		function Pt(e) {
			for (; e.tabIndex === -1;) e = e.parentNode;
			e.style && (Ft(), Mt = e, Nt = e.style.outlineStyle, e.style.outlineStyle = "none", Q(window, "keydown", Ft));
		}
		function Ft() {
			Mt && (Mt.style.outlineStyle = Nt, Mt = void 0, Nt = void 0, Bt(window, "keydown", Ft));
		}
		function It(e) {
			do
				e = e.parentNode;
			while ((!e.offsetWidth || !e.offsetHeight) && e !== document.body);
			return e;
		}
		function Lt(e) {
			var t = e.getBoundingClientRect();
			return {
				x: t.width / e.offsetWidth || 1,
				y: t.height / e.offsetHeight || 1,
				boundingClientRect: t
			};
		}
		var Rt = {
			__proto__: null,
			TRANSFORM: lt,
			TRANSITION: ut,
			TRANSITION_END: dt,
			get: ft,
			getStyle: pt,
			create: J,
			remove: mt,
			empty: ht,
			toFront: Y,
			toBack: gt,
			hasClass: _t,
			addClass: X,
			removeClass: vt,
			setClass: Z,
			getClass: yt,
			setOpacity: bt,
			testProp: St,
			setTransform: Ct,
			setPosition: wt,
			getPosition: Tt,
			get disableTextSelection() {
				return Et;
			},
			get enableTextSelection() {
				return Dt;
			},
			disableImageDrag: At,
			enableImageDrag: jt,
			preventOutline: Pt,
			restoreOutline: Ft,
			getSizedParentNode: It,
			getScale: Lt
		};
		function Q(e, t, n, r) {
			if (t && typeof t == "object") for (var i in t) Ut(e, i, t[i], n);
			else {
				t = f(t);
				for (var a = 0, o = t.length; a < o; a++) Ut(e, t[a], n, r);
			}
			return this;
		}
		var zt = "_leaflet_events";
		function Bt(e, t, n, r) {
			if (arguments.length === 1) Vt(e), delete e[zt];
			else if (t && typeof t == "object") for (var i in t) Wt(e, i, t[i], n);
			else if (t = f(t), arguments.length === 2) Vt(e, function(e) {
				return v(t, e) !== -1;
			});
			else for (var a = 0, o = t.length; a < o; a++) Wt(e, t[a], n, r);
			return this;
		}
		function Vt(e, t) {
			for (var n in e[zt]) {
				var r = n.split(/\d/)[0];
				(!t || t(r)) && Wt(e, r, null, null, n);
			}
		}
		var Ht = {
			mouseenter: "mouseover",
			mouseleave: "mouseout",
			wheel: !("onwheel" in window) && "mousewheel"
		};
		function Ut(e, t, n, r) {
			var i = t + o(n) + (r ? "_" + o(r) : "");
			if (e[zt] && e[zt][i]) return this;
			var a = function(t) {
				return n.call(r || e, t || window.event);
			}, s = a;
			!q.touchNative && q.pointer && t.indexOf("touch") === 0 ? a = Ze(e, t, a) : q.touch && t === "dblclick" ? a = st(e, a) : "addEventListener" in e ? t === "touchstart" || t === "touchmove" || t === "wheel" || t === "mousewheel" ? e.addEventListener(Ht[t] || t, a, q.passiveEvents ? { passive: !1 } : !1) : t === "mouseenter" || t === "mouseleave" ? (a = function(t) {
				t ||= window.event, en(e, t) && s(t);
			}, e.addEventListener(Ht[t], a, !1)) : e.addEventListener(t, s, !1) : e.attachEvent("on" + t, a), e[zt] = e[zt] || {}, e[zt][i] = a;
		}
		function Wt(e, t, n, r, i) {
			i ||= t + o(n) + (r ? "_" + o(r) : "");
			var a = e[zt] && e[zt][i];
			if (!a) return this;
			!q.touchNative && q.pointer && t.indexOf("touch") === 0 ? Qe(e, t, a) : q.touch && t === "dblclick" ? ct(e, a) : "removeEventListener" in e ? e.removeEventListener(Ht[t] || t, a, !1) : e.detachEvent("on" + t, a), e[zt][i] = null;
		}
		function Gt(e) {
			return e.stopPropagation ? e.stopPropagation() : e.originalEvent ? e.originalEvent._stopped = !0 : e.cancelBubble = !0, this;
		}
		function Kt(e) {
			return Ut(e, "wheel", Gt), this;
		}
		function qt(e) {
			return Q(e, "mousedown touchstart dblclick contextmenu", Gt), e._leaflet_disable_click = !0, this;
		}
		function Jt(e) {
			return e.preventDefault ? e.preventDefault() : e.returnValue = !1, this;
		}
		function Yt(e) {
			return Jt(e), Gt(e), this;
		}
		function Xt(e) {
			if (e.composedPath) return e.composedPath();
			for (var t = [], n = e.target; n;) t.push(n), n = n.parentNode;
			return t;
		}
		function Zt(e, t) {
			if (!t) return new M(e.clientX, e.clientY);
			var n = Lt(t), r = n.boundingClientRect;
			return new M((e.clientX - r.left) / n.x - t.clientLeft, (e.clientY - r.top) / n.y - t.clientTop);
		}
		var Qt = q.linux && q.chrome ? window.devicePixelRatio : q.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
		function $t(e) {
			return q.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / Qt : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
		}
		function en(e, t) {
			var n = t.relatedTarget;
			if (!n) return !0;
			try {
				for (; n && n !== e;) n = n.parentNode;
			} catch {
				return !1;
			}
			return n !== e;
		}
		var tn = {
			__proto__: null,
			on: Q,
			off: Bt,
			stopPropagation: Gt,
			disableScrollPropagation: Kt,
			disableClickPropagation: qt,
			preventDefault: Jt,
			stop: Yt,
			getPropagationPath: Xt,
			getMousePosition: Zt,
			getWheelDelta: $t,
			isExternalTarget: en,
			addListener: Q,
			removeListener: Bt
		}, nn = j.extend({
			run: function(e, t, n, r) {
				this.stop(), this._el = e, this._inProgress = !0, this._duration = n || .25, this._easeOutPower = 1 / Math.max(r || .5, .2), this._startPos = Tt(e), this._offset = t.subtract(this._startPos), this._startTime = +/* @__PURE__ */ new Date(), this.fire("start"), this._animate();
			},
			stop: function() {
				this._inProgress && (this._step(!0), this._complete());
			},
			_animate: function() {
				this._animId = T(this._animate, this), this._step();
			},
			_step: function(e) {
				var t = +/* @__PURE__ */ new Date() - this._startTime, n = this._duration * 1e3;
				t < n ? this._runFrame(this._easeOut(t / n), e) : (this._runFrame(1), this._complete());
			},
			_runFrame: function(e, t) {
				var n = this._startPos.add(this._offset.multiplyBy(e));
				t && n._round(), wt(this._el, n), this.fire("step");
			},
			_complete: function() {
				E(this._animId), this._inProgress = !1, this.fire("end");
			},
			_easeOut: function(e) {
				return 1 - (1 - e) ** this._easeOutPower;
			}
		}), rn = j.extend({
			options: {
				crs: oe,
				center: void 0,
				zoom: void 0,
				minZoom: void 0,
				maxZoom: void 0,
				layers: [],
				maxBounds: void 0,
				renderer: void 0,
				zoomAnimation: !0,
				zoomAnimationThreshold: 4,
				fadeAnimation: !0,
				markerZoomAnimation: !0,
				transform3DLimit: 8388608,
				zoomSnap: 1,
				zoomDelta: 1,
				trackResize: !0
			},
			initialize: function(e, t) {
				t = p(this, t), this._handlers = [], this._layers = {}, this._zoomBoundLayers = {}, this._sizeChanged = !0, this._initContainer(e), this._initLayout(), this._onResize = i(this._onResize, this), this._initEvents(), t.maxBounds && this.setMaxBounds(t.maxBounds), t.zoom !== void 0 && (this._zoom = this._limitZoom(t.zoom)), t.center && t.zoom !== void 0 && this.setView(V(t.center), t.zoom, { reset: !0 }), this.callInitHooks(), this._zoomAnimated = ut && q.any3d && !q.mobileOpera && this.options.zoomAnimation, this._zoomAnimated && (this._createAnimProxy(), Q(this._proxy, dt, this._catchTransitionEnd, this)), this._addLayers(this.options.layers);
			},
			setView: function(e, t, r) {
				return t = t === void 0 ? this._zoom : this._limitZoom(t), e = this._limitCenter(V(e), t, this.options.maxBounds), r ||= {}, this._stop(), this._loaded && !r.reset && r !== !0 && (r.animate !== void 0 && (r.zoom = n({ animate: r.animate }, r.zoom), r.pan = n({
					animate: r.animate,
					duration: r.duration
				}, r.pan)), this._zoom === t ? this._tryAnimatedPan(e, r.pan) : this._tryAnimatedZoom && this._tryAnimatedZoom(e, t, r.zoom)) ? (clearTimeout(this._sizeTimer), this) : (this._resetView(e, t, r.pan && r.pan.noMoveStart), this);
			},
			setZoom: function(e, t) {
				return this._loaded ? this.setView(this.getCenter(), e, { zoom: t }) : (this._zoom = e, this);
			},
			zoomIn: function(e, t) {
				return e ||= q.any3d ? this.options.zoomDelta : 1, this.setZoom(this._zoom + e, t);
			},
			zoomOut: function(e, t) {
				return e ||= q.any3d ? this.options.zoomDelta : 1, this.setZoom(this._zoom - e, t);
			},
			setZoomAround: function(e, t, n) {
				var r = this.getZoomScale(t), i = this.getSize().divideBy(2), a = (e instanceof M ? e : this.latLngToContainerPoint(e)).subtract(i).multiplyBy(1 - 1 / r), o = this.containerPointToLatLng(i.add(a));
				return this.setView(o, t, { zoom: n });
			},
			_getBoundsCenterZoom: function(e, t) {
				t ||= {}, e = e.getBounds ? e.getBounds() : z(e);
				var n = P(t.paddingTopLeft || t.padding || [0, 0]), r = P(t.paddingBottomRight || t.padding || [0, 0]), i = this.getBoundsZoom(e, !1, n.add(r));
				if (i = typeof t.maxZoom == "number" ? Math.min(t.maxZoom, i) : i, i === Infinity) return {
					center: e.getCenter(),
					zoom: i
				};
				var a = r.subtract(n).divideBy(2), o = this.project(e.getSouthWest(), i), s = this.project(e.getNorthEast(), i);
				return {
					center: this.unproject(o.add(s).divideBy(2).add(a), i),
					zoom: i
				};
			},
			fitBounds: function(e, t) {
				if (e = z(e), !e.isValid()) throw Error("Bounds are not valid.");
				var n = this._getBoundsCenterZoom(e, t);
				return this.setView(n.center, n.zoom, t);
			},
			fitWorld: function(e) {
				return this.fitBounds([[-90, -180], [90, 180]], e);
			},
			panTo: function(e, t) {
				return this.setView(e, this._zoom, { pan: t });
			},
			panBy: function(e, t) {
				if (e = P(e).round(), t ||= {}, !e.x && !e.y) return this.fire("moveend");
				if (t.animate !== !0 && !this.getSize().contains(e)) return this._resetView(this.unproject(this.project(this.getCenter()).add(e)), this.getZoom()), this;
				if (this._panAnim || (this._panAnim = new nn(), this._panAnim.on({
					step: this._onPanTransitionStep,
					end: this._onPanTransitionEnd
				}, this)), t.noMoveStart || this.fire("movestart"), t.animate !== !1) {
					X(this._mapPane, "leaflet-pan-anim");
					var n = this._getMapPanePos().subtract(e).round();
					this._panAnim.run(this._mapPane, n, t.duration || .25, t.easeLinearity);
				} else this._rawPanBy(e), this.fire("move").fire("moveend");
				return this;
			},
			flyTo: function(e, t, n) {
				if (n ||= {}, n.animate === !1 || !q.any3d) return this.setView(e, t, n);
				this._stop();
				var r = this.project(this.getCenter()), i = this.project(e), a = this.getSize(), o = this._zoom;
				e = V(e), t = t === void 0 ? o : t;
				var s = Math.max(a.x, a.y), c = s * this.getZoomScale(o, t), l = i.distanceTo(r) || 1, u = 1.42, d = u * u;
				function f(e) {
					var t = e ? -1 : 1, n = e ? c : s, r = (c * c - s * s + t * d * d * l * l) / (2 * n * d * l), i = Math.sqrt(r * r + 1) - r;
					return i < 1e-9 ? -18 : Math.log(i);
				}
				function p(e) {
					return (Math.exp(e) - Math.exp(-e)) / 2;
				}
				function m(e) {
					return (Math.exp(e) + Math.exp(-e)) / 2;
				}
				function h(e) {
					return p(e) / m(e);
				}
				var g = f(0);
				function _(e) {
					return s * (m(g) / m(g + u * e));
				}
				function v(e) {
					return s * (m(g) * h(g + u * e) - p(g)) / d;
				}
				function y(e) {
					return 1 - (1 - e) ** 1.5;
				}
				var b = Date.now(), x = (f(1) - g) / u, S = n.duration ? 1e3 * n.duration : 1e3 * x * .8;
				function C() {
					var n = (Date.now() - b) / S, a = y(n) * x;
					n <= 1 ? (this._flyToFrame = T(C, this), this._move(this.unproject(r.add(i.subtract(r).multiplyBy(v(a) / l)), o), this.getScaleZoom(s / _(a), o), { flyTo: !0 })) : this._move(e, t)._moveEnd(!0);
				}
				return this._moveStart(!0, n.noMoveStart), C.call(this), this;
			},
			flyToBounds: function(e, t) {
				var n = this._getBoundsCenterZoom(e, t);
				return this.flyTo(n.center, n.zoom, t);
			},
			setMaxBounds: function(e) {
				return e = z(e), this.listens("moveend", this._panInsideMaxBounds) && this.off("moveend", this._panInsideMaxBounds), e.isValid() ? (this.options.maxBounds = e, this._loaded && this._panInsideMaxBounds(), this.on("moveend", this._panInsideMaxBounds)) : (this.options.maxBounds = null, this);
			},
			setMinZoom: function(e) {
				var t = this.options.minZoom;
				return this.options.minZoom = e, this._loaded && t !== e && (this.fire("zoomlevelschange"), this.getZoom() < this.options.minZoom) ? this.setZoom(e) : this;
			},
			setMaxZoom: function(e) {
				var t = this.options.maxZoom;
				return this.options.maxZoom = e, this._loaded && t !== e && (this.fire("zoomlevelschange"), this.getZoom() > this.options.maxZoom) ? this.setZoom(e) : this;
			},
			panInsideBounds: function(e, t) {
				this._enforcingBounds = !0;
				var n = this.getCenter(), r = this._limitCenter(n, this._zoom, z(e));
				return n.equals(r) || this.panTo(r, t), this._enforcingBounds = !1, this;
			},
			panInside: function(e, t) {
				t ||= {};
				var n = P(t.paddingTopLeft || t.padding || [0, 0]), r = P(t.paddingBottomRight || t.padding || [0, 0]), i = this.project(this.getCenter()), a = this.project(e), o = this.getPixelBounds(), s = I([o.min.add(n), o.max.subtract(r)]), c = s.getSize();
				if (!s.contains(a)) {
					this._enforcingBounds = !0;
					var l = a.subtract(s.getCenter()), u = s.extend(a).getSize().subtract(c);
					i.x += l.x < 0 ? -u.x : u.x, i.y += l.y < 0 ? -u.y : u.y, this.panTo(this.unproject(i), t), this._enforcingBounds = !1;
				}
				return this;
			},
			invalidateSize: function(e) {
				if (!this._loaded) return this;
				e = n({
					animate: !1,
					pan: !0
				}, e === !0 ? { animate: !0 } : e);
				var t = this.getSize();
				this._sizeChanged = !0, this._lastCenter = null;
				var r = this.getSize(), a = t.divideBy(2).round(), o = r.divideBy(2).round(), s = a.subtract(o);
				return !s.x && !s.y ? this : (e.animate && e.pan ? this.panBy(s) : (e.pan && this._rawPanBy(s), this.fire("move"), e.debounceMoveend ? (clearTimeout(this._sizeTimer), this._sizeTimer = setTimeout(i(this.fire, this, "moveend"), 200)) : this.fire("moveend")), this.fire("resize", {
					oldSize: t,
					newSize: r
				}));
			},
			stop: function() {
				return this.setZoom(this._limitZoom(this._zoom)), this.options.zoomSnap || this.fire("viewreset"), this._stop();
			},
			locate: function(e) {
				if (e = this._locateOptions = n({
					timeout: 1e4,
					watch: !1
				}, e), !("geolocation" in navigator)) return this._handleGeolocationError({
					code: 0,
					message: "Geolocation not supported."
				}), this;
				var t = i(this._handleGeolocationResponse, this), r = i(this._handleGeolocationError, this);
				return e.watch ? this._locationWatchId = navigator.geolocation.watchPosition(t, r, e) : navigator.geolocation.getCurrentPosition(t, r, e), this;
			},
			stopLocate: function() {
				return navigator.geolocation && navigator.geolocation.clearWatch && navigator.geolocation.clearWatch(this._locationWatchId), this._locateOptions && (this._locateOptions.setView = !1), this;
			},
			_handleGeolocationError: function(e) {
				if (this._container._leaflet_id) {
					var t = e.code, n = e.message || (t === 1 ? "permission denied" : t === 2 ? "position unavailable" : "timeout");
					this._locateOptions.setView && !this._loaded && this.fitWorld(), this.fire("locationerror", {
						code: t,
						message: "Geolocation error: " + n + "."
					});
				}
			},
			_handleGeolocationResponse: function(e) {
				if (this._container._leaflet_id) {
					var t = e.coords.latitude, n = e.coords.longitude, r = new B(t, n), i = r.toBounds(e.coords.accuracy * 2), a = this._locateOptions;
					if (a.setView) {
						var o = this.getBoundsZoom(i);
						this.setView(r, a.maxZoom ? Math.min(o, a.maxZoom) : o);
					}
					var s = {
						latlng: r,
						bounds: i,
						timestamp: e.timestamp
					};
					for (var c in e.coords) typeof e.coords[c] == "number" && (s[c] = e.coords[c]);
					this.fire("locationfound", s);
				}
			},
			addHandler: function(e, t) {
				if (!t) return this;
				var n = this[e] = new t(this);
				return this._handlers.push(n), this.options[e] && n.enable(), this;
			},
			remove: function() {
				if (this._initEvents(!0), this.options.maxBounds && this.off("moveend", this._panInsideMaxBounds), this._containerId !== this._container._leaflet_id) throw Error("Map container is being reused by another instance");
				try {
					delete this._container._leaflet_id, delete this._containerId;
				} catch {
					this._container._leaflet_id = void 0, this._containerId = void 0;
				}
				for (var e in this._locationWatchId !== void 0 && this.stopLocate(), this._stop(), mt(this._mapPane), this._clearControlPos && this._clearControlPos(), this._resizeRequest &&= (E(this._resizeRequest), null), this._clearHandlers(), this._loaded && this.fire("unload"), this._layers) this._layers[e].remove();
				for (e in this._panes) mt(this._panes[e]);
				return this._layers = [], this._panes = [], delete this._mapPane, delete this._renderer, this;
			},
			createPane: function(e, t) {
				var n = J("div", "leaflet-pane" + (e ? " leaflet-" + e.replace("Pane", "") + "-pane" : ""), t || this._mapPane);
				return e && (this._panes[e] = n), n;
			},
			getCenter: function() {
				return this._checkIfLoaded(), this._lastCenter && !this._moved() ? this._lastCenter.clone() : this.layerPointToLatLng(this._getCenterLayerPoint());
			},
			getZoom: function() {
				return this._zoom;
			},
			getBounds: function() {
				var e = this.getPixelBounds();
				return new R(this.unproject(e.getBottomLeft()), this.unproject(e.getTopRight()));
			},
			getMinZoom: function() {
				return this.options.minZoom === void 0 ? this._layersMinZoom || 0 : this.options.minZoom;
			},
			getMaxZoom: function() {
				return this.options.maxZoom === void 0 ? this._layersMaxZoom === void 0 ? Infinity : this._layersMaxZoom : this.options.maxZoom;
			},
			getBoundsZoom: function(e, t, n) {
				e = z(e), n = P(n || [0, 0]);
				var r = this.getZoom() || 0, i = this.getMinZoom(), a = this.getMaxZoom(), o = e.getNorthWest(), s = e.getSouthEast(), c = this.getSize().subtract(n), l = I(this.project(s, r), this.project(o, r)).getSize(), u = q.any3d ? this.options.zoomSnap : 1, d = c.x / l.x, f = c.y / l.y, p = t ? Math.max(d, f) : Math.min(d, f);
				return r = this.getScaleZoom(p, r), u && (r = Math.round(r / (u / 100)) * (u / 100), r = t ? Math.ceil(r / u) * u : Math.floor(r / u) * u), Math.max(i, Math.min(a, r));
			},
			getSize: function() {
				return (!this._size || this._sizeChanged) && (this._size = new M(this._container.clientWidth || 0, this._container.clientHeight || 0), this._sizeChanged = !1), this._size.clone();
			},
			getPixelBounds: function(e, t) {
				var n = this._getTopLeftPoint(e, t);
				return new F(n, n.add(this.getSize()));
			},
			getPixelOrigin: function() {
				return this._checkIfLoaded(), this._pixelOrigin;
			},
			getPixelWorldBounds: function(e) {
				return this.options.crs.getProjectedBounds(e === void 0 ? this.getZoom() : e);
			},
			getPane: function(e) {
				return typeof e == "string" ? this._panes[e] : e;
			},
			getPanes: function() {
				return this._panes;
			},
			getContainer: function() {
				return this._container;
			},
			getZoomScale: function(e, t) {
				var n = this.options.crs;
				return t = t === void 0 ? this._zoom : t, n.scale(e) / n.scale(t);
			},
			getScaleZoom: function(e, t) {
				var n = this.options.crs;
				t = t === void 0 ? this._zoom : t;
				var r = n.zoom(e * n.scale(t));
				return isNaN(r) ? Infinity : r;
			},
			project: function(e, t) {
				return t = t === void 0 ? this._zoom : t, this.options.crs.latLngToPoint(V(e), t);
			},
			unproject: function(e, t) {
				return t = t === void 0 ? this._zoom : t, this.options.crs.pointToLatLng(P(e), t);
			},
			layerPointToLatLng: function(e) {
				var t = P(e).add(this.getPixelOrigin());
				return this.unproject(t);
			},
			latLngToLayerPoint: function(e) {
				return this.project(V(e))._round()._subtract(this.getPixelOrigin());
			},
			wrapLatLng: function(e) {
				return this.options.crs.wrapLatLng(V(e));
			},
			wrapLatLngBounds: function(e) {
				return this.options.crs.wrapLatLngBounds(z(e));
			},
			distance: function(e, t) {
				return this.options.crs.distance(V(e), V(t));
			},
			containerPointToLayerPoint: function(e) {
				return P(e).subtract(this._getMapPanePos());
			},
			layerPointToContainerPoint: function(e) {
				return P(e).add(this._getMapPanePos());
			},
			containerPointToLatLng: function(e) {
				var t = this.containerPointToLayerPoint(P(e));
				return this.layerPointToLatLng(t);
			},
			latLngToContainerPoint: function(e) {
				return this.layerPointToContainerPoint(this.latLngToLayerPoint(V(e)));
			},
			mouseEventToContainerPoint: function(e) {
				return Zt(e, this._container);
			},
			mouseEventToLayerPoint: function(e) {
				return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
			},
			mouseEventToLatLng: function(e) {
				return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
			},
			_initContainer: function(e) {
				var t = this._container = ft(e);
				if (!t) throw Error("Map container not found.");
				if (t._leaflet_id) throw Error("Map container is already initialized.");
				Q(t, "scroll", this._onScroll, this), this._containerId = o(t);
			},
			_initLayout: function() {
				var e = this._container;
				this._fadeAnimated = this.options.fadeAnimation && q.any3d, X(e, "leaflet-container" + (q.touch ? " leaflet-touch" : "") + (q.retina ? " leaflet-retina" : "") + (q.ielt9 ? " leaflet-oldie" : "") + (q.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
				var t = pt(e, "position");
				t !== "absolute" && t !== "relative" && t !== "fixed" && t !== "sticky" && (e.style.position = "relative"), this._initPanes(), this._initControlPos && this._initControlPos();
			},
			_initPanes: function() {
				var e = this._panes = {};
				this._paneRenderers = {}, this._mapPane = this.createPane("mapPane", this._container), wt(this._mapPane, new M(0, 0)), this.createPane("tilePane"), this.createPane("overlayPane"), this.createPane("shadowPane"), this.createPane("markerPane"), this.createPane("tooltipPane"), this.createPane("popupPane"), this.options.markerZoomAnimation || (X(e.markerPane, "leaflet-zoom-hide"), X(e.shadowPane, "leaflet-zoom-hide"));
			},
			_resetView: function(e, t, n) {
				wt(this._mapPane, new M(0, 0));
				var r = !this._loaded;
				this._loaded = !0, t = this._limitZoom(t), this.fire("viewprereset");
				var i = this._zoom !== t;
				this._moveStart(i, n)._move(e, t)._moveEnd(i), this.fire("viewreset"), r && this.fire("load");
			},
			_moveStart: function(e, t) {
				return e && this.fire("zoomstart"), t || this.fire("movestart"), this;
			},
			_move: function(e, t, n, r) {
				t === void 0 && (t = this._zoom);
				var i = this._zoom !== t;
				return this._zoom = t, this._lastCenter = e, this._pixelOrigin = this._getNewPixelOrigin(e), r ? n && n.pinch && this.fire("zoom", n) : ((i || n && n.pinch) && this.fire("zoom", n), this.fire("move", n)), this;
			},
			_moveEnd: function(e) {
				return e && this.fire("zoomend"), this.fire("moveend");
			},
			_stop: function() {
				return E(this._flyToFrame), this._panAnim && this._panAnim.stop(), this;
			},
			_rawPanBy: function(e) {
				wt(this._mapPane, this._getMapPanePos().subtract(e));
			},
			_getZoomSpan: function() {
				return this.getMaxZoom() - this.getMinZoom();
			},
			_panInsideMaxBounds: function() {
				this._enforcingBounds || this.panInsideBounds(this.options.maxBounds);
			},
			_checkIfLoaded: function() {
				if (!this._loaded) throw Error("Set map center and zoom first.");
			},
			_initEvents: function(e) {
				this._targets = {}, this._targets[o(this._container)] = this;
				var t = e ? Bt : Q;
				t(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this), this.options.trackResize && t(window, "resize", this._onResize, this), q.any3d && this.options.transform3DLimit && (e ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
			},
			_onResize: function() {
				E(this._resizeRequest), this._resizeRequest = T(function() {
					this.invalidateSize({ debounceMoveend: !0 });
				}, this);
			},
			_onScroll: function() {
				this._container.scrollTop = 0, this._container.scrollLeft = 0;
			},
			_onMoveEnd: function() {
				var e = this._getMapPanePos();
				Math.max(Math.abs(e.x), Math.abs(e.y)) >= this.options.transform3DLimit && this._resetView(this.getCenter(), this.getZoom());
			},
			_findEventTargets: function(e, t) {
				for (var n = [], r, i = t === "mouseout" || t === "mouseover", a = e.target || e.srcElement, s = !1; a;) {
					if (r = this._targets[o(a)], r && (t === "click" || t === "preclick") && this._draggableMoved(r)) {
						s = !0;
						break;
					}
					if (r && r.listens(t, !0) && (i && !en(a, e) || (n.push(r), i)) || a === this._container) break;
					a = a.parentNode;
				}
				return !n.length && !s && !i && this.listens(t, !0) && (n = [this]), n;
			},
			_isClickDisabled: function(e) {
				for (; e && e !== this._container;) {
					if (e._leaflet_disable_click) return !0;
					e = e.parentNode;
				}
			},
			_handleDOMEvent: function(e) {
				var t = e.target || e.srcElement;
				if (!(!this._loaded || t._leaflet_disable_events || e.type === "click" && this._isClickDisabled(t))) {
					var n = e.type;
					n === "mousedown" && Pt(t), this._fireDOMEvent(e, n);
				}
			},
			_mouseEvents: [
				"click",
				"dblclick",
				"mouseover",
				"mouseout",
				"contextmenu"
			],
			_fireDOMEvent: function(e, t, r) {
				if (e.type === "click") {
					var i = n({}, e);
					i.type = "preclick", this._fireDOMEvent(i, i.type, r);
				}
				var a = this._findEventTargets(e, t);
				if (r) {
					for (var o = [], s = 0; s < r.length; s++) r[s].listens(t, !0) && o.push(r[s]);
					a = o.concat(a);
				}
				if (a.length) {
					t === "contextmenu" && Jt(e);
					var c = a[0], l = { originalEvent: e };
					if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
						var u = c.getLatLng && (!c._radius || c._radius <= 10);
						l.containerPoint = u ? this.latLngToContainerPoint(c.getLatLng()) : this.mouseEventToContainerPoint(e), l.layerPoint = this.containerPointToLayerPoint(l.containerPoint), l.latlng = u ? c.getLatLng() : this.layerPointToLatLng(l.layerPoint);
					}
					for (s = 0; s < a.length; s++) if (a[s].fire(t, l, !0), l.originalEvent._stopped || a[s].options.bubblingMouseEvents === !1 && v(this._mouseEvents, t) !== -1) return;
				}
			},
			_draggableMoved: function(e) {
				return e = e.dragging && e.dragging.enabled() ? e : this, e.dragging && e.dragging.moved() || this.boxZoom && this.boxZoom.moved();
			},
			_clearHandlers: function() {
				for (var e = 0, t = this._handlers.length; e < t; e++) this._handlers[e].disable();
			},
			whenReady: function(e, t) {
				return this._loaded ? e.call(t || this, { target: this }) : this.on("load", e, t), this;
			},
			_getMapPanePos: function() {
				return Tt(this._mapPane) || new M(0, 0);
			},
			_moved: function() {
				var e = this._getMapPanePos();
				return e && !e.equals([0, 0]);
			},
			_getTopLeftPoint: function(e, t) {
				return (e && t !== void 0 ? this._getNewPixelOrigin(e, t) : this.getPixelOrigin()).subtract(this._getMapPanePos());
			},
			_getNewPixelOrigin: function(e, t) {
				var n = this.getSize()._divideBy(2);
				return this.project(e, t)._subtract(n)._add(this._getMapPanePos())._round();
			},
			_latLngToNewLayerPoint: function(e, t, n) {
				var r = this._getNewPixelOrigin(n, t);
				return this.project(e, t)._subtract(r);
			},
			_latLngBoundsToNewLayerBounds: function(e, t, n) {
				var r = this._getNewPixelOrigin(n, t);
				return I([
					this.project(e.getSouthWest(), t)._subtract(r),
					this.project(e.getNorthWest(), t)._subtract(r),
					this.project(e.getSouthEast(), t)._subtract(r),
					this.project(e.getNorthEast(), t)._subtract(r)
				]);
			},
			_getCenterLayerPoint: function() {
				return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
			},
			_getCenterOffset: function(e) {
				return this.latLngToLayerPoint(e).subtract(this._getCenterLayerPoint());
			},
			_limitCenter: function(e, t, n) {
				if (!n) return e;
				var r = this.project(e, t), i = this.getSize().divideBy(2), a = new F(r.subtract(i), r.add(i)), o = this._getBoundsOffset(a, n, t);
				return Math.abs(o.x) <= 1 && Math.abs(o.y) <= 1 ? e : this.unproject(r.add(o), t);
			},
			_limitOffset: function(e, t) {
				if (!t) return e;
				var n = this.getPixelBounds(), r = new F(n.min.add(e), n.max.add(e));
				return e.add(this._getBoundsOffset(r, t));
			},
			_getBoundsOffset: function(e, t, n) {
				var r = I(this.project(t.getNorthEast(), n), this.project(t.getSouthWest(), n)), i = r.min.subtract(e.min), a = r.max.subtract(e.max);
				return new M(this._rebound(i.x, -a.x), this._rebound(i.y, -a.y));
			},
			_rebound: function(e, t) {
				return e + t > 0 ? Math.round(e - t) / 2 : Math.max(0, Math.ceil(e)) - Math.max(0, Math.floor(t));
			},
			_limitZoom: function(e) {
				var t = this.getMinZoom(), n = this.getMaxZoom(), r = q.any3d ? this.options.zoomSnap : 1;
				return r && (e = Math.round(e / r) * r), Math.max(t, Math.min(n, e));
			},
			_onPanTransitionStep: function() {
				this.fire("move");
			},
			_onPanTransitionEnd: function() {
				vt(this._mapPane, "leaflet-pan-anim"), this.fire("moveend");
			},
			_tryAnimatedPan: function(e, t) {
				var n = this._getCenterOffset(e)._trunc();
				return (t && t.animate) !== !0 && !this.getSize().contains(n) ? !1 : (this.panBy(n, t), !0);
			},
			_createAnimProxy: function() {
				var e = this._proxy = J("div", "leaflet-proxy leaflet-zoom-animated");
				this._panes.mapPane.appendChild(e), this.on("zoomanim", function(e) {
					var t = lt, n = this._proxy.style[t];
					Ct(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1)), n === this._proxy.style[t] && this._animatingZoom && this._onZoomTransitionEnd();
				}, this), this.on("load moveend", this._animMoveEnd, this), this._on("unload", this._destroyAnimProxy, this);
			},
			_destroyAnimProxy: function() {
				mt(this._proxy), this.off("load moveend", this._animMoveEnd, this), delete this._proxy;
			},
			_animMoveEnd: function() {
				var e = this.getCenter(), t = this.getZoom();
				Ct(this._proxy, this.project(e, t), this.getZoomScale(t, 1));
			},
			_catchTransitionEnd: function(e) {
				this._animatingZoom && e.propertyName.indexOf("transform") >= 0 && this._onZoomTransitionEnd();
			},
			_nothingToAnimate: function() {
				return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
			},
			_tryAnimatedZoom: function(e, t, n) {
				if (this._animatingZoom) return !0;
				if (n ||= {}, !this._zoomAnimated || n.animate === !1 || this._nothingToAnimate() || Math.abs(t - this._zoom) > this.options.zoomAnimationThreshold) return !1;
				var r = this.getZoomScale(t), i = this._getCenterOffset(e)._divideBy(1 - 1 / r);
				return n.animate !== !0 && !this.getSize().contains(i) ? !1 : (T(function() {
					this._moveStart(!0, n.noMoveStart || !1)._animateZoom(e, t, !0);
				}, this), !0);
			},
			_animateZoom: function(e, t, n, r) {
				this._mapPane && (n && (this._animatingZoom = !0, this._animateToCenter = e, this._animateToZoom = t, X(this._mapPane, "leaflet-zoom-anim")), this.fire("zoomanim", {
					center: e,
					zoom: t,
					noUpdate: r
				}), this._tempFireZoomEvent ||= this._zoom !== this._animateToZoom, this._move(this._animateToCenter, this._animateToZoom, void 0, !0), setTimeout(i(this._onZoomTransitionEnd, this), 250));
			},
			_onZoomTransitionEnd: function() {
				this._animatingZoom && (this._mapPane && vt(this._mapPane, "leaflet-zoom-anim"), this._animatingZoom = !1, this._move(this._animateToCenter, this._animateToZoom, void 0, !0), this._tempFireZoomEvent && this.fire("zoom"), delete this._tempFireZoomEvent, this.fire("move"), this._moveEnd(!0));
			}
		});
		function an(e, t) {
			return new rn(e, t);
		}
		var on = O.extend({
			options: { position: "topright" },
			initialize: function(e) {
				p(this, e);
			},
			getPosition: function() {
				return this.options.position;
			},
			setPosition: function(e) {
				var t = this._map;
				return t && t.removeControl(this), this.options.position = e, t && t.addControl(this), this;
			},
			getContainer: function() {
				return this._container;
			},
			addTo: function(e) {
				this.remove(), this._map = e;
				var t = this._container = this.onAdd(e), n = this.getPosition(), r = e._controlCorners[n];
				return X(t, "leaflet-control"), n.indexOf("bottom") === -1 ? r.appendChild(t) : r.insertBefore(t, r.firstChild), this._map.on("unload", this.remove, this), this;
			},
			remove: function() {
				return this._map ? (mt(this._container), this.onRemove && this.onRemove(this._map), this._map.off("unload", this.remove, this), this._map = null, this) : this;
			},
			_refocusOnMap: function(e) {
				this._map && e && e.screenX > 0 && e.screenY > 0 && this._map.getContainer().focus();
			}
		}), sn = function(e) {
			return new on(e);
		};
		rn.include({
			addControl: function(e) {
				return e.addTo(this), this;
			},
			removeControl: function(e) {
				return e.remove(), this;
			},
			_initControlPos: function() {
				var e = this._controlCorners = {}, t = "leaflet-", n = this._controlContainer = J("div", t + "control-container", this._container);
				function r(r, i) {
					var a = t + r + " " + t + i;
					e[r + i] = J("div", a, n);
				}
				r("top", "left"), r("top", "right"), r("bottom", "left"), r("bottom", "right");
			},
			_clearControlPos: function() {
				for (var e in this._controlCorners) mt(this._controlCorners[e]);
				mt(this._controlContainer), delete this._controlCorners, delete this._controlContainer;
			}
		});
		var cn = on.extend({
			options: {
				collapsed: !0,
				position: "topright",
				autoZIndex: !0,
				hideSingleBase: !1,
				sortLayers: !1,
				sortFunction: function(e, t, n, r) {
					return n < r ? -1 : +(r < n);
				}
			},
			initialize: function(e, t, n) {
				for (var r in p(this, n), this._layerControlInputs = [], this._layers = [], this._lastZIndex = 0, this._handlingClick = !1, this._preventClick = !1, e) this._addLayer(e[r], r);
				for (r in t) this._addLayer(t[r], r, !0);
			},
			onAdd: function(e) {
				this._initLayout(), this._update(), this._map = e, e.on("zoomend", this._checkDisabledLayers, this);
				for (var t = 0; t < this._layers.length; t++) this._layers[t].layer.on("add remove", this._onLayerChange, this);
				return this._container;
			},
			addTo: function(e) {
				return on.prototype.addTo.call(this, e), this._expandIfNotCollapsed();
			},
			onRemove: function() {
				this._map.off("zoomend", this._checkDisabledLayers, this);
				for (var e = 0; e < this._layers.length; e++) this._layers[e].layer.off("add remove", this._onLayerChange, this);
			},
			addBaseLayer: function(e, t) {
				return this._addLayer(e, t), this._map ? this._update() : this;
			},
			addOverlay: function(e, t) {
				return this._addLayer(e, t, !0), this._map ? this._update() : this;
			},
			removeLayer: function(e) {
				e.off("add remove", this._onLayerChange, this);
				var t = this._getLayer(o(e));
				return t && this._layers.splice(this._layers.indexOf(t), 1), this._map ? this._update() : this;
			},
			expand: function() {
				X(this._container, "leaflet-control-layers-expanded"), this._section.style.height = null;
				var e = this._map.getSize().y - (this._container.offsetTop + 50);
				return e < this._section.clientHeight ? (X(this._section, "leaflet-control-layers-scrollbar"), this._section.style.height = e + "px") : vt(this._section, "leaflet-control-layers-scrollbar"), this._checkDisabledLayers(), this;
			},
			collapse: function() {
				return vt(this._container, "leaflet-control-layers-expanded"), this;
			},
			_initLayout: function() {
				var e = "leaflet-control-layers", t = this._container = J("div", e), n = this.options.collapsed;
				t.setAttribute("aria-haspopup", !0), qt(t), Kt(t);
				var r = this._section = J("section", e + "-list");
				n && (this._map.on("click", this.collapse, this), Q(t, {
					mouseenter: this._expandSafely,
					mouseleave: this.collapse
				}, this));
				var i = this._layersLink = J("a", e + "-toggle", t);
				i.href = "#", i.title = "Layers", i.setAttribute("role", "button"), Q(i, {
					keydown: function(e) {
						e.keyCode === 13 && this._expandSafely();
					},
					click: function(e) {
						Jt(e), this._expandSafely();
					}
				}, this), n || this.expand(), this._baseLayersList = J("div", e + "-base", r), this._separator = J("div", e + "-separator", r), this._overlaysList = J("div", e + "-overlays", r), t.appendChild(r);
			},
			_getLayer: function(e) {
				for (var t = 0; t < this._layers.length; t++) if (this._layers[t] && o(this._layers[t].layer) === e) return this._layers[t];
			},
			_addLayer: function(e, t, n) {
				this._map && e.on("add remove", this._onLayerChange, this), this._layers.push({
					layer: e,
					name: t,
					overlay: n
				}), this.options.sortLayers && this._layers.sort(i(function(e, t) {
					return this.options.sortFunction(e.layer, t.layer, e.name, t.name);
				}, this)), this.options.autoZIndex && e.setZIndex && (this._lastZIndex++, e.setZIndex(this._lastZIndex)), this._expandIfNotCollapsed();
			},
			_update: function() {
				if (!this._container) return this;
				ht(this._baseLayersList), ht(this._overlaysList), this._layerControlInputs = [];
				var e, t, n, r, i = 0;
				for (n = 0; n < this._layers.length; n++) r = this._layers[n], this._addItem(r), t ||= r.overlay, e ||= !r.overlay, i += +!r.overlay;
				return this.options.hideSingleBase && (e &&= i > 1, this._baseLayersList.style.display = e ? "" : "none"), this._separator.style.display = t && e ? "" : "none", this;
			},
			_onLayerChange: function(e) {
				this._handlingClick || this._update();
				var t = this._getLayer(o(e.target)), n = t.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
				n && this._map.fire(n, t);
			},
			_createRadioElement: function(e, t) {
				var n = "<input type=\"radio\" class=\"leaflet-control-layers-selector\" name=\"" + e + "\"" + (t ? " checked=\"checked\"" : "") + "/>", r = document.createElement("div");
				return r.innerHTML = n, r.firstChild;
			},
			_addItem: function(e) {
				var t = document.createElement("label"), n = this._map.hasLayer(e.layer), r;
				e.overlay ? (r = document.createElement("input"), r.type = "checkbox", r.className = "leaflet-control-layers-selector", r.defaultChecked = n) : r = this._createRadioElement("leaflet-base-layers_" + o(this), n), this._layerControlInputs.push(r), r.layerId = o(e.layer), Q(r, "click", this._onInputClick, this);
				var i = document.createElement("span");
				i.innerHTML = " " + e.name;
				var a = document.createElement("span");
				return t.appendChild(a), a.appendChild(r), a.appendChild(i), (e.overlay ? this._overlaysList : this._baseLayersList).appendChild(t), this._checkDisabledLayers(), t;
			},
			_onInputClick: function() {
				if (!this._preventClick) {
					var e = this._layerControlInputs, t, n, r = [], i = [];
					this._handlingClick = !0;
					for (var a = e.length - 1; a >= 0; a--) t = e[a], n = this._getLayer(t.layerId).layer, t.checked ? r.push(n) : t.checked || i.push(n);
					for (a = 0; a < i.length; a++) this._map.hasLayer(i[a]) && this._map.removeLayer(i[a]);
					for (a = 0; a < r.length; a++) this._map.hasLayer(r[a]) || this._map.addLayer(r[a]);
					this._handlingClick = !1, this._refocusOnMap();
				}
			},
			_checkDisabledLayers: function() {
				for (var e = this._layerControlInputs, t, n, r = this._map.getZoom(), i = e.length - 1; i >= 0; i--) t = e[i], n = this._getLayer(t.layerId).layer, t.disabled = n.options.minZoom !== void 0 && r < n.options.minZoom || n.options.maxZoom !== void 0 && r > n.options.maxZoom;
			},
			_expandIfNotCollapsed: function() {
				return this._map && !this.options.collapsed && this.expand(), this;
			},
			_expandSafely: function() {
				var e = this._section;
				this._preventClick = !0, Q(e, "click", Jt), this.expand();
				var t = this;
				setTimeout(function() {
					Bt(e, "click", Jt), t._preventClick = !1;
				});
			}
		}), ln = function(e, t, n) {
			return new cn(e, t, n);
		}, un = on.extend({
			options: {
				position: "topleft",
				zoomInText: "<span aria-hidden=\"true\">+</span>",
				zoomInTitle: "Zoom in",
				zoomOutText: "<span aria-hidden=\"true\">&#x2212;</span>",
				zoomOutTitle: "Zoom out"
			},
			onAdd: function(e) {
				var t = "leaflet-control-zoom", n = J("div", t + " leaflet-bar"), r = this.options;
				return this._zoomInButton = this._createButton(r.zoomInText, r.zoomInTitle, t + "-in", n, this._zoomIn), this._zoomOutButton = this._createButton(r.zoomOutText, r.zoomOutTitle, t + "-out", n, this._zoomOut), this._updateDisabled(), e.on("zoomend zoomlevelschange", this._updateDisabled, this), n;
			},
			onRemove: function(e) {
				e.off("zoomend zoomlevelschange", this._updateDisabled, this);
			},
			disable: function() {
				return this._disabled = !0, this._updateDisabled(), this;
			},
			enable: function() {
				return this._disabled = !1, this._updateDisabled(), this;
			},
			_zoomIn: function(e) {
				!this._disabled && this._map._zoom < this._map.getMaxZoom() && this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			},
			_zoomOut: function(e) {
				!this._disabled && this._map._zoom > this._map.getMinZoom() && this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			},
			_createButton: function(e, t, n, r, i) {
				var a = J("a", n, r);
				return a.innerHTML = e, a.href = "#", a.title = t, a.setAttribute("role", "button"), a.setAttribute("aria-label", t), qt(a), Q(a, "click", Yt), Q(a, "click", i, this), Q(a, "click", this._refocusOnMap, this), a;
			},
			_updateDisabled: function() {
				var e = this._map, t = "leaflet-disabled";
				vt(this._zoomInButton, t), vt(this._zoomOutButton, t), this._zoomInButton.setAttribute("aria-disabled", "false"), this._zoomOutButton.setAttribute("aria-disabled", "false"), (this._disabled || e._zoom === e.getMinZoom()) && (X(this._zoomOutButton, t), this._zoomOutButton.setAttribute("aria-disabled", "true")), (this._disabled || e._zoom === e.getMaxZoom()) && (X(this._zoomInButton, t), this._zoomInButton.setAttribute("aria-disabled", "true"));
			}
		});
		rn.mergeOptions({ zoomControl: !0 }), rn.addInitHook(function() {
			this.options.zoomControl && (this.zoomControl = new un(), this.addControl(this.zoomControl));
		});
		var dn = function(e) {
			return new un(e);
		}, fn = on.extend({
			options: {
				position: "bottomleft",
				maxWidth: 100,
				metric: !0,
				imperial: !0
			},
			onAdd: function(e) {
				var t = "leaflet-control-scale", n = J("div", t), r = this.options;
				return this._addScales(r, t + "-line", n), e.on(r.updateWhenIdle ? "moveend" : "move", this._update, this), e.whenReady(this._update, this), n;
			},
			onRemove: function(e) {
				e.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
			},
			_addScales: function(e, t, n) {
				e.metric && (this._mScale = J("div", t, n)), e.imperial && (this._iScale = J("div", t, n));
			},
			_update: function() {
				var e = this._map, t = e.getSize().y / 2, n = e.distance(e.containerPointToLatLng([0, t]), e.containerPointToLatLng([this.options.maxWidth, t]));
				this._updateScales(n);
			},
			_updateScales: function(e) {
				this.options.metric && e && this._updateMetric(e), this.options.imperial && e && this._updateImperial(e);
			},
			_updateMetric: function(e) {
				var t = this._getRoundNum(e), n = t < 1e3 ? t + " m" : t / 1e3 + " km";
				this._updateScale(this._mScale, n, t / e);
			},
			_updateImperial: function(e) {
				var t = e * 3.2808399, n, r, i;
				t > 5280 ? (n = t / 5280, r = this._getRoundNum(n), this._updateScale(this._iScale, r + " mi", r / n)) : (i = this._getRoundNum(t), this._updateScale(this._iScale, i + " ft", i / t));
			},
			_updateScale: function(e, t, n) {
				e.style.width = Math.round(this.options.maxWidth * n) + "px", e.innerHTML = t;
			},
			_getRoundNum: function(e) {
				var t = 10 ** ((Math.floor(e) + "").length - 1), n = e / t;
				return n = n >= 10 ? 10 : n >= 5 ? 5 : n >= 3 ? 3 : n >= 2 ? 2 : 1, t * n;
			}
		}), pn = function(e) {
			return new fn(e);
		}, mn = on.extend({
			options: {
				position: "bottomright",
				prefix: "<a href=\"https://leafletjs.com\" title=\"A JavaScript library for interactive maps\">" + (q.inlineSvg ? "<svg aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"8\" viewBox=\"0 0 12 8\" class=\"leaflet-attribution-flag\"><path fill=\"#4C7BE1\" d=\"M0 0h12v4H0z\"/><path fill=\"#FFD500\" d=\"M0 4h12v3H0z\"/><path fill=\"#E0BC00\" d=\"M0 7h12v1H0z\"/></svg> " : "") + "Leaflet</a>"
			},
			initialize: function(e) {
				p(this, e), this._attributions = {};
			},
			onAdd: function(e) {
				for (var t in e.attributionControl = this, this._container = J("div", "leaflet-control-attribution"), qt(this._container), e._layers) e._layers[t].getAttribution && this.addAttribution(e._layers[t].getAttribution());
				return this._update(), e.on("layeradd", this._addAttribution, this), this._container;
			},
			onRemove: function(e) {
				e.off("layeradd", this._addAttribution, this);
			},
			_addAttribution: function(e) {
				e.layer.getAttribution && (this.addAttribution(e.layer.getAttribution()), e.layer.once("remove", function() {
					this.removeAttribution(e.layer.getAttribution());
				}, this));
			},
			setPrefix: function(e) {
				return this.options.prefix = e, this._update(), this;
			},
			addAttribution: function(e) {
				return e ? (this._attributions[e] || (this._attributions[e] = 0), this._attributions[e]++, this._update(), this) : this;
			},
			removeAttribution: function(e) {
				return e && this._attributions[e] && (this._attributions[e]--, this._update()), this;
			},
			_update: function() {
				if (this._map) {
					var e = [];
					for (var t in this._attributions) this._attributions[t] && e.push(t);
					var n = [];
					this.options.prefix && n.push(this.options.prefix), e.length && n.push(e.join(", ")), this._container.innerHTML = n.join(" <span aria-hidden=\"true\">|</span> ");
				}
			}
		});
		rn.mergeOptions({ attributionControl: !0 }), rn.addInitHook(function() {
			this.options.attributionControl && new mn().addTo(this);
		}), on.Layers = cn, on.Zoom = un, on.Scale = fn, on.Attribution = mn, sn.layers = ln, sn.zoom = dn, sn.scale = pn, sn.attribution = function(e) {
			return new mn(e);
		};
		var hn = O.extend({
			initialize: function(e) {
				this._map = e;
			},
			enable: function() {
				return this._enabled ? this : (this._enabled = !0, this.addHooks(), this);
			},
			disable: function() {
				return this._enabled ? (this._enabled = !1, this.removeHooks(), this) : this;
			},
			enabled: function() {
				return !!this._enabled;
			}
		});
		hn.addTo = function(e, t) {
			return e.addHandler(t, this), this;
		};
		var gn = { Events: A }, _n = q.touch ? "touchstart mousedown" : "mousedown", vn = j.extend({
			options: { clickTolerance: 3 },
			initialize: function(e, t, n, r) {
				p(this, r), this._element = e, this._dragStartTarget = t || e, this._preventOutline = n;
			},
			enable: function() {
				this._enabled ||= (Q(this._dragStartTarget, _n, this._onDown, this), !0);
			},
			disable: function() {
				this._enabled && (vn._dragging === this && this.finishDrag(!0), Bt(this._dragStartTarget, _n, this._onDown, this), this._enabled = !1, this._moved = !1);
			},
			_onDown: function(e) {
				if (this._enabled && (this._moved = !1, !_t(this._element, "leaflet-zoom-anim"))) {
					if (e.touches && e.touches.length !== 1) {
						vn._dragging === this && this.finishDrag();
						return;
					}
					if (!(vn._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) && (vn._dragging = this, this._preventOutline && Pt(this._element), At(), Et(), !this._moving)) {
						this.fire("down");
						var t = e.touches ? e.touches[0] : e, n = It(this._element);
						this._startPoint = new M(t.clientX, t.clientY), this._startPos = Tt(this._element), this._parentScale = Lt(n);
						var r = e.type === "mousedown";
						Q(document, r ? "mousemove" : "touchmove", this._onMove, this), Q(document, r ? "mouseup" : "touchend touchcancel", this._onUp, this);
					}
				}
			},
			_onMove: function(e) {
				if (this._enabled) {
					if (e.touches && e.touches.length > 1) {
						this._moved = !0;
						return;
					}
					var t = e.touches && e.touches.length === 1 ? e.touches[0] : e, n = new M(t.clientX, t.clientY)._subtract(this._startPoint);
					(n.x || n.y) && (Math.abs(n.x) + Math.abs(n.y) < this.options.clickTolerance || (n.x /= this._parentScale.x, n.y /= this._parentScale.y, Jt(e), this._moved || (this.fire("dragstart"), this._moved = !0, X(document.body, "leaflet-dragging"), this._lastTarget = e.target || e.srcElement, window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance && (this._lastTarget = this._lastTarget.correspondingUseElement), X(this._lastTarget, "leaflet-drag-target")), this._newPos = this._startPos.add(n), this._moving = !0, this._lastEvent = e, this._updatePosition()));
				}
			},
			_updatePosition: function() {
				var e = { originalEvent: this._lastEvent };
				this.fire("predrag", e), wt(this._element, this._newPos), this.fire("drag", e);
			},
			_onUp: function() {
				this._enabled && this.finishDrag();
			},
			finishDrag: function(e) {
				vt(document.body, "leaflet-dragging"), this._lastTarget &&= (vt(this._lastTarget, "leaflet-drag-target"), null), Bt(document, "mousemove touchmove", this._onMove, this), Bt(document, "mouseup touchend touchcancel", this._onUp, this), jt(), Dt();
				var t = this._moved && this._moving;
				this._moving = !1, vn._dragging = !1, t && this.fire("dragend", {
					noInertia: e,
					distance: this._newPos.distanceTo(this._startPos)
				});
			}
		});
		function yn(e, t, n) {
			for (var r, i = [
				1,
				4,
				2,
				8
			], a = 0, o, s, c, l, u = e.length, d, f; a < u; a++) e[a]._code = Mn(e[a], t);
			for (s = 0; s < 4; s++) {
				for (d = i[s], r = [], a = 0, u = e.length, o = u - 1; a < u; o = a++) c = e[a], l = e[o], c._code & d ? l._code & d || (f = jn(l, c, d, t, n), f._code = Mn(f, t), r.push(f)) : (l._code & d && (f = jn(l, c, d, t, n), f._code = Mn(f, t), r.push(f)), r.push(c));
				e = r;
			}
			return e;
		}
		function bn(e, t) {
			var n, r, i, a, o, s, c, l, u;
			if (!e || e.length === 0) throw Error("latlngs not passed");
			Fn(e) || (console.warn("latlngs are not flat! Only the first ring will be used"), e = e[0]);
			var d = V([0, 0]), f = z(e);
			f.getNorthWest().distanceTo(f.getSouthWest()) * f.getNorthEast().distanceTo(f.getNorthWest()) < 1700 && (d = xn(e));
			var p = e.length, m = [];
			for (n = 0; n < p; n++) {
				var h = V(e[n]);
				m.push(t.project(V([h.lat - d.lat, h.lng - d.lng])));
			}
			for (s = c = l = 0, n = 0, r = p - 1; n < p; r = n++) i = m[n], a = m[r], o = i.y * a.x - a.y * i.x, c += (i.x + a.x) * o, l += (i.y + a.y) * o, s += o * 3;
			u = s === 0 ? m[0] : [c / s, l / s];
			var g = t.unproject(P(u));
			return V([g.lat + d.lat, g.lng + d.lng]);
		}
		function xn(e) {
			for (var t = 0, n = 0, r = 0, i = 0; i < e.length; i++) {
				var a = V(e[i]);
				t += a.lat, n += a.lng, r++;
			}
			return V([t / r, n / r]);
		}
		var Sn = {
			__proto__: null,
			clipPolygon: yn,
			polygonCenter: bn,
			centroid: xn
		};
		function Cn(e, t) {
			if (!t || !e.length) return e.slice();
			var n = t * t;
			return e = On(e, n), e = En(e, n), e;
		}
		function wn(e, t, n) {
			return Math.sqrt(Pn(e, t, n, !0));
		}
		function Tn(e, t, n) {
			return Pn(e, t, n);
		}
		function En(e, t) {
			var n = e.length, r = new (typeof Uint8Array < "u" ? Uint8Array : Array)(n);
			r[0] = r[n - 1] = 1, Dn(e, r, t, 0, n - 1);
			var i, a = [];
			for (i = 0; i < n; i++) r[i] && a.push(e[i]);
			return a;
		}
		function Dn(e, t, n, r, i) {
			for (var a = 0, o, s = r + 1, c; s <= i - 1; s++) c = Pn(e[s], e[r], e[i], !0), c > a && (o = s, a = c);
			a > n && (t[o] = 1, Dn(e, t, n, r, o), Dn(e, t, n, o, i));
		}
		function On(e, t) {
			for (var n = [e[0]], r = 1, i = 0, a = e.length; r < a; r++) Nn(e[r], e[i]) > t && (n.push(e[r]), i = r);
			return i < a - 1 && n.push(e[a - 1]), n;
		}
		var kn;
		function An(e, t, n, r, i) {
			var a = r ? kn : Mn(e, n), o = Mn(t, n), s, c, l;
			for (kn = o;;) {
				if (!(a | o)) return [e, t];
				if (a & o) return !1;
				s = a || o, c = jn(e, t, s, n, i), l = Mn(c, n), s === a ? (e = c, a = l) : (t = c, o = l);
			}
		}
		function jn(e, t, n, r, i) {
			var a = t.x - e.x, o = t.y - e.y, s = r.min, c = r.max, l, u;
			return n & 8 ? (l = e.x + a * (c.y - e.y) / o, u = c.y) : n & 4 ? (l = e.x + a * (s.y - e.y) / o, u = s.y) : n & 2 ? (l = c.x, u = e.y + o * (c.x - e.x) / a) : n & 1 && (l = s.x, u = e.y + o * (s.x - e.x) / a), new M(l, u, i);
		}
		function Mn(e, t) {
			var n = 0;
			return e.x < t.min.x ? n |= 1 : e.x > t.max.x && (n |= 2), e.y < t.min.y ? n |= 4 : e.y > t.max.y && (n |= 8), n;
		}
		function Nn(e, t) {
			var n = t.x - e.x, r = t.y - e.y;
			return n * n + r * r;
		}
		function Pn(e, t, n, r) {
			var i = t.x, a = t.y, o = n.x - i, s = n.y - a, c = o * o + s * s, l;
			return c > 0 && (l = ((e.x - i) * o + (e.y - a) * s) / c, l > 1 ? (i = n.x, a = n.y) : l > 0 && (i += o * l, a += s * l)), o = e.x - i, s = e.y - a, r ? o * o + s * s : new M(i, a);
		}
		function Fn(e) {
			return !_(e[0]) || typeof e[0][0] != "object" && e[0][0] !== void 0;
		}
		function In(e) {
			return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."), Fn(e);
		}
		function Ln(e, t) {
			var n, r, i, a, o, s, c, l;
			if (!e || e.length === 0) throw Error("latlngs not passed");
			Fn(e) || (console.warn("latlngs are not flat! Only the first ring will be used"), e = e[0]);
			var u = V([0, 0]), d = z(e);
			d.getNorthWest().distanceTo(d.getSouthWest()) * d.getNorthEast().distanceTo(d.getNorthWest()) < 1700 && (u = xn(e));
			var f = e.length, p = [];
			for (n = 0; n < f; n++) {
				var m = V(e[n]);
				p.push(t.project(V([m.lat - u.lat, m.lng - u.lng])));
			}
			for (n = 0, r = 0; n < f - 1; n++) r += p[n].distanceTo(p[n + 1]) / 2;
			if (r === 0) l = p[0];
			else for (n = 0, a = 0; n < f - 1; n++) if (o = p[n], s = p[n + 1], i = o.distanceTo(s), a += i, a > r) {
				c = (a - r) / i, l = [s.x - c * (s.x - o.x), s.y - c * (s.y - o.y)];
				break;
			}
			var h = t.unproject(P(l));
			return V([h.lat + u.lat, h.lng + u.lng]);
		}
		var Rn = {
			__proto__: null,
			simplify: Cn,
			pointToSegmentDistance: wn,
			closestPointOnSegment: Tn,
			clipSegment: An,
			_getEdgeIntersection: jn,
			_getBitCode: Mn,
			_sqClosestPointOnSegment: Pn,
			isFlat: Fn,
			_flat: In,
			polylineCenter: Ln
		}, zn = {
			project: function(e) {
				return new M(e.lng, e.lat);
			},
			unproject: function(e) {
				return new B(e.y, e.x);
			},
			bounds: new F([-180, -90], [180, 90])
		}, Bn = {
			R: 6378137,
			R_MINOR: 6356752.314245179,
			bounds: new F([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),
			project: function(e) {
				var t = Math.PI / 180, n = this.R, r = e.lat * t, i = this.R_MINOR / n, a = Math.sqrt(1 - i * i), o = a * Math.sin(r), s = Math.tan(Math.PI / 4 - r / 2) / ((1 - o) / (1 + o)) ** (a / 2);
				return r = -n * Math.log(Math.max(s, 1e-10)), new M(e.lng * t * n, r);
			},
			unproject: function(e) {
				for (var t = 180 / Math.PI, n = this.R, r = this.R_MINOR / n, i = Math.sqrt(1 - r * r), a = Math.exp(-e.y / n), o = Math.PI / 2 - 2 * Math.atan(a), s = 0, c = .1, l; s < 15 && Math.abs(c) > 1e-7; s++) l = i * Math.sin(o), l = ((1 - l) / (1 + l)) ** (i / 2), c = Math.PI / 2 - 2 * Math.atan(a * l) - o, o += c;
				return new B(o * t, e.x * t / n);
			}
		}, Vn = {
			__proto__: null,
			LonLat: zn,
			Mercator: Bn,
			SphericalMercator: re
		}, Hn = n({}, te, {
			code: "EPSG:3395",
			projection: Bn,
			transformation: function() {
				var e = .5 / (Math.PI * Bn.R);
				return ae(e, .5, -e, .5);
			}()
		}), Un = n({}, te, {
			code: "EPSG:4326",
			projection: zn,
			transformation: ae(1 / 180, 1, -1 / 180, .5)
		}), Wn = n({}, ee, {
			projection: zn,
			transformation: ae(1, 0, -1, 0),
			scale: function(e) {
				return 2 ** e;
			},
			zoom: function(e) {
				return Math.log(e) / Math.LN2;
			},
			distance: function(e, t) {
				var n = t.lng - e.lng, r = t.lat - e.lat;
				return Math.sqrt(n * n + r * r);
			},
			infinite: !0
		});
		ee.Earth = te, ee.EPSG3395 = Hn, ee.EPSG3857 = oe, ee.EPSG900913 = H, ee.EPSG4326 = Un, ee.Simple = Wn;
		var Gn = j.extend({
			options: {
				pane: "overlayPane",
				attribution: null,
				bubblingMouseEvents: !0
			},
			addTo: function(e) {
				return e.addLayer(this), this;
			},
			remove: function() {
				return this.removeFrom(this._map || this._mapToAdd);
			},
			removeFrom: function(e) {
				return e && e.removeLayer(this), this;
			},
			getPane: function(e) {
				return this._map.getPane(e ? this.options[e] || e : this.options.pane);
			},
			addInteractiveTarget: function(e) {
				return this._map._targets[o(e)] = this, this;
			},
			removeInteractiveTarget: function(e) {
				return delete this._map._targets[o(e)], this;
			},
			getAttribution: function() {
				return this.options.attribution;
			},
			_layerAdd: function(e) {
				var t = e.target;
				if (t.hasLayer(this)) {
					if (this._map = t, this._zoomAnimated = t._zoomAnimated, this.getEvents) {
						var n = this.getEvents();
						t.on(n, this), this.once("remove", function() {
							t.off(n, this);
						}, this);
					}
					this.onAdd(t), this.fire("add"), t.fire("layeradd", { layer: this });
				}
			}
		});
		rn.include({
			addLayer: function(e) {
				if (!e._layerAdd) throw Error("The provided object is not a Layer.");
				var t = o(e);
				return this._layers[t] ? this : (this._layers[t] = e, e._mapToAdd = this, e.beforeAdd && e.beforeAdd(this), this.whenReady(e._layerAdd, e), this);
			},
			removeLayer: function(e) {
				var t = o(e);
				return this._layers[t] ? (this._loaded && e.onRemove(this), delete this._layers[t], this._loaded && (this.fire("layerremove", { layer: e }), e.fire("remove")), e._map = e._mapToAdd = null, this) : this;
			},
			hasLayer: function(e) {
				return o(e) in this._layers;
			},
			eachLayer: function(e, t) {
				for (var n in this._layers) e.call(t, this._layers[n]);
				return this;
			},
			_addLayers: function(e) {
				e = e ? _(e) ? e : [e] : [];
				for (var t = 0, n = e.length; t < n; t++) this.addLayer(e[t]);
			},
			_addZoomLimit: function(e) {
				(!isNaN(e.options.maxZoom) || !isNaN(e.options.minZoom)) && (this._zoomBoundLayers[o(e)] = e, this._updateZoomLevels());
			},
			_removeZoomLimit: function(e) {
				var t = o(e);
				this._zoomBoundLayers[t] && (delete this._zoomBoundLayers[t], this._updateZoomLevels());
			},
			_updateZoomLevels: function() {
				var e = Infinity, t = -Infinity, n = this._getZoomSpan();
				for (var r in this._zoomBoundLayers) {
					var i = this._zoomBoundLayers[r].options;
					e = i.minZoom === void 0 ? e : Math.min(e, i.minZoom), t = i.maxZoom === void 0 ? t : Math.max(t, i.maxZoom);
				}
				this._layersMaxZoom = t === -Infinity ? void 0 : t, this._layersMinZoom = e === Infinity ? void 0 : e, n !== this._getZoomSpan() && this.fire("zoomlevelschange"), this.options.maxZoom === void 0 && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom && this.setZoom(this._layersMaxZoom), this.options.minZoom === void 0 && this._layersMinZoom && this.getZoom() < this._layersMinZoom && this.setZoom(this._layersMinZoom);
			}
		});
		var Kn = Gn.extend({
			initialize: function(e, t) {
				p(this, t), this._layers = {};
				var n, r;
				if (e) for (n = 0, r = e.length; n < r; n++) this.addLayer(e[n]);
			},
			addLayer: function(e) {
				var t = this.getLayerId(e);
				return this._layers[t] = e, this._map && this._map.addLayer(e), this;
			},
			removeLayer: function(e) {
				var t = e in this._layers ? e : this.getLayerId(e);
				return this._map && this._layers[t] && this._map.removeLayer(this._layers[t]), delete this._layers[t], this;
			},
			hasLayer: function(e) {
				return (typeof e == "number" ? e : this.getLayerId(e)) in this._layers;
			},
			clearLayers: function() {
				return this.eachLayer(this.removeLayer, this);
			},
			invoke: function(e) {
				var t = Array.prototype.slice.call(arguments, 1), n, r;
				for (n in this._layers) r = this._layers[n], r[e] && r[e].apply(r, t);
				return this;
			},
			onAdd: function(e) {
				this.eachLayer(e.addLayer, e);
			},
			onRemove: function(e) {
				this.eachLayer(e.removeLayer, e);
			},
			eachLayer: function(e, t) {
				for (var n in this._layers) e.call(t, this._layers[n]);
				return this;
			},
			getLayer: function(e) {
				return this._layers[e];
			},
			getLayers: function() {
				var e = [];
				return this.eachLayer(e.push, e), e;
			},
			setZIndex: function(e) {
				return this.invoke("setZIndex", e);
			},
			getLayerId: function(e) {
				return o(e);
			}
		}), qn = function(e, t) {
			return new Kn(e, t);
		}, $ = Kn.extend({
			addLayer: function(e) {
				return this.hasLayer(e) ? this : (e.addEventParent(this), Kn.prototype.addLayer.call(this, e), this.fire("layeradd", { layer: e }));
			},
			removeLayer: function(e) {
				return this.hasLayer(e) ? (e in this._layers && (e = this._layers[e]), e.removeEventParent(this), Kn.prototype.removeLayer.call(this, e), this.fire("layerremove", { layer: e })) : this;
			},
			setStyle: function(e) {
				return this.invoke("setStyle", e);
			},
			bringToFront: function() {
				return this.invoke("bringToFront");
			},
			bringToBack: function() {
				return this.invoke("bringToBack");
			},
			getBounds: function() {
				var e = new R();
				for (var t in this._layers) {
					var n = this._layers[t];
					e.extend(n.getBounds ? n.getBounds() : n.getLatLng());
				}
				return e;
			}
		}), Jn = function(e, t) {
			return new $(e, t);
		}, Yn = O.extend({
			options: {
				popupAnchor: [0, 0],
				tooltipAnchor: [0, 0],
				crossOrigin: !1
			},
			initialize: function(e) {
				p(this, e);
			},
			createIcon: function(e) {
				return this._createIcon("icon", e);
			},
			createShadow: function(e) {
				return this._createIcon("shadow", e);
			},
			_createIcon: function(e, t) {
				var n = this._getIconUrl(e);
				if (!n) {
					if (e === "icon") throw Error("iconUrl not set in Icon options (see the docs).");
					return null;
				}
				var r = this._createImg(n, t && t.tagName === "IMG" ? t : null);
				return this._setIconStyles(r, e), (this.options.crossOrigin || this.options.crossOrigin === "") && (r.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), r;
			},
			_setIconStyles: function(e, t) {
				var n = this.options, r = n[t + "Size"];
				typeof r == "number" && (r = [r, r]);
				var i = P(r), a = P(t === "shadow" && n.shadowAnchor || n.iconAnchor || i && i.divideBy(2, !0));
				e.className = "leaflet-marker-" + t + " " + (n.className || ""), a && (e.style.marginLeft = -a.x + "px", e.style.marginTop = -a.y + "px"), i && (e.style.width = i.x + "px", e.style.height = i.y + "px");
			},
			_createImg: function(e, t) {
				return t ||= document.createElement("img"), t.src = e, t;
			},
			_getIconUrl: function(e) {
				return q.retina && this.options[e + "RetinaUrl"] || this.options[e + "Url"];
			}
		});
		function Xn(e) {
			return new Yn(e);
		}
		var Zn = Yn.extend({
			options: {
				iconUrl: "marker-icon.png",
				iconRetinaUrl: "marker-icon-2x.png",
				shadowUrl: "marker-shadow.png",
				iconSize: [25, 41],
				iconAnchor: [12, 41],
				popupAnchor: [1, -34],
				tooltipAnchor: [16, -28],
				shadowSize: [41, 41]
			},
			_getIconUrl: function(e) {
				return typeof Zn.imagePath != "string" && (Zn.imagePath = this._detectIconPath()), (this.options.imagePath || Zn.imagePath) + Yn.prototype._getIconUrl.call(this, e);
			},
			_stripUrl: function(e) {
				var t = function(e, t, n) {
					var r = t.exec(e);
					return r && r[n];
				};
				return e = t(e, /^url\((['"])?(.+)\1\)$/, 2), e && t(e, /^(.*)marker-icon\.png$/, 1);
			},
			_detectIconPath: function() {
				var e = J("div", "leaflet-default-icon-path", document.body), t = pt(e, "background-image") || pt(e, "backgroundImage");
				if (document.body.removeChild(e), t = this._stripUrl(t), t) return t;
				var n = document.querySelector("link[href$=\"leaflet.css\"]");
				return n ? n.href.substring(0, n.href.length - 11 - 1) : "";
			}
		}), Qn = hn.extend({
			initialize: function(e) {
				this._marker = e;
			},
			addHooks: function() {
				var e = this._marker._icon;
				this._draggable ||= new vn(e, e, !0), this._draggable.on({
					dragstart: this._onDragStart,
					predrag: this._onPreDrag,
					drag: this._onDrag,
					dragend: this._onDragEnd
				}, this).enable(), X(e, "leaflet-marker-draggable");
			},
			removeHooks: function() {
				this._draggable.off({
					dragstart: this._onDragStart,
					predrag: this._onPreDrag,
					drag: this._onDrag,
					dragend: this._onDragEnd
				}, this).disable(), this._marker._icon && vt(this._marker._icon, "leaflet-marker-draggable");
			},
			moved: function() {
				return this._draggable && this._draggable._moved;
			},
			_adjustPan: function(e) {
				var t = this._marker, n = t._map, r = this._marker.options.autoPanSpeed, i = this._marker.options.autoPanPadding, a = Tt(t._icon), o = n.getPixelBounds(), s = n.getPixelOrigin(), c = I(o.min._subtract(s).add(i), o.max._subtract(s).subtract(i));
				if (!c.contains(a)) {
					var l = P((Math.max(c.max.x, a.x) - c.max.x) / (o.max.x - c.max.x) - (Math.min(c.min.x, a.x) - c.min.x) / (o.min.x - c.min.x), (Math.max(c.max.y, a.y) - c.max.y) / (o.max.y - c.max.y) - (Math.min(c.min.y, a.y) - c.min.y) / (o.min.y - c.min.y)).multiplyBy(r);
					n.panBy(l, { animate: !1 }), this._draggable._newPos._add(l), this._draggable._startPos._add(l), wt(t._icon, this._draggable._newPos), this._onDrag(e), this._panRequest = T(this._adjustPan.bind(this, e));
				}
			},
			_onDragStart: function() {
				this._oldLatLng = this._marker.getLatLng(), this._marker.closePopup && this._marker.closePopup(), this._marker.fire("movestart").fire("dragstart");
			},
			_onPreDrag: function(e) {
				this._marker.options.autoPan && (E(this._panRequest), this._panRequest = T(this._adjustPan.bind(this, e)));
			},
			_onDrag: function(e) {
				var t = this._marker, n = t._shadow, r = Tt(t._icon), i = t._map.layerPointToLatLng(r);
				n && wt(n, r), t._latlng = i, e.latlng = i, e.oldLatLng = this._oldLatLng, t.fire("move", e).fire("drag", e);
			},
			_onDragEnd: function(e) {
				E(this._panRequest), delete this._oldLatLng, this._marker.fire("moveend").fire("dragend", e);
			}
		}), $n = Gn.extend({
			options: {
				icon: new Zn(),
				interactive: !0,
				keyboard: !0,
				title: "",
				alt: "Marker",
				zIndexOffset: 0,
				opacity: 1,
				riseOnHover: !1,
				riseOffset: 250,
				pane: "markerPane",
				shadowPane: "shadowPane",
				bubblingMouseEvents: !1,
				autoPanOnFocus: !0,
				draggable: !1,
				autoPan: !1,
				autoPanPadding: [50, 50],
				autoPanSpeed: 10
			},
			initialize: function(e, t) {
				p(this, t), this._latlng = V(e);
			},
			onAdd: function(e) {
				this._zoomAnimated = this._zoomAnimated && e.options.markerZoomAnimation, this._zoomAnimated && e.on("zoomanim", this._animateZoom, this), this._initIcon(), this.update();
			},
			onRemove: function(e) {
				this.dragging && this.dragging.enabled() && (this.options.draggable = !0, this.dragging.removeHooks()), delete this.dragging, this._zoomAnimated && e.off("zoomanim", this._animateZoom, this), this._removeIcon(), this._removeShadow();
			},
			getEvents: function() {
				return {
					zoom: this.update,
					viewreset: this.update
				};
			},
			getLatLng: function() {
				return this._latlng;
			},
			setLatLng: function(e) {
				var t = this._latlng;
				return this._latlng = V(e), this.update(), this.fire("move", {
					oldLatLng: t,
					latlng: this._latlng
				});
			},
			setZIndexOffset: function(e) {
				return this.options.zIndexOffset = e, this.update();
			},
			getIcon: function() {
				return this.options.icon;
			},
			setIcon: function(e) {
				return this.options.icon = e, this._map && (this._initIcon(), this.update()), this._popup && this.bindPopup(this._popup, this._popup.options), this;
			},
			getElement: function() {
				return this._icon;
			},
			update: function() {
				if (this._icon && this._map) {
					var e = this._map.latLngToLayerPoint(this._latlng).round();
					this._setPos(e);
				}
				return this;
			},
			_initIcon: function() {
				var e = this.options, t = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide"), n = e.icon.createIcon(this._icon), r = !1;
				n !== this._icon && (this._icon && this._removeIcon(), r = !0, e.title && (n.title = e.title), n.tagName === "IMG" && (n.alt = e.alt || "")), X(n, t), e.keyboard && (n.tabIndex = "0", n.setAttribute("role", "button")), this._icon = n, e.riseOnHover && this.on({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				}), this.options.autoPanOnFocus && Q(n, "focus", this._panOnFocus, this);
				var i = e.icon.createShadow(this._shadow), a = !1;
				i !== this._shadow && (this._removeShadow(), a = !0), i && (X(i, t), i.alt = ""), this._shadow = i, e.opacity < 1 && this._updateOpacity(), r && this.getPane().appendChild(this._icon), this._initInteraction(), i && a && this.getPane(e.shadowPane).appendChild(this._shadow);
			},
			_removeIcon: function() {
				this.options.riseOnHover && this.off({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				}), this.options.autoPanOnFocus && Bt(this._icon, "focus", this._panOnFocus, this), mt(this._icon), this.removeInteractiveTarget(this._icon), this._icon = null;
			},
			_removeShadow: function() {
				this._shadow && mt(this._shadow), this._shadow = null;
			},
			_setPos: function(e) {
				this._icon && wt(this._icon, e), this._shadow && wt(this._shadow, e), this._zIndex = e.y + this.options.zIndexOffset, this._resetZIndex();
			},
			_updateZIndex: function(e) {
				this._icon && (this._icon.style.zIndex = this._zIndex + e);
			},
			_animateZoom: function(e) {
				var t = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center).round();
				this._setPos(t);
			},
			_initInteraction: function() {
				if (this.options.interactive && (X(this._icon, "leaflet-interactive"), this.addInteractiveTarget(this._icon), Qn)) {
					var e = this.options.draggable;
					this.dragging && (e = this.dragging.enabled(), this.dragging.disable()), this.dragging = new Qn(this), e && this.dragging.enable();
				}
			},
			setOpacity: function(e) {
				return this.options.opacity = e, this._map && this._updateOpacity(), this;
			},
			_updateOpacity: function() {
				var e = this.options.opacity;
				this._icon && bt(this._icon, e), this._shadow && bt(this._shadow, e);
			},
			_bringToFront: function() {
				this._updateZIndex(this.options.riseOffset);
			},
			_resetZIndex: function() {
				this._updateZIndex(0);
			},
			_panOnFocus: function() {
				var e = this._map;
				if (e) {
					var t = this.options.icon.options, n = t.iconSize ? P(t.iconSize) : P(0, 0), r = t.iconAnchor ? P(t.iconAnchor) : P(0, 0);
					e.panInside(this._latlng, {
						paddingTopLeft: r,
						paddingBottomRight: n.subtract(r)
					});
				}
			},
			_getPopupAnchor: function() {
				return this.options.icon.options.popupAnchor;
			},
			_getTooltipAnchor: function() {
				return this.options.icon.options.tooltipAnchor;
			}
		});
		function er(e, t) {
			return new $n(e, t);
		}
		var tr = Gn.extend({
			options: {
				stroke: !0,
				color: "#3388ff",
				weight: 3,
				opacity: 1,
				lineCap: "round",
				lineJoin: "round",
				dashArray: null,
				dashOffset: null,
				fill: !1,
				fillColor: null,
				fillOpacity: .2,
				fillRule: "evenodd",
				interactive: !0,
				bubblingMouseEvents: !0
			},
			beforeAdd: function(e) {
				this._renderer = e.getRenderer(this);
			},
			onAdd: function() {
				this._renderer._initPath(this), this._reset(), this._renderer._addPath(this);
			},
			onRemove: function() {
				this._renderer._removePath(this);
			},
			redraw: function() {
				return this._map && this._renderer._updatePath(this), this;
			},
			setStyle: function(e) {
				return p(this, e), this._renderer && (this._renderer._updateStyle(this), this.options.stroke && e && Object.prototype.hasOwnProperty.call(e, "weight") && this._updateBounds()), this;
			},
			bringToFront: function() {
				return this._renderer && this._renderer._bringToFront(this), this;
			},
			bringToBack: function() {
				return this._renderer && this._renderer._bringToBack(this), this;
			},
			getElement: function() {
				return this._path;
			},
			_reset: function() {
				this._project(), this._update();
			},
			_clickTolerance: function() {
				return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
			}
		}), nr = tr.extend({
			options: {
				fill: !0,
				radius: 10
			},
			initialize: function(e, t) {
				p(this, t), this._latlng = V(e), this._radius = this.options.radius;
			},
			setLatLng: function(e) {
				var t = this._latlng;
				return this._latlng = V(e), this.redraw(), this.fire("move", {
					oldLatLng: t,
					latlng: this._latlng
				});
			},
			getLatLng: function() {
				return this._latlng;
			},
			setRadius: function(e) {
				return this.options.radius = this._radius = e, this.redraw();
			},
			getRadius: function() {
				return this._radius;
			},
			setStyle: function(e) {
				var t = e && e.radius || this._radius;
				return tr.prototype.setStyle.call(this, e), this.setRadius(t), this;
			},
			_project: function() {
				this._point = this._map.latLngToLayerPoint(this._latlng), this._updateBounds();
			},
			_updateBounds: function() {
				var e = this._radius, t = this._radiusY || e, n = this._clickTolerance(), r = [e + n, t + n];
				this._pxBounds = new F(this._point.subtract(r), this._point.add(r));
			},
			_update: function() {
				this._map && this._updatePath();
			},
			_updatePath: function() {
				this._renderer._updateCircle(this);
			},
			_empty: function() {
				return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
			},
			_containsPoint: function(e) {
				return e.distanceTo(this._point) <= this._radius + this._clickTolerance();
			}
		});
		function rr(e, t) {
			return new nr(e, t);
		}
		var ir = nr.extend({
			initialize: function(e, t, r) {
				if (typeof t == "number" && (t = n({}, r, { radius: t })), p(this, t), this._latlng = V(e), isNaN(this.options.radius)) throw Error("Circle radius cannot be NaN");
				this._mRadius = this.options.radius;
			},
			setRadius: function(e) {
				return this._mRadius = e, this.redraw();
			},
			getRadius: function() {
				return this._mRadius;
			},
			getBounds: function() {
				var e = [this._radius, this._radiusY || this._radius];
				return new R(this._map.layerPointToLatLng(this._point.subtract(e)), this._map.layerPointToLatLng(this._point.add(e)));
			},
			setStyle: tr.prototype.setStyle,
			_project: function() {
				var e = this._latlng.lng, t = this._latlng.lat, n = this._map, r = n.options.crs;
				if (r.distance === te.distance) {
					var i = Math.PI / 180, a = this._mRadius / te.R / i, o = n.project([t + a, e]), s = n.project([t - a, e]), c = o.add(s).divideBy(2), l = n.unproject(c).lat, u = Math.acos((Math.cos(a * i) - Math.sin(t * i) * Math.sin(l * i)) / (Math.cos(t * i) * Math.cos(l * i))) / i;
					(isNaN(u) || u === 0) && (u = a / Math.cos(Math.PI / 180 * t)), this._point = c.subtract(n.getPixelOrigin()), this._radius = isNaN(u) ? 0 : c.x - n.project([l, e - u]).x, this._radiusY = c.y - o.y;
				} else {
					var d = r.unproject(r.project(this._latlng).subtract([this._mRadius, 0]));
					this._point = n.latLngToLayerPoint(this._latlng), this._radius = this._point.x - n.latLngToLayerPoint(d).x;
				}
				this._updateBounds();
			}
		});
		function ar(e, t, n) {
			return new ir(e, t, n);
		}
		var or = tr.extend({
			options: {
				smoothFactor: 1,
				noClip: !1
			},
			initialize: function(e, t) {
				p(this, t), this._setLatLngs(e);
			},
			getLatLngs: function() {
				return this._latlngs;
			},
			setLatLngs: function(e) {
				return this._setLatLngs(e), this.redraw();
			},
			isEmpty: function() {
				return !this._latlngs.length;
			},
			closestLayerPoint: function(e) {
				for (var t = Infinity, n = null, r = Pn, i, a, o = 0, s = this._parts.length; o < s; o++) for (var c = this._parts[o], l = 1, u = c.length; l < u; l++) {
					i = c[l - 1], a = c[l];
					var d = r(e, i, a, !0);
					d < t && (t = d, n = r(e, i, a));
				}
				return n && (n.distance = Math.sqrt(t)), n;
			},
			getCenter: function() {
				if (!this._map) throw Error("Must add layer to map before using getCenter()");
				return Ln(this._defaultShape(), this._map.options.crs);
			},
			getBounds: function() {
				return this._bounds;
			},
			addLatLng: function(e, t) {
				return t ||= this._defaultShape(), e = V(e), t.push(e), this._bounds.extend(e), this.redraw();
			},
			_setLatLngs: function(e) {
				this._bounds = new R(), this._latlngs = this._convertLatLngs(e);
			},
			_defaultShape: function() {
				return Fn(this._latlngs) ? this._latlngs : this._latlngs[0];
			},
			_convertLatLngs: function(e) {
				for (var t = [], n = Fn(e), r = 0, i = e.length; r < i; r++) n ? (t[r] = V(e[r]), this._bounds.extend(t[r])) : t[r] = this._convertLatLngs(e[r]);
				return t;
			},
			_project: function() {
				var e = new F();
				this._rings = [], this._projectLatlngs(this._latlngs, this._rings, e), this._bounds.isValid() && e.isValid() && (this._rawPxBounds = e, this._updateBounds());
			},
			_updateBounds: function() {
				var e = this._clickTolerance(), t = new M(e, e);
				this._rawPxBounds && (this._pxBounds = new F([this._rawPxBounds.min.subtract(t), this._rawPxBounds.max.add(t)]));
			},
			_projectLatlngs: function(e, t, n) {
				var r = e[0] instanceof B, i = e.length, a, o;
				if (r) {
					for (o = [], a = 0; a < i; a++) o[a] = this._map.latLngToLayerPoint(e[a]), n.extend(o[a]);
					t.push(o);
				} else for (a = 0; a < i; a++) this._projectLatlngs(e[a], t, n);
			},
			_clipPoints: function() {
				var e = this._renderer._bounds;
				if (this._parts = [], this._pxBounds && this._pxBounds.intersects(e)) {
					if (this.options.noClip) {
						this._parts = this._rings;
						return;
					}
					for (var t = this._parts, n = 0, r, i = 0, a = this._rings.length, o, s, c; n < a; n++) for (c = this._rings[n], r = 0, o = c.length; r < o - 1; r++) s = An(c[r], c[r + 1], e, r, !0), s && (t[i] = t[i] || [], t[i].push(s[0]), (s[1] !== c[r + 1] || r === o - 2) && (t[i].push(s[1]), i++));
				}
			},
			_simplifyPoints: function() {
				for (var e = this._parts, t = this.options.smoothFactor, n = 0, r = e.length; n < r; n++) e[n] = Cn(e[n], t);
			},
			_update: function() {
				this._map && (this._clipPoints(), this._simplifyPoints(), this._updatePath());
			},
			_updatePath: function() {
				this._renderer._updatePoly(this);
			},
			_containsPoint: function(e, t) {
				var n, r, i, a, o, s, c = this._clickTolerance();
				if (!this._pxBounds || !this._pxBounds.contains(e)) return !1;
				for (n = 0, a = this._parts.length; n < a; n++) for (s = this._parts[n], r = 0, o = s.length, i = o - 1; r < o; i = r++) if ((t || r !== 0) && wn(e, s[i], s[r]) <= c) return !0;
				return !1;
			}
		});
		function sr(e, t) {
			return new or(e, t);
		}
		or._flat = In;
		var cr = or.extend({
			options: { fill: !0 },
			isEmpty: function() {
				return !this._latlngs.length || !this._latlngs[0].length;
			},
			getCenter: function() {
				if (!this._map) throw Error("Must add layer to map before using getCenter()");
				return bn(this._defaultShape(), this._map.options.crs);
			},
			_convertLatLngs: function(e) {
				var t = or.prototype._convertLatLngs.call(this, e), n = t.length;
				return n >= 2 && t[0] instanceof B && t[0].equals(t[n - 1]) && t.pop(), t;
			},
			_setLatLngs: function(e) {
				or.prototype._setLatLngs.call(this, e), Fn(this._latlngs) && (this._latlngs = [this._latlngs]);
			},
			_defaultShape: function() {
				return Fn(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
			},
			_clipPoints: function() {
				var e = this._renderer._bounds, t = this.options.weight, n = new M(t, t);
				if (e = new F(e.min.subtract(n), e.max.add(n)), this._parts = [], this._pxBounds && this._pxBounds.intersects(e)) {
					if (this.options.noClip) {
						this._parts = this._rings;
						return;
					}
					for (var r = 0, i = this._rings.length, a; r < i; r++) a = yn(this._rings[r], e, !0), a.length && this._parts.push(a);
				}
			},
			_updatePath: function() {
				this._renderer._updatePoly(this, !0);
			},
			_containsPoint: function(e) {
				var t = !1, n, r, i, a, o, s, c, l;
				if (!this._pxBounds || !this._pxBounds.contains(e)) return !1;
				for (a = 0, c = this._parts.length; a < c; a++) for (n = this._parts[a], o = 0, l = n.length, s = l - 1; o < l; s = o++) r = n[o], i = n[s], r.y > e.y != i.y > e.y && e.x < (i.x - r.x) * (e.y - r.y) / (i.y - r.y) + r.x && (t = !t);
				return t || or.prototype._containsPoint.call(this, e, !0);
			}
		});
		function lr(e, t) {
			return new cr(e, t);
		}
		var ur = $.extend({
			initialize: function(e, t) {
				p(this, t), this._layers = {}, e && this.addData(e);
			},
			addData: function(e) {
				var t = _(e) ? e : e.features, n, r, i;
				if (t) {
					for (n = 0, r = t.length; n < r; n++) i = t[n], (i.geometries || i.geometry || i.features || i.coordinates) && this.addData(i);
					return this;
				}
				var a = this.options;
				if (a.filter && !a.filter(e)) return this;
				var o = dr(e, a);
				return o ? (o.feature = vr(e), o.defaultOptions = o.options, this.resetStyle(o), a.onEachFeature && a.onEachFeature(e, o), this.addLayer(o)) : this;
			},
			resetStyle: function(e) {
				return e === void 0 ? this.eachLayer(this.resetStyle, this) : (e.options = n({}, e.defaultOptions), this._setLayerStyle(e, this.options.style), this);
			},
			setStyle: function(e) {
				return this.eachLayer(function(t) {
					this._setLayerStyle(t, e);
				}, this);
			},
			_setLayerStyle: function(e, t) {
				e.setStyle && (typeof t == "function" && (t = t(e.feature)), e.setStyle(t));
			}
		});
		function dr(e, t) {
			var n = e.type === "Feature" ? e.geometry : e, r = n ? n.coordinates : null, i = [], a = t && t.pointToLayer, o = t && t.coordsToLatLng || pr, s, c, l, u;
			if (!r && !n) return null;
			switch (n.type) {
				case "Point": return s = o(r), fr(a, e, s, t);
				case "MultiPoint":
					for (l = 0, u = r.length; l < u; l++) s = o(r[l]), i.push(fr(a, e, s, t));
					return new $(i);
				case "LineString":
				case "MultiLineString": return c = mr(r, n.type === "LineString" ? 0 : 1, o), new or(c, t);
				case "Polygon":
				case "MultiPolygon": return c = mr(r, n.type === "Polygon" ? 1 : 2, o), new cr(c, t);
				case "GeometryCollection":
					for (l = 0, u = n.geometries.length; l < u; l++) {
						var d = dr({
							geometry: n.geometries[l],
							type: "Feature",
							properties: e.properties
						}, t);
						d && i.push(d);
					}
					return new $(i);
				case "FeatureCollection":
					for (l = 0, u = n.features.length; l < u; l++) {
						var f = dr(n.features[l], t);
						f && i.push(f);
					}
					return new $(i);
				default: throw Error("Invalid GeoJSON object.");
			}
		}
		function fr(e, t, n, r) {
			return e ? e(t, n) : new $n(n, r && r.markersInheritOptions && r);
		}
		function pr(e) {
			return new B(e[1], e[0], e[2]);
		}
		function mr(e, t, n) {
			for (var r = [], i = 0, a = e.length, o; i < a; i++) o = t ? mr(e[i], t - 1, n) : (n || pr)(e[i]), r.push(o);
			return r;
		}
		function hr(e, t) {
			return e = V(e), e.alt === void 0 ? [u(e.lng, t), u(e.lat, t)] : [
				u(e.lng, t),
				u(e.lat, t),
				u(e.alt, t)
			];
		}
		function gr(e, t, n, r) {
			for (var i = [], a = 0, o = e.length; a < o; a++) i.push(t ? gr(e[a], Fn(e[a]) ? 0 : t - 1, n, r) : hr(e[a], r));
			return !t && n && i.length > 0 && i.push(i[0].slice()), i;
		}
		function _r(e, t) {
			return e.feature ? n({}, e.feature, { geometry: t }) : vr(t);
		}
		function vr(e) {
			return e.type === "Feature" || e.type === "FeatureCollection" ? e : {
				type: "Feature",
				properties: {},
				geometry: e
			};
		}
		var yr = { toGeoJSON: function(e) {
			return _r(this, {
				type: "Point",
				coordinates: hr(this.getLatLng(), e)
			});
		} };
		$n.include(yr), ir.include(yr), nr.include(yr), or.include({ toGeoJSON: function(e) {
			var t = !Fn(this._latlngs), n = gr(this._latlngs, +!!t, !1, e);
			return _r(this, {
				type: (t ? "Multi" : "") + "LineString",
				coordinates: n
			});
		} }), cr.include({ toGeoJSON: function(e) {
			var t = !Fn(this._latlngs), n = t && !Fn(this._latlngs[0]), r = gr(this._latlngs, n ? 2 : +!!t, !0, e);
			return t || (r = [r]), _r(this, {
				type: (n ? "Multi" : "") + "Polygon",
				coordinates: r
			});
		} }), Kn.include({
			toMultiPoint: function(e) {
				var t = [];
				return this.eachLayer(function(n) {
					t.push(n.toGeoJSON(e).geometry.coordinates);
				}), _r(this, {
					type: "MultiPoint",
					coordinates: t
				});
			},
			toGeoJSON: function(e) {
				var t = this.feature && this.feature.geometry && this.feature.geometry.type;
				if (t === "MultiPoint") return this.toMultiPoint(e);
				var n = t === "GeometryCollection", r = [];
				return this.eachLayer(function(t) {
					if (t.toGeoJSON) {
						var i = t.toGeoJSON(e);
						if (n) r.push(i.geometry);
						else {
							var a = vr(i);
							a.type === "FeatureCollection" ? r.push.apply(r, a.features) : r.push(a);
						}
					}
				}), n ? _r(this, {
					geometries: r,
					type: "GeometryCollection"
				}) : {
					type: "FeatureCollection",
					features: r
				};
			}
		});
		function br(e, t) {
			return new ur(e, t);
		}
		var xr = br, Sr = Gn.extend({
			options: {
				opacity: 1,
				alt: "",
				interactive: !1,
				crossOrigin: !1,
				errorOverlayUrl: "",
				zIndex: 1,
				className: ""
			},
			initialize: function(e, t, n) {
				this._url = e, this._bounds = z(t), p(this, n);
			},
			onAdd: function() {
				this._image || (this._initImage(), this.options.opacity < 1 && this._updateOpacity()), this.options.interactive && (X(this._image, "leaflet-interactive"), this.addInteractiveTarget(this._image)), this.getPane().appendChild(this._image), this._reset();
			},
			onRemove: function() {
				mt(this._image), this.options.interactive && this.removeInteractiveTarget(this._image);
			},
			setOpacity: function(e) {
				return this.options.opacity = e, this._image && this._updateOpacity(), this;
			},
			setStyle: function(e) {
				return e.opacity && this.setOpacity(e.opacity), this;
			},
			bringToFront: function() {
				return this._map && Y(this._image), this;
			},
			bringToBack: function() {
				return this._map && gt(this._image), this;
			},
			setUrl: function(e) {
				return this._url = e, this._image && (this._image.src = e), this;
			},
			setBounds: function(e) {
				return this._bounds = z(e), this._map && this._reset(), this;
			},
			getEvents: function() {
				var e = {
					zoom: this._reset,
					viewreset: this._reset
				};
				return this._zoomAnimated && (e.zoomanim = this._animateZoom), e;
			},
			setZIndex: function(e) {
				return this.options.zIndex = e, this._updateZIndex(), this;
			},
			getBounds: function() {
				return this._bounds;
			},
			getElement: function() {
				return this._image;
			},
			_initImage: function() {
				var e = this._url.tagName === "IMG", t = this._image = e ? this._url : J("img");
				if (X(t, "leaflet-image-layer"), this._zoomAnimated && X(t, "leaflet-zoom-animated"), this.options.className && X(t, this.options.className), t.onselectstart = l, t.onmousemove = l, t.onload = i(this.fire, this, "load"), t.onerror = i(this._overlayOnError, this, "error"), (this.options.crossOrigin || this.options.crossOrigin === "") && (t.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), this.options.zIndex && this._updateZIndex(), e) {
					this._url = t.src;
					return;
				}
				t.src = this._url, t.alt = this.options.alt;
			},
			_animateZoom: function(e) {
				var t = this._map.getZoomScale(e.zoom), n = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
				Ct(this._image, n, t);
			},
			_reset: function() {
				var e = this._image, t = new F(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), n = t.getSize();
				wt(e, t.min), e.style.width = n.x + "px", e.style.height = n.y + "px";
			},
			_updateOpacity: function() {
				bt(this._image, this.options.opacity);
			},
			_updateZIndex: function() {
				this._image && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._image.style.zIndex = this.options.zIndex);
			},
			_overlayOnError: function() {
				this.fire("error");
				var e = this.options.errorOverlayUrl;
				e && this._url !== e && (this._url = e, this._image.src = e);
			},
			getCenter: function() {
				return this._bounds.getCenter();
			}
		}), Cr = function(e, t, n) {
			return new Sr(e, t, n);
		}, wr = Sr.extend({
			options: {
				autoplay: !0,
				loop: !0,
				keepAspectRatio: !0,
				muted: !1,
				playsInline: !0
			},
			_initImage: function() {
				var e = this._url.tagName === "VIDEO", t = this._image = e ? this._url : J("video");
				if (X(t, "leaflet-image-layer"), this._zoomAnimated && X(t, "leaflet-zoom-animated"), this.options.className && X(t, this.options.className), t.onselectstart = l, t.onmousemove = l, t.onloadeddata = i(this.fire, this, "load"), e) {
					for (var n = t.getElementsByTagName("source"), r = [], a = 0; a < n.length; a++) r.push(n[a].src);
					this._url = n.length > 0 ? r : [t.src];
					return;
				}
				_(this._url) || (this._url = [this._url]), !this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(t.style, "objectFit") && (t.style.objectFit = "fill"), t.autoplay = !!this.options.autoplay, t.loop = !!this.options.loop, t.muted = !!this.options.muted, t.playsInline = !!this.options.playsInline;
				for (var o = 0; o < this._url.length; o++) {
					var s = J("source");
					s.src = this._url[o], t.appendChild(s);
				}
			}
		});
		function Tr(e, t, n) {
			return new wr(e, t, n);
		}
		var Er = Sr.extend({ _initImage: function() {
			var e = this._image = this._url;
			X(e, "leaflet-image-layer"), this._zoomAnimated && X(e, "leaflet-zoom-animated"), this.options.className && X(e, this.options.className), e.onselectstart = l, e.onmousemove = l;
		} });
		function Dr(e, t, n) {
			return new Er(e, t, n);
		}
		var Or = Gn.extend({
			options: {
				interactive: !1,
				offset: [0, 0],
				className: "",
				pane: void 0,
				content: ""
			},
			initialize: function(e, t) {
				e && (e instanceof B || _(e)) ? (this._latlng = V(e), p(this, t)) : (p(this, e), this._source = t), this.options.content && (this._content = this.options.content);
			},
			openOn: function(e) {
				return e = arguments.length ? e : this._source._map, e.hasLayer(this) || e.addLayer(this), this;
			},
			close: function() {
				return this._map && this._map.removeLayer(this), this;
			},
			toggle: function(e) {
				return this._map ? this.close() : (arguments.length ? this._source = e : e = this._source, this._prepareOpen(), this.openOn(e._map)), this;
			},
			onAdd: function(e) {
				this._zoomAnimated = e._zoomAnimated, this._container || this._initLayout(), e._fadeAnimated && bt(this._container, 0), clearTimeout(this._removeTimeout), this.getPane().appendChild(this._container), this.update(), e._fadeAnimated && bt(this._container, 1), this.bringToFront(), this.options.interactive && (X(this._container, "leaflet-interactive"), this.addInteractiveTarget(this._container));
			},
			onRemove: function(e) {
				e._fadeAnimated ? (bt(this._container, 0), this._removeTimeout = setTimeout(i(mt, void 0, this._container), 200)) : mt(this._container), this.options.interactive && (vt(this._container, "leaflet-interactive"), this.removeInteractiveTarget(this._container));
			},
			getLatLng: function() {
				return this._latlng;
			},
			setLatLng: function(e) {
				return this._latlng = V(e), this._map && (this._updatePosition(), this._adjustPan()), this;
			},
			getContent: function() {
				return this._content;
			},
			setContent: function(e) {
				return this._content = e, this.update(), this;
			},
			getElement: function() {
				return this._container;
			},
			update: function() {
				this._map && (this._container.style.visibility = "hidden", this._updateContent(), this._updateLayout(), this._updatePosition(), this._container.style.visibility = "", this._adjustPan());
			},
			getEvents: function() {
				var e = {
					zoom: this._updatePosition,
					viewreset: this._updatePosition
				};
				return this._zoomAnimated && (e.zoomanim = this._animateZoom), e;
			},
			isOpen: function() {
				return !!this._map && this._map.hasLayer(this);
			},
			bringToFront: function() {
				return this._map && Y(this._container), this;
			},
			bringToBack: function() {
				return this._map && gt(this._container), this;
			},
			_prepareOpen: function(e) {
				var t = this._source;
				if (!t._map) return !1;
				if (t instanceof $) {
					t = null;
					var n = this._source._layers;
					for (var r in n) if (n[r]._map) {
						t = n[r];
						break;
					}
					if (!t) return !1;
					this._source = t;
				}
				if (!e) {
					if (t.getCenter) e = t.getCenter();
					else if (t.getLatLng) e = t.getLatLng();
					else if (t.getBounds) e = t.getBounds().getCenter();
					else throw Error("Unable to get source layer LatLng.");
				}
				return this.setLatLng(e), this._map && this.update(), !0;
			},
			_updateContent: function() {
				if (this._content) {
					var e = this._contentNode, t = typeof this._content == "function" ? this._content(this._source || this) : this._content;
					if (typeof t == "string") e.innerHTML = t;
					else {
						for (; e.hasChildNodes();) e.removeChild(e.firstChild);
						e.appendChild(t);
					}
					this.fire("contentupdate");
				}
			},
			_updatePosition: function() {
				if (this._map) {
					var e = this._map.latLngToLayerPoint(this._latlng), t = P(this.options.offset), n = this._getAnchor();
					this._zoomAnimated ? wt(this._container, e.add(n)) : t = t.add(e).add(n);
					var r = this._containerBottom = -t.y, i = this._containerLeft = -Math.round(this._containerWidth / 2) + t.x;
					this._container.style.bottom = r + "px", this._container.style.left = i + "px";
				}
			},
			_getAnchor: function() {
				return [0, 0];
			}
		});
		rn.include({ _initOverlay: function(e, t, n, r) {
			var i = t;
			return i instanceof e || (i = new e(r).setContent(t)), n && i.setLatLng(n), i;
		} }), Gn.include({ _initOverlay: function(e, t, n, r) {
			var i = n;
			return i instanceof e ? (p(i, r), i._source = this) : (i = t && !r ? t : new e(r, this), i.setContent(n)), i;
		} });
		var kr = Or.extend({
			options: {
				pane: "popupPane",
				offset: [0, 7],
				maxWidth: 300,
				minWidth: 50,
				maxHeight: null,
				autoPan: !0,
				autoPanPaddingTopLeft: null,
				autoPanPaddingBottomRight: null,
				autoPanPadding: [5, 5],
				keepInView: !1,
				closeButton: !0,
				autoClose: !0,
				closeOnEscapeKey: !0,
				className: ""
			},
			openOn: function(e) {
				return e = arguments.length ? e : this._source._map, !e.hasLayer(this) && e._popup && e._popup.options.autoClose && e.removeLayer(e._popup), e._popup = this, Or.prototype.openOn.call(this, e);
			},
			onAdd: function(e) {
				Or.prototype.onAdd.call(this, e), e.fire("popupopen", { popup: this }), this._source && (this._source.fire("popupopen", { popup: this }, !0), this._source instanceof tr || this._source.on("preclick", Gt));
			},
			onRemove: function(e) {
				Or.prototype.onRemove.call(this, e), e.fire("popupclose", { popup: this }), this._source && (this._source.fire("popupclose", { popup: this }, !0), this._source instanceof tr || this._source.off("preclick", Gt));
			},
			getEvents: function() {
				var e = Or.prototype.getEvents.call(this);
				return (this.options.closeOnClick === void 0 ? this._map.options.closePopupOnClick : this.options.closeOnClick) && (e.preclick = this.close), this.options.keepInView && (e.moveend = this._adjustPan), e;
			},
			_initLayout: function() {
				var e = "leaflet-popup", t = this._container = J("div", e + " " + (this.options.className || "") + " leaflet-zoom-animated"), n = this._wrapper = J("div", e + "-content-wrapper", t);
				if (this._contentNode = J("div", e + "-content", n), qt(t), Kt(this._contentNode), Q(t, "contextmenu", Gt), this._tipContainer = J("div", e + "-tip-container", t), this._tip = J("div", e + "-tip", this._tipContainer), this.options.closeButton) {
					var r = this._closeButton = J("a", e + "-close-button", t);
					r.setAttribute("role", "button"), r.setAttribute("aria-label", "Close popup"), r.href = "#close", r.innerHTML = "<span aria-hidden=\"true\">&#215;</span>", Q(r, "click", function(e) {
						Jt(e), this.close();
					}, this);
				}
			},
			_updateLayout: function() {
				var e = this._contentNode, t = e.style;
				t.width = "", t.whiteSpace = "nowrap";
				var n = e.offsetWidth;
				n = Math.min(n, this.options.maxWidth), n = Math.max(n, this.options.minWidth), t.width = n + 1 + "px", t.whiteSpace = "", t.height = "";
				var r = e.offsetHeight, i = this.options.maxHeight, a = "leaflet-popup-scrolled";
				i && r > i ? (t.height = i + "px", X(e, a)) : vt(e, a), this._containerWidth = this._container.offsetWidth;
			},
			_animateZoom: function(e) {
				var t = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), n = this._getAnchor();
				wt(this._container, t.add(n));
			},
			_adjustPan: function() {
				if (this.options.autoPan) {
					if (this._map._panAnim && this._map._panAnim.stop(), this._autopanning) {
						this._autopanning = !1;
						return;
					}
					var e = this._map, t = parseInt(pt(this._container, "marginBottom"), 10) || 0, n = this._container.offsetHeight + t, r = this._containerWidth, i = new M(this._containerLeft, -n - this._containerBottom);
					i._add(Tt(this._container));
					var a = e.layerPointToContainerPoint(i), o = P(this.options.autoPanPadding), s = P(this.options.autoPanPaddingTopLeft || o), c = P(this.options.autoPanPaddingBottomRight || o), l = e.getSize(), u = 0, d = 0;
					a.x + r + c.x > l.x && (u = a.x + r - l.x + c.x), a.x - u - s.x < 0 && (u = a.x - s.x), a.y + n + c.y > l.y && (d = a.y + n - l.y + c.y), a.y - d - s.y < 0 && (d = a.y - s.y), (u || d) && (this.options.keepInView && (this._autopanning = !0), e.fire("autopanstart").panBy([u, d]));
				}
			},
			_getAnchor: function() {
				return P(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
			}
		}), Ar = function(e, t) {
			return new kr(e, t);
		};
		rn.mergeOptions({ closePopupOnClick: !0 }), rn.include({
			openPopup: function(e, t, n) {
				return this._initOverlay(kr, e, t, n).openOn(this), this;
			},
			closePopup: function(e) {
				return e = arguments.length ? e : this._popup, e && e.close(), this;
			}
		}), Gn.include({
			bindPopup: function(e, t) {
				return this._popup = this._initOverlay(kr, this._popup, e, t), this._popupHandlersAdded ||= (this.on({
					click: this._openPopup,
					keypress: this._onKeyPress,
					remove: this.closePopup,
					move: this._movePopup
				}), !0), this;
			},
			unbindPopup: function() {
				return this._popup &&= (this.off({
					click: this._openPopup,
					keypress: this._onKeyPress,
					remove: this.closePopup,
					move: this._movePopup
				}), this._popupHandlersAdded = !1, null), this;
			},
			openPopup: function(e) {
				return this._popup && (this instanceof $ || (this._popup._source = this), this._popup._prepareOpen(e || this._latlng) && this._popup.openOn(this._map)), this;
			},
			closePopup: function() {
				return this._popup && this._popup.close(), this;
			},
			togglePopup: function() {
				return this._popup && this._popup.toggle(this), this;
			},
			isPopupOpen: function() {
				return this._popup ? this._popup.isOpen() : !1;
			},
			setPopupContent: function(e) {
				return this._popup && this._popup.setContent(e), this;
			},
			getPopup: function() {
				return this._popup;
			},
			_openPopup: function(e) {
				if (this._popup && this._map) {
					Yt(e);
					var t = e.layer || e.target;
					if (this._popup._source === t && !(t instanceof tr)) {
						this._map.hasLayer(this._popup) ? this.closePopup() : this.openPopup(e.latlng);
						return;
					}
					this._popup._source = t, this.openPopup(e.latlng);
				}
			},
			_movePopup: function(e) {
				this._popup.setLatLng(e.latlng);
			},
			_onKeyPress: function(e) {
				e.originalEvent.keyCode === 13 && this._openPopup(e);
			}
		});
		var jr = Or.extend({
			options: {
				pane: "tooltipPane",
				offset: [0, 0],
				direction: "auto",
				permanent: !1,
				sticky: !1,
				opacity: .9
			},
			onAdd: function(e) {
				Or.prototype.onAdd.call(this, e), this.setOpacity(this.options.opacity), e.fire("tooltipopen", { tooltip: this }), this._source && (this.addEventParent(this._source), this._source.fire("tooltipopen", { tooltip: this }, !0));
			},
			onRemove: function(e) {
				Or.prototype.onRemove.call(this, e), e.fire("tooltipclose", { tooltip: this }), this._source && (this.removeEventParent(this._source), this._source.fire("tooltipclose", { tooltip: this }, !0));
			},
			getEvents: function() {
				var e = Or.prototype.getEvents.call(this);
				return this.options.permanent || (e.preclick = this.close), e;
			},
			_initLayout: function() {
				var e = "leaflet-tooltip " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
				this._contentNode = this._container = J("div", e), this._container.setAttribute("role", "tooltip"), this._container.setAttribute("id", "leaflet-tooltip-" + o(this));
			},
			_updateLayout: function() {},
			_adjustPan: function() {},
			_setPosition: function(e) {
				var t, n, r = this._map, i = this._container, a = r.latLngToContainerPoint(r.getCenter()), o = r.layerPointToContainerPoint(e), s = this.options.direction, c = i.offsetWidth, l = i.offsetHeight, u = P(this.options.offset), d = this._getAnchor();
				s === "top" ? (t = c / 2, n = l) : s === "bottom" ? (t = c / 2, n = 0) : s === "center" ? (t = c / 2, n = l / 2) : s === "right" ? (t = 0, n = l / 2) : s === "left" ? (t = c, n = l / 2) : o.x < a.x ? (s = "right", t = 0, n = l / 2) : (s = "left", t = c + (u.x + d.x) * 2, n = l / 2), e = e.subtract(P(t, n, !0)).add(u).add(d), vt(i, "leaflet-tooltip-right"), vt(i, "leaflet-tooltip-left"), vt(i, "leaflet-tooltip-top"), vt(i, "leaflet-tooltip-bottom"), X(i, "leaflet-tooltip-" + s), wt(i, e);
			},
			_updatePosition: function() {
				var e = this._map.latLngToLayerPoint(this._latlng);
				this._setPosition(e);
			},
			setOpacity: function(e) {
				this.options.opacity = e, this._container && bt(this._container, e);
			},
			_animateZoom: function(e) {
				var t = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
				this._setPosition(t);
			},
			_getAnchor: function() {
				return P(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
			}
		}), Mr = function(e, t) {
			return new jr(e, t);
		};
		rn.include({
			openTooltip: function(e, t, n) {
				return this._initOverlay(jr, e, t, n).openOn(this), this;
			},
			closeTooltip: function(e) {
				return e.close(), this;
			}
		}), Gn.include({
			bindTooltip: function(e, t) {
				return this._tooltip && this.isTooltipOpen() && this.unbindTooltip(), this._tooltip = this._initOverlay(jr, this._tooltip, e, t), this._initTooltipInteractions(), this._tooltip.options.permanent && this._map && this._map.hasLayer(this) && this.openTooltip(), this;
			},
			unbindTooltip: function() {
				return this._tooltip &&= (this._initTooltipInteractions(!0), this.closeTooltip(), null), this;
			},
			_initTooltipInteractions: function(e) {
				if (e || !this._tooltipHandlersAdded) {
					var t = e ? "off" : "on", n = {
						remove: this.closeTooltip,
						move: this._moveTooltip
					};
					this._tooltip.options.permanent ? n.add = this._openTooltip : (n.mouseover = this._openTooltip, n.mouseout = this.closeTooltip, n.click = this._openTooltip, this._map ? this._addFocusListeners() : n.add = this._addFocusListeners), this._tooltip.options.sticky && (n.mousemove = this._moveTooltip), this[t](n), this._tooltipHandlersAdded = !e;
				}
			},
			openTooltip: function(e) {
				return this._tooltip && (this instanceof $ || (this._tooltip._source = this), this._tooltip._prepareOpen(e) && (this._tooltip.openOn(this._map), this.getElement ? this._setAriaDescribedByOnLayer(this) : this.eachLayer && this.eachLayer(this._setAriaDescribedByOnLayer, this))), this;
			},
			closeTooltip: function() {
				if (this._tooltip) return this._tooltip.close();
			},
			toggleTooltip: function() {
				return this._tooltip && this._tooltip.toggle(this), this;
			},
			isTooltipOpen: function() {
				return this._tooltip.isOpen();
			},
			setTooltipContent: function(e) {
				return this._tooltip && this._tooltip.setContent(e), this;
			},
			getTooltip: function() {
				return this._tooltip;
			},
			_addFocusListeners: function() {
				this.getElement ? this._addFocusListenersOnLayer(this) : this.eachLayer && this.eachLayer(this._addFocusListenersOnLayer, this);
			},
			_addFocusListenersOnLayer: function(e) {
				var t = typeof e.getElement == "function" && e.getElement();
				t && (Q(t, "focus", function() {
					this._tooltip._source = e, this.openTooltip();
				}, this), Q(t, "blur", this.closeTooltip, this));
			},
			_setAriaDescribedByOnLayer: function(e) {
				var t = typeof e.getElement == "function" && e.getElement();
				t && t.setAttribute("aria-describedby", this._tooltip._container.id);
			},
			_openTooltip: function(e) {
				if (this._tooltip && this._map) {
					if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
						this._openOnceFlag = !0;
						var t = this;
						this._map.once("moveend", function() {
							t._openOnceFlag = !1, t._openTooltip(e);
						});
						return;
					}
					this._tooltip._source = e.layer || e.target, this.openTooltip(this._tooltip.options.sticky ? e.latlng : void 0);
				}
			},
			_moveTooltip: function(e) {
				var t = e.latlng, n, r;
				this._tooltip.options.sticky && e.originalEvent && (n = this._map.mouseEventToContainerPoint(e.originalEvent), r = this._map.containerPointToLayerPoint(n), t = this._map.layerPointToLatLng(r)), this._tooltip.setLatLng(t);
			}
		});
		var Nr = Yn.extend({
			options: {
				iconSize: [12, 12],
				html: !1,
				bgPos: null,
				className: "leaflet-div-icon"
			},
			createIcon: function(e) {
				var t = e && e.tagName === "DIV" ? e : document.createElement("div"), n = this.options;
				if (n.html instanceof Element ? (ht(t), t.appendChild(n.html)) : t.innerHTML = n.html === !1 ? "" : n.html, n.bgPos) {
					var r = P(n.bgPos);
					t.style.backgroundPosition = -r.x + "px " + -r.y + "px";
				}
				return this._setIconStyles(t, "icon"), t;
			},
			createShadow: function() {
				return null;
			}
		});
		function Pr(e) {
			return new Nr(e);
		}
		Yn.Default = Zn;
		var Fr = Gn.extend({
			options: {
				tileSize: 256,
				opacity: 1,
				updateWhenIdle: q.mobile,
				updateWhenZooming: !0,
				updateInterval: 200,
				zIndex: 1,
				bounds: null,
				minZoom: 0,
				maxZoom: void 0,
				maxNativeZoom: void 0,
				minNativeZoom: void 0,
				noWrap: !1,
				pane: "tilePane",
				className: "",
				keepBuffer: 2
			},
			initialize: function(e) {
				p(this, e);
			},
			onAdd: function() {
				this._initContainer(), this._levels = {}, this._tiles = {}, this._resetView();
			},
			beforeAdd: function(e) {
				e._addZoomLimit(this);
			},
			onRemove: function(e) {
				this._removeAllTiles(), mt(this._container), e._removeZoomLimit(this), this._container = null, this._tileZoom = void 0;
			},
			bringToFront: function() {
				return this._map && (Y(this._container), this._setAutoZIndex(Math.max)), this;
			},
			bringToBack: function() {
				return this._map && (gt(this._container), this._setAutoZIndex(Math.min)), this;
			},
			getContainer: function() {
				return this._container;
			},
			setOpacity: function(e) {
				return this.options.opacity = e, this._updateOpacity(), this;
			},
			setZIndex: function(e) {
				return this.options.zIndex = e, this._updateZIndex(), this;
			},
			isLoading: function() {
				return this._loading;
			},
			redraw: function() {
				if (this._map) {
					this._removeAllTiles();
					var e = this._clampZoom(this._map.getZoom());
					e !== this._tileZoom && (this._tileZoom = e, this._updateLevels()), this._update();
				}
				return this;
			},
			getEvents: function() {
				var e = {
					viewprereset: this._invalidateAll,
					viewreset: this._resetView,
					zoom: this._resetView,
					moveend: this._onMoveEnd
				};
				return this.options.updateWhenIdle || (this._onMove ||= s(this._onMoveEnd, this.options.updateInterval, this), e.move = this._onMove), this._zoomAnimated && (e.zoomanim = this._animateZoom), e;
			},
			createTile: function() {
				return document.createElement("div");
			},
			getTileSize: function() {
				var e = this.options.tileSize;
				return e instanceof M ? e : new M(e, e);
			},
			_updateZIndex: function() {
				this._container && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._container.style.zIndex = this.options.zIndex);
			},
			_setAutoZIndex: function(e) {
				for (var t = this.getPane().children, n = -e(-Infinity, Infinity), r = 0, i = t.length, a; r < i; r++) a = t[r].style.zIndex, t[r] !== this._container && a && (n = e(n, +a));
				isFinite(n) && (this.options.zIndex = n + e(-1, 1), this._updateZIndex());
			},
			_updateOpacity: function() {
				if (this._map && !q.ielt9) {
					bt(this._container, this.options.opacity);
					var e = +/* @__PURE__ */ new Date(), t = !1, n = !1;
					for (var r in this._tiles) {
						var i = this._tiles[r];
						if (i.current && i.loaded) {
							var a = Math.min(1, (e - i.loaded) / 200);
							bt(i.el, a), a < 1 ? t = !0 : (i.active ? n = !0 : this._onOpaqueTile(i), i.active = !0);
						}
					}
					n && !this._noPrune && this._pruneTiles(), t && (E(this._fadeFrame), this._fadeFrame = T(this._updateOpacity, this));
				}
			},
			_onOpaqueTile: l,
			_initContainer: function() {
				this._container || (this._container = J("div", "leaflet-layer " + (this.options.className || "")), this._updateZIndex(), this.options.opacity < 1 && this._updateOpacity(), this.getPane().appendChild(this._container));
			},
			_updateLevels: function() {
				var e = this._tileZoom, t = this.options.maxZoom;
				if (e !== void 0) {
					for (var n in this._levels) n = Number(n), this._levels[n].el.children.length || n === e ? (this._levels[n].el.style.zIndex = t - Math.abs(e - n), this._onUpdateLevel(n)) : (mt(this._levels[n].el), this._removeTilesAtZoom(n), this._onRemoveLevel(n), delete this._levels[n]);
					var r = this._levels[e], i = this._map;
					return r || (r = this._levels[e] = {}, r.el = J("div", "leaflet-tile-container leaflet-zoom-animated", this._container), r.el.style.zIndex = t, r.origin = i.project(i.unproject(i.getPixelOrigin()), e).round(), r.zoom = e, this._setZoomTransform(r, i.getCenter(), i.getZoom()), r.el.offsetWidth, this._onCreateLevel(r)), this._level = r, r;
				}
			},
			_onUpdateLevel: l,
			_onRemoveLevel: l,
			_onCreateLevel: l,
			_pruneTiles: function() {
				if (this._map) {
					var e, t, n = this._map.getZoom();
					if (n > this.options.maxZoom || n < this.options.minZoom) {
						this._removeAllTiles();
						return;
					}
					for (e in this._tiles) t = this._tiles[e], t.retain = t.current;
					for (e in this._tiles) if (t = this._tiles[e], t.current && !t.active) {
						var r = t.coords;
						this._retainParent(r.x, r.y, r.z, r.z - 5) || this._retainChildren(r.x, r.y, r.z, r.z + 2);
					}
					for (e in this._tiles) this._tiles[e].retain || this._removeTile(e);
				}
			},
			_removeTilesAtZoom: function(e) {
				for (var t in this._tiles) this._tiles[t].coords.z === e && this._removeTile(t);
			},
			_removeAllTiles: function() {
				for (var e in this._tiles) this._removeTile(e);
			},
			_invalidateAll: function() {
				for (var e in this._levels) mt(this._levels[e].el), this._onRemoveLevel(Number(e)), delete this._levels[e];
				this._removeAllTiles(), this._tileZoom = void 0;
			},
			_retainParent: function(e, t, n, r) {
				var i = Math.floor(e / 2), a = Math.floor(t / 2), o = n - 1, s = new M(+i, +a);
				s.z = +o;
				var c = this._tileCoordsToKey(s), l = this._tiles[c];
				return l && l.active ? (l.retain = !0, !0) : (l && l.loaded && (l.retain = !0), o > r && this._retainParent(i, a, o, r));
			},
			_retainChildren: function(e, t, n, r) {
				for (var i = 2 * e; i < 2 * e + 2; i++) for (var a = 2 * t; a < 2 * t + 2; a++) {
					var o = new M(i, a);
					o.z = n + 1;
					var s = this._tileCoordsToKey(o), c = this._tiles[s];
					if (c && c.active) {
						c.retain = !0;
						continue;
					}
					c && c.loaded && (c.retain = !0), n + 1 < r && this._retainChildren(i, a, n + 1, r);
				}
			},
			_resetView: function(e) {
				var t = e && (e.pinch || e.flyTo);
				this._setView(this._map.getCenter(), this._map.getZoom(), t, t);
			},
			_animateZoom: function(e) {
				this._setView(e.center, e.zoom, !0, e.noUpdate);
			},
			_clampZoom: function(e) {
				var t = this.options;
				return t.minNativeZoom !== void 0 && e < t.minNativeZoom ? t.minNativeZoom : t.maxNativeZoom !== void 0 && t.maxNativeZoom < e ? t.maxNativeZoom : e;
			},
			_setView: function(e, t, n, r) {
				var i = Math.round(t);
				i = this.options.maxZoom !== void 0 && i > this.options.maxZoom || this.options.minZoom !== void 0 && i < this.options.minZoom ? void 0 : this._clampZoom(i);
				var a = this.options.updateWhenZooming && i !== this._tileZoom;
				(!r || a) && (this._tileZoom = i, this._abortLoading && this._abortLoading(), this._updateLevels(), this._resetGrid(), i !== void 0 && this._update(e), n || this._pruneTiles(), this._noPrune = !!n), this._setZoomTransforms(e, t);
			},
			_setZoomTransforms: function(e, t) {
				for (var n in this._levels) this._setZoomTransform(this._levels[n], e, t);
			},
			_setZoomTransform: function(e, t, n) {
				var r = this._map.getZoomScale(n, e.zoom), i = e.origin.multiplyBy(r).subtract(this._map._getNewPixelOrigin(t, n)).round();
				q.any3d ? Ct(e.el, i, r) : wt(e.el, i);
			},
			_resetGrid: function() {
				var e = this._map, t = e.options.crs, n = this._tileSize = this.getTileSize(), r = this._tileZoom, i = this._map.getPixelWorldBounds(this._tileZoom);
				i && (this._globalTileRange = this._pxBoundsToTileRange(i)), this._wrapX = t.wrapLng && !this.options.noWrap && [Math.floor(e.project([0, t.wrapLng[0]], r).x / n.x), Math.ceil(e.project([0, t.wrapLng[1]], r).x / n.y)], this._wrapY = t.wrapLat && !this.options.noWrap && [Math.floor(e.project([t.wrapLat[0], 0], r).y / n.x), Math.ceil(e.project([t.wrapLat[1], 0], r).y / n.y)];
			},
			_onMoveEnd: function() {
				this._map && !this._map._animatingZoom && this._update();
			},
			_getTiledPixelBounds: function(e) {
				var t = this._map, n = t._animatingZoom ? Math.max(t._animateToZoom, t.getZoom()) : t.getZoom(), r = t.getZoomScale(n, this._tileZoom), i = t.project(e, this._tileZoom).floor(), a = t.getSize().divideBy(r * 2);
				return new F(i.subtract(a), i.add(a));
			},
			_update: function(e) {
				var t = this._map;
				if (t) {
					var n = this._clampZoom(t.getZoom());
					if (e === void 0 && (e = t.getCenter()), this._tileZoom !== void 0) {
						var r = this._getTiledPixelBounds(e), i = this._pxBoundsToTileRange(r), a = i.getCenter(), o = [], s = this.options.keepBuffer, c = new F(i.getBottomLeft().subtract([s, -s]), i.getTopRight().add([s, -s]));
						if (!(isFinite(i.min.x) && isFinite(i.min.y) && isFinite(i.max.x) && isFinite(i.max.y))) throw Error("Attempted to load an infinite number of tiles");
						for (var l in this._tiles) {
							var u = this._tiles[l].coords;
							(u.z !== this._tileZoom || !c.contains(new M(u.x, u.y))) && (this._tiles[l].current = !1);
						}
						if (Math.abs(n - this._tileZoom) > 1) {
							this._setView(e, n);
							return;
						}
						for (var d = i.min.y; d <= i.max.y; d++) for (var f = i.min.x; f <= i.max.x; f++) {
							var p = new M(f, d);
							if (p.z = this._tileZoom, this._isValidTile(p)) {
								var m = this._tiles[this._tileCoordsToKey(p)];
								m ? m.current = !0 : o.push(p);
							}
						}
						if (o.sort(function(e, t) {
							return e.distanceTo(a) - t.distanceTo(a);
						}), o.length !== 0) {
							this._loading || (this._loading = !0, this.fire("loading"));
							var h = document.createDocumentFragment();
							for (f = 0; f < o.length; f++) this._addTile(o[f], h);
							this._level.el.appendChild(h);
						}
					}
				}
			},
			_isValidTile: function(e) {
				var t = this._map.options.crs;
				if (!t.infinite) {
					var n = this._globalTileRange;
					if (!t.wrapLng && (e.x < n.min.x || e.x > n.max.x) || !t.wrapLat && (e.y < n.min.y || e.y > n.max.y)) return !1;
				}
				if (!this.options.bounds) return !0;
				var r = this._tileCoordsToBounds(e);
				return z(this.options.bounds).overlaps(r);
			},
			_keyToBounds: function(e) {
				return this._tileCoordsToBounds(this._keyToTileCoords(e));
			},
			_tileCoordsToNwSe: function(e) {
				var t = this._map, n = this.getTileSize(), r = e.scaleBy(n), i = r.add(n);
				return [t.unproject(r, e.z), t.unproject(i, e.z)];
			},
			_tileCoordsToBounds: function(e) {
				var t = this._tileCoordsToNwSe(e), n = new R(t[0], t[1]);
				return this.options.noWrap || (n = this._map.wrapLatLngBounds(n)), n;
			},
			_tileCoordsToKey: function(e) {
				return e.x + ":" + e.y + ":" + e.z;
			},
			_keyToTileCoords: function(e) {
				var t = e.split(":"), n = new M(+t[0], +t[1]);
				return n.z = +t[2], n;
			},
			_removeTile: function(e) {
				var t = this._tiles[e];
				t && (mt(t.el), delete this._tiles[e], this.fire("tileunload", {
					tile: t.el,
					coords: this._keyToTileCoords(e)
				}));
			},
			_initTile: function(e) {
				X(e, "leaflet-tile");
				var t = this.getTileSize();
				e.style.width = t.x + "px", e.style.height = t.y + "px", e.onselectstart = l, e.onmousemove = l, q.ielt9 && this.options.opacity < 1 && bt(e, this.options.opacity);
			},
			_addTile: function(e, t) {
				var n = this._getTilePos(e), r = this._tileCoordsToKey(e), a = this.createTile(this._wrapCoords(e), i(this._tileReady, this, e));
				this._initTile(a), this.createTile.length < 2 && T(i(this._tileReady, this, e, null, a)), wt(a, n), this._tiles[r] = {
					el: a,
					coords: e,
					current: !0
				}, t.appendChild(a), this.fire("tileloadstart", {
					tile: a,
					coords: e
				});
			},
			_tileReady: function(e, t, n) {
				t && this.fire("tileerror", {
					error: t,
					tile: n,
					coords: e
				});
				var r = this._tileCoordsToKey(e);
				n = this._tiles[r], n && (n.loaded = +/* @__PURE__ */ new Date(), this._map._fadeAnimated ? (bt(n.el, 0), E(this._fadeFrame), this._fadeFrame = T(this._updateOpacity, this)) : (n.active = !0, this._pruneTiles()), t || (X(n.el, "leaflet-tile-loaded"), this.fire("tileload", {
					tile: n.el,
					coords: e
				})), this._noTilesToLoad() && (this._loading = !1, this.fire("load"), q.ielt9 || !this._map._fadeAnimated ? T(this._pruneTiles, this) : setTimeout(i(this._pruneTiles, this), 250)));
			},
			_getTilePos: function(e) {
				return e.scaleBy(this.getTileSize()).subtract(this._level.origin);
			},
			_wrapCoords: function(e) {
				var t = new M(this._wrapX ? c(e.x, this._wrapX) : e.x, this._wrapY ? c(e.y, this._wrapY) : e.y);
				return t.z = e.z, t;
			},
			_pxBoundsToTileRange: function(e) {
				var t = this.getTileSize();
				return new F(e.min.unscaleBy(t).floor(), e.max.unscaleBy(t).ceil().subtract([1, 1]));
			},
			_noTilesToLoad: function() {
				for (var e in this._tiles) if (!this._tiles[e].loaded) return !1;
				return !0;
			}
		});
		function Ir(e) {
			return new Fr(e);
		}
		var Lr = Fr.extend({
			options: {
				minZoom: 0,
				maxZoom: 18,
				subdomains: "abc",
				errorTileUrl: "",
				zoomOffset: 0,
				tms: !1,
				zoomReverse: !1,
				detectRetina: !1,
				crossOrigin: !1,
				referrerPolicy: !1
			},
			initialize: function(e, t) {
				this._url = e, t = p(this, t), t.detectRetina && q.retina && t.maxZoom > 0 ? (t.tileSize = Math.floor(t.tileSize / 2), t.zoomReverse ? (t.zoomOffset--, t.minZoom = Math.min(t.maxZoom, t.minZoom + 1)) : (t.zoomOffset++, t.maxZoom = Math.max(t.minZoom, t.maxZoom - 1)), t.minZoom = Math.max(0, t.minZoom)) : t.zoomReverse ? t.minZoom = Math.min(t.maxZoom, t.minZoom) : t.maxZoom = Math.max(t.minZoom, t.maxZoom), typeof t.subdomains == "string" && (t.subdomains = t.subdomains.split("")), this.on("tileunload", this._onTileRemove);
			},
			setUrl: function(e, t) {
				return this._url === e && t === void 0 && (t = !0), this._url = e, t || this.redraw(), this;
			},
			createTile: function(e, t) {
				var n = document.createElement("img");
				return Q(n, "load", i(this._tileOnLoad, this, t, n)), Q(n, "error", i(this._tileOnError, this, t, n)), (this.options.crossOrigin || this.options.crossOrigin === "") && (n.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), typeof this.options.referrerPolicy == "string" && (n.referrerPolicy = this.options.referrerPolicy), n.alt = "", n.src = this.getTileUrl(e), n;
			},
			getTileUrl: function(e) {
				var t = {
					r: q.retina ? "@2x" : "",
					s: this._getSubdomain(e),
					x: e.x,
					y: e.y,
					z: this._getZoomForUrl()
				};
				if (this._map && !this._map.options.crs.infinite) {
					var r = this._globalTileRange.max.y - e.y;
					this.options.tms && (t.y = r), t["-y"] = r;
				}
				return g(this._url, n(t, this.options));
			},
			_tileOnLoad: function(e, t) {
				q.ielt9 ? setTimeout(i(e, this, null, t), 0) : e(null, t);
			},
			_tileOnError: function(e, t, n) {
				var r = this.options.errorTileUrl;
				r && t.getAttribute("src") !== r && (t.src = r), e(n, t);
			},
			_onTileRemove: function(e) {
				e.tile.onload = null;
			},
			_getZoomForUrl: function() {
				var e = this._tileZoom, t = this.options.maxZoom, n = this.options.zoomReverse, r = this.options.zoomOffset;
				return n && (e = t - e), e + r;
			},
			_getSubdomain: function(e) {
				var t = Math.abs(e.x + e.y) % this.options.subdomains.length;
				return this.options.subdomains[t];
			},
			_abortLoading: function() {
				var e, t;
				for (e in this._tiles) if (this._tiles[e].coords.z !== this._tileZoom && (t = this._tiles[e].el, t.onload = l, t.onerror = l, !t.complete)) {
					t.src = y;
					var n = this._tiles[e].coords;
					mt(t), delete this._tiles[e], this.fire("tileabort", {
						tile: t,
						coords: n
					});
				}
			},
			_removeTile: function(e) {
				var t = this._tiles[e];
				if (t) return t.el.setAttribute("src", y), Fr.prototype._removeTile.call(this, e);
			},
			_tileReady: function(e, t, n) {
				if (!(!this._map || n && n.getAttribute("src") === y)) return Fr.prototype._tileReady.call(this, e, t, n);
			}
		});
		function Rr(e, t) {
			return new Lr(e, t);
		}
		var zr = Lr.extend({
			defaultWmsParams: {
				service: "WMS",
				request: "GetMap",
				layers: "",
				styles: "",
				format: "image/jpeg",
				transparent: !1,
				version: "1.1.1"
			},
			options: {
				crs: null,
				uppercase: !1
			},
			initialize: function(e, t) {
				this._url = e;
				var r = n({}, this.defaultWmsParams);
				for (var i in t) i in this.options || (r[i] = t[i]);
				t = p(this, t);
				var a = t.detectRetina && q.retina ? 2 : 1, o = this.getTileSize();
				r.width = o.x * a, r.height = o.y * a, this.wmsParams = r;
			},
			onAdd: function(e) {
				this._crs = this.options.crs || e.options.crs, this._wmsVersion = parseFloat(this.wmsParams.version);
				var t = this._wmsVersion >= 1.3 ? "crs" : "srs";
				this.wmsParams[t] = this._crs.code, Lr.prototype.onAdd.call(this, e);
			},
			getTileUrl: function(e) {
				var t = this._tileCoordsToNwSe(e), n = this._crs, r = I(n.project(t[0]), n.project(t[1])), i = r.min, a = r.max, o = (this._wmsVersion >= 1.3 && this._crs === Un ? [
					i.y,
					i.x,
					a.y,
					a.x
				] : [
					i.x,
					i.y,
					a.x,
					a.y
				]).join(","), s = Lr.prototype.getTileUrl.call(this, e);
				return s + m(this.wmsParams, s, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + o;
			},
			setParams: function(e, t) {
				return n(this.wmsParams, e), t || this.redraw(), this;
			}
		});
		function Br(e, t) {
			return new zr(e, t);
		}
		Lr.WMS = zr, Rr.wms = Br;
		var Vr = Gn.extend({
			options: { padding: .1 },
			initialize: function(e) {
				p(this, e), o(this), this._layers = this._layers || {};
			},
			onAdd: function() {
				this._container || (this._initContainer(), X(this._container, "leaflet-zoom-animated")), this.getPane().appendChild(this._container), this._update(), this.on("update", this._updatePaths, this);
			},
			onRemove: function() {
				this.off("update", this._updatePaths, this), this._destroyContainer();
			},
			getEvents: function() {
				var e = {
					viewreset: this._reset,
					zoom: this._onZoom,
					moveend: this._update,
					zoomend: this._onZoomEnd
				};
				return this._zoomAnimated && (e.zoomanim = this._onAnimZoom), e;
			},
			_onAnimZoom: function(e) {
				this._updateTransform(e.center, e.zoom);
			},
			_onZoom: function() {
				this._updateTransform(this._map.getCenter(), this._map.getZoom());
			},
			_updateTransform: function(e, t) {
				var n = this._map.getZoomScale(t, this._zoom), r = this._map.getSize().multiplyBy(.5 + this.options.padding), i = this._map.project(this._center, t), a = r.multiplyBy(-n).add(i).subtract(this._map._getNewPixelOrigin(e, t));
				q.any3d ? Ct(this._container, a, n) : wt(this._container, a);
			},
			_reset: function() {
				for (var e in this._update(), this._updateTransform(this._center, this._zoom), this._layers) this._layers[e]._reset();
			},
			_onZoomEnd: function() {
				for (var e in this._layers) this._layers[e]._project();
			},
			_updatePaths: function() {
				for (var e in this._layers) this._layers[e]._update();
			},
			_update: function() {
				var e = this.options.padding, t = this._map.getSize(), n = this._map.containerPointToLayerPoint(t.multiplyBy(-e)).round();
				this._bounds = new F(n, n.add(t.multiplyBy(1 + e * 2)).round()), this._center = this._map.getCenter(), this._zoom = this._map.getZoom();
			}
		}), Hr = Vr.extend({
			options: { tolerance: 0 },
			getEvents: function() {
				var e = Vr.prototype.getEvents.call(this);
				return e.viewprereset = this._onViewPreReset, e;
			},
			_onViewPreReset: function() {
				this._postponeUpdatePaths = !0;
			},
			onAdd: function() {
				Vr.prototype.onAdd.call(this), this._draw();
			},
			_initContainer: function() {
				var e = this._container = document.createElement("canvas");
				Q(e, "mousemove", this._onMouseMove, this), Q(e, "click dblclick mousedown mouseup contextmenu", this._onClick, this), Q(e, "mouseout", this._handleMouseOut, this), e._leaflet_disable_events = !0, this._ctx = e.getContext("2d");
			},
			_destroyContainer: function() {
				E(this._redrawRequest), delete this._ctx, mt(this._container), Bt(this._container), delete this._container;
			},
			_updatePaths: function() {
				if (!this._postponeUpdatePaths) {
					var e;
					for (var t in this._redrawBounds = null, this._layers) e = this._layers[t], e._update();
					this._redraw();
				}
			},
			_update: function() {
				if (!(this._map._animatingZoom && this._bounds)) {
					Vr.prototype._update.call(this);
					var e = this._bounds, t = this._container, n = e.getSize(), r = q.retina ? 2 : 1;
					wt(t, e.min), t.width = r * n.x, t.height = r * n.y, t.style.width = n.x + "px", t.style.height = n.y + "px", q.retina && this._ctx.scale(2, 2), this._ctx.translate(-e.min.x, -e.min.y), this.fire("update");
				}
			},
			_reset: function() {
				Vr.prototype._reset.call(this), this._postponeUpdatePaths && (this._postponeUpdatePaths = !1, this._updatePaths());
			},
			_initPath: function(e) {
				this._updateDashArray(e), this._layers[o(e)] = e;
				var t = e._order = {
					layer: e,
					prev: this._drawLast,
					next: null
				};
				this._drawLast && (this._drawLast.next = t), this._drawLast = t, this._drawFirst = this._drawFirst || this._drawLast;
			},
			_addPath: function(e) {
				this._requestRedraw(e);
			},
			_removePath: function(e) {
				var t = e._order, n = t.next, r = t.prev;
				n ? n.prev = r : this._drawLast = r, r ? r.next = n : this._drawFirst = n, delete e._order, delete this._layers[o(e)], this._requestRedraw(e);
			},
			_updatePath: function(e) {
				this._extendRedrawBounds(e), e._project(), e._update(), this._requestRedraw(e);
			},
			_updateStyle: function(e) {
				this._updateDashArray(e), this._requestRedraw(e);
			},
			_updateDashArray: function(e) {
				if (typeof e.options.dashArray == "string") {
					for (var t = e.options.dashArray.split(/[, ]+/), n = [], r, i = 0; i < t.length; i++) {
						if (r = Number(t[i]), isNaN(r)) return;
						n.push(r);
					}
					e.options._dashArray = n;
				} else e.options._dashArray = e.options.dashArray;
			},
			_requestRedraw: function(e) {
				this._map && (this._extendRedrawBounds(e), this._redrawRequest = this._redrawRequest || T(this._redraw, this));
			},
			_extendRedrawBounds: function(e) {
				if (e._pxBounds) {
					var t = (e.options.weight || 0) + 1;
					this._redrawBounds = this._redrawBounds || new F(), this._redrawBounds.extend(e._pxBounds.min.subtract([t, t])), this._redrawBounds.extend(e._pxBounds.max.add([t, t]));
				}
			},
			_redraw: function() {
				this._redrawRequest = null, this._redrawBounds && (this._redrawBounds.min._floor(), this._redrawBounds.max._ceil()), this._clear(), this._draw(), this._redrawBounds = null;
			},
			_clear: function() {
				var e = this._redrawBounds;
				if (e) {
					var t = e.getSize();
					this._ctx.clearRect(e.min.x, e.min.y, t.x, t.y);
				} else this._ctx.save(), this._ctx.setTransform(1, 0, 0, 1, 0, 0), this._ctx.clearRect(0, 0, this._container.width, this._container.height), this._ctx.restore();
			},
			_draw: function() {
				var e, t = this._redrawBounds;
				if (this._ctx.save(), t) {
					var n = t.getSize();
					this._ctx.beginPath(), this._ctx.rect(t.min.x, t.min.y, n.x, n.y), this._ctx.clip();
				}
				this._drawing = !0;
				for (var r = this._drawFirst; r; r = r.next) e = r.layer, (!t || e._pxBounds && e._pxBounds.intersects(t)) && e._updatePath();
				this._drawing = !1, this._ctx.restore();
			},
			_updatePoly: function(e, t) {
				if (this._drawing) {
					var n, r, i, a, o = e._parts, s = o.length, c = this._ctx;
					if (s) {
						for (c.beginPath(), n = 0; n < s; n++) {
							for (r = 0, i = o[n].length; r < i; r++) a = o[n][r], c[r ? "lineTo" : "moveTo"](a.x, a.y);
							t && c.closePath();
						}
						this._fillStroke(c, e);
					}
				}
			},
			_updateCircle: function(e) {
				if (this._drawing && !e._empty()) {
					var t = e._point, n = this._ctx, r = Math.max(Math.round(e._radius), 1), i = (Math.max(Math.round(e._radiusY), 1) || r) / r;
					i !== 1 && (n.save(), n.scale(1, i)), n.beginPath(), n.arc(t.x, t.y / i, r, 0, Math.PI * 2, !1), i !== 1 && n.restore(), this._fillStroke(n, e);
				}
			},
			_fillStroke: function(e, t) {
				var n = t.options;
				n.fill && (e.globalAlpha = n.fillOpacity, e.fillStyle = n.fillColor || n.color, e.fill(n.fillRule || "evenodd")), n.stroke && n.weight !== 0 && (e.setLineDash && e.setLineDash(t.options && t.options._dashArray || []), e.globalAlpha = n.opacity, e.lineWidth = n.weight, e.strokeStyle = n.color, e.lineCap = n.lineCap, e.lineJoin = n.lineJoin, e.stroke());
			},
			_onClick: function(e) {
				for (var t = this._map.mouseEventToLayerPoint(e), n, r, i = this._drawFirst; i; i = i.next) n = i.layer, n.options.interactive && n._containsPoint(t) && (e.type !== "click" && e.type !== "preclick" || !this._map._draggableMoved(n)) && (r = n);
				this._fireEvent(r ? [r] : !1, e);
			},
			_onMouseMove: function(e) {
				if (!(!this._map || this._map.dragging.moving() || this._map._animatingZoom)) {
					var t = this._map.mouseEventToLayerPoint(e);
					this._handleMouseHover(e, t);
				}
			},
			_handleMouseOut: function(e) {
				var t = this._hoveredLayer;
				t && (vt(this._container, "leaflet-interactive"), this._fireEvent([t], e, "mouseout"), this._hoveredLayer = null, this._mouseHoverThrottled = !1);
			},
			_handleMouseHover: function(e, t) {
				if (!this._mouseHoverThrottled) {
					for (var n, r, a = this._drawFirst; a; a = a.next) n = a.layer, n.options.interactive && n._containsPoint(t) && (r = n);
					r !== this._hoveredLayer && (this._handleMouseOut(e), r && (X(this._container, "leaflet-interactive"), this._fireEvent([r], e, "mouseover"), this._hoveredLayer = r)), this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : !1, e), this._mouseHoverThrottled = !0, setTimeout(i(function() {
						this._mouseHoverThrottled = !1;
					}, this), 32);
				}
			},
			_fireEvent: function(e, t, n) {
				this._map._fireDOMEvent(t, n || t.type, e);
			},
			_bringToFront: function(e) {
				var t = e._order;
				if (t) {
					var n = t.next, r = t.prev;
					if (n) n.prev = r;
					else return;
					r ? r.next = n : n && (this._drawFirst = n), t.prev = this._drawLast, this._drawLast.next = t, t.next = null, this._drawLast = t, this._requestRedraw(e);
				}
			},
			_bringToBack: function(e) {
				var t = e._order;
				if (t) {
					var n = t.next, r = t.prev;
					if (r) r.next = n;
					else return;
					n ? n.prev = r : r && (this._drawLast = r), t.prev = null, t.next = this._drawFirst, this._drawFirst.prev = t, this._drawFirst = t, this._requestRedraw(e);
				}
			}
		});
		function Ur(e) {
			return q.canvas ? new Hr(e) : null;
		}
		var Wr = (function() {
			try {
				return document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml"), function(e) {
					return document.createElement("<lvml:" + e + " class=\"lvml\">");
				};
			} catch {}
			return function(e) {
				return document.createElement("<" + e + " xmlns=\"urn:schemas-microsoft.com:vml\" class=\"lvml\">");
			};
		})(), Gr = {
			_initContainer: function() {
				this._container = J("div", "leaflet-vml-container");
			},
			_update: function() {
				this._map._animatingZoom || (Vr.prototype._update.call(this), this.fire("update"));
			},
			_initPath: function(e) {
				var t = e._container = Wr("shape");
				X(t, "leaflet-vml-shape " + (this.options.className || "")), t.coordsize = "1 1", e._path = Wr("path"), t.appendChild(e._path), this._updateStyle(e), this._layers[o(e)] = e;
			},
			_addPath: function(e) {
				var t = e._container;
				this._container.appendChild(t), e.options.interactive && e.addInteractiveTarget(t);
			},
			_removePath: function(e) {
				var t = e._container;
				mt(t), e.removeInteractiveTarget(t), delete this._layers[o(e)];
			},
			_updateStyle: function(e) {
				var t = e._stroke, n = e._fill, r = e.options, i = e._container;
				i.stroked = !!r.stroke, i.filled = !!r.fill, r.stroke ? (t ||= e._stroke = Wr("stroke"), i.appendChild(t), t.weight = r.weight + "px", t.color = r.color, t.opacity = r.opacity, r.dashArray ? t.dashStyle = _(r.dashArray) ? r.dashArray.join(" ") : r.dashArray.replace(/( *, *)/g, " ") : t.dashStyle = "", t.endcap = r.lineCap.replace("butt", "flat"), t.joinstyle = r.lineJoin) : t && (i.removeChild(t), e._stroke = null), r.fill ? (n ||= e._fill = Wr("fill"), i.appendChild(n), n.color = r.fillColor || r.color, n.opacity = r.fillOpacity) : n && (i.removeChild(n), e._fill = null);
			},
			_updateCircle: function(e) {
				var t = e._point.round(), n = Math.round(e._radius), r = Math.round(e._radiusY || n);
				this._setPath(e, e._empty() ? "M0 0" : "AL " + t.x + "," + t.y + " " + n + "," + r + " 0,23592600");
			},
			_setPath: function(e, t) {
				e._path.v = t;
			},
			_bringToFront: function(e) {
				Y(e._container);
			},
			_bringToBack: function(e) {
				gt(e._container);
			}
		}, Kr = q.vml ? Wr : U, qr = Vr.extend({
			_initContainer: function() {
				this._container = Kr("svg"), this._container.setAttribute("pointer-events", "none"), this._rootGroup = Kr("g"), this._container.appendChild(this._rootGroup);
			},
			_destroyContainer: function() {
				mt(this._container), Bt(this._container), delete this._container, delete this._rootGroup, delete this._svgSize;
			},
			_update: function() {
				if (!(this._map._animatingZoom && this._bounds)) {
					Vr.prototype._update.call(this);
					var e = this._bounds, t = e.getSize(), n = this._container;
					(!this._svgSize || !this._svgSize.equals(t)) && (this._svgSize = t, n.setAttribute("width", t.x), n.setAttribute("height", t.y)), wt(n, e.min), n.setAttribute("viewBox", [
						e.min.x,
						e.min.y,
						t.x,
						t.y
					].join(" ")), this.fire("update");
				}
			},
			_initPath: function(e) {
				var t = e._path = Kr("path");
				e.options.className && X(t, e.options.className), e.options.interactive && X(t, "leaflet-interactive"), this._updateStyle(e), this._layers[o(e)] = e;
			},
			_addPath: function(e) {
				this._rootGroup || this._initContainer(), this._rootGroup.appendChild(e._path), e.addInteractiveTarget(e._path);
			},
			_removePath: function(e) {
				mt(e._path), e.removeInteractiveTarget(e._path), delete this._layers[o(e)];
			},
			_updatePath: function(e) {
				e._project(), e._update();
			},
			_updateStyle: function(e) {
				var t = e._path, n = e.options;
				t && (n.stroke ? (t.setAttribute("stroke", n.color), t.setAttribute("stroke-opacity", n.opacity), t.setAttribute("stroke-width", n.weight), t.setAttribute("stroke-linecap", n.lineCap), t.setAttribute("stroke-linejoin", n.lineJoin), n.dashArray ? t.setAttribute("stroke-dasharray", n.dashArray) : t.removeAttribute("stroke-dasharray"), n.dashOffset ? t.setAttribute("stroke-dashoffset", n.dashOffset) : t.removeAttribute("stroke-dashoffset")) : t.setAttribute("stroke", "none"), n.fill ? (t.setAttribute("fill", n.fillColor || n.color), t.setAttribute("fill-opacity", n.fillOpacity), t.setAttribute("fill-rule", n.fillRule || "evenodd")) : t.setAttribute("fill", "none"));
			},
			_updatePoly: function(e, t) {
				this._setPath(e, se(e._parts, t));
			},
			_updateCircle: function(e) {
				var t = e._point, n = Math.max(Math.round(e._radius), 1), r = Math.max(Math.round(e._radiusY), 1) || n, i = "a" + n + "," + r + " 0 1,0 ", a = e._empty() ? "M0 0" : "M" + (t.x - n) + "," + t.y + i + n * 2 + ",0 " + i + -n * 2 + ",0 ";
				this._setPath(e, a);
			},
			_setPath: function(e, t) {
				e._path.setAttribute("d", t);
			},
			_bringToFront: function(e) {
				Y(e._path);
			},
			_bringToBack: function(e) {
				gt(e._path);
			}
		});
		q.vml && qr.include(Gr);
		function Jr(e) {
			return q.svg || q.vml ? new qr(e) : null;
		}
		rn.include({
			getRenderer: function(e) {
				var t = e.options.renderer || this._getPaneRenderer(e.options.pane) || this.options.renderer || this._renderer;
				return t ||= this._renderer = this._createRenderer(), this.hasLayer(t) || this.addLayer(t), t;
			},
			_getPaneRenderer: function(e) {
				if (e === "overlayPane" || e === void 0) return !1;
				var t = this._paneRenderers[e];
				return t === void 0 && (t = this._createRenderer({ pane: e }), this._paneRenderers[e] = t), t;
			},
			_createRenderer: function(e) {
				return this.options.preferCanvas && Ur(e) || Jr(e);
			}
		});
		var Yr = cr.extend({
			initialize: function(e, t) {
				cr.prototype.initialize.call(this, this._boundsToLatLngs(e), t);
			},
			setBounds: function(e) {
				return this.setLatLngs(this._boundsToLatLngs(e));
			},
			_boundsToLatLngs: function(e) {
				return e = z(e), [
					e.getSouthWest(),
					e.getNorthWest(),
					e.getNorthEast(),
					e.getSouthEast()
				];
			}
		});
		function Xr(e, t) {
			return new Yr(e, t);
		}
		qr.create = Kr, qr.pointsToPath = se, ur.geometryToLayer = dr, ur.coordsToLatLng = pr, ur.coordsToLatLngs = mr, ur.latLngToCoords = hr, ur.latLngsToCoords = gr, ur.getFeature = _r, ur.asFeature = vr, rn.mergeOptions({ boxZoom: !0 });
		var Zr = hn.extend({
			initialize: function(e) {
				this._map = e, this._container = e._container, this._pane = e._panes.overlayPane, this._resetStateTimeout = 0, e.on("unload", this._destroy, this);
			},
			addHooks: function() {
				Q(this._container, "mousedown", this._onMouseDown, this);
			},
			removeHooks: function() {
				Bt(this._container, "mousedown", this._onMouseDown, this);
			},
			moved: function() {
				return this._moved;
			},
			_destroy: function() {
				mt(this._pane), delete this._pane;
			},
			_resetState: function() {
				this._resetStateTimeout = 0, this._moved = !1;
			},
			_clearDeferredResetState: function() {
				this._resetStateTimeout !== 0 && (clearTimeout(this._resetStateTimeout), this._resetStateTimeout = 0);
			},
			_onMouseDown: function(e) {
				if (!e.shiftKey || e.which !== 1 && e.button !== 1) return !1;
				this._clearDeferredResetState(), this._resetState(), Et(), At(), this._startPoint = this._map.mouseEventToContainerPoint(e), Q(document, {
					contextmenu: Yt,
					mousemove: this._onMouseMove,
					mouseup: this._onMouseUp,
					keydown: this._onKeyDown
				}, this);
			},
			_onMouseMove: function(e) {
				this._moved || (this._moved = !0, this._box = J("div", "leaflet-zoom-box", this._container), X(this._container, "leaflet-crosshair"), this._map.fire("boxzoomstart")), this._point = this._map.mouseEventToContainerPoint(e);
				var t = new F(this._point, this._startPoint), n = t.getSize();
				wt(this._box, t.min), this._box.style.width = n.x + "px", this._box.style.height = n.y + "px";
			},
			_finish: function() {
				this._moved && (mt(this._box), vt(this._container, "leaflet-crosshair")), Dt(), jt(), Bt(document, {
					contextmenu: Yt,
					mousemove: this._onMouseMove,
					mouseup: this._onMouseUp,
					keydown: this._onKeyDown
				}, this);
			},
			_onMouseUp: function(e) {
				if ((e.which === 1 || e.button === 1) && (this._finish(), this._moved)) {
					this._clearDeferredResetState(), this._resetStateTimeout = setTimeout(i(this._resetState, this), 0);
					var t = new R(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
					this._map.fitBounds(t).fire("boxzoomend", { boxZoomBounds: t });
				}
			},
			_onKeyDown: function(e) {
				e.keyCode === 27 && (this._finish(), this._clearDeferredResetState(), this._resetState());
			}
		});
		rn.addInitHook("addHandler", "boxZoom", Zr), rn.mergeOptions({ doubleClickZoom: !0 });
		var Qr = hn.extend({
			addHooks: function() {
				this._map.on("dblclick", this._onDoubleClick, this);
			},
			removeHooks: function() {
				this._map.off("dblclick", this._onDoubleClick, this);
			},
			_onDoubleClick: function(e) {
				var t = this._map, n = t.getZoom(), r = t.options.zoomDelta, i = e.originalEvent.shiftKey ? n - r : n + r;
				t.options.doubleClickZoom === "center" ? t.setZoom(i) : t.setZoomAround(e.containerPoint, i);
			}
		});
		rn.addInitHook("addHandler", "doubleClickZoom", Qr), rn.mergeOptions({
			dragging: !0,
			inertia: !0,
			inertiaDeceleration: 3400,
			inertiaMaxSpeed: Infinity,
			easeLinearity: .2,
			worldCopyJump: !1,
			maxBoundsViscosity: 0
		});
		var $r = hn.extend({
			addHooks: function() {
				if (!this._draggable) {
					var e = this._map;
					this._draggable = new vn(e._mapPane, e._container), this._draggable.on({
						dragstart: this._onDragStart,
						drag: this._onDrag,
						dragend: this._onDragEnd
					}, this), this._draggable.on("predrag", this._onPreDragLimit, this), e.options.worldCopyJump && (this._draggable.on("predrag", this._onPreDragWrap, this), e.on("zoomend", this._onZoomEnd, this), e.whenReady(this._onZoomEnd, this));
				}
				X(this._map._container, "leaflet-grab leaflet-touch-drag"), this._draggable.enable(), this._positions = [], this._times = [];
			},
			removeHooks: function() {
				vt(this._map._container, "leaflet-grab"), vt(this._map._container, "leaflet-touch-drag"), this._draggable.disable();
			},
			moved: function() {
				return this._draggable && this._draggable._moved;
			},
			moving: function() {
				return this._draggable && this._draggable._moving;
			},
			_onDragStart: function() {
				var e = this._map;
				if (e._stop(), this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
					var t = z(this._map.options.maxBounds);
					this._offsetLimit = I(this._map.latLngToContainerPoint(t.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(t.getSouthEast()).multiplyBy(-1).add(this._map.getSize())), this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity));
				} else this._offsetLimit = null;
				e.fire("movestart").fire("dragstart"), e.options.inertia && (this._positions = [], this._times = []);
			},
			_onDrag: function(e) {
				if (this._map.options.inertia) {
					var t = this._lastTime = +/* @__PURE__ */ new Date(), n = this._lastPos = this._draggable._absPos || this._draggable._newPos;
					this._positions.push(n), this._times.push(t), this._prunePositions(t);
				}
				this._map.fire("move", e).fire("drag", e);
			},
			_prunePositions: function(e) {
				for (; this._positions.length > 1 && e - this._times[0] > 50;) this._positions.shift(), this._times.shift();
			},
			_onZoomEnd: function() {
				var e = this._map.getSize().divideBy(2), t = this._map.latLngToLayerPoint([0, 0]);
				this._initialWorldOffset = t.subtract(e).x, this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
			},
			_viscousLimit: function(e, t) {
				return e - (e - t) * this._viscosity;
			},
			_onPreDragLimit: function() {
				if (this._viscosity && this._offsetLimit) {
					var e = this._draggable._newPos.subtract(this._draggable._startPos), t = this._offsetLimit;
					e.x < t.min.x && (e.x = this._viscousLimit(e.x, t.min.x)), e.y < t.min.y && (e.y = this._viscousLimit(e.y, t.min.y)), e.x > t.max.x && (e.x = this._viscousLimit(e.x, t.max.x)), e.y > t.max.y && (e.y = this._viscousLimit(e.y, t.max.y)), this._draggable._newPos = this._draggable._startPos.add(e);
				}
			},
			_onPreDragWrap: function() {
				var e = this._worldWidth, t = Math.round(e / 2), n = this._initialWorldOffset, r = this._draggable._newPos.x, i = (r - t + n) % e + t - n, a = (r + t + n) % e - t - n, o = Math.abs(i + n) < Math.abs(a + n) ? i : a;
				this._draggable._absPos = this._draggable._newPos.clone(), this._draggable._newPos.x = o;
			},
			_onDragEnd: function(e) {
				var t = this._map, n = t.options, r = !n.inertia || e.noInertia || this._times.length < 2;
				if (t.fire("dragend", e), r) t.fire("moveend");
				else {
					this._prunePositions(+/* @__PURE__ */ new Date());
					var i = this._lastPos.subtract(this._positions[0]), a = (this._lastTime - this._times[0]) / 1e3, o = n.easeLinearity, s = i.multiplyBy(o / a), c = s.distanceTo([0, 0]), l = Math.min(n.inertiaMaxSpeed, c), u = s.multiplyBy(l / c), d = l / (n.inertiaDeceleration * o), f = u.multiplyBy(-d / 2).round();
					!f.x && !f.y ? t.fire("moveend") : (f = t._limitOffset(f, t.options.maxBounds), T(function() {
						t.panBy(f, {
							duration: d,
							easeLinearity: o,
							noMoveStart: !0,
							animate: !0
						});
					}));
				}
			}
		});
		rn.addInitHook("addHandler", "dragging", $r), rn.mergeOptions({
			keyboard: !0,
			keyboardPanDelta: 80
		});
		var ei = hn.extend({
			keyCodes: {
				left: [37],
				right: [39],
				down: [40],
				up: [38],
				zoomIn: [
					187,
					107,
					61,
					171
				],
				zoomOut: [
					189,
					109,
					54,
					173
				]
			},
			initialize: function(e) {
				this._map = e, this._setPanDelta(e.options.keyboardPanDelta), this._setZoomDelta(e.options.zoomDelta);
			},
			addHooks: function() {
				var e = this._map._container;
				e.tabIndex <= 0 && (e.tabIndex = "0"), Q(e, {
					focus: this._onFocus,
					blur: this._onBlur,
					mousedown: this._onMouseDown
				}, this), this._map.on({
					focus: this._addHooks,
					blur: this._removeHooks
				}, this);
			},
			removeHooks: function() {
				this._removeHooks(), Bt(this._map._container, {
					focus: this._onFocus,
					blur: this._onBlur,
					mousedown: this._onMouseDown
				}, this), this._map.off({
					focus: this._addHooks,
					blur: this._removeHooks
				}, this);
			},
			_onMouseDown: function() {
				if (!this._focused) {
					var e = document.body, t = document.documentElement, n = e.scrollTop || t.scrollTop, r = e.scrollLeft || t.scrollLeft;
					this._map._container.focus(), window.scrollTo(r, n);
				}
			},
			_onFocus: function() {
				this._focused = !0, this._map.fire("focus");
			},
			_onBlur: function() {
				this._focused = !1, this._map.fire("blur");
			},
			_setPanDelta: function(e) {
				for (var t = this._panKeys = {}, n = this.keyCodes, r = 0, i = n.left.length; r < i; r++) t[n.left[r]] = [-1 * e, 0];
				for (r = 0, i = n.right.length; r < i; r++) t[n.right[r]] = [e, 0];
				for (r = 0, i = n.down.length; r < i; r++) t[n.down[r]] = [0, e];
				for (r = 0, i = n.up.length; r < i; r++) t[n.up[r]] = [0, -1 * e];
			},
			_setZoomDelta: function(e) {
				for (var t = this._zoomKeys = {}, n = this.keyCodes, r = 0, i = n.zoomIn.length; r < i; r++) t[n.zoomIn[r]] = e;
				for (r = 0, i = n.zoomOut.length; r < i; r++) t[n.zoomOut[r]] = -e;
			},
			_addHooks: function() {
				Q(document, "keydown", this._onKeyDown, this);
			},
			_removeHooks: function() {
				Bt(document, "keydown", this._onKeyDown, this);
			},
			_onKeyDown: function(e) {
				if (!(e.altKey || e.ctrlKey || e.metaKey)) {
					var t = e.keyCode, n = this._map, r;
					if (t in this._panKeys) {
						if (!n._panAnim || !n._panAnim._inProgress) {
							if (r = this._panKeys[t], e.shiftKey && (r = P(r).multiplyBy(3)), n.options.maxBounds && (r = n._limitOffset(P(r), n.options.maxBounds)), n.options.worldCopyJump) {
								var i = n.wrapLatLng(n.unproject(n.project(n.getCenter()).add(r)));
								n.panTo(i);
							} else n.panBy(r);
						}
					} else if (t in this._zoomKeys) n.setZoom(n.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[t]);
					else if (t === 27 && n._popup && n._popup.options.closeOnEscapeKey) n.closePopup();
					else return;
					Yt(e);
				}
			}
		});
		rn.addInitHook("addHandler", "keyboard", ei), rn.mergeOptions({
			scrollWheelZoom: !0,
			wheelDebounceTime: 40,
			wheelPxPerZoomLevel: 60
		});
		var ti = hn.extend({
			addHooks: function() {
				Q(this._map._container, "wheel", this._onWheelScroll, this), this._delta = 0;
			},
			removeHooks: function() {
				Bt(this._map._container, "wheel", this._onWheelScroll, this);
			},
			_onWheelScroll: function(e) {
				var t = $t(e), n = this._map.options.wheelDebounceTime;
				this._delta += t, this._lastMousePos = this._map.mouseEventToContainerPoint(e), this._startTime ||= +/* @__PURE__ */ new Date();
				var r = Math.max(n - (+/* @__PURE__ */ new Date() - this._startTime), 0);
				clearTimeout(this._timer), this._timer = setTimeout(i(this._performZoom, this), r), Yt(e);
			},
			_performZoom: function() {
				var e = this._map, t = e.getZoom(), n = this._map.options.zoomSnap || 0;
				e._stop();
				var r = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), i = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(r)))) / Math.LN2, a = n ? Math.ceil(i / n) * n : i, o = e._limitZoom(t + (this._delta > 0 ? a : -a)) - t;
				this._delta = 0, this._startTime = null, o && (e.options.scrollWheelZoom === "center" ? e.setZoom(t + o) : e.setZoomAround(this._lastMousePos, t + o));
			}
		});
		rn.addInitHook("addHandler", "scrollWheelZoom", ti);
		var ni = 600;
		rn.mergeOptions({
			tapHold: q.touchNative && q.safari && q.mobile,
			tapTolerance: 15
		});
		var ri = hn.extend({
			addHooks: function() {
				Q(this._map._container, "touchstart", this._onDown, this);
			},
			removeHooks: function() {
				Bt(this._map._container, "touchstart", this._onDown, this);
			},
			_onDown: function(e) {
				if (clearTimeout(this._holdTimeout), e.touches.length === 1) {
					var t = e.touches[0];
					this._startPos = this._newPos = new M(t.clientX, t.clientY), this._holdTimeout = setTimeout(i(function() {
						this._cancel(), this._isTapValid() && (Q(document, "touchend", Jt), Q(document, "touchend touchcancel", this._cancelClickPrevent), this._simulateEvent("contextmenu", t));
					}, this), ni), Q(document, "touchend touchcancel contextmenu", this._cancel, this), Q(document, "touchmove", this._onMove, this);
				}
			},
			_cancelClickPrevent: function e() {
				Bt(document, "touchend", Jt), Bt(document, "touchend touchcancel", e);
			},
			_cancel: function() {
				clearTimeout(this._holdTimeout), Bt(document, "touchend touchcancel contextmenu", this._cancel, this), Bt(document, "touchmove", this._onMove, this);
			},
			_onMove: function(e) {
				var t = e.touches[0];
				this._newPos = new M(t.clientX, t.clientY);
			},
			_isTapValid: function() {
				return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
			},
			_simulateEvent: function(e, t) {
				var n = new MouseEvent(e, {
					bubbles: !0,
					cancelable: !0,
					view: window,
					screenX: t.screenX,
					screenY: t.screenY,
					clientX: t.clientX,
					clientY: t.clientY
				});
				n._simulated = !0, t.target.dispatchEvent(n);
			}
		});
		rn.addInitHook("addHandler", "tapHold", ri), rn.mergeOptions({
			touchZoom: q.touch,
			bounceAtZoomLimits: !0
		});
		var ii = hn.extend({
			addHooks: function() {
				X(this._map._container, "leaflet-touch-zoom"), Q(this._map._container, "touchstart", this._onTouchStart, this);
			},
			removeHooks: function() {
				vt(this._map._container, "leaflet-touch-zoom"), Bt(this._map._container, "touchstart", this._onTouchStart, this);
			},
			_onTouchStart: function(e) {
				var t = this._map;
				if (!(!e.touches || e.touches.length !== 2 || t._animatingZoom || this._zooming)) {
					var n = t.mouseEventToContainerPoint(e.touches[0]), r = t.mouseEventToContainerPoint(e.touches[1]);
					this._centerPoint = t.getSize()._divideBy(2), this._startLatLng = t.containerPointToLatLng(this._centerPoint), t.options.touchZoom !== "center" && (this._pinchStartLatLng = t.containerPointToLatLng(n.add(r)._divideBy(2))), this._startDist = n.distanceTo(r), this._startZoom = t.getZoom(), this._moved = !1, this._zooming = !0, t._stop(), Q(document, "touchmove", this._onTouchMove, this), Q(document, "touchend touchcancel", this._onTouchEnd, this), Jt(e);
				}
			},
			_onTouchMove: function(e) {
				if (e.touches && e.touches.length === 2 && this._zooming) {
					var t = this._map, n = t.mouseEventToContainerPoint(e.touches[0]), r = t.mouseEventToContainerPoint(e.touches[1]), a = n.distanceTo(r) / this._startDist;
					if (this._zoom = t.getScaleZoom(a, this._startZoom), !t.options.bounceAtZoomLimits && (this._zoom < t.getMinZoom() && a < 1 || this._zoom > t.getMaxZoom() && a > 1) && (this._zoom = t._limitZoom(this._zoom)), t.options.touchZoom === "center") {
						if (this._center = this._startLatLng, a === 1) return;
					} else {
						var o = n._add(r)._divideBy(2)._subtract(this._centerPoint);
						if (a === 1 && o.x === 0 && o.y === 0) return;
						this._center = t.unproject(t.project(this._pinchStartLatLng, this._zoom).subtract(o), this._zoom);
					}
					this._moved ||= (t._moveStart(!0, !1), !0), E(this._animRequest);
					var s = i(t._move, t, this._center, this._zoom, {
						pinch: !0,
						round: !1
					}, void 0);
					this._animRequest = T(s, this, !0), Jt(e);
				}
			},
			_onTouchEnd: function() {
				if (!this._moved || !this._zooming) {
					this._zooming = !1;
					return;
				}
				this._zooming = !1, E(this._animRequest), Bt(document, "touchmove", this._onTouchMove, this), Bt(document, "touchend touchcancel", this._onTouchEnd, this), this._map.options.zoomAnimation ? this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), !0, this._map.options.zoomSnap) : this._map._resetView(this._center, this._map._limitZoom(this._zoom));
			}
		});
		rn.addInitHook("addHandler", "touchZoom", ii), rn.BoxZoom = Zr, rn.DoubleClickZoom = Qr, rn.Drag = $r, rn.Keyboard = ei, rn.ScrollWheelZoom = ti, rn.TapHold = ri, rn.TouchZoom = ii, e.Bounds = F, e.Browser = q, e.CRS = ee, e.Canvas = Hr, e.Circle = ir, e.CircleMarker = nr, e.Class = O, e.Control = on, e.DivIcon = Nr, e.DivOverlay = Or, e.DomEvent = tn, e.DomUtil = Rt, e.Draggable = vn, e.Evented = j, e.FeatureGroup = $, e.GeoJSON = ur, e.GridLayer = Fr, e.Handler = hn, e.Icon = Yn, e.ImageOverlay = Sr, e.LatLng = B, e.LatLngBounds = R, e.Layer = Gn, e.LayerGroup = Kn, e.LineUtil = Rn, e.Map = rn, e.Marker = $n, e.Mixin = gn, e.Path = tr, e.Point = M, e.PolyUtil = Sn, e.Polygon = cr, e.Polyline = or, e.Popup = kr, e.PosAnimation = nn, e.Projection = Vn, e.Rectangle = Yr, e.Renderer = Vr, e.SVG = qr, e.SVGOverlay = Er, e.TileLayer = Lr, e.Tooltip = jr, e.Transformation = ie, e.Util = D, e.VideoOverlay = wr, e.bind = i, e.bounds = I, e.canvas = Ur, e.circle = ar, e.circleMarker = rr, e.control = sn, e.divIcon = Pr, e.extend = n, e.featureGroup = Jn, e.geoJSON = br, e.geoJson = xr, e.gridLayer = Ir, e.icon = Xn, e.imageOverlay = Cr, e.latLng = V, e.latLngBounds = z, e.layerGroup = qn, e.map = an, e.marker = er, e.point = P, e.polygon = lr, e.polyline = sr, e.popup = Ar, e.rectangle = Xr, e.setOptions = p, e.stamp = o, e.svg = Jr, e.svgOverlay = Dr, e.tileLayer = Rr, e.tooltip = Mr, e.transformation = ae, e.version = t, e.videoOverlay = Tr;
		var ai = window.L;
		e.noConflict = function() {
			return window.L = ai, this;
		}, window.L = e;
	}));
})))(), Xl = new Ht(), Zl = new Ut(), Ql = null, $l = null, eu = null, tu = null, nu = null, ru = null, iu, au, ou, su, cu, lu, uu = 500, du = 6, fu = {
	id: "Map",
	icon: ji,
	tooltip: "",
	Title: pu,
	Content: mu
};
function pu() {
	let { t: e } = h("teiaviewer");
	return /* @__PURE__ */ G(S, { children: e("teia.widgets.settings_widget.tabs.map.title") });
}
function mu() {
	let { t } = h("teiaviewer"), { viewer: n } = H(), r = Qi(nt.Twin), { plugin: i } = U("Map"), { plugin: a } = U("Teia"), [o, s] = f(!1), [c, l] = f(!1), [u, d] = f(parseFloat((i.mapContainer?.center.lat ?? 0).toFixed(du))), [p, g] = f(parseFloat((i.mapContainer?.center.lng ?? 0).toFixed(du))), [_, v] = f(i.mapContainer?.azimuth ?? 0), [y, b] = f(i.mapContainer?.opacity ?? .7), [x, S] = f(i.mapContainer?.elevation ?? 0), [w, T] = f(i.mapContainer?.size ?? 100), [E, D] = f(i.mapContainer?.shape ?? Ae.square), [O, k] = f(i.mapContainer?.mapType ?? je.default);
	return r ? /* @__PURE__ */ K(e, {
		sx: { fill: (e) => e.palette.primary.main },
		divider: /* @__PURE__ */ G(Kt, {}),
		spacing: 3,
		children: [
			/* @__PURE__ */ K(e, {
				spacing: 2,
				children: [/* @__PURE__ */ K(e, {
					direction: "row",
					spacing: 2,
					alignItems: "center",
					children: [/* @__PURE__ */ G(hu, {
						longitude: p,
						latitude: u,
						setLatitude: d
					}), /* @__PURE__ */ G(gu, {
						longitude: p,
						latitude: u,
						setLongitude: g
					})]
				}), /* @__PURE__ */ K(e, {
					direction: "row",
					spacing: 2,
					alignItems: "center",
					children: [/* @__PURE__ */ G(_u, {
						elevation: x,
						setElevation: S
					}), /* @__PURE__ */ G(vu, {
						rotation: _,
						setRotation: v
					})]
				})]
			}),
			/* @__PURE__ */ K(e, {
				spacing: 2,
				children: [/* @__PURE__ */ G(yu, {
					opacity: y,
					setOpacity: b
				}), /* @__PURE__ */ G(bu, {
					size: w,
					setSize: T
				})]
			}),
			/* @__PURE__ */ K(e, {
				spacing: 2,
				children: [/* @__PURE__ */ G("p", {
					style: {
						marginTop: 2,
						marginBottom: 2
					},
					children: t("widgets.map_widget.plan_type.text")
				}), /* @__PURE__ */ G(xu, {
					type: O,
					setType: k
				})]
			}),
			/* @__PURE__ */ K(e, { children: [
				/* @__PURE__ */ G("p", {
					style: {
						marginTop: 2,
						marginBottom: 2
					},
					children: t("widgets.map_widget.shape_type.text")
				}),
				/* @__PURE__ */ G(Su, {
					shape: E,
					setShape: D
				}),
				/* @__PURE__ */ G(m, {
					severity: "info",
					sx: { marginTop: 3 },
					children: t("widgets.map_widget.warning.text")
				}),
				/* @__PURE__ */ G(e, {
					direction: "row",
					justifyContent: "flex-end",
					sx: { marginTop: 3 },
					children: /* @__PURE__ */ G(Z, {
						"data-testid": "map-settings-save-button",
						onClick: async () => {
							if (!a.currentSource) return;
							l(!0), i.settings.opacity.value = y, i.settings.shape.value = E, i.settings.size.value = w, i.settings.type.value = O;
							let e = new Ue(n, a.currentSource.projectId, _, u, p, x);
							await e.execute(), s(e.isError), l(!1), e.isError || (new C(n, "Settings").execute(), i.signals.onSettingsMapSaved.emit());
						},
						variant: o ? "error" : "info",
						isLoading: c,
						children: t("widgets.map_widget.validate.text")
					})
				})
			] })
		]
	}) : /* @__PURE__ */ G(m, {
		severity: "info",
		children: t("widgets.map_widget.warning_no_twin.text")
	});
}
var hu = (t) => {
	let { latitude: n, longitude: r, setLatitude: i } = t, { t: a } = h("teiaviewer"), { viewer: o } = H(), { plugin: s } = U("Map");
	return c(() => {
		let e = (e) => {
			Ql || i(e.lat);
		};
		return s.mapContainer?.signals.onLatLngChanged.connect(e), () => {
			s.mapContainer?.signals.onLatLngChanged.disconnect(e);
		};
	}, []), /* @__PURE__ */ K(e, {
		direction: "row",
		alignItems: "center",
		spacing: 2,
		sx: { width: "100%" },
		children: [/* @__PURE__ */ G(Rl, { style: { fill: "inherit" } }), /* @__PURE__ */ G(E, {
			label: a("widgets.map_widget.latitude.text"),
			name: "latitude",
			id: "latitude",
			"data-testid": "map-settings-latitude-field",
			value: n,
			onChange: (e) => {
				i(e);
				let t = new Yl.LatLng(e, r);
				Ql ? (Ql.update(t), clearTimeout(iu)) : (Ql = new Ge(o, t), Ql.execute()), iu = setTimeout(() => {
					Ql = null;
				}, uu);
			},
			min: -Infinity,
			maxDigits: du,
			step: 1e-5,
			sx: { width: "100%" }
		})]
	});
}, gu = (t) => {
	let { latitude: n, longitude: r, setLongitude: i } = t, { t: a } = h("teiaviewer"), { viewer: o } = H(), { plugin: s } = U("Map");
	return c(() => {
		let e = (e) => {
			$l || i(e.lng);
		};
		return s.mapContainer?.signals.onLatLngChanged.connect(e), () => {
			s.mapContainer?.signals.onLatLngChanged.disconnect(e);
		};
	}, []), /* @__PURE__ */ K(e, {
		direction: "row",
		alignItems: "center",
		spacing: 2,
		sx: { width: "100%" },
		children: [/* @__PURE__ */ G(zl, { style: { fill: "inherit" } }), /* @__PURE__ */ G(E, {
			label: a("widgets.map_widget.longitude.text"),
			name: "longitude",
			id: "longitude",
			"data-testid": "map-settings-longitude-field",
			value: r,
			onChange: (e) => {
				i(e);
				let t = new Yl.LatLng(n, e);
				$l ? ($l.update(t), clearTimeout(au)) : ($l = new Ge(o, t), $l.execute()), au = setTimeout(() => {
					$l = null;
				}, uu);
			},
			min: -Infinity,
			maxDigits: du,
			step: 1e-5,
			sx: { width: "100%" }
		})]
	});
}, _u = (t) => {
	let { setElevation: n, elevation: r } = t, { t: i } = h("teiaviewer"), { viewer: a } = H(), { plugin: o } = U("Map");
	return c(() => {
		let e = () => {
			tu || (o.mapContainer?.getMatrix(Xl), Zl.setFromMatrixPosition(Xl), n(Zl.y));
		};
		return o.mapContainer?.signals.onTransformChanged.connect(e), () => {
			o.mapContainer?.signals.onTransformChanged.disconnect(e);
		};
	}, []), /* @__PURE__ */ K(e, {
		direction: "row",
		alignItems: "center",
		spacing: 2,
		sx: { width: "100%" },
		children: [/* @__PURE__ */ G(Ll, { style: { fill: "inherit" } }), /* @__PURE__ */ G(E, {
			label: i("widgets.map_widget.elevation.text"),
			name: "elevation",
			id: "elevation",
			"data-testid": "map-settings-elevation-field",
			value: r,
			onChange: (e) => {
				n(e), tu ? (tu.update(e), clearInterval(su)) : (tu = new Ke(a, e), tu.execute()), su = setTimeout(() => {
					tu = null;
				}, uu);
			},
			step: .1,
			min: -Infinity,
			maxDigits: 5,
			sx: { width: "100%" }
		})]
	});
}, vu = (t) => {
	let { setRotation: n, rotation: r } = t, { t: i } = h("teiaviewer"), { viewer: a } = H(), { plugin: o } = U("Map");
	return c(() => {
		let e = (e) => {
			eu || n(e);
		};
		return o.mapContainer?.signals.onRotationChanged.connect(e), () => {
			o.mapContainer?.signals.onRotationChanged.disconnect(e);
		};
	}, []), /* @__PURE__ */ K(e, {
		direction: "row",
		alignItems: "center",
		spacing: 2,
		sx: { width: "100%" },
		children: [/* @__PURE__ */ G(Ul, { style: { fill: "inherit" } }), /* @__PURE__ */ G(E, {
			label: i("widgets.map_widget.rotation.text"),
			name: "rotation",
			id: "rotation",
			"data-testid": "map-settings-rotation-field",
			value: r,
			onChange: (e) => {
				n(e), eu ? (eu.update(e), clearInterval(ou)) : (eu = new Je(a, e), eu.execute()), ou = setTimeout(() => {
					eu = null;
				}, uu);
			},
			step: .1,
			min: 0,
			max: 360,
			sx: { width: "100%" },
			maxDigits: 5
		})]
	});
}, yu = (t) => {
	let { setOpacity: n, opacity: r } = t, { viewer: i } = H(), { plugin: a } = U("Map");
	return c(() => {
		let e = (e) => {
			nu || n(e);
		};
		return a.mapContainer?.signals.onOpacityChanged.connect(e), () => {
			a.mapContainer?.signals.onOpacityChanged.disconnect(e);
		};
	}, []), /* @__PURE__ */ K(e, {
		direction: "row",
		alignItems: "center",
		spacing: 2,
		children: [/* @__PURE__ */ G(Hl, { style: { fill: "inherit" } }), /* @__PURE__ */ G(M, {
			value: r,
			step: .1,
			onChange: (e) => {
				n(e), nu ? (nu.update(e), clearInterval(cu)) : (nu = new qe(i, e), nu.execute()), cu = setTimeout(() => {
					nu = null;
				}, uu);
			},
			showAdditionalInput: !0,
			inputWidth: 90,
			max: 1,
			min: .1,
			maxDigits: 2
		})]
	});
}, bu = (t) => {
	let { setSize: n, size: r } = t, { viewer: i } = H(), { plugin: a } = U("Map");
	return c(() => {
		let e = (e) => {
			ru || n(e);
		};
		return a.mapContainer?.signals.onSizeChanged.connect(e), () => {
			a.mapContainer?.signals.onSizeChanged.disconnect(e);
		};
	}, []), /* @__PURE__ */ K(e, {
		direction: "row",
		alignItems: "center",
		spacing: 2,
		children: [/* @__PURE__ */ G(Wl, { style: { fill: "inherit" } }), /* @__PURE__ */ G(M, {
			value: r,
			onChange: (e) => {
				n(e), ru ? (ru.update(e), clearInterval(lu)) : (ru = new Xe(i, e), ru.execute()), lu = setTimeout(() => {
					ru = null;
				}, uu);
			},
			showAdditionalInput: !0,
			inputWidth: 90,
			min: 1,
			max: a.mapContainer?.maxSizeMeters,
			step: 1,
			maxDigits: 2
		})]
	});
}, xu = (t) => {
	let { setType: n, type: r } = t, { t: i } = h("teiaviewer"), { viewer: a } = H(), { plugin: o } = U("Map"), s = (e) => {
		let t = Number(e.target.value);
		(t === je.default || t === je.simple || t === je.cadastral || t === je.satellite) && (new Ze(a, t).execute(), n(t));
	};
	return c(() => {
		let e = (e) => {
			n(e);
		};
		return o.mapContainer?.signals.onTypeChanged.connect(e), () => {
			o.mapContainer?.signals.onTypeChanged.disconnect(e);
		};
	}, []), /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 3,
		sx: { "& label": {
			margin: 0,
			"& span": { fontSize: 14 }
		} },
		children: [
			/* @__PURE__ */ K(e, {
				alignItems: "center",
				children: [/* @__PURE__ */ G("img", {
					src: Kl,
					style: {
						minWidth: "72px",
						minHeight: "72px"
					},
					alt: i("widgets.map_widget.maps.default.text")
				}), /* @__PURE__ */ G(Bn, {
					label: i("widgets.map_widget.maps.default.text"),
					labelPlacement: "bottom",
					"data-testid": "map-settings-type-default-radio",
					value: je.default,
					onChange: s,
					checked: r === je.default
				})]
			}),
			/* @__PURE__ */ K(e, {
				alignItems: "center",
				children: [/* @__PURE__ */ G("img", {
					src: Jl,
					style: {
						minWidth: "72px",
						minHeight: "72px"
					},
					alt: i("widgets.map_widget.maps.simple.text")
				}), /* @__PURE__ */ G(Bn, {
					label: i("widgets.map_widget.maps.simple.text"),
					labelPlacement: "bottom",
					"data-testid": "map-settings-type-simple-radio",
					value: je.simple,
					onChange: s,
					checked: r === je.simple
				})]
			}),
			/* @__PURE__ */ K(e, {
				alignItems: "center",
				children: [/* @__PURE__ */ G("img", {
					src: ql,
					style: {
						minWidth: "72px",
						minHeight: "72px"
					},
					alt: i("widgets.map_widget.maps.satellite.text")
				}), /* @__PURE__ */ G(Bn, {
					label: i("widgets.map_widget.maps.satellite.text"),
					labelPlacement: "bottom",
					"data-testid": "map-settings-type-satellite-radio",
					value: je.satellite,
					onChange: s,
					checked: r === je.satellite
				})]
			}),
			/* @__PURE__ */ K(e, {
				alignItems: "center",
				children: [/* @__PURE__ */ G("img", {
					src: Gl,
					style: {
						minWidth: "72px",
						minHeight: "72px"
					},
					alt: i("widgets.map_widget.maps.cadastral.text")
				}), /* @__PURE__ */ G(Bn, {
					label: i("widgets.map_widget.maps.cadastral.text"),
					labelPlacement: "bottom",
					"data-testid": "map-settings-type-cadastral-radio",
					value: je.cadastral,
					onChange: s,
					checked: r === je.cadastral
				})]
			})
		]
	});
}, Su = (t) => {
	let { setShape: n, shape: r } = t, { t: i } = h("teiaviewer"), { viewer: a } = H(), { plugin: o } = U("Map"), s = (e) => {
		let t = Number(e.target.value);
		(t == Ae.circle || t == Ae.square) && (new Ye(a, t).execute(), n(t));
	};
	return c(() => {
		let e = (e) => {
			n(e);
		};
		return o.mapContainer?.signals.onShapeChanged.connect(e), () => {
			o.mapContainer?.signals.onShapeChanged.disconnect(e);
		};
	}, []), /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 10,
		children: [/* @__PURE__ */ K(e, {
			direction: "row",
			alignItems: "center",
			sx: { "& label": { margin: 0 } },
			children: [/* @__PURE__ */ G(Vl, { style: { fill: "inherit" } }), /* @__PURE__ */ G(Bn, {
				label: i("widgets.map_widget.shapes.square.text"),
				"data-testid": "map-settings-shape-square-radio",
				value: Ae.square,
				onChange: s,
				checked: r === Ae.square
			})]
		}), /* @__PURE__ */ K(e, {
			direction: "row",
			alignItems: "center",
			sx: { "& label": { margin: 0 } },
			children: [/* @__PURE__ */ G(Bl, { style: { fill: "inherit" } }), /* @__PURE__ */ G(Bn, {
				label: i("widgets.map_widget.shapes.circle.text"),
				"data-testid": "map-settings-shape-circle-radio",
				value: Ae.circle,
				onChange: s,
				checked: r === Ae.circle
			})]
		})]
	});
};
//#endregion
//#region src/widgets/navigation/voxelization/VoxelizationContext.tsx
function Cu(e) {
	return e.split(",").map((e) => e.trim()).filter(Boolean);
}
var wu = i(null), Tu = ({ children: e }) => {
	let { viewer: t } = H(), n = t.getPlugin("Path"), r = n.voxelizationController, { forceUpdate: i } = ne(), [a, o] = f(be.granularities.join(", ")), [s, l] = f(be.boxTreeLevel), [u, d] = f(be.workerCount), [p, m] = f(be.maxVoxelCount), [h, g] = f(""), [_, v] = f(be.excludedObjectTypes.join(", ")), [y, b] = f(be.passableObjectTypes.join(", ")), [x, S] = f(be.verticalConnectionObjectTypes.join(", ")), C = r.status === "preparing" || r.status === "running";
	c(() => (r.signals.onChanged.connect(i), () => {
		r.signals.onChanged.disconnect(i);
	}), [r, i]), c(() => {
		n.navigationGraphController.setIgnoredObjectTypes([...Cu(_), ...Cu(y)]);
	}, [
		_,
		y,
		n
	]), c(() => {
		r.markResultForUpdate();
	}, [
		r,
		_,
		h,
		y,
		x
	]);
	let w = {
		controller: r,
		running: C,
		granularities: a,
		setGranularities: o,
		boxTreeLevel: s,
		setBoxTreeLevel: l,
		workerCount: u,
		setWorkerCount: d,
		maxVoxelCount: p,
		setMaxVoxelCount: m,
		includedObjectTypes: h,
		setIncludedObjectTypes: g,
		excludedObjectTypes: _,
		setExcludedObjectTypes: v,
		passableObjectTypes: y,
		setPassableObjectTypes: b,
		verticalConnectionObjectTypes: x,
		setVerticalConnectionObjectTypes: S
	};
	return /* @__PURE__ */ G(wu.Provider, {
		value: w,
		children: e
	});
};
function Eu() {
	let e = s(wu);
	if (e === null) throw Error("useVoxelizationContext must be used within a VoxelizationProvider.");
	return e;
}
//#endregion
//#region src/widgets/navigation/NavigationOption.tsx
var Du = ({ label: e, children: t }) => {
	let n = l(), [r, i] = f(null);
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(v, {
		icon: mn,
		"data-testid": "navigation-option-help",
		"aria-describedby": r ? n : void 0,
		"aria-label": e,
		size: "small",
		onClick: (e) => {
			i(e.currentTarget);
		}
	}), /* @__PURE__ */ G(Mn, {
		id: n,
		open: r !== null,
		anchorEl: r,
		onClose: () => {
			i(null);
		},
		anchorOrigin: {
			vertical: "bottom",
			horizontal: "right"
		},
		transformOrigin: {
			vertical: "top",
			horizontal: "right"
		},
		children: /* @__PURE__ */ G(S, {
			sx: {
				maxWidth: 360,
				padding: 2
			},
			variant: "body2",
			children: t
		})
	})] });
}, Ou = ({ children: t, helpLabel: n, helpText: r, alignItems: i = "flex-start" }) => /* @__PURE__ */ K(e, {
	direction: "row",
	spacing: 1,
	alignItems: i,
	sx: { width: "100%" },
	children: [/* @__PURE__ */ G(e, {
		sx: {
			flex: 1,
			minWidth: 0
		},
		children: t
	}), /* @__PURE__ */ G(Du, {
		label: n,
		children: r
	})]
}), ku = [
	"empty",
	"solid",
	"all"
], Au = [
	"solid",
	"navigable",
	"unclassified",
	"all"
], ju = "all", Mu = () => {
	let { t } = h("teiaviewer"), { viewer: n } = H(), { controller: r } = Eu(), i = n.getPlugin("Path"), a = i.voxelDebugController, { forceUpdate: o } = ne(), [s, l] = f(String(a.displayStride)), u = (e, t) => {
		a.visible = t;
	}, d = (e) => {
		e !== null && (a.category = e);
	}, p = (e) => {
		e !== null && (a.level = e === ju ? null : Number(e));
	}, m = (e, t) => {
		a.showVoxelsOnTop = t;
	}, g = (e) => {
		l(e.target.value);
	}, _ = () => {
		a.displayStride = Number(s), l(String(a.displayStride));
	};
	c(() => {
		let e = () => {
			l(String(a.displayStride)), o();
		};
		return a.signals.onChanged.connect(e), () => {
			a.signals.onChanged.disconnect(e);
		};
	}, [a, o]);
	let v = i.floodFillController.result === null ? ku : Au, b = Array.from(r.result?.granularities ?? [], (e, t) => String(t)), x = (e) => t(`teia.widgets.navigation_widget.flood_fill.display_category.${e}.text`), S = (e) => {
		if (e === ju || r.result === null) return t("teia.widgets.navigation_widget.flood_fill.display_level.all.text");
		let n = r.result.granularities[Number(e)];
		return `${Number(n.toPrecision(6))} m`;
	};
	return /* @__PURE__ */ K(e, {
		spacing: 3,
		children: [/* @__PURE__ */ G(Wt, {
			"data-testid": "voxel-grid-visible-switch",
			checked: a.visible,
			disabled: r.result === null,
			onChange: u,
			label: t("teia.widgets.navigation_widget.flood_fill.display_grid.text")
		}), r.result !== null && /* @__PURE__ */ K(W, { children: [
			/* @__PURE__ */ G(dt, {
				"data-testid": "voxel-grid-category-select",
				label: t("teia.widgets.navigation_widget.flood_fill.display_category.label"),
				options: [...v],
				getOptionLabel: x,
				value: a.category,
				onChange: d,
				sx: {
					width: "100%",
					fontSize: "14px"
				}
			}),
			/* @__PURE__ */ G(dt, {
				"data-testid": "voxel-grid-level-select",
				label: t("teia.widgets.navigation_widget.flood_fill.display_level.label"),
				options: [ju, ...b],
				getOptionLabel: S,
				value: String(a.level ?? ju),
				onChange: p,
				sx: {
					width: "100%",
					fontSize: "14px"
				}
			}),
			/* @__PURE__ */ G(Wt, {
				"data-testid": "voxel-grid-on-top-switch",
				checked: a.showVoxelsOnTop,
				onChange: m,
				label: t("teia.widgets.navigation_widget.flood_fill.voxels_on_top.text")
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: t("teia.widgets.navigation_widget.voxelization.debug.display_stride.help.label"),
				helpText: t("teia.widgets.navigation_widget.voxelization.debug.display_stride.help.text"),
				children: /* @__PURE__ */ G(y, {
					sx: { width: "100%" },
					type: "number",
					label: t("teia.widgets.navigation_widget.voxelization.debug.display_stride.label"),
					value: s,
					onChange: g,
					onBlur: _,
					slotProps: { htmlInput: {
						min: 1,
						step: 1,
						"data-testid": "voxel-grid-display-stride-input"
					} }
				})
			})
		] })]
	});
}, Nu = ({ running: t, onRun: n, onCancel: r }) => {
	let { t: i } = h("teiaviewer");
	return /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 1,
		children: [/* @__PURE__ */ G(Z, {
			"data-testid": "flood-fill-run-button",
			variant: "primary",
			disabled: t,
			onClick: n,
			children: i("teia.widgets.navigation_widget.flood_fill.calculate.text")
		}), !!t && /* @__PURE__ */ G(Z, {
			"data-testid": "flood-fill-cancel-button",
			variant: "secondary",
			onClick: r,
			children: i("teia.widgets.navigation_widget.flood_fill.cancel.text")
		})]
	});
}, Pu = i(null), Fu = ({ children: e }) => {
	let { viewer: t } = H(), { forceUpdate: n } = ne(), r = t.getPlugin("Path").voxelizationController, i = t.getPlugin("Path").floodFillController, a = t.viewport?.operator.name === "FloodFillSeedOperator", s = o(() => {
		t.viewport?.operator.name === "FloodFillSeedOperator" && t.viewport.resetDefaultOperator();
	}, [t]);
	c(() => (r.signals.onChanged.connect(n), i.signals.onChanged.connect(n), t.signals.onOperatorChanged.connect(n), () => {
		r.signals.onChanged.disconnect(n), i.signals.onChanged.disconnect(n), t.signals.onOperatorChanged.disconnect(n), s();
	}), [
		s,
		n,
		i,
		t.signals.onOperatorChanged,
		r
	]);
	let l = u(() => ({
		hasGrid: r.result !== null,
		hasFloodFillResult: i.result !== null,
		isSeedPlacementActive: a,
		deactivateSeedPlacement: s
	}), [
		s,
		i.result,
		a,
		r.result
	]);
	return /* @__PURE__ */ G(Pu.Provider, {
		value: l,
		children: e
	});
};
function Iu() {
	let e = s(Pu);
	if (e === null) throw Error("useFloodFill must be used inside FloodFillProvider.");
	return e;
}
//#endregion
//#region src/widgets/navigation/floodFill/FloodFillParameters.tsx
var Lu = ({ seedObjectTypes: e, maximumSeedDistance: t, workerCount: n, manualSeedCount: r, running: i, isSeedPlacementActive: a, onSeedObjectTypesChange: o, onMaximumSeedDistanceChange: s, onWorkerCountChange: c, onToggleSeedPlacement: l }) => {
	let { t: u } = h("teiaviewer");
	return /* @__PURE__ */ K(W, { children: [
		/* @__PURE__ */ G(y, {
			"data-testid": "flood-fill-seed-types-input",
			label: u("teia.widgets.navigation_widget.flood_fill.seed_types.label"),
			value: e,
			disabled: i,
			onChange: (e) => o(e.target.value),
			helperText: u("teia.widgets.navigation_widget.flood_fill.seed_types.text")
		}),
		/* @__PURE__ */ G(E, {
			"data-testid": "flood-fill-seed-distance-input",
			label: u("teia.widgets.navigation_widget.flood_fill.seed_distance.label"),
			value: t,
			disabled: i,
			min: 0,
			step: .1,
			maxDigits: 2,
			defaultValue: 1,
			onChange: s
		}),
		/* @__PURE__ */ G(E, {
			"data-testid": "flood-fill-worker-count-input",
			label: u("teia.widgets.navigation_widget.flood_fill.worker_count.label"),
			value: n,
			disabled: i,
			min: 1,
			max: 32,
			step: 1,
			maxDigits: 2,
			defaultValue: ve.workerCount,
			onChange: c
		}),
		/* @__PURE__ */ G(Z, {
			"data-testid": "flood-fill-seed-placement-button",
			variant: "secondary",
			disabled: i,
			onClick: l,
			children: u(a ? "teia.widgets.navigation_widget.flood_fill.quit_seed_placement.text" : "teia.widgets.navigation_widget.flood_fill.place_seed.text")
		}),
		/* @__PURE__ */ G(S, {
			"data-testid": "flood-fill-manual-seeds",
			variant: "caption",
			children: u("teia.widgets.navigation_widget.flood_fill.manual_seeds.text", { count: r })
		})
	] });
}, Ru = ({ needsUpdate: t, error: n, seedWarningCount: r, running: i, visitedVoxelCount: a, componentCount: o, validSeedCount: s }) => {
	let { t: c } = h("teiaviewer");
	return /* @__PURE__ */ K(W, { children: [
		!!t && /* @__PURE__ */ G(m, {
			"data-testid": "flood-fill-needs-update-alert",
			severity: "warning",
			children: c("teia.widgets.navigation_widget.flood_fill.needs_update.text")
		}),
		n !== null && /* @__PURE__ */ G(m, {
			"data-testid": "flood-fill-error-alert",
			severity: "error",
			children: n
		}),
		r > 0 && /* @__PURE__ */ G(m, {
			"data-testid": "flood-fill-seed-warnings-alert",
			severity: "warning",
			children: c("teia.widgets.navigation_widget.flood_fill.seed_warnings.text", { count: r })
		}),
		!!i && /* @__PURE__ */ K(e, {
			"data-testid": "flood-fill-progress",
			spacing: 1,
			children: [/* @__PURE__ */ G(bt, { variant: "indeterminate" }), /* @__PURE__ */ G(S, {
				variant: "caption",
				children: c("teia.widgets.navigation_widget.flood_fill.progress.text", { count: a })
			})]
		}),
		o !== null && /* @__PURE__ */ G(S, {
			"data-testid": "flood-fill-result",
			variant: "caption",
			children: c("teia.widgets.navigation_widget.flood_fill.result.text", {
				components: o,
				seeds: s
			})
		})
	] });
}, zu = () => {
	let { t } = h("teiaviewer"), { viewer: n } = H(), { forceUpdate: r } = ne(), i = n.getPlugin("Path").floodFillController, { isSeedPlacementActive: a, deactivateSeedPlacement: o } = Iu(), [s, l] = f(ve.seedObjectTypes.join(", ")), [u, d] = f(ve.maximumSeedDistance), [p, m] = f(ve.workerCount), g = i.status === "running", _ = i.result?.seeds.filter((e) => e.voxelIndex >= 0).length ?? 0, v = i.result?.seeds.filter((e) => e.warning !== null).length ?? 0;
	return c(() => (i.signals.onChanged.connect(r), () => {
		i.signals.onChanged.disconnect(r);
	}), [i, r]), c(() => {
		i.options = {
			seedObjectTypes: s.split(",").map((e) => e.trim()).filter(Boolean),
			maximumSeedDistance: u,
			workerCount: p
		};
	}, [
		i,
		u,
		s,
		p
	]), /* @__PURE__ */ K(e, {
		spacing: 1,
		children: [
			/* @__PURE__ */ G(S, { children: t("teia.widgets.navigation_widget.flood_fill.title") }),
			/* @__PURE__ */ G(Lu, {
				seedObjectTypes: s,
				maximumSeedDistance: u,
				workerCount: p,
				manualSeedCount: i.manualSeeds.length,
				running: g,
				isSeedPlacementActive: a,
				onSeedObjectTypesChange: l,
				onMaximumSeedDistanceChange: d,
				onWorkerCountChange: m,
				onToggleSeedPlacement: () => {
					if (a) {
						o();
						return;
					}
					let e = n.viewport;
					e && i.grid !== null && (e.setOperator(new Ee(e)), e.canvas.focus());
				}
			}),
			/* @__PURE__ */ G(Kt, {}),
			/* @__PURE__ */ G(Mu, {}),
			/* @__PURE__ */ G(Kt, {}),
			/* @__PURE__ */ G(Ru, {
				needsUpdate: i.needsUpdate,
				error: i.error,
				seedWarningCount: v,
				running: g,
				visitedVoxelCount: i.progress.visitedVoxelCount,
				componentCount: i.result?.components.length ?? null,
				validSeedCount: _
			}),
			/* @__PURE__ */ G(Nu, {
				running: g,
				onRun: () => {
					i.start().catch(() => {});
				},
				onCancel: () => {
					i.cancel();
				}
			})
		]
	});
}, Bu = (e) => {
	let { open: t, onClose: n, onConfirm: r } = e, { t: i } = h("teiaviewer");
	return /* @__PURE__ */ K(Et, {
		open: t,
		onClose: n,
		children: [
			/* @__PURE__ */ G(kt, { children: i("teia.widgets.navigation_widget.import_modal.title") }),
			/* @__PURE__ */ G(Dt, { children: /* @__PURE__ */ G(m, {
				severity: "warning",
				sx: {
					display: "flex",
					alignItems: "center"
				},
				children: /* @__PURE__ */ G("p", { children: i("teia.widgets.navigation_widget.import_modal.warning.text") })
			}) }),
			/* @__PURE__ */ K(Ot, { children: [/* @__PURE__ */ G(Z, {
				"data-testid": "navigation-graph-import-cancel-button",
				variant: "error",
				onClick: n,
				sx: { fontSize: "14px" },
				children: i("teia.widgets.navigation_widget.import_modal.cancel.text")
			}), /* @__PURE__ */ G(Z, {
				"data-testid": "navigation-graph-import-confirm-button",
				variant: "primary",
				sx: { fontSize: "14px" },
				onClick: r,
				children: i("teia.widgets.navigation_widget.import_modal.confirm.text")
			})] })
		]
	});
}, Vu = i(null);
function Hu({ children: e }) {
	let { viewer: t } = H(), n = t.getPlugin("Path").navigationGraphController, { forceUpdate: r } = ne(), [i, a] = f(() => n.isEditing ? n.activeGraph?.validate() ?? [] : []), [s, l] = f(null), d = n.activeGraph, p = n.selectedElements, m = n.isEditing, h = o((e) => {
		n.setEditing(e), e && t.viewport ? (new Lt(t, []).execute(), t.viewport.setOperator(new Le(t.viewport)), t.viewport.canvas.focus()) : t.viewport?.resetDefaultOperator();
	}, [n, t]);
	c(() => {
		let e = (e) => {
			e?.transient || a(n.isEditing ? n.activeGraph?.validate() ?? [] : []), r();
		}, i = (e) => {
			a(e ? n.activeGraph?.validate() ?? [] : []), r();
		}, o = () => r(), s = (e) => {
			e.name !== "NavigationGraphOperator" && n.isEditing && n.setEditing(!1);
		};
		return n.signals.onGraphChanged.connect(e), n.signals.onSelectionChanged.connect(o), n.signals.onEditingChanged.connect(i), t.signals.onOperatorChanged.connect(s), () => {
			n.signals.onGraphChanged.disconnect(e), n.signals.onSelectionChanged.disconnect(o), n.signals.onEditingChanged.disconnect(i), t.signals.onOperatorChanged.disconnect(s);
		};
	}, [
		n,
		r,
		t.signals.onOperatorChanged
	]);
	let g = u(() => ({
		graphController: n,
		graph: d,
		selection: p,
		isEditing: m,
		validationErrors: i,
		setValidationErrors: a,
		importError: s,
		setImportError: l,
		setEditing: h
	}), [
		n,
		d,
		p,
		m,
		i,
		s,
		h
	]);
	return /* @__PURE__ */ G(Vu.Provider, {
		value: g,
		children: e
	});
}
function Uu() {
	let e = s(Vu);
	if (!e) throw Error("useNavigationGraph must be used inside NavigationGraphProvider.");
	return e;
}
//#endregion
//#region src/widgets/navigation/graph/NavigationGraphImportExportMenu.tsx
var Wu = () => {
	let { graphController: t, validationErrors: n, setImportError: i, setValidationErrors: a, setEditing: o } = Uu(), { t: s } = h("teiaviewer"), c = d(null), u = l(), [p, m] = f(null), [g, _] = f(null), [y, x] = f(!1), S = (e) => {
		m(e.currentTarget);
	}, C = () => {
		m(null);
	};
	return /* @__PURE__ */ K(r, { children: [
		/* @__PURE__ */ G(b, {
			title: s("teia.widgets.navigation_widget.actions.more.label"),
			children: /* @__PURE__ */ G(v, {
				"data-testid": "navigation-graph-more-button",
				icon: cn,
				"aria-label": s("teia.widgets.navigation_widget.actions.more.label"),
				"aria-describedby": u,
				onClick: S
			})
		}),
		/* @__PURE__ */ G(Mn, {
			id: u,
			open: p !== null,
			anchorEl: p,
			onClose: C,
			anchorOrigin: {
				vertical: "bottom",
				horizontal: "right"
			},
			transformOrigin: {
				vertical: "top",
				horizontal: "right"
			},
			children: /* @__PURE__ */ K(e, { children: [/* @__PURE__ */ G(Z, {
				"data-testid": "navigation-graph-import-button",
				variant: "info",
				sx: { fontSize: "14px" },
				startIcon: /* @__PURE__ */ G(Y, {
					component: dn,
					fontSize: "small"
				}),
				onClick: () => {
					C(), c.current?.click();
				},
				children: s("teia.widgets.navigation_widget.actions.import_json.text")
			}), /* @__PURE__ */ G(Z, {
				"data-testid": "navigation-graph-export-button",
				variant: "info",
				sx: { fontSize: "14px" },
				startIcon: /* @__PURE__ */ G(Y, {
					component: sn,
					fontSize: "small"
				}),
				disabled: !t.activeGraph || n.length > 0,
				onClick: async () => {
					if (C(), !(!t.activeGraph || n.length > 0)) try {
						let e = t.exportGraph(), n = URL.createObjectURL(new Blob([JSON.stringify(e, null, 2)], { type: "application/json" })), r = document.createElement("a");
						r.href = n, r.download = `navigation-graph-${e.id}.json`, r.click(), URL.revokeObjectURL(n);
					} catch {
						a(t.validate());
					}
				},
				children: s("teia.widgets.navigation_widget.actions.export_json.text")
			})] })
		}),
		/* @__PURE__ */ G("input", {
			"data-testid": "navigation-graph-file-input",
			ref: c,
			hidden: !0,
			type: "file",
			accept: ".json,application/json",
			onChange: async (e) => {
				let t = e.target.files?.[0];
				if (e.target.value = "", t) {
					i(null);
					try {
						_(JSON.parse(await t.text())), x(!0);
					} catch (e) {
						i(String(e));
					}
				}
			}
		}),
		/* @__PURE__ */ G(Bu, {
			open: y,
			onClose: () => {
				x(!1), _(null);
			},
			onConfirm: () => {
				try {
					t.importGraph(g), o(!0);
				} catch (e) {
					i(String(e));
				} finally {
					x(!1), _(null);
				}
			}
		})
	] });
}, Gu = () => {
	let { viewer: t } = H(), { graphController: n, graph: r, isEditing: i, setEditing: a } = Uu(), { t: o } = h("teiaviewer");
	return /* @__PURE__ */ K(e, {
		spacing: 1,
		children: [/* @__PURE__ */ K(e, {
			direction: "row",
			spacing: 1,
			justifyContent: "space-between",
			alignItems: "center",
			children: [/* @__PURE__ */ G(Z, {
				"data-testid": "navigation-graph-create-button",
				variant: "primary",
				startIcon: /* @__PURE__ */ G(Y, {
					component: n.activeGraph ? vn : yn,
					fontSize: "small"
				}),
				disabled: i,
				onClick: async () => {
					n.activeGraph || await new _e(t).execute(), a(!0);
				},
				sx: { fontSize: "14px" },
				children: n.activeGraph ? o("teia.widgets.navigation_widget.actions.edit.text") : o("teia.widgets.navigation_widget.actions.create.text")
			}), r !== null && /* @__PURE__ */ K(S, {
				"data-testid": "navigation-graph-counts",
				sx: {
					fontSize: "12px",
					marginLeft: 2
				},
				children: [
					o("teia.widgets.navigation_widget.overview.nodes.text", { count: r.nodes.size }),
					" · ",
					o("teia.widgets.navigation_widget.overview.edges.text", { count: r.edges.size })
				]
			})]
		}), r !== null && !i && /* @__PURE__ */ G(Z, {
			"data-testid": "navigation-graph-clear-button",
			variant: "error",
			startIcon: /* @__PURE__ */ G(Y, {
				component: Cn,
				fontSize: "small"
			}),
			onClick: () => {
				new Ce(t).execute();
			},
			children: o("teia.widgets.navigation_widget.actions.clear_graph.text")
		})]
	});
}, Ku = () => /* @__PURE__ */ K(e, {
	direction: "row",
	spacing: 1,
	justifyContent: "space-between",
	alignItems: "center",
	children: [/* @__PURE__ */ G(Gu, {}), /* @__PURE__ */ G(Wu, {})]
}), qu = () => {
	let { viewer: t } = H(), n = t.getPlugin("Path"), { t: r } = h("teiaviewer"), [i, a] = oe(n.navigationGraphSettings.connectNodesAutomatically), [o, s] = oe(n.navigationGraphSettings.mergeThreshold);
	return /* @__PURE__ */ K(e, {
		spacing: 2,
		sx: { marginTop: 2 },
		children: [/* @__PURE__ */ G(E, {
			"data-testid": "navigation-graph-merge-threshold-input",
			label: r("teia.widgets.navigation_widget.overview.merge_threshold.label"),
			value: o,
			min: .01,
			max: 5,
			step: .01,
			maxDigits: 2,
			defaultValue: .1,
			onChange: s,
			sx: { "& input": { fontSize: "14px" } }
		}), /* @__PURE__ */ G(Wt, {
			"data-testid": "navigation-graph-auto-connect-switch",
			sx: {
				margin: 0,
				"& .MuiFormControlLabel-label": { fontSize: "14px" }
			},
			checked: i,
			onChange: (e, t) => {
				a(t);
			},
			label: r("teia.widgets.navigation_widget.overview.connect_nodes_automatically.label")
		})]
	});
}, Ju = ({ elementType: e, elementId: t, accessible: n }) => {
	let { viewer: r } = H(), { t: i } = h("teiaviewer"), a = async (n) => {
		await new $e(r, e, t, n).execute();
	};
	return /* @__PURE__ */ G(Wt, {
		"data-testid": "navigation-graph-accessible-switch",
		sx: {
			margin: 0,
			"& .MuiFormControlLabel-label": { fontSize: "14px" }
		},
		checked: n,
		label: i("teia.widgets.navigation_widget.selection.accessible.label"),
		onChange: (e, t) => {
			a(t);
		}
	});
}, Yu = ["both", "forward"], Xu = ({ edge: t }) => {
	let { viewer: n } = H(), { t: r } = h("teiaviewer"), i = async (e) => {
		await new Qe(n, t.id, e).execute();
	}, a = async () => {
		await new He(n, t.id).execute();
	}, o = (e) => {
		e !== null && i(e);
	}, s = (e) => r(e === "both" ? "teia.widgets.navigation_widget.selection.direction_both.text" : "teia.widgets.navigation_widget.selection.direction_forward.text"), c = r("teia.widgets.navigation_widget.selection.reverse_direction.text");
	return /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 1,
		children: [/* @__PURE__ */ G(dt, {
			"data-testid": "navigation-graph-direction-select",
			sx: { fontSize: "14px" },
			options: Yu,
			getOptionLabel: s,
			value: t.direction,
			onChange: o
		}), t.direction === "forward" && /* @__PURE__ */ G(b, {
			title: c,
			children: /* @__PURE__ */ G(v, {
				"data-testid": "navigation-graph-reverse-button",
				icon: Yt,
				"aria-label": c,
				onClick: a
			})
		})]
	});
}, Zu = ({ nodeIds: t }) => {
	let { viewer: n } = H(), { t: r } = h("teiaviewer"), i = async (e) => {
		await new Ne(n, t, e).execute();
	};
	return /* @__PURE__ */ K(_, { children: [/* @__PURE__ */ G(S, {
		sx: {
			fontSize: "14px",
			margin: 1
		},
		children: r("teia.widgets.navigation_widget.selection.merge_nodes.text")
	}), /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 1,
		children: [
			/* @__PURE__ */ G(b, {
				title: r("teia.widgets.navigation_widget.selection.merge_first.text"),
				children: /* @__PURE__ */ G(v, {
					"data-testid": "navigation-graph-merge-first-button",
					icon: $t,
					"aria-label": r("teia.widgets.navigation_widget.selection.merge_first.text"),
					onClick: () => {
						i("first");
					}
				})
			}),
			/* @__PURE__ */ G(b, {
				title: r("teia.widgets.navigation_widget.selection.merge_center.text"),
				children: /* @__PURE__ */ G(v, {
					"data-testid": "navigation-graph-merge-center-button",
					icon: pn,
					"aria-label": r("teia.widgets.navigation_widget.selection.merge_center.text"),
					onClick: () => {
						i("center");
					}
				})
			}),
			/* @__PURE__ */ G(b, {
				title: r("teia.widgets.navigation_widget.selection.merge_last.text"),
				children: /* @__PURE__ */ G(v, {
					"data-testid": "navigation-graph-merge-last-button",
					icon: en,
					"aria-label": r("teia.widgets.navigation_widget.selection.merge_last.text"),
					onClick: () => {
						i("last");
					}
				})
			})
		]
	})] });
}, Qu = ({ selection: t, selectedNodePair: n, selectedConnectionId: r }) => {
	let { viewer: i } = H(), { graphController: a } = Uu(), { t: o } = h("teiaviewer"), s = t.ids.length > 0, c = n !== null && r === null, l = r !== null, u = async () => {
		c && await new de(i, n[0], n[1]).execute();
	}, d = async () => {
		l && await new Se(i, r).execute();
	}, f = async () => {
		if (t.type === "node") for (let e of Array.from(t.ids)) await new we(i, e).execute();
		else for (let e of Array.from(t.ids)) await new Se(i, e).execute();
	}, p = async () => {
		s && await new xe(i, t.ids[0]).execute();
	}, m = () => {
		let e = i.viewport?.operator;
		e instanceof Le ? e.clearSelection() : a.selectNodes([]);
	}, g = o("teia.widgets.navigation_widget.selection.clear.text"), _ = o("teia.widgets.navigation_widget.selection.connect_nodes.text"), y = o("teia.widgets.navigation_widget.selection.delete_connection.text"), x = o("teia.widgets.navigation_widget.selection.delete.text"), S = o("teia.widgets.navigation_widget.selection.delete_connected_graph.text");
	return /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 1,
		flexWrap: "wrap",
		children: [
			/* @__PURE__ */ G(b, {
				title: g,
				children: /* @__PURE__ */ G(v, {
					"data-testid": "navigation-graph-clear-selection-button",
					icon: Sn,
					"aria-label": g,
					disabled: !s,
					onClick: m
				})
			}),
			/* @__PURE__ */ G(b, {
				title: _,
				children: /* @__PURE__ */ G(v, {
					"data-testid": "navigation-graph-connect-nodes-button",
					icon: hn,
					"aria-label": _,
					disabled: !c,
					onClick: u
				})
			}),
			/* @__PURE__ */ G(b, {
				title: y,
				children: /* @__PURE__ */ G(v, {
					"data-testid": "navigation-graph-delete-connection-button",
					icon: gn,
					"aria-label": y,
					variant: "error",
					disabled: !l,
					onClick: d
				})
			}),
			/* @__PURE__ */ G(b, {
				title: x,
				children: /* @__PURE__ */ G(v, {
					"data-testid": "navigation-graph-delete-selection-button",
					icon: Cn,
					"aria-label": x,
					variant: "error",
					disabled: !s,
					onClick: f
				})
			}),
			/* @__PURE__ */ G(b, {
				title: S,
				children: /* @__PURE__ */ G(v, {
					"data-testid": "navigation-graph-delete-connected-button",
					icon: Cn,
					"aria-label": S,
					variant: "error",
					disabled: !s,
					onClick: p
				})
			})
		]
	});
}, $u = () => {
	let { graph: t, selection: n } = Uu(), { t: r } = h("teiaviewer");
	if (!t) return null;
	let i = n.type === "node" ? n.ids : [], a = n.type === "edge" ? n.ids : [], o = i.length === 2 ? [i[0], i[1]] : null, s = a.length === 1 ? t.edges.get(a[0]) : void 0, c = o ? t.findEdge(o[0], o[1]) : void 0, l;
	n.ids.length === 1 && (l = n.type === "node" ? t.nodes.get(n.ids[0]) : t.edges.get(n.ids[0]));
	let u = n.type === "node" ? "teia.widgets.navigation_widget.selection.nodes.text" : "teia.widgets.navigation_widget.selection.edges.text";
	return /* @__PURE__ */ K(e, {
		spacing: 2,
		children: [
			/* @__PURE__ */ G(S, {
				sx: {
					fontSize: "14px",
					margin: 1
				},
				children: n.ids.length === 0 ? r("teia.widgets.navigation_widget.selection.empty.text") : r(u, { count: n.ids.length })
			}),
			/* @__PURE__ */ G(Qu, {
				selection: n,
				selectedNodePair: o,
				selectedConnectionId: c?.id ?? null
			}),
			i.length >= 2 && /* @__PURE__ */ G(Zu, { nodeIds: i }),
			l !== void 0 && /* @__PURE__ */ G(Ju, {
				elementType: n.type,
				elementId: l.id,
				accessible: l.accessible
			}),
			s !== void 0 && /* @__PURE__ */ G(Xu, { edge: s })
		]
	});
}, ed = {
	"invalid-position": "teia.widgets.navigation_widget.validation.errors.invalid_position.text",
	"invalid-edge": "teia.widgets.navigation_widget.validation.errors.invalid_edge.text",
	"missing-node": "teia.widgets.navigation_widget.validation.errors.missing_node.text",
	"self-edge": "teia.widgets.navigation_widget.validation.errors.self_edge.text",
	"duplicate-edge": "teia.widgets.navigation_widget.validation.errors.duplicate_edge.text"
}, td = () => {
	let { viewer: t } = H(), { graphController: n, validationErrors: r, setValidationErrors: i, setEditing: a } = Uu(), { t: o } = h("teiaviewer");
	return /* @__PURE__ */ K(e, {
		spacing: 2,
		children: [r.map((e, t) => /* @__PURE__ */ G(m, {
			"data-testid": "navigation-graph-validation-error",
			severity: "error",
			children: o(ed[e.code])
		}, `${e.elementId}-${t}`)), /* @__PURE__ */ K(e, {
			direction: "row",
			spacing: 1,
			children: [/* @__PURE__ */ G(Z, {
				"data-testid": "navigation-graph-validate-button",
				sx: { fontSize: "14px" },
				variant: "primary",
				startIcon: /* @__PURE__ */ G(Y, {
					component: Zt,
					fontSize: "small"
				}),
				disabled: r.length > 0,
				onClick: () => {
					n.commit(), a(!1);
				},
				children: o("teia.widgets.navigation_widget.validation.validate.text")
			}), /* @__PURE__ */ G(Z, {
				"data-testid": "navigation-graph-revert-button",
				variant: "info",
				sx: {
					fontSize: "14px",
					backgroundColor: (e) => e.palette.warning.main,
					color: "white",
					padding: "0px 10px",
					"&:hover": {
						backgroundColor: (e) => e.palette.warning.dark,
						color: "white"
					}
				},
				startIcon: /* @__PURE__ */ G(Y, {
					component: wn,
					fontSize: "small"
				}),
				onClick: async () => {
					await new q(t).execute(), i(n.activeGraph?.validate() ?? []), a(!1);
				},
				children: o("teia.widgets.navigation_widget.validation.revert.text")
			})]
		})]
	});
}, nd = ({ running: t, generationDisabled: n, onGenerate: r, onCancel: i }) => {
	let { t: a } = h("teiaviewer");
	return /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 1,
		children: [/* @__PURE__ */ G(Z, {
			variant: "primary",
			disabled: n,
			onClick: r,
			children: a("teia.widgets.navigation_widget.navmesh.generate.text")
		}), !!t && /* @__PURE__ */ G(Z, {
			variant: "secondary",
			onClick: i,
			children: a("teia.widgets.navigation_widget.navmesh.cancel.text")
		})]
	});
}, rd = ({ options: t, disabled: n, onOptionChange: r }) => {
	let { t: i } = h("teiaviewer");
	return /* @__PURE__ */ K(e, {
		spacing: 3,
		children: [
			/* @__PURE__ */ G(Ou, {
				helpLabel: i("teia.widgets.navigation_widget.navmesh.target_nodes.help.label"),
				helpText: i("teia.widgets.navigation_widget.navmesh.target_nodes.help.text"),
				children: /* @__PURE__ */ G(E, {
					label: i("teia.widgets.navigation_widget.navmesh.target_nodes.label"),
					value: t.targetNodeCount,
					disabled: n,
					min: 1,
					max: t.maximumNodeCount,
					step: 1e3,
					maxDigits: 0,
					onChange: (e) => r("targetNodeCount", e)
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: i("teia.widgets.navigation_widget.navmesh.maximum_nodes.help.label"),
				helpText: i("teia.widgets.navigation_widget.navmesh.maximum_nodes.help.text"),
				children: /* @__PURE__ */ G(E, {
					label: i("teia.widgets.navigation_widget.navmesh.maximum_nodes.label"),
					value: t.maximumNodeCount,
					disabled: n,
					min: 1,
					step: 1e3,
					maxDigits: 0,
					onChange: (e) => r("maximumNodeCount", e)
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: i("teia.widgets.navigation_widget.navmesh.maximum_edges.help.label"),
				helpText: i("teia.widgets.navigation_widget.navmesh.maximum_edges.help.text"),
				children: /* @__PURE__ */ G(E, {
					label: i("teia.widgets.navigation_widget.navmesh.maximum_edges.label"),
					value: t.maximumEdgeCount,
					disabled: n,
					min: 1,
					step: 1e3,
					maxDigits: 0,
					onChange: (e) => r("maximumEdgeCount", e)
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: i("teia.widgets.navigation_widget.navmesh.maximum_height.help.label"),
				helpText: i("teia.widgets.navigation_widget.navmesh.maximum_height.help.text"),
				children: /* @__PURE__ */ G(E, {
					label: i("teia.widgets.navigation_widget.navmesh.maximum_height.label"),
					value: t.maximumHeightDifference,
					disabled: n,
					min: 0,
					step: .05,
					maxDigits: 2,
					onChange: (e) => r("maximumHeightDifference", e)
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: i("teia.widgets.navigation_widget.navmesh.maximum_slope.help.label"),
				helpText: i("teia.widgets.navigation_widget.navmesh.maximum_slope.help.text"),
				children: /* @__PURE__ */ G(E, {
					label: i("teia.widgets.navigation_widget.navmesh.maximum_slope.label"),
					value: t.maximumSlopeAngle,
					disabled: n,
					min: 0,
					max: 89,
					step: 1,
					maxDigits: 0,
					onChange: (e) => r("maximumSlopeAngle", e)
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: i("teia.widgets.navigation_widget.navmesh.simplification_tolerance.help.label"),
				helpText: i("teia.widgets.navigation_widget.navmesh.simplification_tolerance.help.text"),
				children: /* @__PURE__ */ G(E, {
					label: i("teia.widgets.navigation_widget.navmesh.simplification_tolerance.label"),
					value: t.simplificationTolerance,
					disabled: n,
					min: 0,
					step: .01,
					maxDigits: 2,
					onChange: (e) => r("simplificationTolerance", e)
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: i("teia.widgets.navigation_widget.navmesh.maximum_merge_distance.help.label"),
				helpText: i("teia.widgets.navigation_widget.navmesh.maximum_merge_distance.help.text"),
				children: /* @__PURE__ */ G(E, {
					label: i("teia.widgets.navigation_widget.navmesh.maximum_merge_distance.label"),
					value: t.maximumMergeDistance,
					disabled: n,
					min: 0,
					step: .1,
					maxDigits: 2,
					onChange: (e) => r("maximumMergeDistance", e)
				})
			})
		]
	});
}, id = (e) => {
	let { result: t } = e, { t: n } = h("teiaviewer"), r = (t.horizontalEdges.length + t.verticalEdges.length) / 2, i = new Set(t.componentIds).size, a = t.originalNodeCount > 0 ? Math.round((1 - t.sizes.length / t.originalNodeCount) * 100) : 0, o = t.originalEdgeCount > 0 ? Math.round((1 - r / t.originalEdgeCount) * 100) : 0;
	return /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(S, { children: n("teia.widgets.navigation_widget.navmesh.result.text", {
		nodes: t.sizes.length,
		edges: r,
		components: i
	}) }), /* @__PURE__ */ G(S, { children: n("teia.widgets.navigation_widget.navmesh.reduction.text", {
		nodes: a,
		edges: o
	}) })] });
}, ad = ({ voxelizationOutdated: e, generationOutdated: t, error: n, running: r }) => {
	let { t: i } = h("teiaviewer");
	return /* @__PURE__ */ K(W, { children: [
		!!r && /* @__PURE__ */ G(bt, {
			"data-testid": "navigation-graph-generation-progress",
			variant: "indeterminate"
		}),
		!!e && /* @__PURE__ */ G(m, {
			severity: "warning",
			children: i("teia.widgets.navigation_widget.navmesh.voxelization_outdated.text")
		}),
		!!t && /* @__PURE__ */ G(m, {
			severity: "warning",
			children: i("teia.widgets.navigation_widget.navmesh.needs_update.text")
		}),
		!!n && /* @__PURE__ */ G(m, {
			severity: "error",
			children: n
		})
	] });
}, od = () => {
	let { t } = h("teiaviewer"), { viewer: n } = H(), { forceUpdate: r } = ne(), i = Eu(), a = n.getPlugin("Path"), o = a.navigationGraphGenerationController, [s, l] = f(ye);
	c(() => (o.signals.onChanged.connect(r), () => {
		o.signals.onChanged.disconnect(r);
	}), [o, r]);
	let u = (e, t) => {
		l((n) => ({
			...n,
			[e]: t
		}));
	}, d = async () => {
		a.navigationGraphSettings.simplificationTolerance.value = s.simplificationTolerance;
		try {
			await new ke(n, s).execute();
		} catch {}
	}, p = o.result, m = o.status === "running", g = m || i.running || a.floodFillController.status === "running", _ = m || a.floodFillController.result === null || a.floodFillController.needsUpdate === !0 || i.controller.needsUpdate === !0;
	return /* @__PURE__ */ K(e, {
		spacing: 2,
		children: [
			/* @__PURE__ */ G(S, { children: t("teia.widgets.navigation_widget.navmesh.title") }),
			/* @__PURE__ */ G(rd, {
				options: s,
				disabled: g,
				onOptionChange: u
			}),
			/* @__PURE__ */ G(ad, {
				running: m,
				voxelizationOutdated: i.controller.needsUpdate,
				generationOutdated: o.needsUpdate,
				error: o.error
			}),
			!!p && /* @__PURE__ */ G(id, { result: p }),
			/* @__PURE__ */ G(nd, {
				running: m,
				generationDisabled: _,
				onGenerate: d,
				onCancel: () => o.cancel()
			})
		]
	});
}, sd = i(null), cd = ({ children: e }) => {
	let { viewer: t } = H(), n = t.getPlugin("Path").navigationRoutingController, { forceUpdate: r } = ne(), i = n.activeRoute, a = n.startPoint, s = n.endPoint, l = n.error, d = l === null, f = t.viewport?.operator, p = f?.name === "NavigationRoutingOperator" ? f.placementMode : null, m = o((e) => {
		let r = t.viewport;
		r && (new Lt(t, []).execute(), r.setOperator(new Re(r, n, e)), r.canvas.focus());
	}, [n, t]), h = o(() => {
		let e = t.viewport;
		e?.operator.name === "NavigationRoutingOperator" && e.resetDefaultOperator();
	}, [t]), g = o((e) => {
		let n = t.viewport?.operator;
		if (n?.name === "NavigationRoutingOperator" && n.placementMode === e) {
			h();
			return;
		}
		m(e);
	}, [
		m,
		h,
		t
	]);
	c(() => {
		let e = () => r();
		return n.signals.onChanged.connect(e), t.signals.onOperatorChanged.connect(e), () => {
			n.signals.onChanged.disconnect(e), t.signals.onOperatorChanged.disconnect(e), h();
		};
	}, [
		h,
		r,
		n,
		t.signals.onOperatorChanged
	]);
	let _ = u(() => ({
		routingController: n,
		activeRoute: i,
		startPoint: a,
		endPoint: s,
		routingError: l,
		canCalculateRoute: d,
		routingPlacementMode: p,
		toggleRoutingOperator: g,
		deactivateRoutingOperator: h
	}), [
		n,
		i,
		a,
		s,
		l,
		d,
		p,
		g,
		h
	]);
	return /* @__PURE__ */ G(sd.Provider, {
		value: _,
		children: e
	});
};
function ld() {
	let e = s(sd);
	if (!e) throw Error("useNavigationRouting must be used inside NavigationRoutingProvider.");
	return e;
}
//#endregion
//#region src/widgets/navigation/routing/NavigationRoutingPointControls.tsx
var ud = () => {
	let { viewer: t } = H(), { startPoint: n, endPoint: r, routingPlacementMode: i, toggleRoutingOperator: a } = ld(), { t: o } = h("teiaviewer"), s = () => {
		a("start");
	}, c = () => {
		a("end");
	}, l = () => {
		d("start");
	}, u = () => {
		d("end");
	}, d = (e) => {
		new Te(t, e).execute();
	};
	return /* @__PURE__ */ K(e, {
		spacing: 3,
		children: [
			/* @__PURE__ */ G(dd, {
				type: "start",
				point: n,
				placing: i === "start",
				icon: /* @__PURE__ */ G(Y, {
					component: _n,
					fontSize: "small"
				}),
				onPlace: s,
				onDelete: l
			}),
			/* @__PURE__ */ G(dd, {
				type: "end",
				point: r,
				placing: i === "end",
				icon: /* @__PURE__ */ G(Y, {
					component: fn,
					fontSize: "small"
				}),
				onPlace: c,
				onDelete: u
			}),
			/* @__PURE__ */ G(Z, {
				"data-testid": "navigation-routing-clear-points-button",
				variant: "primary",
				sx: {
					backgroundColor: (e) => e.palette.warning.main,
					"&:hover": { backgroundColor: (e) => e.palette.warning.dark }
				},
				startIcon: /* @__PURE__ */ G(Y, {
					component: Cn,
					fontSize: "small"
				}),
				disabled: !n && !r,
				onClick: () => {
					new ge(t).execute();
				},
				children: o("teia.widgets.navigation_widget.routing.clear_points.text")
			})
		]
	});
}, dd = ({ type: t, point: n, placing: r, icon: i, onPlace: a, onDelete: o }) => {
	let { t: s } = h("teiaviewer"), c = t === "start" ? Ie : Fe, l = t === "start" ? "teia.widgets.navigation_widget.routing.start.label" : "teia.widgets.navigation_widget.routing.end.label", u = r ? "teia.widgets.navigation_widget.routing.quit_placement.text" : t === "start" ? "teia.widgets.navigation_widget.routing.place_start.text" : "teia.widgets.navigation_widget.routing.place_end.text";
	return /* @__PURE__ */ K(e, {
		spacing: .5,
		children: [/* @__PURE__ */ K(e, {
			direction: "row",
			spacing: 1,
			alignItems: "center",
			children: [/* @__PURE__ */ G(Z, {
				"data-testid": `navigation-routing-place-${t}-button`,
				variant: "primary",
				startIcon: i,
				onClick: a,
				sx: {
					flex: 1,
					backgroundColor: c,
					"&:hover": { backgroundColor: c }
				},
				children: s(u)
			}), n !== null && /* @__PURE__ */ G(b, {
				title: s("teia.widgets.navigation_widget.routing.delete_point.text"),
				children: /* @__PURE__ */ G(v, {
					"data-testid": `navigation-routing-delete-${t}-button`,
					icon: Cn,
					"aria-label": s("teia.widgets.navigation_widget.routing.delete_point.text"),
					size: "small",
					onClick: o
				})
			})]
		}), /* @__PURE__ */ K(S, {
			sx: {
				color: c,
				fontSize: "14px"
			},
			children: [
				s(l),
				" : ",
				n ? s("teia.widgets.navigation_widget.routing.connections.text", { count: n.connections.length }) : s("teia.widgets.navigation_widget.routing.not_placed.text")
			]
		})]
	});
}, fd = () => {
	let { viewer: t } = H(), n = t.getPlugin("Path"), { t: r } = h("teiaviewer"), [i, a] = oe(n.navigationGraphSettings.routingConnectionDistance);
	return /* @__PURE__ */ G(e, {
		spacing: 1,
		children: /* @__PURE__ */ G(E, {
			"data-testid": "navigation-routing-connection-distance-input",
			label: r("teia.widgets.navigation_widget.routing.connection_distance.label"),
			value: i,
			min: .1,
			max: 100,
			step: .1,
			maxDigits: 2,
			defaultValue: 10,
			onChange: a,
			sx: { "& input": { fontSize: "14px" } }
		})
	});
}, pd = {
	"missing-graph": "teia.widgets.navigation_widget.routing.errors.missing_graph.text",
	"invalid-graph": "teia.widgets.navigation_widget.routing.errors.invalid_graph.text",
	"missing-start": "teia.widgets.navigation_widget.routing.errors.missing_start.text",
	"missing-end": "teia.widgets.navigation_widget.routing.errors.missing_end.text",
	"unconnected-start": "teia.widgets.navigation_widget.routing.errors.unconnected_start.text",
	"unconnected-end": "teia.widgets.navigation_widget.routing.errors.unconnected_end.text",
	"disconnected-components": "teia.widgets.navigation_widget.routing.errors.disconnected_components.text",
	"no-route": "teia.widgets.navigation_widget.routing.errors.no_route.text"
}, md = () => {
	let { viewer: t } = H(), { routingController: n, activeRoute: r, routingError: i, canCalculateRoute: a } = ld(), { t: o } = h("teiaviewer"), s = d(null), c = async () => {
		let e = new he(t), n = await e.execute();
		s.current = n ? e : null;
	}, l = () => Array.from(t.commandHistory.undoHistory).reverse().find(({ name: e }) => e === "CalculateNavigationRouteCommand");
	return r === null ? /* @__PURE__ */ K(e, {
		spacing: 3,
		children: [
			/* @__PURE__ */ G(S, { children: o("teia.widgets.navigation_widget.routing.title") }),
			/* @__PURE__ */ G(fd, {}),
			/* @__PURE__ */ G(Kt, {}),
			/* @__PURE__ */ G(ud, {}),
			/* @__PURE__ */ G(Kt, {}),
			i !== null && /* @__PURE__ */ G(m, {
				"data-testid": "navigation-routing-error",
				severity: "warning",
				children: o(pd[i])
			}),
			/* @__PURE__ */ G(Z, {
				"data-testid": "navigation-routing-calculate-button",
				variant: "primary",
				startIcon: /* @__PURE__ */ G(Y, {
					component: bn,
					fontSize: "small"
				}),
				disabled: !a,
				onClick: c,
				children: o("teia.widgets.navigation_widget.routing.calculate.text")
			})
		]
	}) : /* @__PURE__ */ K(e, {
		spacing: 2,
		children: [
			/* @__PURE__ */ G(S, { children: o("teia.widgets.navigation_widget.routing.title") }),
			/* @__PURE__ */ G(S, {
				"data-testid": "navigation-routing-result",
				sx: {
					fontSize: "14px",
					marginTop: "0px !important"
				},
				children: o("teia.widgets.navigation_widget.routing.route_result.text", {
					count: r.nodeIds.length,
					distance: r.distance.toFixed(2)
				})
			}),
			/* @__PURE__ */ G(Z, {
				"data-testid": "navigation-routing-back-button",
				variant: "secondary",
				startIcon: /* @__PURE__ */ G(Y, {
					component: Jt,
					fontSize: "small"
				}),
				onClick: async () => {
					let e = s.current, r = e?.hasBeenExecuted ? e : l();
					if (r) {
						let e = t.commandHistory;
						await r.undo({ addToRedoHistory: r === e.lastCommand }), s.current = null;
						return;
					}
					n.clearRoute();
				},
				children: o("teia.widgets.navigation_widget.routing.back_to_creation.text")
			})
		]
	});
};
//#endregion
//#region src/widgets/navigation/voxelization/VoxelizationActions.tsx
function hd(e) {
	return e.split(",").map((e) => e.trim()).filter(Boolean);
}
var gd = () => {
	let { t } = h("teiaviewer"), n = Eu(), { isEditing: r } = Uu(), { controller: i, running: a } = n;
	return /* @__PURE__ */ K(e, {
		direction: "row",
		spacing: 1,
		children: [
			/* @__PURE__ */ G(Z, {
				"data-testid": "voxelization-start-button",
				variant: "primary",
				onClick: async () => {
					let e = {
						...be,
						granularities: hd(n.granularities).map(Number),
						boxTreeLevel: n.boxTreeLevel,
						workerCount: n.workerCount,
						maxVoxelCount: n.maxVoxelCount,
						includedObjectTypes: hd(n.includedObjectTypes),
						excludedObjectTypes: hd(n.excludedObjectTypes),
						passableObjectTypes: hd(n.passableObjectTypes),
						verticalConnectionObjectTypes: hd(n.verticalConnectionObjectTypes)
					};
					try {
						await i.start(e);
					} catch {}
				},
				disabled: a || r,
				children: t("teia.widgets.navigation_widget.voxelization.start.text")
			}),
			!!a && /* @__PURE__ */ G(Z, {
				"data-testid": "voxelization-cancel-button",
				variant: "secondary",
				onClick: () => {
					i.cancel();
				},
				children: t("teia.widgets.navigation_widget.voxelization.cancel.text")
			}),
			!!i.result && !a && /* @__PURE__ */ G(Z, {
				"data-testid": "voxelization-clear-button",
				variant: "secondary",
				onClick: () => {
					i.clear();
				},
				children: t("teia.widgets.navigation_widget.voxelization.clear.text")
			})
		]
	});
}, _d = () => {
	let { t } = h("teiaviewer"), n = Eu(), [r, i] = f(String(n.boxTreeLevel)), [a, o] = f(String(n.maxVoxelCount)), [s, c] = f(String(n.workerCount));
	return /* @__PURE__ */ K(e, {
		spacing: 3,
		children: [
			/* @__PURE__ */ G(Ou, {
				helpLabel: t("teia.widgets.navigation_widget.voxelization.granularities.help.label"),
				helpText: t("teia.widgets.navigation_widget.voxelization.granularities.help.text"),
				children: /* @__PURE__ */ G(y, {
					sx: { width: "100%" },
					label: t("teia.widgets.navigation_widget.voxelization.granularities.label"),
					"data-testid": "voxelization-granularities-input",
					value: n.granularities,
					onChange: (e) => {
						n.setGranularities(e.target.value);
					},
					disabled: n.running
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: t("teia.widgets.navigation_widget.voxelization.box_tree_level.help.label"),
				helpText: t("teia.widgets.navigation_widget.voxelization.box_tree_level.help.text"),
				children: /* @__PURE__ */ G(y, {
					sx: { width: "100%" },
					label: t("teia.widgets.navigation_widget.voxelization.box_tree_level.label"),
					value: r,
					onChange: (e) => {
						i(e.target.value);
					},
					onBlur: () => {
						let e = Number(r), t = r.trim() !== "" && Number.isInteger(e) && e >= 0 ? e : n.boxTreeLevel;
						n.setBoxTreeLevel(t), i(String(t));
					},
					disabled: n.running,
					type: "number",
					slotProps: { htmlInput: {
						min: 0,
						step: 1,
						"data-testid": "voxelization-box-tree-level-input"
					} }
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: t("teia.widgets.navigation_widget.voxelization.max_voxel_count.help.label"),
				helpText: t("teia.widgets.navigation_widget.voxelization.max_voxel_count.help.text"),
				children: /* @__PURE__ */ G(y, {
					sx: { width: "100%" },
					label: t("teia.widgets.navigation_widget.voxelization.max_voxel_count.label"),
					value: a,
					onChange: (e) => {
						o(e.target.value);
					},
					onBlur: () => {
						let e = Number(a), t = Number.isInteger(e) && e > 0 ? e : n.maxVoxelCount;
						n.setMaxVoxelCount(t), o(String(t));
					},
					disabled: n.running,
					type: "number",
					slotProps: { htmlInput: {
						min: 1,
						step: 1e5,
						"data-testid": "voxelization-max-voxel-count-input"
					} }
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: t("teia.widgets.navigation_widget.voxelization.worker_count.help.label"),
				helpText: t("teia.widgets.navigation_widget.voxelization.worker_count.help.text"),
				children: /* @__PURE__ */ G(y, {
					sx: { width: "100%" },
					label: t("teia.widgets.navigation_widget.voxelization.worker_count.label"),
					value: s,
					onChange: (e) => {
						c(e.target.value);
					},
					onBlur: () => {
						let e = Number(s), t = Number.isInteger(e) && e >= 1 && e <= 32 ? e : n.workerCount;
						n.setWorkerCount(t), c(String(t));
					},
					disabled: n.running,
					type: "number",
					slotProps: { htmlInput: {
						min: 1,
						max: 32,
						step: 1,
						"data-testid": "voxelization-worker-count-input"
					} }
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: t("teia.widgets.navigation_widget.voxelization.included_object_types.help.label"),
				helpText: t("teia.widgets.navigation_widget.voxelization.included_object_types.help.text"),
				children: /* @__PURE__ */ G(y, {
					sx: { width: "100%" },
					label: t("teia.widgets.navigation_widget.voxelization.included_object_types.label"),
					"data-testid": "voxelization-included-types-input",
					value: n.includedObjectTypes,
					onChange: (e) => {
						n.setIncludedObjectTypes(e.target.value);
					},
					disabled: n.running
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: t("teia.widgets.navigation_widget.voxelization.excluded_object_types.help.label"),
				helpText: t("teia.widgets.navigation_widget.voxelization.excluded_object_types.help.text"),
				children: /* @__PURE__ */ G(y, {
					sx: { width: "100%" },
					label: t("teia.widgets.navigation_widget.voxelization.excluded_object_types.label"),
					"data-testid": "voxelization-excluded-types-input",
					value: n.excludedObjectTypes,
					onChange: (e) => {
						n.setExcludedObjectTypes(e.target.value);
					},
					disabled: n.running
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: t("teia.widgets.navigation_widget.voxelization.passable_object_types.help.label"),
				helpText: t("teia.widgets.navigation_widget.voxelization.passable_object_types.help.text"),
				children: /* @__PURE__ */ G(y, {
					sx: { width: "100%" },
					label: t("teia.widgets.navigation_widget.voxelization.passable_object_types.label"),
					value: n.passableObjectTypes,
					onChange: (e) => {
						n.setPassableObjectTypes(e.target.value);
					},
					disabled: n.running
				})
			}),
			/* @__PURE__ */ G(Ou, {
				helpLabel: t("teia.widgets.navigation_widget.voxelization.vertical_connection_object_types.help.label"),
				helpText: t("teia.widgets.navigation_widget.voxelization.vertical_connection_object_types.help.text"),
				children: /* @__PURE__ */ G(y, {
					sx: { width: "100%" },
					label: t("teia.widgets.navigation_widget.voxelization.vertical_connection_object_types.label"),
					value: n.verticalConnectionObjectTypes,
					onChange: (e) => {
						n.setVerticalConnectionObjectTypes(e.target.value);
					},
					disabled: n.running
				})
			})
		]
	});
}, vd = () => {
	let { t } = h("teiaviewer"), { controller: n, running: r } = Eu();
	return /* @__PURE__ */ K(W, { children: [
		!!r && /* @__PURE__ */ K(e, {
			"data-testid": "voxelization-progress",
			spacing: 1,
			children: [/* @__PURE__ */ G(bt, {
				variant: n.status === "running" ? "determinate" : "indeterminate",
				value: n.progress.progress * 100
			}), /* @__PURE__ */ G(S, {
				variant: "caption",
				children: t("teia.widgets.navigation_widget.voxelization.progress.text", { count: n.progress.processedVoxelCount })
			})]
		}),
		n.error !== null && /* @__PURE__ */ G(m, {
			"data-testid": "voxelization-error-alert",
			severity: "error",
			children: n.error
		}),
		n.warning === "missingObjectTypes" && /* @__PURE__ */ G(m, {
			"data-testid": "voxelization-warning-alert",
			severity: "warning",
			children: t("teia.widgets.navigation_widget.voxelization.warning.missing_object_types.text")
		}),
		!!n.result && /* @__PURE__ */ G(m, {
			"data-testid": "voxelization-result-alert",
			severity: "success",
			children: t("teia.widgets.navigation_widget.voxelization.result.text", {
				count: n.result.voxelCount,
				solid: n.result.solidVoxelCount,
				empty: n.result.emptyVoxelCount
			})
		})
	] });
}, yd = () => {
	let { t } = h("teiaviewer"), { controller: n, running: r } = Eu(), i = r || n.error !== null || n.result !== null;
	return /* @__PURE__ */ K(e, { children: [
		/* @__PURE__ */ G(S, {
			sx: { marginBottom: "10px" },
			children: t("teia.widgets.navigation_widget.voxelization.title")
		}),
		/* @__PURE__ */ G(_d, {}),
		/* @__PURE__ */ G(Kt, { sx: {
			marginTop: "10px",
			marginBottom: "5px"
		} }),
		/* @__PURE__ */ G(Mu, {}),
		!!i && /* @__PURE__ */ K(W, { children: [/* @__PURE__ */ G(Kt, { sx: { margin: "10px 0px" } }), /* @__PURE__ */ G(vd, {})] }),
		/* @__PURE__ */ G(Kt, { sx: { margin: "10px 0px" } }),
		/* @__PURE__ */ G(gd, {})
	] });
}, bd = 0, xd = 1, Sd = 2, Cd = 3, wd = 4, Td = () => {
	let { isEditing: t } = Uu(), { activeRoute: n, deactivateRoutingOperator: r } = ld(), { deactivateSeedPlacement: i, hasFloodFillResult: a, hasGrid: o } = Iu(), s = Qi(), { t: l } = h("teiaviewer"), [u, d] = f(bd), p = n !== null, g = (e) => e !== u && (e === bd && p || e !== bd && t || e === Cd && !o || e === wd && !a);
	if (c(() => {
		!o && u === Cd ? d(Sd) : !a && u === wd && d(o ? Cd : Sd);
	}, [
		a,
		o,
		u
	]), s?.sourceType !== nt.Twin) return /* @__PURE__ */ G(m, {
		"data-testid": "navigation-no-twin-alert",
		severity: "warning",
		sx: { margin: 2 },
		children: l("teia.widgets.navigation_widget.no_twin.text")
	});
	let v = [
		{
			id: "NavigationGraphCreation",
			icon: Fr,
			tooltip: l(p ? "teia.widgets.navigation_widget.tabs.creation_route_disabled.text" : "teia.widgets.navigation_widget.tabs.creation.text"),
			disabled: g(bd)
		},
		{
			id: "NavigationGraphRouting",
			icon: Dr,
			tooltip: l(t ? "teia.widgets.navigation_widget.tabs.routing_editing_disabled.text" : "teia.widgets.navigation_widget.tabs.routing.text"),
			disabled: g(xd)
		},
		{
			id: "NavigationVoxelization",
			icon: pr,
			tooltip: l(t ? "teia.widgets.navigation_widget.tabs.voxelization_editing_disabled.text" : "teia.widgets.navigation_widget.tabs.voxelization.text"),
			disabled: g(Sd)
		},
		{
			id: "NavigationFloodFill",
			icon: kr,
			tooltip: l(o ? "teia.widgets.navigation_widget.tabs.flood_fill.text" : "teia.widgets.navigation_widget.tabs.flood_fill_disabled.text"),
			disabled: g(Cd)
		},
		{
			id: "NavigationGraphGeneration",
			icon: Lr,
			tooltip: l(a ? "teia.widgets.navigation_widget.tabs.navmesh.text" : "teia.widgets.navigation_widget.tabs.navmesh_disabled.text"),
			disabled: g(wd)
		}
	];
	return /* @__PURE__ */ K(_, {
		sx: {
			display: "flex",
			width: "100%",
			height: "100%"
		},
		children: [/* @__PURE__ */ G(F, {
			tabs: v,
			selectedTabIndex: u,
			onTabSelected: (e) => {
				e === u || g(e) || (i(), r(), d(e));
			}
		}), /* @__PURE__ */ K(e, {
			spacing: 2,
			sx: {
				padding: 2,
				width: "100%",
				height: "100%",
				overflowY: "auto"
			},
			children: [
				u === bd && /* @__PURE__ */ G(Ed, {}),
				u === xd && /* @__PURE__ */ G(md, {}),
				u === Sd && /* @__PURE__ */ G(yd, {}),
				u === Cd && /* @__PURE__ */ G(zu, {}),
				u === wd && /* @__PURE__ */ G(od, {})
			]
		})]
	});
}, Ed = () => {
	let { importError: e, isEditing: t } = Uu(), { t: n } = h("teiaviewer");
	return /* @__PURE__ */ K(W, { children: [
		/* @__PURE__ */ G(S, { children: n("teia.widgets.navigation_widget.creation.title") }),
		/* @__PURE__ */ G(Ku, {}),
		e !== null && /* @__PURE__ */ G(m, {
			"data-testid": "navigation-graph-import-error",
			severity: "error",
			children: e
		}),
		!!t && /* @__PURE__ */ K(W, { children: [
			/* @__PURE__ */ G(Kt, {}),
			/* @__PURE__ */ G(qu, {}),
			/* @__PURE__ */ G(Kt, {}),
			/* @__PURE__ */ G($u, {}),
			/* @__PURE__ */ G(Kt, { sx: { marginBottom: "3px" } }),
			/* @__PURE__ */ G(td, {})
		] })
	] });
}, Dd = () => /* @__PURE__ */ G(Hu, { children: /* @__PURE__ */ G(cd, { children: /* @__PURE__ */ G(Tu, { children: /* @__PURE__ */ G(Fu, { children: /* @__PURE__ */ G(Td, {}) }) }) }) });
//#endregion
//#region src/widgets/navigation/NavigationWidget.tsx
function Od() {
	let { t: e } = h("teiaviewer");
	return /* @__PURE__ */ G(te, {
		"data-testid": "navigation-widget-title",
		icon: Fr,
		children: e("teia.widgets.navigation_widget.title")
	});
}
var kd = class extends N {
	constructor(e, t = {}) {
		super(e, {
			...t,
			isResizable: !0,
			width: 396,
			minWidth: 396,
			height: 480,
			minHeight: 480,
			useFooter: !1
		}), this.type = "NavigationGraph", this.Header = Od, this.Content = () => /* @__PURE__ */ G(Dd, {});
	}
}, Ad = zt.Create("PluginUI", () => ({ advancedSearch: {
	enableJsonEditor: new At(!0),
	enableAI: new At(!1)
} })), jd = {
	Projection: "Projection",
	FloorPlan: "FloorPlan",
	NavigationGraph: "Path"
}, Md = ["TeiaAdvancedSearch", ...Object.keys(jd)], Nd = class extends Ad {
	constructor(...e) {
		super(...e), this._onPluginAdded = (e) => {
			e === "Map" && this.viewer.getPlugin("Viewport").widgetController.content.settingsTabs.add(fu);
		}, this._onPluginRemoved = (e) => {
			let t = this.viewer.getPlugin("Viewport");
			for (let [n, r] of Object.entries(jd)) r === e && Pd(t, n);
			e === "Map" && t.widgetController.content.settingsTabs.delete(fu);
		};
	}
	static {
		this.ToolbarItems = {
			TeiaSearchToolbarItem: Eo,
			ObjectTransformToolbarItem: So,
			ShowProjectionsWidgetToolbarItem: wo,
			MeasureLineToolbarItem: ia,
			ShowFloorPlanWidgetToolbarItem: na,
			ZoneToolbarItem: Fo,
			NavigationGraphToolbarItem: aa
		};
	}
	dependencies() {
		return ["Teia", "Viewport"];
	}
	onRegister() {
		Id(this.viewer);
		let e = this.viewer.getPlugin("Viewport");
		e.wrappers.add(Io), e.widgetController.content.infoboxTabs.add(Tc), e.widgetController.content.infoboxTabs.add(Fc), e.widgetController.content.infoboxTabs.add(Rc), e.widgetController.content.infoboxTabs.add(Mc), e.widgetController.content.infoboxTabs.add(bc), this.viewer.hasPlugin("Map") && e.widgetController.content.settingsTabs.add(fu), this.viewer.signals.onPluginAdded.connect(this._onPluginAdded), this.viewer.signals.onPluginRemoved.connect(this._onPluginRemoved);
	}
	onUnregister() {
		this.viewer.signals.onPluginAdded.disconnect(this._onPluginAdded), this.viewer.signals.onPluginRemoved.disconnect(this._onPluginRemoved);
		let e = this.viewer.getPlugin("Viewport");
		for (let t of Md) Pd(e, t), e.widgetController.factory.unregisterWidget(t);
		e.wrappers.delete(Io), e.widgetController.content.infoboxTabs.delete(Tc), e.widgetController.content.infoboxTabs.delete(Fc), e.widgetController.content.infoboxTabs.delete(Rc), e.widgetController.content.infoboxTabs.delete(Mc), e.widgetController.content.infoboxTabs.delete(bc), e.widgetController.content.settingsTabs.delete(fu);
	}
};
function Pd(e, t) {
	let { widgetController: n } = e;
	for (let e of Array.from(n.getWidgetsOfType(t))) n.removeWidget(e);
}
function Fd(e, t) {
	let n = jd[t];
	if (!e.hasPlugin(n)) throw new Ft(n);
}
function Id(e) {
	let t = e.getPlugin("Viewport");
	t.widgetController.factory.registerWidget("TeiaAdvancedSearch", (t) => {
		let { viewportRect: n } = t, { width: r, height: i } = n;
		return new Uo(e, {
			x: (r - 900) / 2,
			y: (i - 140) / 2,
			width: 900,
			height: 140,
			...t
		});
	}), t.widgetController.factory.registerWidget("Projection", (t) => (Fd(e, "Projection"), new Il(e, {
		x: 20,
		y: 50,
		...t
	}))), t.widgetController.factory.registerWidget("FloorPlan", (t) => (Fd(e, "FloorPlan"), new cc(e, {
		x: 20,
		y: 50,
		...t
	}))), t.widgetController.factory.registerWidget("NavigationGraph", (t) => (Fd(e, "NavigationGraph"), new kd(e, {
		x: 20,
		y: 50,
		...t
	})));
}
//#endregion
export { Nd as PluginsUIPlugin, Zi as TeiaSearchFilterEditor, $i as useHasTwinSource, Qi as useTeiaSource, ea as useTwinSource };

//# sourceMappingURL=exports.js.map